import { jsx as v, jsxs as _, Fragment as Ue } from "react/jsx-runtime";
import { Transition as xa, Dialog as Nn, Popover as _i, PopoverButton as Fi, PopoverPanel as Ki, Switch as su, FocusTrap as uu, FocusTrapFeatures as lu, MenuButton as cu, Menu as du, MenuItems as pu, MenuItem as fu, ComboboxButton as Yr, Combobox as xi, ComboboxInput as hu, Field as Wr, ComboboxOption as Hi, ComboboxOptions as Ui, Listbox as Vr, ListboxButton as Ot, ListboxOptions as jr, ListboxOption as Yi } from "@headlessui/react";
import * as me from "react";
import C, { Fragment as ut, useState as de, useRef as Ae, useEffect as Ne, forwardRef as Mt, createContext as mu, useCallback as Ha, useMemo as qa, createElement as gu, Component as vu, createRef as Su, useLayoutEffect as bu } from "react";
import { twMerge as A, twJoin as kr } from "tailwind-merge";
import { C as yt, P as ce, i as W, a as Mu, L as ie, D as yu, b as Cu, c as ku, Q as Wi, A as Vi, d as Tu, _ as Ba, e as ae, f as te, g as G, S as wu, h as Au, j as Nu, k as Du, l as ji } from "./i18n-DY3kJsfw.mjs";
import { HexAlphaColorPicker as Iu, HexColorPicker as Eu, HexColorInput as Bu } from "react-colorful";
import Pu, { toast as Qe, Toaster as Ou } from "react-hot-toast";
import * as Gu from "react-dom";
import Lu, { findDOMNode as Ru } from "react-dom";
var _u = /* @__PURE__ */ ((a) => (a.small = "small", a.medium = "medium", a.big = "big", a))(_u || {});
function Vm({
  opened: a,
  onClose: r,
  children: n,
  title: t,
  size: e = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: s,
  className: u,
  contentClassName: l,
  isCentered: c,
  dialogClassName: d,
  backdropClassName: h,
  dialogContentClassName: p,
  dialogContentWrapperClassName: g,
  dialogContentWrapper1ClassName: S,
  titleClassName: b,
  closeIconWrapperClassName: w,
  closeIconClassName: T,
  ...k
}) {
  return /* @__PURE__ */ v(xa.Root, { afterEnter: s, show: a, as: ut, children: /* @__PURE__ */ _(
    Nn,
    {
      className: A("relative z-10", d),
      onClose: i ? () => {
      } : r,
      children: [
        /* @__PURE__ */ v(
          xa.Child,
          {
            as: ut,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ v(
              "div",
              {
                className: A(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  h
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v(
          "div",
          {
            className: A("fixed inset-0 z-10 overflow-y-auto", g),
            children: /* @__PURE__ */ v(
              "div",
              {
                id: "modal-background",
                className: A(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  S
                ),
                children: /* @__PURE__ */ v(
                  xa.Child,
                  {
                    as: ut,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ _(
                      Nn.Panel,
                      {
                        className: A(
                          "relative w-full",
                          e === "small" ? "max-w-2xl" : e === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          u
                        ),
                        ...k,
                        children: [
                          /* @__PURE__ */ _(
                            "div",
                            {
                              className: A(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                c ? "justify-center" : "justify-between",
                                p
                              ),
                              children: [
                                /* @__PURE__ */ v("h3", { className: A(c ? "px-6 lg:px-10" : "", b), children: t }),
                                /* @__PURE__ */ v(
                                  "button",
                                  {
                                    className: A(
                                      "focus-ring rounded-full",
                                      c && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      w
                                    ),
                                    disabled: i,
                                    onClick: r,
                                    children: /* @__PURE__ */ v(
                                      yt,
                                      {
                                        className: A(
                                          "cursor-pointer",
                                          i && "fill-text-secondary pointer-events-none",
                                          T
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ v(
                            "div",
                            {
                              className: A(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                l
                              ),
                              children: n
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const Gt = ({ small: a = !1, type: r = "light", className: n, style: t }) => /* @__PURE__ */ _("div", { role: "status", className: n, style: t, children: [
  /* @__PURE__ */ _(
    "svg",
    {
      "aria-hidden": "true",
      className: `${a ? "h-5 w-5" : "h-8 w-8"} animate-spin ${r === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ v(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ v("span", { className: "sr-only", children: "Loading..." })
] });
function Zt(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function Dn(a, r) {
  (r == null || r > a.length) && (r = a.length);
  for (var n = 0, t = Array(r); n < r; n++) t[n] = a[n];
  return t;
}
function Fu(a, r) {
  if (a) {
    if (typeof a == "string") return Dn(a, r);
    var n = {}.toString.call(a).slice(8, -1);
    return n === "Object" && a.constructor && (n = a.constructor.name), n === "Map" || n === "Set" ? Array.from(a) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Dn(a, r) : void 0;
  }
}
const jm = (a) => {
  switch (a) {
    case ce.stripe_card:
      return W.t("public_pages_purchase.payment.stripe_card");
    case ce.stripe_ideal:
      return W.t("public_pages_purchase.payment.stripe_ideal");
    case ce.stripe_bancontact:
      return W.t("public_pages_purchase.payment.stripe_bancotact");
    case ce.stripe_applepay:
      return W.t("public_pages_purchase.payment.stripe_applepay");
    case ce.dlocal_card:
      return W.t("public_pages_purchase.payment.dlocal_card");
    case ce.dlocal_boleto:
      return W.t("public_pages_purchase.payment.dlocal_boleto");
    case ce.dlocal_pix:
      return W.t("public_pages_purchase.payment.dlocal_pix");
    case ce.paypal_soap:
    case ce.paypal_rest:
      return W.t("public_pages_purchase.payment.paypal_soap");
    case ce.mercadopago_br_card:
      return W.t("public_pages_purchase.payment.mercadopago_card");
    case ce.mercadopago_br_pix:
      return W.t("public_pages_purchase.payment.mercadopago_pix");
    case ce.mercadopago_br_boleto:
      return W.t("public_pages_purchase.payment.mercadopago_boleto");
    case ce.mercadopago_co_card:
    case ce.mercadopago_ar_card:
    case ce.mercadopago_mx_card:
    case ce.mercadopago_cl_card:
      return W.t("public_pages_purchase.payment.mercadopago_card");
    case ce.razorpay:
      return W.t("public_pages_purchase.payment.razorpay");
    case ce.flutterwave:
      return W.t("public_pages_purchase.payment.flutterwave");
    case ce.mollie:
      return W.t("public_pages_purchase.payment.mollie");
    case ce.gocardless:
      return W.t("public_pages_purchase.payment.gocardless");
    case ce.cash_on_delivery:
      return W.t("public_pages_purchase.payment.cash_on_delivery");
    case ce.xendit_id_card:
    case ce.xendit_ph_card:
      return W.t("public_pages_purchase.payment.xendit_card");
    case ce.paystack_gh_card:
    case ce.paystack_ke_card:
    case ce.paystack_ng_card:
    case ce.paystack_za_card:
    case ce.paystack_eg_card:
    case ce.paystack_ci_card:
      return W.t("public_pages_purchase.payment.paystack_card");
    case ce.secure_and_pay:
      return W.t("public_pages_purchase.payment.secure_and_pay");
  }
}, Sa = ({
  description: a,
  descriptionClassName: r,
  error: n,
  errorClassName: t,
  className: e
}) => {
  const i = n ? /* @__PURE__ */ v(
    "p",
    {
      className: A("text-danger [&>a]:text-brand-primary text-sm", t),
      ...typeof n == "string" ? {
        dangerouslySetInnerHTML: { __html: n }
      } : {
        children: n
      }
    }
  ) : null;
  return n || a ? /* @__PURE__ */ _("div", { className: e, children: [
    a ? /* @__PURE__ */ v(
      "span",
      {
        className: A("[&>a]:text-brand-primary text-sm opacity-70", r),
        children: a
      }
    ) : null,
    i
  ] }) : null;
}, Zm = ({
  inputRef: a,
  error: r,
  description: n,
  value: t,
  onChange: e,
  label: i,
  disabled: o,
  isFetching: s,
  labelClassName: u,
  className: l,
  errorClassName: c,
  descriptionClassName: d,
  checkboxIconClassName: h,
  inputClassName: p,
  inputWrapperClassName: g
}) => /* @__PURE__ */ _(
  "label",
  {
    className: A(
      "group flex w-fit items-center gap-3",
      o ? "cursor-default" : "cursor-pointer",
      l
    ),
    "aria-checked": t,
    children: [
      /* @__PURE__ */ _("div", { className: A("relative flex items-center justify-center", g), children: [
        /* @__PURE__ */ v(
          "input",
          {
            ref: a,
            disabled: o,
            checked: t,
            className: A(
              "peer/checkbox main-transition-colors",
              o ? "bg-skeleton-primary/40 border-darkgray/20 checked:bg-text-primary/60 checked:border-text-primary/75 cursor-default" : "border-darkgray bg-background-secondary checked:border-text-primary checked:bg-text-primary",
              s && "animate-pulse",
              "focus-ring h-[20px] w-[20px] cursor-pointer appearance-none rounded-md border",
              p
            ),
            type: "checkbox",
            onChange: (S) => e(S.target.checked)
          }
        ),
        /* @__PURE__ */ v(
          Mu,
          {
            className: A(
              "absolute",
              o ? t ? "fill-background-secondary/70 opacity-100" : "opacity-0" : "fill-background-secondary opacity-100",
              h
            )
          }
        )
      ] }),
      i && /* @__PURE__ */ v(
        "span",
        {
          className: A(
            "main-transition-colors",
            t ? "text-text-primary" : "text-text-primary/50",
            "leading-5",
            u,
            "text-left"
          ),
          children: i
        }
      ),
      /* @__PURE__ */ v(
        Sa,
        {
          description: n,
          error: r,
          errorClassName: c,
          descriptionClassName: d
        }
      )
    ]
  }
);
function Pa({
  wrapperAs: a = "div",
  wrapperProps: r = { className: "flex justify-between gap-2" },
  label: n,
  required: t,
  labelClassName: e,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return n || t || i ? /* @__PURE__ */ _(a, { ...r, children: [
    (n || t) && /* @__PURE__ */ _("span", { className: A("flex", e), children: [
      n,
      " ",
      t && /* @__PURE__ */ v("i", { className: A("text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
function Zi() {
  const [a, r] = C.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function n() {
    r({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return C.useEffect(() => (r({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", n), () => {
    window.removeEventListener("resize", n);
  }), []), a;
}
const zi = ({ hoverOpenDelay: a = 100 } = {}) => {
  const [r, n] = de(!1), t = Ae(null), e = () => {
    t.current !== null && (clearTimeout(t.current), t.current = null);
  }, i = () => {
    e(), n(!0);
  }, o = () => {
    e(), t.current = setTimeout(() => {
      n(!0);
    }, a);
  }, s = () => {
    e(), n(!1);
  }, u = () => {
    e(), t.current = setTimeout(() => {
      n(!1);
    }, 100);
  };
  return Ne(() => () => e(), []), { show: r, open: i, close: s, delayClose: u, delayOpen: o };
}, Ji = (a) => {
  var r;
  return a.hasChildNodes() ? ((r = a.childNodes[0]) == null ? void 0 : r.nodeType) === 3 ? a : Ji(a.childNodes[0]) : a;
}, Ku = (a, r) => {
  const [n, t] = me.useState(void 0), { width: e } = Zi();
  return me.useLayoutEffect(() => {
    const { current: i } = a;
    i && (() => {
      const s = Ji(i);
      if (!s) return;
      const u = s.scrollWidth > i.clientWidth;
      t(u), r && r(u);
    })();
  }, [r, a, e]), n;
}, Qi = Mt(function(a, r) {
  return /* @__PURE__ */ v(
    "button",
    {
      ref: r,
      ...a,
      onClick: (n) => {
        var t;
        n.preventDefault = () => {
        }, (t = a.onClick) == null || t.call(a, n);
      }
    }
  );
}), xu = Mt(function(a, r) {
  return /* @__PURE__ */ v(
    "div",
    {
      ref: r,
      ...a,
      onClick: (n) => {
        var t;
        n.preventDefault = () => {
        }, n.stopPropagation = () => {
        }, (t = a.onClick) == null || t.call(a, n);
      }
    }
  );
}), Zr = ({
  mode: a = "hover",
  popoverButtonRef: r,
  label: n,
  position: t = "top",
  anchor: e,
  className: i,
  wrapperClassName: o,
  popoverClassName: s,
  labelClassName: u,
  disabled: l,
  stayOnHover: c,
  children: d,
  hoverOpenDelay: h
}) => {
  const p = Ae(), g = Ae(null), S = Ku(p), { width: b } = Zi(), { show: w, delayOpen: T, delayClose: k } = zi({ hoverOpenDelay: h });
  return /* @__PURE__ */ v(_i, { className: A("flex items-center", o), children: ({ open: N }) => {
    const M = l ? !1 : a === "click" || b < 1024 ? N : a === "hover" || a === "overflow" && S ? w : !1;
    return /* @__PURE__ */ _(Ue, { children: [
      /* @__PURE__ */ v(
        Fi,
        {
          ref: (y) => {
            p && (p.current = y), r && (r.current = y);
          },
          as: a === "click" ? Qi : xu,
          className: A(
            "relative truncate outline-hidden",
            a === "click" && !l && "cursor-pointer",
            "h-full w-full max-w-fit",
            i
          ),
          disabled: l,
          onMouseEnter: T,
          onMouseLeave: k,
          children: typeof d == "function" ? d(M) : d
        }
      ),
      /* @__PURE__ */ v(
        xa,
        {
          as: ut,
          show: M,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ v(
            Ki,
            {
              ref: g,
              anchor: e ?? t.replace("-", " "),
              className: A(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                s
              ),
              onMouseEnter: c ? T : void 0,
              onMouseLeave: c ? k : void 0,
              children: /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    u
                  ),
                  children: n
                }
              )
            }
          )
        }
      )
    ] });
  } });
}, zm = (a) => /* @__PURE__ */ v(Zr, { ...a, mode: "click" }), Jm = ({
  selected: a,
  onChange: r,
  label: n,
  labelClassName: t,
  wrapperClassName: e,
  switcherClassName: i,
  disabled: o
}) => /* @__PURE__ */ _("div", { className: A("relative flex flex-col gap-2 md:flex-row", e), children: [
  /* @__PURE__ */ v(
    su,
    {
      checked: a,
      onChange: r,
      disabled: o,
      className: A(
        "main-transition-colors focus-ring relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
        a && !o ? "bg-brand-primary" : "bg-fill-primary",
        i
      ),
      children: /* @__PURE__ */ v(
        "span",
        {
          "aria-hidden": "true",
          className: A(
            "bg-background-secondary pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-lg ring-0 transition-transform duration-200 ease-linear",
            a ? "translate-x-5" : "translate-x-0"
          )
        }
      )
    }
  ),
  n && /* @__PURE__ */ v("div", { className: A(t), children: n })
] }), Qm = ({
  color: a,
  labelClassName: r,
  popoverClassName: n,
  popoverButtonClassName: t,
  popoverButtonChildClassName: e,
  hexColorInput: i,
  wrapperClassName: o,
  children: s,
  additionalPopoverChildren: u,
  focusTrapFeatures: l = lu.None,
  stayWhenUnfocused: c = !1,
  showAlpha: d = !0,
  showOnlyHue: h = !1,
  pickerRef: p,
  error: g,
  description: S,
  anchor: b = "top",
  disabled: w,
  ...T
}) => {
  const [k, N] = de(!1), M = Ae(null);
  Ne(() => {
    const D = (B) => {
      var K;
      (K = M.current) != null && K.contains(B.target) && N(!0);
    }, I = (B) => {
      M.current && !M.current.contains(B.target) && N(!1);
    }, P = (B) => {
      B.key === "Escape" && N(!1);
    };
    return document.addEventListener("focusin", D), document.addEventListener("touchstart", I, !0), document.addEventListener("mousedown", I, !0), document.addEventListener("keydown", P), () => {
      document.removeEventListener("focusin", D), document.removeEventListener("touchstart", I, !0), document.removeEventListener("mousedown", I, !0), document.removeEventListener("keydown", P);
    };
  }, []), p && (p.current = {
    allowToHideWhenUnfocused: (D) => {
      N(!D);
    }
  });
  const y = d && !h ? Iu : Eu;
  return /* @__PURE__ */ v(_i, { className: "flex items-center", children: ({ open: D, close: I }) => {
    const P = c && k || D;
    return /* @__PURE__ */ _(Ue, { children: [
      /* @__PURE__ */ v(
        Fi,
        {
          disabled: w,
          as: Qi,
          className: A(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            g && "border-danger rounded-xl border-2 p-0.5",
            t
          ),
          children: (s == null ? void 0 : s(P)) ?? /* @__PURE__ */ v(
            "div",
            {
              style: { backgroundColor: a },
              className: A(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                e
              )
            }
          )
        }
      ),
      /* @__PURE__ */ v(
        xa,
        {
          as: ut,
          show: P,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ v(
            Ki,
            {
              ref: M,
              anchor: b,
              className: A(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                h ? "pt-4" : "pt-5",
                n
              ),
              children: /* @__PURE__ */ v(uu, { features: l, children: /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    r
                  ),
                  children: /* @__PURE__ */ _(
                    "div",
                    {
                      className: A(
                        "flex flex-col gap-3",
                        h && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        o
                      ),
                      children: [
                        /* @__PURE__ */ v(y, { color: a, ...T }),
                        !h && /* @__PURE__ */ _("div", { className: "flex", children: [
                          /* @__PURE__ */ v("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ v(
                            Bu,
                            {
                              alpha: !0,
                              className: A(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                i
                              ),
                              color: a,
                              onChange: T.onChange
                            }
                          )
                        ] }),
                        u == null ? void 0 : u(I),
                        /* @__PURE__ */ v(
                          Sa,
                          {
                            errorClassName: "text-left",
                            error: g,
                            description: S
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
}, Tr = (a, r) => ({
  ...a ? {
    "data-test-id": `${r}`
  } : {}
});
var be = /* @__PURE__ */ ((a) => (a.Stripe = "stripe", a.PaypalSoap = "paypal-soap", a.Dlocal = "dlocal", a.MercadoPagoBR = "mercadopago-br", a.MercadoPagoCO = "mercadopago-co", a.MercadoPagoMX = "mercadopago-mx", a.MercadoPagoAR = "mercadopago-ar", a.MercadoPagoCL = "mercadopago-cl", a.Razorpay = "razorpay", a.Flutterwave = "flutterwave", a.Mollie = "mollie", a.Gocardless = "gocardless", a.XenditID = "xendit-id", a.XenditPH = "xendit-ph", a.PaystackGH = "paystack-gh", a.PaystackKE = "paystack-ke", a.PaystackNG = "paystack-ng", a.PaystackZA = "paystack-za", a.PaystackEG = "paystack-eg", a.PaystackCI = "paystack-ci", a.CashOnDelivery = "cash-on-delivery", a.PaypalRest = "paypal-rest", a.SecureAndPay = "secure-and-pay", a))(be || {});
const qm = (a) => {
  switch (a) {
    case be.Stripe:
      return "Stripe";
    case be.PaypalSoap:
    case be.PaypalRest:
      return "PayPal";
    case be.Dlocal:
      return "dLocal";
    case be.MercadoPagoBR:
    case be.MercadoPagoCO:
    case be.MercadoPagoMX:
    case be.MercadoPagoAR:
    case be.MercadoPagoCL:
      return "Mercado Pago";
    case be.Razorpay:
      return "Razorpay";
    case be.Flutterwave:
      return "Flutterwave";
    case be.Mollie:
      return "Mollie";
    case be.Gocardless:
      return "GoCardless";
    case be.XenditID:
    case be.XenditPH:
      return "Xendit";
    case be.PaystackGH:
    case be.PaystackKE:
    case be.PaystackNG:
    case be.PaystackZA:
    case be.PaystackEG:
    case be.PaystackCI:
      return "Paystack";
    case be.CashOnDelivery:
      return W.t("public_pages_purchase.payment.cash_on_delivery");
    case be.SecureAndPay:
      return "Secure and Pay";
  }
};
var wr = /* @__PURE__ */ ((a) => (a.dateFirst = "d/m/Y", a.monthFirst = "m/d/Y", a))(wr || {}), Hu = /* @__PURE__ */ ((a) => (a.hourMinute = "H:i", a.hourMinuteAmPm = "h:i A", a.hourMinuteSecond = "H:i:s", a.hourMinuteSecondAmPm = "h:i:s A", a))(Hu || {}), Da = /* @__PURE__ */ ((a) => (a.ENGLISH = "en", a.FRENCH = "fr", a.SPANISH = "es", a.ITALIAN = "it", a.PORTUGUESE = "pt", a.DEUTSCH = "de", a.DUTCH = "nl", a.RUSSIAN = "ru", a.JAPANESE = "jp", a.ARABIC = "ar", a.TURKISH = "tr", a.CHINESE = "zh", a.SWEDISH = "sv", a.ROMANIAN = "ro", a.CZECH = "cs", a.HUNGARIAN = "hu", a.SLOVAK = "sk", a.DANISH = "dk", a.INDONESIAN = "id", a.POLISH = "pl", a.GREEK = "el", a.SERBIAN = "sr", a.NORWEGIAN = "no", a.THAI = "th", a.SLOVENIAN = "sl", a.UKRAINIAN = "ua", a.ALBANIA = "sq", a.HINDI = "hi", a))(Da || {});
const Xm = {
  en: "EN",
  fr: "FR",
  es: "ES",
  it: "IT",
  pt: "PT",
  de: "DE",
  nl: "NL",
  ru: "RU",
  jp: "JP",
  ar: "AR",
  tr: "TR",
  zh: "CH",
  sv: "SV",
  ro: "RO",
  cs: "CS",
  hu: "HU",
  sk: "SK",
  dk: "DK",
  id: "ID",
  pl: "PL",
  el: "EL",
  sr: "SR",
  hi: "HI",
  no: "NO",
  th: "TH",
  sl: "SL",
  ua: "UA",
  sq: "SQ"
}, $m = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  de: "Deutsch",
  nl: "Nederlands",
  ru: "Русский",
  jp: "日本語",
  ar: "عربي",
  tr: "Türkçe",
  zh: "中文(简体)",
  sv: "Svenska",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sk: "Slovenský",
  dk: "Dansk",
  id: "Indonesian",
  pl: "Polski",
  el: "Ελληνικά",
  sr: "Srpski",
  hi: "Hindi",
  no: "Norsk",
  th: "ไทย",
  sl: "Slovenski",
  ua: "Український",
  sq: "Shqiptare"
}, Uu = {
  en: "public_pages_purchase.locale.english",
  fr: "public_pages_purchase.locale.french",
  es: "public_pages_purchase.locale.spanish",
  it: "public_pages_purchase.locale.italian",
  pt: "public_pages_purchase.locale.portuguese",
  de: "public_pages_purchase.locale.german",
  nl: "public_pages_purchase.locale.dutch",
  ru: "public_pages_purchase.locale.russian",
  jp: "public_pages_purchase.locale.japanese",
  zh: "public_pages_purchase.locale.chinese",
  tr: "public_pages_purchase.locale.turkish",
  ar: "public_pages_purchase.locale.arabic",
  sv: "public_pages_purchase.locale.swedish",
  ro: "public_pages_purchase.locale.romanian",
  cs: "public_pages_purchase.locale.czech",
  hu: "public_pages_purchase.locale.hungarian",
  sk: "public_pages_purchase.locale.slovak",
  dk: "public_pages_purchase.locale.danish",
  id: "public_pages_purchase.locale.indonesian",
  pl: "public_pages_purchase.locale.polish",
  el: "public_pages_purchase.locale.greek",
  sr: "public_pages_purchase.locale.serbian",
  hi: "public_pages_purchase.locale.hindi",
  no: "public_pages_purchase.locale.norwegian",
  th: "public_pages_purchase.locale.thai",
  sl: "public_pages_purchase.locale.slovenian",
  ua: "public_pages_purchase.locale.ukrainian",
  sq: "public_pages_purchase.locale.albania"
};
function qi(a) {
  const r = Object.keys(Da).find(
    (n) => Da[n] === a
  );
  return r ? ie[r] : ie.ENGLISH;
}
function eg(a) {
  const r = Object.keys(ie).find(
    (n) => ie[n] === a
  );
  return r ? Da[r] : Da.ENGLISH;
}
function ag(a) {
  return W.t(Uu[a]);
}
const Yu = mu(null), tg = ({
  children: a,
  locale: r
}) => (Ne(() => {
  if (!W.isInitialized) return;
  const n = qi(r);
  W.language !== n && W.changeLanguage(n);
}, [r]), /* @__PURE__ */ v(Yu.Provider, { value: { locale: r }, children: a }));
var zr = /* @__PURE__ */ ((a) => (a.Afghanistan = "AF", a.AlandIslands = "AX", a.Albania = "AL", a.Algeria = "DZ", a.AmericanSamoa = "AS", a.Andorra = "AD", a.Angola = "AO", a.Anguilla = "AI", a.Antarctica = "AQ", a.AntiguaAndBarbuda = "AG", a.Argentina = "AR", a.Armenia = "AM", a.Aruba = "AW", a.Australia = "AU", a.Austria = "AT", a.Azerbaijan = "AZ", a.Bahamas = "BS", a.Bahrain = "BH", a.Bangladesh = "BD", a.Barbados = "BB", a.Belarus = "BY", a.Belgium = "BE", a.Belize = "BZ", a.Benin = "BJ", a.Bermuda = "BM", a.Bhutan = "BT", a.Bolivia = "BO", a.BonaireSintEustatiusSaba = "BQ", a.BosniaAndHerzegovina = "BA", a.Botswana = "BW", a.BouvetIsland = "BV", a.Brazil = "BR", a.BritishIndianOceanTerritory = "IO", a.BruneiDarussalam = "BN", a.Bulgaria = "BG", a.BurkinaFaso = "BF", a.Burundi = "BI", a.Cambodia = "KH", a.Cameroon = "CM", a.Canada = "CA", a.CapeVerde = "CV", a.CaymanIslands = "KY", a.CentralAfricanRepublic = "CF", a.Chad = "TD", a.Chile = "CL", a.China = "CN", a.ChristmasIsland = "CX", a.CocosKeelingIslands = "CC", a.Colombia = "CO", a.Comoros = "KM", a.Congo = "CG", a.CongoDemocraticRepublic = "CD", a.CookIslands = "CK", a.CostaRica = "CR", a.CoteDIvoire = "CI", a.Croatia = "HR", a.Cuba = "CU", a.Curaçao = "CW", a.Cyprus = "CY", a.CzechRepublic = "CZ", a.Denmark = "DK", a.Djibouti = "DJ", a.Dominica = "DM", a.DominicanRepublic = "DO", a.Ecuador = "EC", a.Egypt = "EG", a.ElSalvador = "SV", a.EquatorialGuinea = "GQ", a.Eritrea = "ER", a.Estonia = "EE", a.Ethiopia = "ET", a.FalklandIslands = "FK", a.FaroeIslands = "FO", a.Fiji = "FJ", a.Finland = "FI", a.France = "FR", a.FrenchGuiana = "GF", a.FrenchPolynesia = "PF", a.FrenchSouthernTerritories = "TF", a.Gabon = "GA", a.Gambia = "GM", a.Georgia = "GE", a.Germany = "DE", a.Ghana = "GH", a.Gibraltar = "GI", a.Greece = "GR", a.Greenland = "GL", a.Grenada = "GD", a.Guadeloupe = "GP", a.Guam = "GU", a.Guatemala = "GT", a.Guernsey = "GG", a.Guinea = "GN", a.GuineaBissau = "GW", a.Guyana = "GY", a.Haiti = "HT", a.HeardIslandMcdonaldIslands = "HM", a.HolySeeVaticanCityState = "VA", a.Honduras = "HN", a.HongKong = "HK", a.Hungary = "HU", a.Iceland = "IS", a.India = "IN", a.Indonesia = "ID", a.Iran = "IR", a.Iraq = "IQ", a.Ireland = "IE", a.IsleOfMan = "IM", a.Israel = "IL", a.Italy = "IT", a.Jamaica = "JM", a.Japan = "JP", a.Jersey = "JE", a.Jordan = "JO", a.Kazakhstan = "KZ", a.Kenya = "KE", a.Kiribati = "KI", a.Korea = "KR", a.KoreaDemocraticPeoplesRepublic = "KP", a.Kuwait = "KW", a.Kyrgyzstan = "KG", a.LaoPeoplesDemocraticRepublic = "LA", a.Latvia = "LV", a.Lebanon = "LB", a.Lesotho = "LS", a.Liberia = "LR", a.LibyanArabJamahiriya = "LY", a.Liechtenstein = "LI", a.Lithuania = "LT", a.Luxembourg = "LU", a.Macao = "MO", a.Macedonia = "MK", a.Madagascar = "MG", a.Malawi = "MW", a.Malaysia = "MY", a.Maldives = "MV", a.Mali = "ML", a.Malta = "MT", a.MarshallIslands = "MH", a.Martinique = "MQ", a.Mauritania = "MR", a.Mauritius = "MU", a.Mayotte = "YT", a.Mexico = "MX", a.Micronesia = "FM", a.Moldova = "MD", a.Monaco = "MC", a.Mongolia = "MN", a.Montenegro = "ME", a.Montserrat = "MS", a.Morocco = "MA", a.Mozambique = "MZ", a.Myanmar = "MM", a.Namibia = "NA", a.Nauru = "NR", a.Nepal = "NP", a.Netherlands = "NL", a.NewCaledonia = "NC", a.NewZealand = "NZ", a.Nicaragua = "NI", a.Niger = "NE", a.Nigeria = "NG", a.Niue = "NU", a.NorfolkIsland = "NF", a.NorthernMarianaIslands = "MP", a.Norway = "NO", a.Oman = "OM", a.Pakistan = "PK", a.Palau = "PW", a.PalestinianTerritory = "PS", a.Panama = "PA", a.PapuaNewGuinea = "PG", a.Paraguay = "PY", a.Peru = "PE", a.Philippines = "PH", a.Pitcairn = "PN", a.Poland = "PL", a.Portugal = "PT", a.PuertoRico = "PR", a.Qatar = "QA", a.Reunion = "RE", a.Romania = "RO", a.RussianFederation = "RU", a.Rwanda = "RW", a.SaintBarthelemy = "BL", a.SaintHelena = "SH", a.SaintKittsAndNevis = "KN", a.SaintLucia = "LC", a.SaintMartin = "MF", a.SaintPierreAndMiquelon = "PM", a.SaintVincentAndGrenadines = "VC", a.Samoa = "WS", a.SanMarino = "SM", a.SaoTomeAndPrincipe = "ST", a.SaudiArabia = "SA", a.Senegal = "SN", a.Serbia = "RS", a.Seychelles = "SC", a.SierraLeone = "SL", a.Singapore = "SG", a.SintMaarten = "SX", a.Slovakia = "SK", a.Slovenia = "SI", a.SolomonIslands = "SB", a.Somalia = "SO", a.SouthAfrica = "ZA", a.SouthGeorgiaAndSandwichIsl = "GS", a.SouthSudan = "SS", a.Spain = "ES", a.SriLanka = "LK", a.Sudan = "SD", a.Suriname = "SR", a.SvalbardAndJanMayen = "SJ", a.Swaziland = "SZ", a.Sweden = "SE", a.Switzerland = "CH", a.SyrianArabRepublic = "SY", a.Taiwan = "TW", a.Tajikistan = "TJ", a.Tanzania = "TZ", a.Thailand = "TH", a.TimorLeste = "TL", a.Togo = "TG", a.Tokelau = "TK", a.Tonga = "TO", a.TrinidadAndTobago = "TT", a.Tunisia = "TN", a.Turkey = "TR", a.Turkmenistan = "TM", a.TurksAndCaicosIslands = "TC", a.Tuvalu = "TV", a.Uganda = "UG", a.Ukraine = "UA", a.UnitedArabEmirates = "AE", a.UnitedKingdom = "GB", a.UnitedStates = "US", a.UnitedStatesOutlyingIslands = "UM", a.Uruguay = "UY", a.Uzbekistan = "UZ", a.Vanuatu = "VU", a.Venezuela = "VE", a.Vietnam = "VN", a.VirginIslandsBritish = "VG", a.VirginIslandsUS = "VI", a.WallisAndFutuna = "WF", a.WesternSahara = "EH", a.Yemen = "YE", a.Zambia = "ZM", a.Zimbabwe = "ZW", a))(zr || {}), ir = {};
const Wu = /* @__PURE__ */ JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKK","983","ISO 3166-2:XK"]]'), Vu = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var at = {}, In;
function ju() {
  if (In) return at;
  In = 1, at.remove = i;
  for (var a = [
    {
      base: " ",
      chars: " "
    },
    {
      base: "0",
      chars: "߀"
    },
    {
      base: "A",
      chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
    },
    {
      base: "AA",
      chars: "Ꜳ"
    },
    {
      base: "AE",
      chars: "ÆǼǢ"
    },
    {
      base: "AO",
      chars: "Ꜵ"
    },
    {
      base: "AU",
      chars: "Ꜷ"
    },
    {
      base: "AV",
      chars: "ꜸꜺ"
    },
    {
      base: "AY",
      chars: "Ꜽ"
    },
    {
      base: "B",
      chars: "ⒷＢḂḄḆɃƁ"
    },
    {
      base: "C",
      chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
    },
    {
      base: "D",
      chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
    },
    {
      base: "Dh",
      chars: "Ð"
    },
    {
      base: "DZ",
      chars: "ǱǄ"
    },
    {
      base: "Dz",
      chars: "ǲǅ"
    },
    {
      base: "E",
      chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
    },
    {
      base: "F",
      chars: "ꝼⒻＦḞƑꝻ"
    },
    {
      base: "G",
      chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
    },
    {
      base: "H",
      chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    },
    {
      base: "I",
      chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
    },
    {
      base: "J",
      chars: "ⒿＪĴɈȷ"
    },
    {
      base: "K",
      chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    },
    {
      base: "L",
      chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    },
    {
      base: "LJ",
      chars: "Ǉ"
    },
    {
      base: "Lj",
      chars: "ǈ"
    },
    {
      base: "M",
      chars: "ⓂＭḾṀṂⱮƜϻ"
    },
    {
      base: "N",
      chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
    },
    {
      base: "NJ",
      chars: "Ǌ"
    },
    {
      base: "Nj",
      chars: "ǋ"
    },
    {
      base: "O",
      chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
    },
    {
      base: "OE",
      chars: "Œ"
    },
    {
      base: "OI",
      chars: "Ƣ"
    },
    {
      base: "OO",
      chars: "Ꝏ"
    },
    {
      base: "OU",
      chars: "Ȣ"
    },
    {
      base: "P",
      chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
    },
    {
      base: "Q",
      chars: "ⓆＱꝖꝘɊ"
    },
    {
      base: "R",
      chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    },
    {
      base: "S",
      chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    },
    {
      base: "T",
      chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    },
    {
      base: "Th",
      chars: "Þ"
    },
    {
      base: "TZ",
      chars: "Ꜩ"
    },
    {
      base: "U",
      chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    },
    {
      base: "V",
      chars: "ⓋＶṼṾƲꝞɅ"
    },
    {
      base: "VY",
      chars: "Ꝡ"
    },
    {
      base: "W",
      chars: "ⓌＷẀẂŴẆẄẈⱲ"
    },
    {
      base: "X",
      chars: "ⓍＸẊẌ"
    },
    {
      base: "Y",
      chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
    },
    {
      base: "Z",
      chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    },
    {
      base: "a",
      chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
    },
    {
      base: "aa",
      chars: "ꜳ"
    },
    {
      base: "ae",
      chars: "æǽǣ"
    },
    {
      base: "ao",
      chars: "ꜵ"
    },
    {
      base: "au",
      chars: "ꜷ"
    },
    {
      base: "av",
      chars: "ꜹꜻ"
    },
    {
      base: "ay",
      chars: "ꜽ"
    },
    {
      base: "b",
      chars: "ⓑｂḃḅḇƀƃɓƂ"
    },
    {
      base: "c",
      chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
    },
    {
      base: "d",
      chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
    },
    {
      base: "dh",
      chars: "ð"
    },
    {
      base: "dz",
      chars: "ǳǆ"
    },
    {
      base: "e",
      chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
    },
    {
      base: "f",
      chars: "ⓕｆḟƒ"
    },
    {
      base: "ff",
      chars: "ﬀ"
    },
    {
      base: "fi",
      chars: "ﬁ"
    },
    {
      base: "fl",
      chars: "ﬂ"
    },
    {
      base: "ffi",
      chars: "ﬃ"
    },
    {
      base: "ffl",
      chars: "ﬄ"
    },
    {
      base: "g",
      chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
    },
    {
      base: "h",
      chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    },
    {
      base: "hv",
      chars: "ƕ"
    },
    {
      base: "i",
      chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
    },
    {
      base: "j",
      chars: "ⓙｊĵǰɉ"
    },
    {
      base: "k",
      chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    },
    {
      base: "l",
      chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
    },
    {
      base: "lj",
      chars: "ǉ"
    },
    {
      base: "m",
      chars: "ⓜｍḿṁṃɱɯ"
    },
    {
      base: "n",
      chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
    },
    {
      base: "nj",
      chars: "ǌ"
    },
    {
      base: "o",
      chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
    },
    {
      base: "oe",
      chars: "œ"
    },
    {
      base: "oi",
      chars: "ƣ"
    },
    {
      base: "oo",
      chars: "ꝏ"
    },
    {
      base: "ou",
      chars: "ȣ"
    },
    {
      base: "p",
      chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
    },
    {
      base: "q",
      chars: "ⓠｑɋꝗꝙ"
    },
    {
      base: "r",
      chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    },
    {
      base: "s",
      chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
    },
    {
      base: "ss",
      chars: "ß"
    },
    {
      base: "t",
      chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    },
    {
      base: "th",
      chars: "þ"
    },
    {
      base: "tz",
      chars: "ꜩ"
    },
    {
      base: "u",
      chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    },
    {
      base: "v",
      chars: "ⓥｖṽṿʋꝟʌ"
    },
    {
      base: "vy",
      chars: "ꝡ"
    },
    {
      base: "w",
      chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
    },
    {
      base: "x",
      chars: "ⓧｘẋẍ"
    },
    {
      base: "y",
      chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
    },
    {
      base: "z",
      chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }
  ], r = {}, n = 0; n < a.length; n += 1)
    for (var t = a[n].chars, e = 0; e < t.length; e += 1)
      r[t[e]] = a[n].base;
  function i(o) {
    return o.replace(/[^\u0000-\u007e]/g, function(s) {
      return r[s] || s;
    });
  }
  return at.replacementList = a, at.diacriticsMap = r, at;
}
var En;
function Zu() {
  return En || (En = 1, (function(a) {
    const r = Wu, n = Vu, t = ju().remove, e = {}, i = {}, o = {}, s = {}, u = {};
    r.forEach(function(M) {
      const y = M;
      i[y[0]] = y[1], o[y[1]] = y[0], s[y[2]] = y[0], u[y[0]] = y[2];
    });
    function l(M) {
      return ("000" + (M || "")).slice(-3);
    }
    function c(M, y) {
      return Object.prototype.hasOwnProperty.call(M, y);
    }
    function d(M, y) {
      return Object.keys(M).reduce(function(D, I) {
        const P = M[I];
        return D[I] = y(P, I), D;
      }, {});
    }
    function h(M, y) {
      switch (M) {
        case "official":
          return Array.isArray(y) ? y[0] : y;
        case "all":
          return typeof y == "string" ? [y] : y;
        case "alias":
          return Array.isArray(y) ? y[1] || y[0] : y;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    a.registerLocale = function(M) {
      if (!M.locale)
        throw new TypeError("Missing localeData.locale");
      if (!M.countries)
        throw new TypeError("Missing localeData.countries");
      e[M.locale] = M.countries;
    };
    function p(M) {
      return o[M];
    }
    a.alpha3ToAlpha2 = p;
    function g(M) {
      return i[M];
    }
    a.alpha2ToAlpha3 = g;
    function S(M) {
      return u[p(M)];
    }
    a.alpha3ToNumeric = S;
    function b(M) {
      return u[M];
    }
    a.alpha2ToNumeric = b;
    function w(M) {
      const y = l(M);
      return g(s[y]);
    }
    a.numericToAlpha3 = w;
    function T(M) {
      const y = l(M);
      return s[y];
    }
    a.numericToAlpha2 = T;
    function k(M) {
      if (typeof M == "string") {
        if (/^[0-9]*$/.test(M))
          return w(M);
        if (M.length === 2)
          return g(M.toUpperCase());
        if (M.length === 3)
          return M.toUpperCase();
      }
      if (typeof M == "number")
        return w(M);
    }
    a.toAlpha3 = k;
    function N(M) {
      if (typeof M == "string") {
        if (/^[0-9]*$/.test(M))
          return T(M);
        if (M.length === 2)
          return M.toUpperCase();
        if (M.length === 3)
          return p(M.toUpperCase());
      }
      if (typeof M == "number")
        return T(M);
    }
    a.toAlpha2 = N, a.getName = function(M, y, D = {}) {
      "select" in D || (D.select = "official");
      try {
        const P = e[y.toLowerCase()][N(M)];
        return h(D.select, P);
      } catch {
        return;
      }
    }, a.getNames = function(M, y = {}) {
      "select" in y || (y.select = "official");
      const D = e[M.toLowerCase()];
      return D === void 0 ? {} : d(D, function(I) {
        return h(y.select, I);
      });
    }, a.getAlpha2Code = function(M, y) {
      const D = (P) => P.toLowerCase(), I = (P, B) => D(P) === D(B);
      try {
        const P = e[y.toLowerCase()];
        for (const B in P)
          if (c(P, B)) {
            if (typeof P[B] == "string" && I(P[B], M))
              return B;
            if (Array.isArray(P[B])) {
              for (const K of P[B])
                if (I(K, M))
                  return B;
            }
          }
        return;
      } catch {
        return;
      }
    }, a.getSimpleAlpha2Code = function(M, y) {
      const D = (P) => t(P.toLowerCase()), I = (P, B) => D(P) === D(B);
      try {
        const P = e[y.toLowerCase()];
        for (const B in P)
          if (c(P, B)) {
            if (typeof P[B] == "string" && I(P[B], M))
              return B;
            if (Array.isArray(P[B])) {
              for (const K of P[B])
                if (I(K, M))
                  return B;
            }
          }
        return;
      } catch {
        return;
      }
    }, a.getAlpha2Codes = function() {
      return i;
    }, a.getAlpha3Code = function(M, y) {
      const D = a.getAlpha2Code(M, y);
      if (D)
        return a.toAlpha3(D);
    }, a.getSimpleAlpha3Code = function(M, y) {
      const D = a.getSimpleAlpha2Code(M, y);
      if (D)
        return a.toAlpha3(D);
    }, a.getAlpha3Codes = function() {
      return o;
    }, a.getNumericCodes = function() {
      return s;
    }, a.langs = function() {
      return Object.keys(e);
    }, a.getSupportedLanguages = function() {
      return n;
    }, a.isValid = function(M) {
      if (!M)
        return !1;
      const y = M.toString().toUpperCase();
      return c(o, y) || c(i, y) || c(s, y);
    };
  })(ir)), ir;
}
var zu = Zu();
const Ar = /* @__PURE__ */ Zt(zu), Xi = "ar", $i = { AF: "أفغانستان", AL: "ألبانيا", DZ: "الجزائر", AS: "ساموا الأمريكية", AD: "أندورا", AO: "أنغولا", AI: "أنغويلا", AQ: "القارة القطبية الجنوبية", AG: "أنتيغوا وباربودا", AR: "الأرجنتين", AM: "أرمينيا", AW: "أروبا", AU: "أستراليا", AT: "النمسا", AZ: "أذربيجان", BS: "باهاماس", BH: "البحرين", BD: "بنغلاديش", BB: "باربادوس", BY: "روسيا البيضاء", BE: "بلجيكا", BZ: "بليز", BJ: "بنين", BM: "برمودا", BT: "بوتان", BO: "بوليفيا", BA: "البوسنة والهرسك", BW: "بوتسوانا", BV: "جزيرة بوفيه", BR: "البرازيل", IO: "إقليم المحيط الهندي البريطاني", BN: "بروناي", BG: "بلغاريا", BF: "بوركينا فاسو", BI: "بوروندي", KH: "كمبوديا", CM: "الكاميرون", CA: "كندا", CV: "الرأس الأخضر", KY: "جزر كايمان", CF: "جمهورية أفريقيا الوسطى", TD: "تشاد", CL: "تشيلي", CN: "الصين", CX: "جزيرة عيد الميلاد", CC: "جزر كوكوس", CO: "كولومبيا", KM: "جزر القمر", CG: "جمهورية الكونغو", CD: "جمهورية الكونغو الديمقراطية", CK: "جزر كوك", CR: "كوستاريكا", CI: "ساحل العاج", HR: "كرواتيا", CU: "كوبا", CY: "قبرص", CZ: "جمهورية التشيك", DK: "الدنمارك", DJ: "جيبوتي", DM: "دومينيكا", DO: "جمهورية الدومينيكان", EC: "الإكوادور", EG: "مصر", SV: "السلفادور", GQ: "غينيا الاستوائية", ER: "إريتريا", EE: "إستونيا", ET: "إثيوبيا", FK: "جزر فوكلاند", FO: "جزر فارو", FJ: "فيجي", FI: "فنلندا", FR: "فرنسا", GF: "غويانا الفرنسية", PF: "بولينزيا الفرنسية", TF: "أراض فرنسية جنوبية وأنتارتيكية", GA: "الغابون", GM: "غامبيا", GE: "جورجيا", DE: "ألمانيا", GH: "غانا", GI: "جبل طارق", GR: "اليونان", GL: "جرينلاند", GD: "غرينادا", GP: "غوادلوب", GU: "غوام", GT: "غواتيمالا", GN: "غينيا", GW: "غينيا بيساو", GY: "غيانا", HT: "هايتي", HM: "جزيرة هيرد وجزر ماكدونالد", VA: "الفاتيكان", HN: "هندوراس", HK: "هونغ كونغ", HU: "المجر", IS: "آيسلندا", IN: "الهند", ID: "إندونيسيا", IR: "إيران", IQ: "العراق", IE: "أيرلندا", IL: "إسرائيل", IT: "إيطاليا", JM: "جامايكا", JP: "اليابان", JO: "الأردن", KZ: "كازاخستان", KE: "كينيا", KI: "كيريباتي", KP: "كوريا الشمالية", KR: "كوريا الجنوبية", KW: "الكويت", KG: "قيرغيزستان", LA: "لاوس", LV: "لاتفيا", LB: "لبنان", LS: "ليسوتو", LR: "ليبيريا", LY: "ليبيا", LI: "ليختنشتاين", LT: "ليتوانيا", LU: "لوكسمبورغ", MO: "ماكاو", MK: "مقدونيا الشمالية", MG: "مدغشقر", MW: "مالاوي", MY: "ماليزيا", MV: "جزر المالديف", ML: "مالي", MT: "مالطا", MH: "جزر مارشال", MQ: "مارتينيك", MR: "موريتانيا", MU: "موريشيوس", YT: "مايوت", MX: "المكسيك", FM: "ولايات ميكرونيسيا المتحدة", MD: "مولدوفا", MC: "موناكو", MN: "منغوليا", MS: "مونتسرات", MA: "المغرب", MZ: "موزمبيق", MM: "بورما", NA: "ناميبيا", NR: "ناورو", NP: "نيبال", NL: "هولندا", NC: "كاليدونيا الجديدة", NZ: "نيوزيلندا", NI: "نيكاراغوا", NE: "النيجر", NG: "نيجيريا", NU: "نييوي", NF: "جزيرة نورفولك", MP: "جزر ماريانا الشمالية", NO: "النرويج", OM: "عمان", PK: "باكستان", PW: "بالاو", PS: "فلسطين", PA: "بنما", PG: "بابوا غينيا الجديدة", PY: "باراغواي", PE: "بيرو", PH: "الفلبين", PN: "جزر بيتكيرن", PL: "بولندا", PT: "البرتغال", PR: "بورتوريكو", QA: "قطر", RE: "لا ريونيون", RO: "رومانيا", RU: "روسيا", RW: "رواندا", SH: "سانت هيلينا وأسينشين وتريستان دا كونا", KN: "سانت كيتس ونيفيس", LC: "سانت لوسيا", PM: "سان بيير وميكلون", VC: "سانت فينسنت والغرينادين", WS: "ساموا", SM: "سان مارينو", ST: "ساو تومي وبرينسيب", SA: "السعودية", SN: "السنغال", SC: "سيشل", SL: "سيراليون", SG: "سنغافورة", SK: "سلوفاكيا", SI: "سلوفينيا", SB: "جزر سليمان", SO: "الصومال", ZA: "جنوب أفريقيا", GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية", ES: "إسبانيا", LK: "سريلانكا", SD: "السودان", SR: "سورينام", SJ: "سفالبارد ويان ماين", SZ: "سوازيلاند", SE: "السويد", CH: "سويسرا", SY: "سوريا", TW: "تايوان", TJ: "طاجيكستان", TZ: "تانزانيا", TH: "تايلاند", TL: "تيمور الشرقية", TG: "توغو", TK: "توكيلاو", TO: "تونغا", TT: "ترينيداد وتوباغو", TN: "تونس", TR: "تركيا", TM: "تركمانستان", TC: "جزر توركس وكايكوس", TV: "توفالو", UG: "أوغندا", UA: "أوكرانيا", AE: "الإمارات العربية المتحدة", GB: "المملكة المتحدة", US: "الولايات المتحدة", UM: "جزر الولايات المتحدة", UY: "الأوروغواي", UZ: "أوزبكستان", VU: "فانواتو", VE: "فنزويلا", VN: "فيتنام", VG: "جزر العذراء البريطانية", VI: "جزر العذراء الأمريكية", WF: "والس وفوتونا", EH: "الصحراء الغربية", YE: "اليمن", ZM: "زامبيا", ZW: "زيمبابوي", AX: "جزر أولاند", BQ: "الجزر الكاريبية الهولندية", CW: "كوراساو", GG: "غيرنزي", IM: "جزيرة مان", JE: "جيرزي", ME: "الجبل الأسود", BL: "سان بارتيلمي", MF: "سانت مارتن (الجزء الفرنسي)", RS: "صربيا", SX: "سانت مارتن (الجزء الهولندي)", SS: "جنوب السودان", XK: "كوسوفو" }, Ju = {
  locale: Xi,
  countries: $i
}, Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: $i,
  default: Ju,
  locale: Xi
}, Symbol.toStringTag, { value: "Module" })), eo = "cs", ao = { AF: "Afghánistán", AX: "Ålandy", AL: "Albánie", DZ: "Alžírsko", AS: "Americká Samoa", VI: "Americké Panenské ostrovy", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktida", AG: "Antigua a Barbuda", AR: "Argentina", AM: "Arménie", AW: "Aruba", AU: "Austrálie", AZ: "Ázerbájdžán", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladéš", BB: "Barbados", BE: "Belgie", BZ: "Belize", BY: "Bělorusko", BJ: "Benin", BM: "Bermudy", BT: "Bhútán", BO: "Bolívie", BQ: "Bonaire, Svatý Eustach a Saba", BA: "Bosna a Hercegovina", BW: "Botswana", BV: "Bouvetův ostrov", BR: "Brazílie", IO: "Britské indickooceánské území", VG: "Britské Panenské ostrovy", BN: "Brunej", BG: "Bulharsko", BF: "Burkina Faso", BI: "Burundi", CK: "Cookovy ostrovy", CW: "Curaçao", TD: "Čad", ME: "Černá Hora", CZ: "Česká republika", CN: "Čína", DK: "Dánsko", CD: "Demokratická republika Kongo", DM: "Dominika", DO: "Dominikánská republika", DJ: "Džibutsko", EG: "Egypt", EC: "Ekvádor", ER: "Eritrea", EE: "Estonsko", ET: "Etiopie", FO: "Faerské ostrovy", FK: "Falklandy (Malvíny)", FJ: "Fidži", PH: "Filipíny", FI: "Finsko", FR: "Francie", GF: "Francouzská Guyana", TF: "Francouzská jižní a antarktická území", PF: "Francouzská Polynésie", GA: "Gabon", GM: "Gambie", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GL: "Grónsko", GE: "Gruzie", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GG: "Guernsey", GY: "Guyana", HT: "Haiti", HM: "Heardův ostrov a McDonaldovy ostrovy", HN: "Honduras", HK: "Hongkong", CL: "Chile", HR: "Chorvatsko", IN: "Indie", ID: "Indonésie", IQ: "Irák", IR: "Írán", IE: "Irsko", IS: "Island", IT: "Itálie", IL: "Izrael", JM: "Jamajka", JP: "Japonsko", YE: "Jemen", JE: "Jersey", ZA: "Jihoafrická republika", GS: "Jižní Georgie a Jižní Sandwichovy ostrovy", KR: "Jižní Korea", SS: "Jižní Súdán", JO: "Jordánsko", KY: "Kajmanské ostrovy", KH: "Kambodža", CM: "Kamerun", CA: "Kanada", CV: "Kapverdy", QA: "Katar", KZ: "Kazachstán", KE: "Keňa", KI: "Kiribati", CC: "Kokosové ostrovy", CO: "Kolumbie", KM: "Komory", CG: "Kongo", CR: "Kostarika", CU: "Kuba", KW: "Kuvajt", CY: "Kypr", KG: "Kyrgyzstán", LA: "Laos", LS: "Lesotho", LB: "Libanon", LR: "Libérie", LY: "Libye", LI: "Lichtenštejnsko", LT: "Litva", LV: "Lotyšsko", LU: "Lucembursko", MO: "Macao", MG: "Madagaskar", HU: "Maďarsko", MY: "Malajsie", MW: "Malawi", MV: "Maledivy", ML: "Mali", MT: "Malta", IM: "Ostrov Man", MA: "Maroko", MH: "Marshallovy ostrovy", MQ: "Martinik", MU: "Mauricius", MR: "Mauritánie", YT: "Mayotte", UM: "Menší odlehlé ostrovy USA", MX: "Mexiko", FM: "Mikronésie", MD: "Moldavsko", MC: "Monako", MN: "Mongolsko", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibie", NR: "Nauru", DE: "Německo", NP: "Nepál", NE: "Niger", NG: "Nigérie", NI: "Nikaragua", NU: "Niue", NL: "Nizozemsko", NF: "Norfolk", NO: "Norsko", NC: "Nová Kaledonie", NZ: "Nový Zéland", OM: "Omán", PK: "Pákistán", PW: "Palau", PS: "Palestinská autonomie", PA: "Panama", PG: "Papua-Nová Guinea", PY: "Paraguay", PE: "Peru", PN: "Pitcairnovy ostrovy", CI: "Pobřeží slonoviny", PL: "Polsko", PR: "Portoriko", PT: "Portugalsko", AT: "Rakousko", RE: "Réunion", GQ: "Rovníková Guinea", RO: "Rumunsko", RU: "Rusko", RW: "Rwanda", GR: "Řecko", PM: "Saint-Pierre a Miquelon", SV: "Salvador", WS: "Samoa", SM: "San Marino", SA: "Saúdská Arábie", SN: "Senegal", KP: "Severní Korea", MK: "Severní Makedonie", MP: "Severní Mariany", SC: "Seychely", SL: "Sierra Leone", SG: "Singapur", SK: "Slovensko", SI: "Slovinsko", SO: "Somálsko", AE: "Spojené arabské emiráty", GB: "Spojené království", US: "Spojené státy americké", RS: "Srbsko", CF: "Středoafrická republika", SD: "Súdán", SR: "Surinam", SH: "Svatá Helena, Ascension a Tristan da Cunha", LC: "Svatá Lucie", BL: "Svatý Bartoloměj", KN: "Svatý Kryštof a Nevis", MF: "Svatý Martin (francouzská část)", SX: "Svatý Martin (nizozemská část)", ST: "Svatý Tomáš a Princův ostrov", VC: "Svatý Vincenc a Grenadiny", SZ: "Svazijsko", SY: "Sýrie", SB: "Šalamounovy ostrovy", ES: "Španělsko", SJ: "Špicberky a Jan Mayen", LK: "Šrí Lanka", SE: "Švédsko", CH: "Švýcarsko", TJ: "Tádžikistán", TZ: "Tanzanie", TH: "Thajsko", TW: "Tchaj-wan", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad a Tobago", TN: "Tunisko", TR: "Turecko", TM: "Turkmenistán", TC: "Turks a Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajina", UY: "Uruguay", UZ: "Uzbekistán", CX: "Vánoční ostrov", VU: "Vanuatu", VA: "Vatikán", VE: "Venezuela", VN: "Vietnam", TL: "Východní Timor", WF: "Wallis a Futuna", ZM: "Zambie", EH: "Západní Sahara", ZW: "Zimbabwe", XK: "Kosovo" }, qu = {
  locale: eo,
  countries: ao
}, Xu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ao,
  default: qu,
  locale: eo
}, Symbol.toStringTag, { value: "Module" })), to = "da", ro = { AF: "Afghanistan", AL: "Albanien", DZ: "Algeriet", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenien", AW: "Aruba", AU: "Australien", AT: "Østrig", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviderusland", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnien-Hercegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brasilien", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Cameroun", CA: "Canada", CV: "Kap Verde", KY: "Caymanøerne", CF: "Den Centralafrikanske Republik", TD: "Tchad", CL: "Chile", CN: "Kina", CX: "Juløen", CC: "Cocosøerne", CO: "Colombia", KM: "Comorerne", CG: "Congo", CD: "Demokratiske Republik Congo", CK: "Cookøerne", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatien", CU: "Cuba", CY: "Cypern", CZ: "Tjekkiet", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominikanske Republik", EC: "Ecuador", EG: "Egypten", SV: "El Salvador", GQ: "Ækvatorialguinea", ER: "Eritrea", EE: "Estland", ET: "Etiopien", FK: "Falklandsøerne", FO: "Færøerne", FJ: "Fiji", FI: "Finland", FR: "Frankrig", GF: "Fransk Guiana", PF: "Fransk Polynesien", TF: "Franske Sydterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgien", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Grækenland", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard-øen og McDonald-øerne", VA: "Vatikanstaten", HN: "Honduras", HK: "Hong Kong", HU: "Ungarn", IS: "Island", IN: "Indien", ID: "Indonesien", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italien", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxembourg", MO: "Macao", MK: "Nordmakedonien", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldiverne", ML: "Mali", MT: "Malta", MH: "Marshalløerne", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesien", MD: "Moldova", MC: "Monaco", MN: "Mongoliet", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holland", NC: "Ny Kaledonien", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MP: "Nordmarianerne", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palæstina", PA: "Panama", PG: "Papua Ny Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinerne", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Rumænien", RU: "Rusland", RW: "Rwanda", SH: "Sankt Helena", KN: "Saint Kitts og Nevis", LC: "Saint Lucia", PM: "Saint-Pierre og Miquelon", VC: "Saint Vincent og Grenadinerne", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabien", SN: "Senegal", SC: "Seychellerne", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakiet", SI: "Slovenien", SB: "Salomonøerne", SO: "Somalia", ZA: "Sydafrika", GS: "South Georgia og South Sandwich Islands", ES: "Spanien", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Norge Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Schweiz", SY: "Syrien", TW: "Republikken Kina Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Østtimor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunesien", TR: "Tyrkiet", TM: "Turkmenistan", TC: "Turks- og Caicosøerne", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: "Forenede Arabiske Emirater", GB: "Storbritannien", US: "USA", UM: "USA's ydre småøer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Britiske Jomfruøer", VI: "Amerikanske Jomfruøer", WF: "Wallis og Futuna", EH: "Vestsahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Ålandsøerne", BQ: "Nederlandske Antiller", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint Martin (fransk side)", RS: "Serbien", SX: "Saint Martin (hollandsk side)", SS: "Sydsudan", XK: "Kosovo" }, $u = {
  locale: to,
  countries: ro
}, el = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ro,
  default: $u,
  locale: to
}, Symbol.toStringTag, { value: "Module" })), no = "de", io = { AF: "Afghanistan", EG: "Ägypten", AX: "Åland", AL: "Albanien", DZ: "Algerien", AS: "Amerikanisch-Samoa", VI: "Amerikanische Jungferninseln", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua und Barbuda", GQ: "Äquatorialguinea", AR: "Argentinien", AM: "Armenien", AW: "Aruba", AZ: "Aserbaidschan", ET: "Äthiopien", AU: "Australien", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesch", BB: "Barbados", BY: "Belarus", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivien", BQ: "Bonaire", BA: "Bosnien und Herzegowina", BW: "Botswana", BV: "Bouvetinsel", BR: "Brasilien", VG: "Britische Jungferninseln", IO: "Britisches Territorium im Indischen Ozean", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", CL: "Chile", CN: "China", CK: "Cookinseln", CR: "Costa Rica", CI: "Elfenbeinküste", CW: "Curaçao", DK: "Dänemark", DE: "Deutschland", DM: "Dominica", DO: "Dominikanische Republik", DJ: "Dschibuti", EC: "Ecuador", SV: "El Salvador", ER: "Eritrea", EE: "Estland", FK: "Falklandinseln", FO: "Färöer", FJ: "Fidschi", FI: "Finnland", FR: "Frankreich", GF: "Französisch-Guayana", PF: "Französisch-Polynesien", TF: "Französische Süd- und Antarktisgebiete", GA: "Gabun", GM: "Gambia", GE: "Georgien", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GR: "Griechenland", GL: "Grönland", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard und McDonaldinseln", HN: "Honduras", HK: ["Hongkong", "Hong Kong"], IN: "Indien", ID: "Indonesien", IM: "Insel Man", IQ: "Irak", IR: "Iran", IE: "Irland", IS: "Island", IL: "Israel", IT: "Italien", JM: "Jamaika", JP: "Japan", YE: "Jemen", JE: "Jersey", JO: "Jordanien", KY: "Kaimaninseln", KH: "Kambodscha", CM: "Kamerun", CA: "Kanada", CV: "Kap Verde", KZ: "Kasachstan", QA: "Katar", KE: "Kenia", KG: "Kirgisistan", KI: "Kiribati", CC: "Kokosinseln", CO: "Kolumbien", KM: "Komoren", CD: "Kongo", KP: "Nordkorea", KR: "Südkorea", HR: "Kroatien", CU: "Kuba", KW: "Kuwait", LA: "Laos", LS: "Lesotho", LV: "Lettland", LB: "Libanon", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Malediven", ML: "Mali", MT: "Malta", MA: "Marokko", MH: "Marshallinseln", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexiko", FM: "Mikronesien", MD: "Moldawien", MC: "Monaco", MN: "Mongolei", ME: "Montenegro", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NC: "Neukaledonien", NZ: "Neuseeland", NI: "Nicaragua", NL: "Niederlande", NE: "Niger", NG: "Nigeria", NU: "Niue", MK: "Nordmazedonien", MP: "Nördliche Marianen", NF: "Norfolkinsel", NO: "Norwegen", OM: "Oman", AT: "Österreich", TL: "Osttimor", PK: "Pakistan", PS: "Staat Palästina", PW: "Palau", PA: "Panama", PG: "Papua-Neuguinea", PY: "Paraguay", PE: "Peru", PH: "Philippinen", PN: "Pitcairninseln", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", TW: "Taiwan", CG: "Republik Kongo", RE: "Réunion", RW: "Ruanda", RO: "Rumänien", RU: ["Russische Föderation", "Russland"], BL: "Saint-Barthélemy", MF: "Saint-Martin", SB: "Salomonen", ZM: "Sambia", WS: "Samoa", SM: "San Marino", ST: "São Tomé und Príncipe", SA: "Saudi-Arabien", SE: "Schweden", CH: "Schweiz", SN: "Senegal", RS: "Serbien", SC: "Seychellen", SL: "Sierra Leone", ZW: "Simbabwe", SG: "Singapur", SX: "Sint Maarten", SK: "Slowakei", SI: "Slowenien", SO: "Somalia", ES: "Spanien", LK: "Sri Lanka", SH: "St. Helena", KN: "St. Kitts und Nevis", LC: "St. Lucia", PM: "Saint-Pierre und Miquelon", VC: "St. Vincent und die Grenadinen", ZA: "Südafrika", SD: "Sudan", GS: "Südgeorgien und die Südlichen Sandwichinseln", SS: "Südsudan", SR: "Suriname", SJ: "Svalbard und Jan Mayen", SZ: "Eswatini", SY: "Syrien, Arabische Republik", TJ: "Tadschikistan", TZ: ["Tansania, Vereinigte Republik", "Tansania"], TH: "Thailand", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad und Tobago", TD: "Tschad", CZ: ["Tschechische Republik", "Tschechien"], TN: "Tunesien", TR: "Türkei", TM: "Turkmenistan", TC: "Turks- und Caicosinseln", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", HU: "Ungarn", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VA: "Vatikanstadt", VE: "Venezuela", AE: "Vereinigte Arabische Emirate", US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"], GB: ["Vereinigtes Königreich", "Großbritannien"], VN: "Vietnam", WF: "Wallis und Futuna", CX: "Weihnachtsinsel", EH: "Westsahara", CF: "Zentralafrikanische Republik", CY: "Zypern", XK: "Kosovo" }, al = {
  locale: no,
  countries: io
}, tl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: io,
  default: al,
  locale: no
}, Symbol.toStringTag, { value: "Module" })), oo = "el", so = { AF: "Αφγανιστάν", AL: "Αλβανία", DZ: "Αλγερία", AS: "Αμερικανική Σαμόα", AD: "Ανδόρρα", AO: "Ανγκόλα", AI: "Ανγκουίλα", AQ: "Ανταρκτική", AG: "Αντίγκουα και Μπαρμπούντα", AR: "Αργεντινή", AM: "Αρμενία", AW: "Αρούμπα", AU: "Αυστραλία", AT: "Αυστρία", AZ: "Αζερμπαϊτζάν", BS: "Μπαχάμες", BH: "Μπαχρέιν", BD: "Μπανγκλαντές", BB: "Μπαρμπάντος", BY: "Λευκορωσία", BE: "Βέλγιο", BZ: "Μπελίζ", BJ: "Μπενίν", BM: "Βερμούδες", BT: "Μπουτάν", BO: "Βολιβία", BA: "Βοσνία και Ερζεγοβίνη", BW: "Μποτσουάνα", BV: "Μπουβέ", BR: "Βραζιλία", IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού", BN: "Σουλτανάτο του Μπρουνέι", BG: "Βουλγαρία", BF: "Μπουρκίνα Φάσο", BI: "Μπουρουντί", KH: "Καμπότζη", CM: "Καμερούν", CA: "Καναδάς", CV: ["Δημοκρατία του Πράσινου Ακρωτηρίου", "Πράσινο Ακρωτήριο"], KY: "Κέιμαν Νήσοι", CF: "Κεντροαφρικανική Δημοκρατία", TD: "Τσάντ", CL: "Χιλή", CN: "Κίνα", CX: "Νήσος των Χριστουγέννων", CC: "Νησιά Κόκος", CO: "Κολομβία", KM: "Ένωση των Κομορών", CG: ["Δημοκρατία του Κονγκό", "Κονγκό"], CD: "Λαϊκή Δημοκρατία του Κονγκό", CK: "Νήσοι Κουκ", CR: "Κόστα Ρίκα", CI: "Ακτή Ελεφαντοστού", HR: "Κροατία", CU: "Κούβα", CY: "Κύπρος", CZ: ["Τσεχική Δημοκρατία", "Τσεχία"], DK: "Δανία", DJ: "Τζιμπουτί", DM: ["Κοινοπολιτεία της Δομινίκας", "Ντομίνικα"], DO: "Δομινικανή Δημοκρατία", EC: "Εκουαδόρ", EG: "Αίγυπτος", SV: "Ελ Σαλβαδόρ", GQ: "Ισημερινή-Γουινέα", ER: ["Κράτος της Ερυθραίας", "Ερυθραία"], EE: "Εσθονία", ET: "Αιθιοπία", FK: "Νήσοι Φώκλαντ (Μαλβίνας)", FO: "Νήσοι Φερόες", FJ: "Δημοκρατία των Φίτζι", FI: "Φινλανδία", FR: "Γαλλία", GF: "Γαλλική Γουιάνα", PF: "Γαλλική Πολυνησία", TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη", GA: "Γκαμπόν", GM: "Γκάμπια", GE: "Γεωργία", DE: "Γερμανία", GH: "Γκάνα", GI: "Γιβραλτάρ", GR: "Ελλάδα", GL: "Γροιλανδία", GD: "Γρενάδα", GP: "Γουαδελούπη", GU: "Γκουάμ", GT: "Γουατεμάλα", GN: "Γουινέα", GW: "Γουινέα-Μπισσάου", GY: "Γουιάνα", HT: "Αϊτη", HM: "Νήσοι Χερντ και Μακντόναλντ", VA: ["Κράτος της Πόλης του Βατικανού", "Βατικανό"], HN: "Ονδούρα", HK: "Χονγκ Κόνγκ", HU: "Ουγγαρία", IS: "Ισλανδία", IN: "Ινδία", ID: "Ινδονησία", IR: ["Ισλαμική Δημοκρατία του Ιράν", "Ιράν"], IQ: "Ιράκ", IE: "Ιρλανδία", IL: "Ισραήλ", IT: "Ιταλία", JM: "Τζαμάικα", JP: "Ιαπωνία", JO: "Ιορδανία", KZ: "Καζακστάν", KE: "Κένυα", KI: "Κιριμπάτι", KP: ["Λαοκρατική Δημοκρατία της Κορέας", "Βόρεια Κορέα"], KR: ["Δημοκρατία της Κορέας", "Νότια Κορέα"], KW: "Κουβέιτ", KG: "Κιργιζία", LA: ["Λαϊκή Δημοκρατία του Λάος", "Λάος"], LV: "Λετονία", LB: "Λίβανο", LS: ["Βασίλειο του Λεσότο", "Λεσότο"], LR: "Λιβερία", LY: ["Κράτος της Λιβύης", "Λιβύη"], LI: ["Πριγκιπάτο του Λίχτενσταϊν", "Λίχτενσταϊν"], LT: "Λιθουανία", LU: "Λουξεμβούργο", MO: "Μακάου", MK: ["Δημοκρατία της Βόρειας Μακεδονίας", "Βόρεια Μακεδονία"], MG: "Μαδαγασκάρη", MW: "Μαλάουι", MY: "Μαλαισία", MV: "Μαλβίδες", ML: "Μαλί", MT: "Μάλτα", MH: "Νήσοι Μάρσαλ", MQ: "Μαρτινίκα", MR: "Μαυριτανία", MU: "Μαυρίκιος", YT: "Μαγιότ", MX: "Μεξικό", FM: ["Ομόσπονδες Πολιτείες της Μικρονησίας", "Μικρονησία"], MD: ["Δημοκρατία της Μολδαβίας", "Μολδαβία"], MC: ["Πριγκιπάτο του Μονακό", "Μονακό"], MN: "Μογγολία", MS: "Μοντσερράτ", MA: "Μαρόκο", MZ: "Μοζαμβίκη", MM: "Μιανμάρ", NA: "Ναμίμπια", NR: "Ναουρού", NP: "Νεπάλ", NL: "Ολλανδία", NC: "Νέα Καληδονία", NZ: "Νέα Ζηλανδία", NI: "Νικαράγουα", NE: "Νίγηρας", NG: "Νιγηρία", NU: "Νιούε", NF: "Νησί Νόρφολκ", MP: "Βόρειες Μαριάνες Νήσοι", NO: "Νορβηγία", OM: "Ομάν", PK: "Πακιστάν", PW: "Παλάου", PS: ["Κράτος της Παλαιστίνης", "Παλαιστίνη"], PA: "Παναμάς", PG: "Παπούα Νέα Γουινέα", PY: "Παραγουάη", PE: "Περού", PH: "Φιλιππίνες", PN: "Νήσοι Πίτκαιρν", PL: "Πολωνία", PT: "Πορτογαλία", PR: "Πουέρτο Ρίκο", QA: "Κατάρ", RE: "Ρεϋνιόν", RO: "Ρουμανία", RU: ["Ρωσική Ομοσπονδία", "Ρωσία"], RW: "Ρουάντα", SH: "Νήσος Αγίας Ελένης", KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις", LC: "Αγία Λουκία", PM: "Σαιν Πιερ και Μικελόν", VC: "Άγιος Βικέντιος και Γρεναδίνες", WS: "Σαμόα", SM: "Άγιος Μαρίνος", ST: "Σάο Τομέ και Πρίνσιπε", SA: "Σαουδική Αραβία", SN: "Σενεγάλη", SC: "Σεϋχέλλες", SL: "Σιέρα Λεόνε", SG: "Σιγκαπούρη", SK: "Σλοβακία", SI: "Σλοβενία", SB: "Νήσοι Σολομώντα", SO: "Σομαλία", ZA: "Νότια Αφρική", GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι", ES: "Ισπανία", LK: "Σρι Λάνκα", SD: "Σουδάν", SR: "Σουρινάμ", SJ: "Σβάλμπαρντ και Γιαν Μαγιέν", SZ: "Σουαζιλάνδη", SE: "Σουηδία", CH: "Ελβετία", SY: ["Αραβική Δημοκρατία της Συρίας", "Συρία"], TW: "Δημοκρατία της Κίνας", TJ: "Τατζικιστάν", TZ: ["Ενωμένη Δημοκρατία της Τανζανίας", "Τανζανία"], TH: "Ταϊλάνδη", TL: "Ανατολικό Τιμόρ", TG: "Τογκό", TK: "Τοκελάου", TO: "Τόνγκα", TT: "Τρινιντάντ και Τομπάγκο", TN: "Τυνησία", TR: "Τουρκία", TM: "Τουρκμενιστάν", TC: "Τερκς και Κέικος", TV: "Τουβαλού", UG: "Ουγκάντα", UA: "Ουκρανια", AE: "Ηνωμένα Αραβικά Εμιράτα", GB: "Ηνωμένο Βασίλειο", US: ["Ηνωμένες Πολιτείες Αμερικής", "Αμερική", "ΗΠΑ"], UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών", UY: "Ουρουγουάη", UZ: "Ουζμπεκιστάν", VU: "Βανουάτου", VE: "Βενεζουέλα", VN: "Βιετνάμ", VG: "Βρετανικές Παρθένοι Νήσοι", VI: "Αμερικανικές Παρθένοι Νήσοι", WF: "Ουαλίς και Φουτουνά", EH: "Δυτική Σαχάρα", YE: "Υεμένη", ZM: "Ζάμπια", ZW: "Ζιμπάμπουε", AX: "Νήσοι Ώλαντ", BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα", CW: "Κουρασάο", GG: "Γκουέρνσεϊ", IM: "Νήσος του Μαν", JE: "Βαϊλάτο του Τζέρσεϊ", ME: "Μαυροβούνιο", BL: "Άγιος Βαρθολομαίος", MF: "Άγιος Μαρτίνος (Γαλλία)", RS: "Σερβία", SX: "Άγιος Μαρτίνος (Ολλανδία)", SS: "Νότιο Σουδάν", XK: "Κόσοβο" }, rl = {
  locale: oo,
  countries: so
}, nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: so,
  default: rl,
  locale: oo
}, Symbol.toStringTag, { value: "Module" })), uo = "en", lo = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "American Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua and Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarus", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia and Herzegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brazil", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodia", CM: "Cameroon", CA: "Canada", CV: "Cape Verde", KY: "Cayman Islands", CF: "Central African Republic", TD: "Chad", CL: "Chile", CN: ["People's Republic of China", "China"], CX: "Christmas Island", CC: "Cocos (Keeling) Islands", CO: "Colombia", KM: "Comoros", CG: ["Republic of the Congo", "Congo"], CD: ["Democratic Republic of the Congo", "Congo"], CK: "Cook Islands", CR: "Costa Rica", CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"], HR: "Croatia", CU: "Cuba", CY: "Cyprus", CZ: ["Czech Republic", "Czechia"], DK: "Denmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominican Republic", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Equatorial Guinea", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Falkland Islands (Malvinas)", FO: "Faroe Islands", FJ: "Fiji", FI: "Finland", FR: "France", GF: "French Guiana", PF: "French Polynesia", TF: "French Southern Territories", GA: "Gabon", GM: ["Republic of The Gambia", "The Gambia", "Gambia"], GE: "Georgia", DE: "Germany", GH: "Ghana", GI: "Gibraltar", GR: "Greece", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard Island and McDonald Islands", VA: "Holy See (Vatican City State)", HN: "Honduras", HK: "Hong Kong", HU: "Hungary", IS: "Iceland", IN: "India", ID: "Indonesia", IR: ["Islamic Republic of Iran", "Iran"], IQ: "Iraq", IE: "Ireland", IL: "Israel", IT: "Italy", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "North Korea", KR: ["South Korea", "Korea, Republic of", "Republic of Korea"], KW: "Kuwait", KG: "Kyrgyzstan", LA: "Lao People's Democratic Republic", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxembourg", MO: "Macao", MG: "Madagascar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Marshall Islands", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesia, Federated States of", MD: "Moldova, Republic of", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Morocco", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"], NC: "New Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MK: ["The Republic of North Macedonia", "North Macedonia"], MP: "Northern Mariana Islands", NO: "Norway", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: ["State of Palestine", "Palestine"], PA: "Panama", PG: "Papua New Guinea", PY: "Paraguay", PE: "Peru", PH: "Philippines", PN: ["Pitcairn", "Pitcairn Islands"], PL: "Poland", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Reunion", RO: "Romania", RU: ["Russian Federation", "Russia"], RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts and Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent and the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome and Principe", SA: "Saudi Arabia", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Solomon Islands", SO: "Somalia", ZA: "South Africa", GS: "South Georgia and the South Sandwich Islands", ES: "Spain", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard and Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Switzerland", SY: "Syrian Arab Republic", TW: ["Taiwan, Province of China", "Taiwan"], TJ: "Tajikistan", TZ: ["United Republic of Tanzania", "Tanzania"], TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad and Tobago", TN: "Tunisia", TR: ["Türkiye", "Turkey"], TM: "Turkmenistan", TC: "Turks and Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: ["United Arab Emirates", "UAE"], GB: ["United Kingdom", "UK", "Great Britain"], US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."], UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Western Sahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: ["Åland Islands", "Aland Islands"], BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "South Sudan", XK: "Kosovo" }, il = {
  locale: uo,
  countries: lo
}, ol = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: lo,
  default: il,
  locale: uo
}, Symbol.toStringTag, { value: "Module" })), co = "es", po = { AF: "Afganistán", AL: "Albania", DZ: "Argelia", AS: "Samoa Americana", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antigua y Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaiyán", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bielorrusia", BE: "Bélgica", BZ: "Belice", BJ: "Benin", BM: "Bermudas", BT: "Bután", BO: "Bolivia", BA: "Bosnia y Herzegovina", BW: "Botswana", BV: "Isla Bouvet", BR: "Brasil", IO: "Territorio Británico del Océano Índico", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Camboya", CM: "Camerún", CA: "Canadá", CV: "Cabo Verde", KY: "Islas Caimán", CF: "República Centroafricana", TD: "Chad", CL: "Chile", CN: "China", CX: "Isla de Navidad", CC: "Islas Cocos (Keeling)", CO: "Colombia", KM: "Comoras", CG: "Congo", CD: "Congo (República Democrática del)", CK: "Islas Cook", CR: "Costa Rica", CI: "Costa de Marfil", HR: "Croacia", CU: "Cuba", CY: "Chipre", CZ: "República Checa", DK: "Dinamarca", DJ: "Yibuti", DM: "Dominica", DO: "República Dominicana", EC: "Ecuador", EG: "Egipto", SV: "El Salvador", GQ: "Guinea Ecuatorial", ER: "Eritrea", EE: "Estonia", ET: "Etiopía", FK: "Islas Malvinas", FO: "Islas Feroe", FJ: "Fiji", FI: "Finlandia", FR: "Francia", GF: "Guayana Francesa", PF: "Polinesia Francesa", TF: "Tierras Australes Francesas", GA: "Gabón", GM: "Gambia", GE: "Georgia", DE: "Alemania", GH: "Ghana", GI: "Gibraltar", GR: "Grecia", GL: "Groenlandia", GD: "Granada", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea Bissau", GY: "Guyana", HT: "Haití", HM: "Heard e Islas McDonald", VA: "Santa Sede", HN: "Honduras", HK: "Hong Kong", HU: "Hungría", IS: "Islandia", IN: "India", ID: "Indonesia", IR: ["Irán", "República Islámica de Irán"], IQ: "Iraq", IE: "Irlanda", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japón", JO: "Jordania", KZ: "Kazajistán", KE: "Kenia", KI: "Kiribati", KP: "República Popular Democrática de Corea", KR: "República de Corea", KW: "Kuwait", KG: "Kirguistán", LA: "República Democrática Popular de Lao", LV: "Letonia", LB: "Líbano", LS: "Lesoto", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Lituania", LU: "Luxemburgo", MO: "Macao", MK: "Macedonia del Norte", MG: "Madagascar", MW: "Malaui", MY: "Malasia", MV: "Maldivas", ML: "Malí", MT: "Malta", MH: "Islas Marshall", MQ: "Martinica", MR: "Mauritania", MU: "Mauricio", YT: "Mayotte", MX: "México", FM: "Micronesia", MD: "Moldavia", MC: "Mónaco", MN: "Mongolia", MS: "Montserrat", MA: "Marruecos", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Países Bajos", NC: "Nueva Caledonia", NZ: "Nueva Zelanda", NI: "Nicaragua", NE: "Níger", NG: "Nigeria", NU: "Niue", NF: "Isla Norfolk", MP: "Islas Marianas del Norte", NO: "Noruega", OM: "Omán", PK: "Pakistán", PW: "Palau", PS: "Palestina", PA: "Panamá", PG: "Papua Nueva Guinea", PY: "Paraguay", PE: "Perú", PH: "Filipinas", PN: "Pitcairn", PL: "Polonia", PT: "Portugal", PR: "Puerto Rico", QA: "Catar", RE: "Reunión", RO: "Rumanía", RU: "Rusia", RW: "Ruanda", SH: "Santa Helena, Ascensión y Tristán de Acuña", KN: "Saint Kitts y Nevis", LC: "Santa Lucía", PM: "San Pedro y Miquelón", VC: "San Vicente y las Granadinas", WS: "Samoa", SM: "San Marino", ST: "Santo Tomé y Príncipe", SA: "Arabia Saudita", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leona", SG: "Singapur", SK: "Eslovaquia", SI: "Eslovenia", SB: "Islas Salomón", SO: "Somalia", ZA: "Sudáfrica", GS: "Georgia del Sur y las Islas Sandwich del Sur", ES: "España", LK: "Sri Lanka", SD: "Sudán", SR: "Suriname", SJ: "Svalbard y Jan Mayen", SZ: "Esuatini", SE: "Suecia", CH: "Suiza", SY: "República Árabe Siria", TW: "Taiwán", TJ: "Tayikistán", TZ: "Tanzania", TH: "Tailandia", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad y Tobago", TN: "Túnez", TR: "Turquía", TM: "Turkmenistán", TC: "Islas Turcas y Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ucrania", AE: "Emiratos Árabes Unidos", GB: "Reino Unido", US: "Estados Unidos", UM: "Islas Ultramarinas Menores de los Estados Unidos", UY: "Uruguay", UZ: "Uzbekistán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Islas Vírgenes británicas", VI: "Islas Vírgenes de los Estados Unidos", WF: "Wallis y Futuna", EH: "Sahara Occidental", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabue", AX: "Islas Åland", BQ: "Bonaire, San Eustaquio y Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isla de Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (francesa)", RS: "Serbia", SX: "Sint Maarten (neerlandesa)", SS: "Sudán del Sur", XK: "Kosovo" }, sl = {
  locale: co,
  countries: po
}, ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: po,
  default: sl,
  locale: co
}, Symbol.toStringTag, { value: "Module" })), fo = "fr", ho = { AF: "Afghanistan", AL: "Albanie", DZ: "Algérie", AS: "Samoa américaines", AD: "Andorre", AO: "Angola", AI: "Anguilla", AQ: "Antarctique", AG: "Antigua-et-Barbuda", AR: "Argentine", AM: "Arménie", AW: "Aruba", AU: "Australie", AT: "Autriche", AZ: "Azerbaïdjan", BS: "Bahamas", BH: "Bahreïn", BD: "Bangladesh", BB: "Barbade", BY: "Biélorussie", BE: "Belgique", BZ: "Belize", BJ: "Bénin", BM: "Bermudes", BT: "Bhoutan", BO: "Bolivie", BA: "Bosnie-Herzégovine", BW: "Botswana", BV: "Île Bouvet", BR: "Brésil", IO: "Océan Indien Britannique", BN: "Brunei Darussalam", BG: "Bulgarie", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodge", CM: "Cameroun", CA: "Canada", CV: "Cap-Vert", KY: "Îles Caïmans", CF: "République Centrafricaine", TD: "Tchad", CL: "Chili", CN: "Chine", CX: "Île Christmas", CC: "Îles Cocos", CO: "Colombie", KM: "Comores", CG: "République du Congo", CD: "République démocratique du Congo", CK: "Îles Cook", CR: "Costa Rica", CI: "Côte-d'Ivoire", HR: "Croatie", CU: "Cuba", CY: "Chypre", CZ: "République Tchèque", DK: "Danemark", DJ: "Djibouti", DM: "Dominique", DO: "République Dominicaine", EC: "Équateur", EG: "Égypte", SV: "El Salvador", GQ: "Guinée équatoriale", ER: "Érythrée", EE: "Estonie", ET: "Éthiopie", FK: "Îles Malouines", FO: "Îles Féroé", FJ: "Fidji", FI: "Finlande", FR: "France", GF: "Guyane française", PF: "Polynésie française", TF: "Terres australes françaises", GA: "Gabon", GM: "Gambie", GE: "Géorgie", DE: "Allemagne", GH: "Ghana", GI: "Gibraltar", GR: "Grèce", GL: "Groenland", GD: "Grenade", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinée", GW: "Guinée-Bissau", GY: "Guyana", HT: "Haïti", HM: "Îles Heard-et-MacDonald", VA: "Saint-Siège (Vatican)", HN: "Honduras", HK: "Hong Kong", HU: "Hongrie", IS: "Islande", IN: "Inde", ID: "Indonésie", IR: "Iran", IQ: "Irak", IE: "Irlande", IL: "Israël", IT: "Italie", JM: "Jamaïque", JP: "Japon", JO: "Jordanie", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Corée du Nord", KR: "Corée du Sud", KW: "Koweït", KG: "Kirghizistan", LA: "Laos", LV: "Lettonie", LB: "Liban", LS: "Lesotho", LR: "Libéria", LY: "Libye", LI: "Liechtenstein", LT: "Lituanie", LU: "Luxembourg", MO: "Macao", MK: "Macédoine du Nord", MG: "Madagascar", MW: "Malawi", MY: "Malaisie", MV: "Maldives", ML: "Mali", MT: "Malte", MH: "Îles Marshall", MQ: "Martinique", MR: "Mauritanie", MU: "Maurice", YT: "Mayotte", MX: "Mexique", FM: "Micronésie", MD: "Moldavie", MC: "Monaco", MN: "Mongolie", MS: "Montserrat", MA: "Maroc", MZ: "Mozambique", MM: "Myanmar", NA: "Namibie", NR: "Nauru", NP: "Népal", NL: "Pays-Bas", NC: "Nouvelle-Calédonie", NZ: "Nouvelle-Zélande", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niué", NF: "Île Norfolk", MP: "Îles Mariannes du Nord", NO: "Norvège", OM: "Oman", PK: "Pakistan", PW: "Palaos", PS: "Palestine", PA: "Panama", PG: "Papouasie-Nouvelle-Guinée", PY: "Paraguay", PE: "Pérou", PH: "Philippines", PN: "Îles Pitcairn", PL: "Pologne", PT: "Portugal", PR: "Porto Rico", QA: "Qatar", RE: "Réunion", RO: "Roumanie", RU: "Russie", RW: "Rwanda", SH: "Sainte-Hélène", KN: "Saint-Christophe-et-Niévès", LC: "Sainte-Lucie", PM: "Saint-Pierre-et-Miquelon", VC: "Saint-Vincent-et-les-Grenadines", WS: "Samoa", SM: "Saint-Marin", ST: "São Tomé-et-Principe", SA: "Arabie Saoudite", SN: "Sénégal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapour", SK: "Slovaquie", SI: "Slovénie", SB: "Îles Salomon", SO: "Somalie", ZA: "Afrique du Sud", GS: "Géorgie du Sud-et-les Îles Sandwich du Sud", ES: "Espagne", LK: "Sri Lanka", SD: "Soudan", SR: "Suriname", SJ: "Svalbard et Île Jan Mayen", SZ: "Royaume d'Eswatini", SE: "Suède", CH: "Suisse", SY: "Syrie", TW: "Taïwan", TJ: "Tadjikistan", TZ: "République unie de Tanzanie", TH: "Thaïlande", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinité-et-Tobago", TN: "Tunisie", TR: "Turquie", TM: "Turkménistan", TC: "Îles Turques-et-Caïques", TV: "Tuvalu", UG: "Ouganda", UA: "Ukraine", AE: "Émirats Arabes Unis", GB: "Royaume-Uni", US: "États-Unis d'Amérique", UM: "Îles mineures éloignées des États-Unis", UY: "Uruguay", UZ: "Ouzbékistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Îles vierges britanniques", VI: "Îles vierges américaines", WF: "Wallis-et-Futuna", EH: "Sahara occidental", YE: "Yémen", ZM: "Zambie", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Saint-Eustache et Saba", CW: "Curaçao", GG: "Guernesey", IM: "Île de Man", JE: "Jersey", ME: "Monténégro", BL: "Saint-Barthélemy", MF: "Saint-Martin (partie française)", RS: "Serbie", SX: "Saint-Martin (partie néerlandaise)", SS: "Soudan du Sud", XK: "Kosovo" }, ll = {
  locale: fo,
  countries: ho
}, cl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ho,
  default: ll,
  locale: fo
}, Symbol.toStringTag, { value: "Module" })), mo = "hi", go = { AD: "अंडोरा", AE: "संयुक्त अरब अमीरात", AF: "अफगानिस्तान", AG: "एंटीगुआ और बारबूडा", AI: "अंग्विला", AL: "अल्बानिया", AM: "अर्मेनिया", AO: "अंगोला", AQ: "अंटार्टिका", AR: "अर्जेंटिना", AS: "अमेरिकान सामोआ", AT: "आस्ट्रिया", AU: "आस्ट्रेलिया", AW: "अरुबा", AX: "ऑलैण्ड द्वीपसमूह", AZ: "अजरबेजान", BA: "बोस्निया हर्जेगोविना", BB: "बार्बाडोस", BD: "बांग्लादेश", BE: "बेल्जियम", BF: "बुर्किना फासो", BG: "बल्गारिया", BH: "बहरीन", BI: "बुरुंडी", BJ: "बानिन", BL: "सेंट_बार्थेलेमी", BM: "बर्मूडा", BN: "ब्रुनेई", BO: "बोलिविया", BQ: "कैरिबियन नीदरलैंड", BR: "ब्राजील", BS: "बहामास", BT: "भूटान", BV: "बाउवेट", BW: "बोत्सवाना", BY: "बेलारुस", BZ: "बेलिजे", CA: "कनाडा", CC: "कोकोस (कीलिंग) द्वीप", CD: "कांगो लोकतान्त्रिक गणराज्य", CF: "सेंट्रल अफ्रीका गणतंत्र", CG: "कांगो", CH: "स्विट्जरलैंड", CI: "आइवरी कोस्ट", CK: "कुक द्वीप", CL: "चिली", CM: "कैमरून", CN: "चीन", CO: "कोलंबिया", CR: "कोस्टा रिका", CU: "क्यूबा", CV: "केप वर्दे", CW: "कुराकाओ", CX: "क्रिसमस द्वीप", CY: "साइप्रस", CZ: "चेक", DE: "जर्मनी", DJ: "जिबॉती", DK: "डैनमार्क", DM: "डोमिनिक", DO: "डोमिनिक गणतंत्र", DZ: "अल्जीरिया", EC: "इक्वाडोर", EE: "एस्तोनिया", EG: "मिस्र", EH: "पश्चिमी सहारा", ER: "एरिट्रेया", ES: "स्पेन", ET: "इथियोपिया", FI: "फिनलैंड", FJ: "फिजी", FK: "फाकलैंड द्वीप समूह (मालविनास)", FM: "माइक्रोनेशिया", FO: "फराओ द्वीप समूह", FR: "फ्रांस", GA: "गैबोन", GB: "ग्रेट ब्रिटेन", GD: "ग्रेनेडा", GE: "जॉर्जिया", GF: "फ्रेंच गुआना", GG: "ग्वेर्नसे", GH: "घाना", GI: "जिब्राल्टर", GL: "ग्रीनलैंड", GM: "गाम्बिया", GN: "गिनी", GP: "ग्वाडेलोप", GQ: "एक्वेटोरियल गिनी", GR: "यूनान", GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह", GT: "ग्वाटेमाला", GU: "ग्वाम", GW: "गिनी-बिसाउ", GY: "गुआना", HK: "हांग कांग", HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह", HN: "होंडुरास", HR: "क्रोएशिया", HT: "हैती", HU: "हंगरी", ID: "इंडोनेशिया", IE: "आयरलैंड", IL: "इजराइल", IM: "आइसल ऑफ मैन", IN: "भारत", IO: "ब्रितानी हिंद महासागरीय क्षेत्र", IQ: "इराक", IR: "ईरान", IS: "आइसलैंड", IT: "इटली", JE: "जर्सी", JM: "जमैका", JO: "जॉर्डन", JP: "जापान", KE: "केन्या", KG: "किर्जिस्तान", KH: "कंबोडिया", KI: "किरिबिती", KM: "कोमोरोस", KN: "सेंट किट्स एंड नेविस", KP: "उत्तर कोरिया", KR: "दक्षिण कोरिया", KW: "कुवैत", KY: "केमैन आइसलैंड्स", KZ: "कज़ाखिस्तान", LA: "लाओस", LB: "लेबनान", LC: "सेंट लुसिया", LI: "लिक्टेनिस्टीन", LK: "श्री लंका", LR: "लाइबेरिया", LS: "लेसोथो", LT: "लिथुआनिया", LU: "लक्जमबर्ग", LV: "लात्विया", LY: "लीबिया", MA: "मोरक्को", MC: "मोनाको", MD: "मोलदोवा", ME: "मोंटेनेग्रो", MF: "सेंट मार्टिन की सामूहिकता", MG: "मैडागास्कर", MH: "मार्शल द्वीपसमूह", MK: "मकदूनिया", ML: "माली", MM: "म्यामांर (बर्मा)", MN: "मंगोलिया", MO: "मकाओ", MP: "उत्तर मैरिना द्वीपसमूह", MQ: "मार्टिनिक", MR: "मॉरितानिया", MS: "मोंटसेराट", MT: "माल्टा", MU: "मारीशस", MV: "मालदीव", MW: "मालावी", MX: "मेक्सिको", MY: "मलयेशिया", MZ: "मोजांबिक", NA: "नामीबिया", NC: "न्यू कैलेडोनिया", NE: "नाइजर", NF: "नोरफॉक द्वीप", NG: "नाइजीरिया", NI: "निकारागुआ", NL: "नीदरलैंड्स", NO: "नॉर्वे", NP: "नेपाल", NR: "नाउरू", NU: "नियू", NZ: "न्यूजीलैंड", OM: "ओमान", PA: "पनामा", PE: "पेरू", PF: "फ्रैंच गुआना", PG: "पापुआ न्यू गिनी", PH: "फिलीपींस", PK: "पाकिस्तान", PL: "पोलैंड", PM: "सेंट पिएरे एंड मिक्वेलॉन", PN: "पिटकैर्न द्वीपसमूह", PR: "पुएर्तो रिको", PS: "फिलिस्तीन राज्य", PT: "पुर्तगाल", PW: "पलाउ", PY: "पराग्वे", QA: "क़तार", RE: "रीयूनियन", RO: "रोमानिया", RS: "सर्बिया", RU: "रूस", RW: "रवांडा", SA: "सऊदी अरब", SB: "सोलोमन द्वीपसमूह", SC: "सेशेल्स", SD: "सूडान", SE: "स्वीडन", SG: "सिंगापुर", SH: "सेंट हेलेना", SI: "स्लोवानिया", SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)", SK: "स्लोवाकिया", SL: "सियारा लिओन", SM: "सैन मारिनो", SN: "सेनेगल", SO: "सोमालिया", SR: "सूरीनाम", SS: "दक्षिण सूडान", ST: "साओ टॉम एंड प्रिंसिपी", SV: "सल्वाडोर", SX: "सिण्ट मार्टेन", SY: "सीरिया", SZ: "स्वाजीलैंड", TC: "तुर्क एंड कैकोस द्वीपसमूह", TD: "चाड", TF: "फ्रांसीसी दक्षिणी क्षेत्र", TG: "टोगो", TH: "थाईलैंड", TJ: "तज़ाकिस्तान", TK: "टोकेलू", TL: "पूर्वी तिमोर", TM: "तुर्कमेनिस्तान", TN: "ट्यूनीशिया", TO: "टोंगा", TR: "तुर्की", TT: "ट्रिनिडाड एंड टोबैगो", TV: "तुवालू", TW: "ताइवान", TZ: "तंजानिया", UA: "उक्रेन", UG: "उगांडा", UM: "यूएस माइनर आउटलाइंग द्वीपसमूह", US: "यूएसए (संयुक्त राज्य अमेरिका)", UY: "उरुग्वे", UZ: "उजबेकिस्तान", VA: "वेटिकन", VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स", VE: "वेनेजुएला", VG: "ब्रितानी वर्जिन द्वीपसमूह", VI: "अमेरिकी वर्जिन द्वीपसमूह", VN: "विएतनाम", VU: "वनातू", WF: "वालीज एंड फुटुना", WS: "पश्चिमी सामोआ", XK: "कोसोवो", YE: "यमन", YT: "मायोते", ZA: "दक्षिण अफ्रीका", ZM: "जाम्बिया", ZW: "जिंबावे" }, dl = {
  locale: mo,
  countries: go
}, pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: go,
  default: dl,
  locale: mo
}, Symbol.toStringTag, { value: "Module" })), vo = "hu", So = { AF: "Afganisztán", AL: "Albánia", DZ: "Algéria", AS: "Amerikai Szamoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktisz", AG: "Antigua és Barbuda", AR: "Argentína", AM: "Örményország", AW: "Aruba", AU: "Ausztrália", AT: "Ausztria", AZ: "Azerbajdzsán", BS: "Bahama-szigetek", BH: "Bahrein", BD: "Banglades", BB: "Barbados", BY: "Fehéroroszország", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhután", BO: "Bolívia", BA: "Bosznia-Hercegovina", BW: "Botswana", BV: "Bouvet-sziget", BR: "Brazília", IO: "Brit Indiai-óceáni Terület", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodzsa", CM: "Kamerun", CA: "Kanada", CV: "Zöld-foki Köztársaság", KY: "Kajmán-szigetek", CF: "Közép-afrikai Köztársaság", TD: "Csád", CL: "Chile", CN: "Kína", CX: "Karácsony-sziget", CC: "Kókusz (Keeling)-szigetek", CO: "Kolumbia", KM: "Comore-szigetek", CG: "Kongói Köztársaság", CD: "Kongói Demokratikus Köztársaság", CK: "Cook-szigetek", CR: "Costa Rica", CI: "Elefántcsontpart", HR: "Horvátország", CU: "Kuba", CY: "Ciprus", CZ: "Csehország", DK: "Dánia", DJ: "Dzsibuti", DM: "Dominikai Közösség", DO: "Dominikai Köztársaság", EC: "Ecuador", EG: "Egyiptom", SV: "Salvador", GQ: "Egyenlítői-Guinea", ER: "Eritrea", EE: "Észtország", ET: "Etiópia", FK: "Falkland-szigetek", FO: "Feröer", FJ: "Fidzsi-szigetek", FI: "Finnország", FR: "Franciaország", GF: "Francia Guyana", PF: "Francia Polinézia", TF: "Francia déli területek", GA: "Gabon", GM: "Gambia", GE: "Grúzia", DE: "Németország", GH: "Ghána", GI: "Gibraltár", GR: "Görögország", GL: "Grönland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Bissau-Guinea", GY: "Guyana", HT: "Haiti", HM: "Heard-sziget és McDonald-szigetek", VA: "Vatikán", HN: "Honduras", HK: "Hong Kong", HU: "Magyarország", IS: "Izland", IN: "India", ID: "Indonézia", IR: "Irán", IQ: "Irak", IE: "Írország", IL: "Izrael", IT: "Olaszország", JM: "Jamaica", JP: "Japán", JO: "Jordánia", KZ: "Kazahsztán", KE: "Kenya", KI: "Kiribati", KP: "Észak-Korea", KR: "Dél-Korea", KW: "Kuvait", KG: "Kirgizisztán", LA: "Laosz", LV: "Lettország", LB: "Libanon", LS: "Lesotho", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Litvánia", LU: "Luxemburg", MO: "Makao", MK: "Észak-Macedónia", MG: "Madagaszkár", MW: "Malawi", MY: "Malajzia", MV: "Maldív-szigetek", ML: "Mali", MT: "Málta", MH: "Marshall-szigetek", MQ: "Martinique", MR: "Mauritánia", MU: "Mauritius", YT: "Mayotte", MX: "Mexikó", FM: "Mikronéziai Szövetségi Államok", MD: "Moldova", MC: "Monaco", MN: "Mongólia", MS: "Montserrat", MA: "Marokkó", MZ: "Mozambik", MM: "Mianmar", NA: "Namíbia", NR: "Nauru", NP: "Nepál", NL: "Hollandia", NC: "Új-Kaledónia", NZ: "Új-Zéland", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niue", NF: "Norfolk-sziget", MP: "Északi-Mariana-szigetek", NO: "Norvégia", OM: "Omán", PK: "Pakisztán", PW: "Palau", PS: "Palesztina", PA: "Panama", PG: "Pápua Új-Guinea", PY: "Paraguay", PE: "Peru", PH: "Fülöp-szigetek", PN: "Pitcairn-szigetek", PL: "Lengyelország", PT: "Portugália", PR: "Puerto Rico", QA: "Katar", RE: "Réunion", RO: "Románia", RU: "Oroszország", RW: "Ruanda", SH: "Saint Helena", KN: "Saint Kitts és Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent és a Grenadine-szigetek", WS: "Szamoa", SM: "San Marino", ST: "São Tomé és Príncipe", SA: "Szaudi-Arábia", SN: "Szenegál", SC: "Seychelle-szigetek", SL: "Sierra Leone", SG: "Szingapúr", SK: "Szlovákia", SI: "Szlovénia", SB: "Salamon-szigetek", SO: "Szomália", ZA: "Dél-Afrika", GS: "Déli-Georgia és Déli-Sandwich-szigetek", ES: "Spanyolország", LK: "Sri Lanka", SD: "Szudán", SR: "Suriname", SJ: "Spitzbergák és Jan Mayen", SZ: "Szváziföld", SE: "Svédország", CH: "Svájc", SY: "Szíria", TW: "Tajvan", TJ: "Tádzsikisztán", TZ: "Tanzánia", TH: "Thaiföld", TL: "Kelet-Timor", TG: "Togo", TK: "Tokelau-szigetek", TO: "Tonga", TT: "Trinidad és Tobago", TN: "Tunézia", TR: "Törökország", TM: "Türkmenisztán", TC: "Turks- és Caicos-szigetek", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajna", AE: "Egyesült Arab Emírségek", GB: "Egyesült Királyság", US: "Amerikai Egyesült Államok", UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai", UY: "Uruguay", UZ: "Üzbegisztán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Brit Virgin-szigetek", VI: "Amerikai Virgin-szigetek", WF: "Wallis és Futuna", EH: "Nyugat-Szahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibi Hollandia", CW: "Curaçao", GG: "Guernsey", IM: "Man-sziget", JE: "Jersey", ME: "Montenegró", BL: "Saint Barthélemy", MF: "Szent Márton-sziget (francia rész)", RS: "Szerbia", SX: "Szent Márton-sziget (holland rész)", SS: "Dél-Szudán", XK: "Koszovó" }, fl = {
  locale: vo,
  countries: So
}, hl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: So,
  default: fl,
  locale: vo
}, Symbol.toStringTag, { value: "Module" })), bo = "id", Mo = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "Samoa Amerika", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua dan Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahama", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarusia", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia dan Herzegovina", BW: "Botswana", BV: "Kepulauan Bouvet", BR: "Brasil", IO: "Teritori Samudra Hindia Britania", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kamboja", CM: "Kamerun", CA: "Kanada", CV: "Tanjung Verde", KY: "Kepulauan Cayman", CF: "Afrika Tengah", TD: "Chad", CL: "Chile", CN: "China", CX: "Pulau Natal", CC: "Kepulauan Cocos (Keeling)", CO: "Kolombia", KM: "Komoro", CG: "Kongo", CD: "Republik Demokratik Kongo", CK: "Kepulauan Cook", CR: "Kosta Rika", CI: "Pantai Gading", HR: "Kroasia", CU: "Kuba", CY: "Siprus", CZ: "Republik Ceko", DK: "Denmark", DJ: "Djibouti", DM: "Dominika", DO: "Republik Dominika", EC: "Ekuador", EG: "Mesir", SV: "El Salvador", GQ: "Guinea Khatulistiwa", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Kepulauan Falkland(Malvinas)", FO: "Kepulauan Faroe", FJ: "Fiji", FI: "Finlandia", FR: "Perancis", GF: "Guyana Perancis", PF: "Polinesia Perancis", TF: "Antartika Perancis", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Jerman", GH: "Ghana", GI: "Gibraltar", GR: "Yunani", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatamala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Pulau Heard dan Kepulauan McDonald", VA: "Vatikan", HN: "Honduras", HK: "Hong Kong", HU: "Hungaria", IS: "Islandia", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Israel", IT: "Italia", JM: "Jamaika", JP: "Jepang", JO: "Yordania", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Korea Utara", KR: "Korea Selatan", KW: "Kuwait", KG: "Kyrgyzstan", LA: "Laos", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxemburg", MO: "Makau", MK: "Makedonia Utara", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Kepulauan Marshall", MQ: "Martinik", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Meksiko", FM: "Federasi Mikronesia", MD: "Moldova", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Moroko", MZ: "Mozambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Belanda", NC: "Kaledonia Baru", NZ: "Selandia Baru", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Kepulauan Norfolk", MP: "Kepulauan Mariana Utara", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papua Nugini", PY: "Paraguay", PE: "Peru", PH: "Filipina", PN: "Pitcairn", PL: "Polandia", PT: "Portugal", PR: "Puerto Riko", QA: "Qatar", RE: "Reunion", RO: "Rumania", RU: "Rusia", RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts dan Nevis", LC: "Saint Lucia", PM: "Saint Pierre dan Miquelon", VC: "Saint Vincent dan the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome dan Principe", SA: "Arab Saudi", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapura", SK: "Slovakia", SI: "Slovenia", SB: "Kepulauan Solomon", SO: "Somalia", ZA: "Afrika Selatan", GS: "Georgia Selatan dan Kepulauan Sandwich Selatan", ES: "Spanyol", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard dan Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Swiss", SY: "Suriah", TW: "Taiwan", TJ: "Tajikistan", TZ: "Tanzania", TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad dan Tobago", TN: "Tunisia", TR: "Turki", TM: "Turkmenistan", TC: "Turks dan Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Uni Emirat Arab", GB: "Britania Raya", US: "Amerika Serikat", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Viet Nam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Sahara Barat", YE: "Yaman", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland Islands", BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "Sudan Selatan", XK: "Kosovo" }, ml = {
  locale: bo,
  countries: Mo
}, gl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Mo,
  default: ml,
  locale: bo
}, Symbol.toStringTag, { value: "Module" })), yo = "it", Co = { AD: "Andorra", AE: "Emirati Arabi Uniti", AF: "Afghanistan", AG: "Antigua e Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antartide", AR: "Argentina", AS: "Samoa Americane", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Isole Åland", AZ: "Azerbaigian", BA: "Bosnia ed Erzegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgio", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Isole BES", BR: "Brasile", BS: "Bahamas", BT: "Bhutan", BV: "Isola Bouvet", BW: "Botswana", BY: "Bielorussia", BZ: "Belize", CA: "Canada", CC: "Isole Cocos e Keeling", CD: "Repubblica Democratica del Congo", CF: "Repubblica Centrafricana", CG: "Repubblica del Congo", CH: "Svizzera", CI: "Costa d'Avorio", CK: "Isole Cook", CL: "Cile", CM: "Camerun", CN: "Cina", CO: "Colombia", CR: "Costa Rica", CU: "Cuba", CV: "Capo Verde", CW: "Curaçao", CX: "Isola del Natale", CY: "Cipro", CZ: "Repubblica Ceca", DE: "Germania", DJ: "Gibuti", DK: "Danimarca", DM: "Dominica", DO: "Repubblica Dominicana", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egitto", EH: "Sahara Occidentale", ER: "Eritrea", ES: "Spagna", ET: "Etiopia", FI: "Finlandia", FJ: "Figi", FK: "Isole Falkland", FM: "Stati Federati di Micronesia", FO: "Isole Fær Øer", FR: "Francia", GA: "Gabon", GB: "Regno Unito", GD: "Grenada", GE: "Georgia", GF: "Guyana Francese", GG: "Guernsey", GH: "Ghana", GI: "Gibilterra", GL: "Groenlandia", GM: "Gambia", GN: "Guinea", GP: "Guadalupa", GQ: "Guinea Equatoriale", GR: "Grecia", GS: "Georgia del Sud e isole Sandwich meridionali", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guyana", HK: "Hong Kong", HM: "Isole Heard e McDonald", HN: "Honduras", HR: "Croazia", HT: "Haiti", HU: "Ungheria", ID: "Indonesia", IE: "Irlanda", IL: "Israele", IM: "Isola di Man", IN: "India", IO: "Territori Britannici dell'Oceano Indiano", IQ: "Iraq", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Giamaica", JO: "Giordania", JP: "Giappone", KE: "Kenya", KG: "Kirghizistan", KH: "Cambogia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts e Nevis", KP: "Corea del Nord", KR: "Corea del Sud", KW: "Kuwait", KY: "Isole Cayman", KZ: "Kazakistan", LA: "Laos", LB: "Libano", LC: "Santa Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Lussemburgo", LV: "Lettonia", LY: "Libia", MA: "Marocco", MC: "Monaco", MD: "Moldavia", ME: "Montenegro", MF: "Saint-Martin", MG: "Madagascar", MH: "Isole Marshall", MK: "Macedonia del Nord", ML: "Mali", MM: "Birmania  Myanmar", MN: "Mongolia", MO: "Macao", MP: "Isole Marianne Settentrionali", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Messico", MY: "Malesia", MZ: "Mozambico", NA: "Namibia", NC: "Nuova Caledonia", NE: "Niger", NF: "Isola Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Paesi Bassi", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nuova Zelanda", OM: "Oman", PA: "Panamá", PE: "Perù", PF: "Polinesia Francese", PG: "Papua Nuova Guinea", PH: "Filippine", PK: "Pakistan", PL: "Polonia", PM: "Saint Pierre e Miquelon", PN: "Isole Pitcairn", PR: "Porto Rico", PS: "Stato di Palestina", PT: "Portogallo", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Romania", RS: "Serbia", RU: "Russia", RW: "Ruanda", SA: "Arabia Saudita", SB: "Isole Salomone", SC: "Seychelles", SD: "Sudan", SE: "Svezia", SG: "Singapore", SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha", SI: "Slovenia", SJ: "Svalbard e Jan Mayen", SK: "Slovacchia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudan del Sud", ST: "São Tomé e Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Siria", SZ: "Eswatini", TC: "Isole Turks e Caicos", TD: "Ciad", TF: "Territori Francesi del Sud", TG: "Togo", TH: "Thailandia", TJ: "Tagikistan", TK: "Tokelau", TL: "Timor Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turchia", TT: "Trinidad e Tobago", TV: "Tuvalu", TW: ["Repubblica di Cina", "Taiwan"], TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Isole minori esterne degli Stati Uniti", US: "Stati Uniti d'America", UY: "Uruguay", UZ: "Uzbekistan", VA: "Città del Vaticano", VC: "Saint Vincent e Grenadine", VE: "Venezuela", VG: "Isole Vergini Britanniche", VI: "Isole Vergini Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis e Futuna", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Sudafrica", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, vl = {
  locale: yo,
  countries: Co
}, Sl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Co,
  default: vl,
  locale: yo
}, Symbol.toStringTag, { value: "Module" })), ko = "ja", To = { AF: "アフガニスタン", AL: "アルバニア", DZ: "アルジェリア", AS: "アメリカ領サモア", AD: "アンドラ", AO: "アンゴラ", AI: "アンギラ", AQ: "南極", AG: "アンティグア・バーブーダ", AR: "アルゼンチン", AM: "アルメニア", AW: "アルバ", AU: "オーストラリア", AT: "オーストリア", AZ: "アゼルバイジャン", BS: "バハマ", BH: "バーレーン", BD: "バングラデシュ", BB: "バルバドス", BY: "ベラルーシ", BE: "ベルギー", BZ: "ベリーズ", BJ: "ベナン", BM: "バミューダ", BT: "ブータン", BO: "ボリビア多民族国", BA: "ボスニア・ヘルツェゴビナ", BW: "ボツワナ", BV: "ブーベ島", BR: "ブラジル", IO: "イギリス領インド洋地域", BN: "ブルネイ・ダルサラーム", BG: "ブルガリア", BF: "ブルキナファソ", BI: "ブルンジ", KH: "カンボジア", CM: "カメルーン", CA: "カナダ", CV: "カーボベルデ", KY: "ケイマン諸島", CF: "中央アフリカ共和国", TD: "チャド", CL: "チリ", CN: "中華人民共和国", CX: "クリスマス島", CC: "ココス（キーリング）諸島", CO: "コロンビア", KM: "コモロ", CG: "コンゴ共和国", CD: "コンゴ民主共和国", CK: "クック諸島", CR: "コスタリカ", CI: "コートジボワール", HR: "クロアチア", CU: "キューバ", CY: "キプロス", CZ: "チェコ", DK: "デンマーク", DJ: "ジブチ", DM: "ドミニカ国", DO: "ドミニカ共和国", EC: "エクアドル", EG: "エジプト", SV: "エルサルバドル", GQ: "赤道ギニア", ER: "エリトリア", EE: "エストニア", ET: "エチオピア", FK: "フォークランド（マルビナス）諸島", FO: "フェロー諸島", FJ: "フィジー", FI: "フィンランド", FR: "フランス", GF: "フランス領ギアナ", PF: "フランス領ポリネシア", TF: "フランス領南方・南極地域", GA: "ガボン", GM: "ガンビア", GE: "ジョージア", DE: "ドイツ", GH: "ガーナ", GI: "ジブラルタル", GR: "ギリシャ", GL: "グリーンランド", GD: "グレナダ", GP: "グアドループ", GU: "グアム", GT: "グアテマラ", GN: "ギニア", GW: "ギニアビサウ", GY: "ガイアナ", HT: "ハイチ", HM: "ハード島とマクドナルド諸島", VA: "バチカン市国", HN: "ホンジュラス", HK: "香港", HU: "ハンガリー", IS: "アイスランド", IN: "インド", ID: "インドネシア", IR: "イラン・イスラム共和国", IQ: "イラク", IE: "アイルランド", IL: "イスラエル", IT: "イタリア", JM: "ジャマイカ", JP: "日本", JO: "ヨルダン", KZ: "カザフスタン", KE: "ケニア", KI: "キリバス", KP: "朝鮮民主主義人民共和国", KR: "大韓民国", KW: "クウェート", KG: "キルギス", LA: "ラオス人民民主共和国", LV: "ラトビア", LB: "レバノン", LS: "レソト", LR: "リベリア", LY: "リビア", LI: "リヒテンシュタイン", LT: "リトアニア", LU: "ルクセンブルク", MO: "マカオ", MG: "マダガスカル", MW: "マラウイ", MY: "マレーシア", MV: "モルディブ", ML: "マリ", MT: "マルタ", MH: "マーシャル諸島", MQ: "マルティニーク", MR: "モーリタニア", MU: "モーリシャス", YT: "マヨット", MX: "メキシコ", FM: "ミクロネシア連邦", MD: "モルドバ共和国", MC: "モナコ", MN: "モンゴル", MS: "モントセラト", MA: "モロッコ", MZ: "モザンビーク", MM: "ミャンマー", NA: "ナミビア", NR: "ナウル", NP: "ネパール", NL: "オランダ", NC: "ニューカレドニア", NZ: "ニュージーランド", NI: "ニカラグア", NE: "ニジェール", NG: "ナイジェリア", NU: "ニウエ", NF: "ノーフォーク島", MK: "北マケドニア", MP: "北マリアナ諸島", NO: "ノルウェー", OM: "オマーン", PK: "パキスタン", PW: "パラオ", PS: "パレスチナ", PA: "パナマ", PG: "パプアニューギニア", PY: "パラグアイ", PE: "ペルー", PH: "フィリピン", PN: "ピトケアン", PL: "ポーランド", PT: "ポルトガル", PR: "プエルトリコ", QA: "カタール", RE: "レユニオン", RO: "ルーマニア", RU: "ロシア連邦", RW: "ルワンダ", SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ", KN: "セントクリストファー・ネイビス", LC: "セントルシア", PM: "サンピエール島・ミクロン島", VC: "セントビンセントおよびグレナディーン諸島", WS: "サモア", SM: "サンマリノ", ST: "サントメ・プリンシペ", SA: "サウジアラビア", SN: "セネガル", SC: "セーシェル", SL: "シエラレオネ", SG: "シンガポール", SK: "スロバキア", SI: "スロベニア", SB: "ソロモン諸島", SO: "ソマリア", ZA: "南アフリカ", GS: "サウスジョージア・サウスサンドウィッチ諸島", ES: "スペイン", LK: "スリランカ", SD: "スーダン", SR: "スリナム", SJ: "スヴァールバル諸島およびヤンマイエン島", SZ: "スワジランド", SE: "スウェーデン", CH: "スイス", SY: "シリア・アラブ共和国", TW: "台湾", TJ: "タジキスタン", TZ: "タンザニア", TH: "タイ", TL: "東ティモール", TG: "トーゴ", TK: "トケラウ", TO: "トンガ", TT: "トリニダード・トバゴ", TN: "チュニジア", TR: "トルコ", TM: "トルクメニスタン", TC: "タークス・カイコス諸島", TV: "ツバル", UG: "ウガンダ", UA: "ウクライナ", AE: "アラブ首長国連邦", GB: "イギリス", US: "アメリカ合衆国", UM: "合衆国領有小離島", UY: "ウルグアイ", UZ: "ウズベキスタン", VU: "バヌアツ", VE: "ベネズエラ・ボリバル共和国", VN: "ベトナム", VG: "イギリス領ヴァージン諸島", VI: "アメリカ領ヴァージン諸島", WF: "ウォリス・フツナ", EH: "西サハラ", YE: "イエメン", ZM: "ザンビア", ZW: "ジンバブエ", AX: "オーランド諸島", BQ: "ボネール、シント・ユースタティウスおよびサバ", CW: "キュラソー", GG: "ガーンジー", IM: "マン島", JE: "ジャージー", ME: "モンテネグロ", BL: "サン・バルテルミー", MF: "サン・マルタン（フランス領）", RS: "セルビア", SX: "シント・マールテン（オランダ領）", SS: "南スーダン", XK: "コソボ" }, bl = {
  locale: ko,
  countries: To
}, Ml = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: To,
  default: bl,
  locale: ko
}, Symbol.toStringTag, { value: "Module" })), wo = "nl", Ao = { AF: "Afghanistan", AL: "Albanië", DZ: "Algerije", AS: "Amerikaans-Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua en Barbuda", AR: "Argentinië", AM: "Armenië", AW: "Aruba", AU: "Australië", AT: "Oostenrijk", AZ: "Azerbeidzjan", BS: "Bahama's", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Wit-Rusland", BE: ["België", "Koninkrijk België"], BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivië", BA: "Bosnië-Herzegovina", BW: "Botswana", BV: "Bouvet Eiland", BR: "Brazilië", IO: "Brits Indische oceaan", BN: "Brunei Darussalam", BG: "Bulgarije", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Kameroen", CA: "Canada", CV: "Kaapverdië", KY: "Kaaimaneilanden", CF: "Centraal-Afrikaanse Republiek", TD: "Tsjaad", CL: "Chili", CN: "China", CX: "Christmaseiland", CC: "Cocoseilanden", CO: "Colombia", KM: "Comoren", CG: "Congo, Volksrepubliek", CD: "Congo, Democratische Republiek", CK: "Cookeilanden", CR: "Costa Rica", CI: "Ivoorkust", HR: "Kroatië", CU: "Cuba", CY: "Cyprus", CZ: "Tsjechië", DK: "Denemarken", DJ: "Djibouti", DM: "Dominica", DO: "Dominicaanse Republiek", EC: "Ecuador", EG: "Egypte", SV: "El Salvador", GQ: "Equatoriaal-Guinea", ER: "Eritrea", EE: "Estland", ET: "Ethiopië", FK: "Falklandeilanden", FO: "Faeröer", FJ: "Fiji", FI: "Finland", FR: "Frankrijk", GF: "Frans-Guyana", PF: "Frans-Polynesië", TF: "Franse Zuidelijke Gebieden", GA: "Gabon", GM: "Gambia", GE: "Georgië", DE: "Duitsland", GH: "Ghana", GI: "Gibraltar", GR: "Griekenland", GL: "Groenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinee-Bissau", GY: "Guyana", HT: "Haïti", HM: "Heard en McDonaldeilanden", VA: "Heilige Stoel", HN: "Honduras", HK: "Hong Kong", HU: "Hongarije", IS: "IJsland", IN: "India", ID: "Indonesië", IR: "Iran", IQ: "Irak", IE: "Ierland", IL: "Israël", IT: "Italië", JM: "Jamaica", JP: "Japan", JO: "Jordanië", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Noord-Korea", KR: "Zuid-Korea", KW: "Koeweit", KG: "Kirgizstan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libië", LI: "Liechtenstein", LT: "Litouwen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Maleisië", MV: ["Maldiven", "Malediven"], ML: "Mali", MT: "Malta", MH: "Marshalleilanden", MQ: "Martinique", MR: "Mauritanië", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesië, Federale Staten", MD: "Moldavië", MC: "Monaco", MN: "Mongolië", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar", NA: "Namibië", NR: "Nauru", NP: "Nepal", NL: ["Nederland", "Koninkrijk der Nederlanden"], NC: "Nieuw-Caledonië", NZ: "Nieuw-Zeeland", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Noordelijke Marianen", MK: "Noord-Macedonië", NO: "Noorwegen", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papoea-Nieuw-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filipijnen", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Roemenië", RU: "Rusland", RW: "Rwanda", SH: "Sint-Helena", KN: "Saint Kitts en Nevis", LC: "Saint Lucia", PM: "Saint-Pierre en Miquelon", VC: "Saint Vincent en de Grenadines", WS: "Samoa", SM: "San Marino", ST: "São Tomé en Principe", SA: "Saudi-Arabië", SN: "Senegal", SC: "Seychellen", SL: "Sierra Leone", SG: "Singapore", SK: "Slowakije", SI: "Slovenië", SB: "Salomonseilanden", SO: "Somalië", ZA: "Zuid-Afrika", GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden", ES: "Spanje", LK: "Sri Lanka", SD: "Soedan", SR: "Suriname", SJ: "Spitsbergen en Jan Mayen", SZ: "Ngwane, Koninkrijk Eswatini", SE: "Zweden", CH: "Zwitserland", SY: "Syrië", TW: "Taiwan", TJ: "Tadzjikistan", TZ: ["Tanzania", "Tanzania, Verenigde Republiek"], TH: "Thailand", TL: "Timor Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad en Tobago", TN: "Tunesië", TR: "Turkije", TM: "Turkmenistan", TC: "Turks- en Caicoseilanden", TV: "Tuvalu", UG: "Oeganda", UA: "Oekraïne", AE: "Verenigde Arabische Emiraten", GB: ["Groot-Brittannië", "Verenigd Koninkrijk"], US: ["Verenigde Staten van Amerika", "Verenigde Staten"], UM: "Ver afgelegen eilandjes van de Verenigde Staten", UY: "Uruguay", UZ: "Oezbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Maagdeneilanden, Britse", VI: "Maagdeneilanden, Amerikaanse", WF: "Wallis en Futuna", EH: "Westelijke Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Sint Eustatius en Saba", CW: "Curaçao", GG: "Guernsey", IM: "Man Eiland", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: ["Sint-Maarten (Frans deel)", "Sint-Maarten (Franse Antillen)", "Collectiviteit van Sint-Maarten"], RS: "Servië", SX: ["Sint Maarten", "Sint-Maarten", "Sint Maarten (Nederlands deel)", "Land Sint Maarten"], SS: "Zuid-Soedan", XK: "Kosovo" }, yl = {
  locale: wo,
  countries: Ao
}, Cl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ao,
  default: yl,
  locale: wo
}, Symbol.toStringTag, { value: "Module" })), No = "no", Do = { AF: "Afghanistan", AL: "Albania", DZ: "Algerie", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Østerrike", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviterussland", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia-Hercegovina", BW: "Botswana", BV: "Bouvetøya", BR: "Brasil", IO: "Det britiske territoriet i Indiahavet", BN: "Brunei", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodsja", CM: "Kamerun", CA: "Canada", CV: "Kapp Verde", KY: "Caymanøyene", CF: "Den sentralafrikanske republikk", TD: "Tsjad", CL: "Chile", CN: "Kina", CX: "Christmasøya", CC: "Kokosøyene", CO: "Colombia", KM: "Komorene", CG: "Kongo-Brazzaville", CD: "Kongo", CK: "Cookøyene", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatia", CU: "Cuba", CY: "Kypros", CZ: "Tsjekkia", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Den dominikanske republikk", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Ekvatorial-Guinea", ER: "Eritrea", EE: "Estland", ET: "Etiopia", FK: "Falklandsøyene", FO: "Færøyene", FJ: "Fiji", FI: "Finland", FR: "Frankrike", GF: "Fransk Guyana", PF: "Fransk Polynesia", TF: "De franske sørterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Hellas", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard- og McDonaldøyene", VA: "Vatikanstaten", HN: "Honduras", HK: "Hongkong SAR Kina", HU: "Ungarn", IS: "Island", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kasakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nord-Korea", KR: "Sør-Korea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Latvia", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao SAR Kina", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldivene", ML: "Mali", MT: "Malta", MH: "Marshalløyene", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesiaføderasjonen", MD: "Moldova", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Marokko", MZ: "Mosambik", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Nederland", NC: "Ny-Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolkøya", MK: "Nord-Makedonia", MP: "Nord-Marianene", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Det palestinske området", PA: "Panama", PG: "Papua Ny-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinene", PN: "Pitcairnøyene", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Romania", RU: "Russland", RW: "Rwanda", SH: "St. Helena", KN: "Saint Kitts og Nevis", LC: "St. Lucia", PM: "Saint-Pierre-et-Miquelon", VC: "St. Vincent og Grenadinene", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabia", SN: "Senegal", SC: "Seychellene", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Salomonøyene", SO: "Somalia", ZA: "Sør-Afrika", GS: "Sør-Georgia og Sør-Sandwichøyene", ES: "Spania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Sveits", SY: "Syria", TW: "Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Øst-Timor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunisia", TR: "Tyrkia", TM: "Turkmenistan", TC: "Turks- og Caicosøyene", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "De forente arabiske emirater", GB: "Storbritannia", US: "USA", UM: "USAs ytre øyer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "De britiske jomfruøyene", VI: "De amerikanske jomfruøyene", WF: "Wallis og Futuna", EH: "Vest-Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibisk Nederland", CW: "Curaçao", GG: "Guernsey", IM: "Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sør-Sudan", XK: "Kosovo" }, kl = {
  locale: No,
  countries: Do
}, Tl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Do,
  default: kl,
  locale: No
}, Symbol.toStringTag, { value: "Module" })), Io = "pl", Eo = { AF: "Afganistan", AL: "Albania", DZ: "Algieria", AS: "Samoa Amerykańskie", AD: "Andora", AO: "Angola", AI: "Anguilla", AQ: "Antarktyka", AG: "Antigua i Barbuda", AR: "Argentyna", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbejdżan", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladesz", BB: "Barbados", BY: "Białoruś", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermudy", BT: "Bhutan", BO: "Boliwia", BA: "Bośnia i Hercegowina", BW: "Botswana", BV: "Wyspa Bouveta", BR: "Brazylia", IO: "Brytyjskie Terytorium Oceanu Indyjskiego", BN: "Brunei", BG: "Bułgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodża", CM: "Kamerun", CA: "Kanada", CV: "Republika Zielonego Przylądka", KY: "Kajmany", CF: "Republika Środkowoafrykańska", TD: "Czad", CL: "Chile", CN: "Chiny", CX: "Wyspa Bożego Narodzenia", CC: "Wyspy Kokosowe", CO: "Kolumbia", KM: "Komory", CG: "Kongo", CD: "Demokratyczna Republika Konga", CK: "Wyspy Cooka", CR: "Kostaryka", CI: "Wybrzeże Kości Słoniowej", HR: "Chorwacja", CU: "Kuba", CY: "Cypr", CZ: "Czechy", DK: "Dania", DJ: "Dżibuti", DM: "Dominika", DO: "Dominikana", EC: "Ekwador", EG: "Egipt", SV: "Salwador", GQ: "Gwinea Równikowa", ER: "Erytrea", EE: "Estonia", ET: "Etiopia", FK: "Falklandy", FO: "Wyspy Owcze", FJ: "Fidżi", FI: "Finlandia", FR: "Francja", GF: "Gujana Francuska", PF: "Polinezja Francuska", TF: "Francuskie Terytoria Południowe i Antarktyczne", GA: "Gabon", GM: "Gambia", GE: "Gruzja", DE: "Niemcy", GH: "Ghana", GI: "Gibraltar", GR: "Grecja", GL: "Grenlandia", GD: "Grenada", GP: "Gwadelupa", GU: "Guam", GT: "Gwatemala", GN: "Gwinea", GW: "Gwinea Bissau", GY: "Gujana", HT: "Haiti", HM: "Wyspy Heard i McDonalda", VA: "Watykan", HN: "Honduras", HK: "Hongkong", HU: "Węgry", IS: "Islandia", IN: "Indie", ID: "Indonezja", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Izrael", IT: "Włochy", JM: "Jamajka", JP: "Japonia", JO: "Jordania", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Korea Północna", KR: "Korea Południowa", KW: "Kuwejt", KG: "Kirgistan", LA: "Laos", LV: "Łotwa", LB: "Liban", LS: "Lesotho", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Litwa", LU: "Luksemburg", MO: "Makau", MK: "Macedonia Północna", MG: "Madagaskar", MW: "Malawi", MY: "Malezja", MV: "Malediwy", ML: "Mali", MT: "Malta", MH: "Wyspy Marshalla", MQ: "Martynika", MR: "Mauretania", MU: "Mauritius", YT: "Majotta", MX: "Meksyk", FM: "Mikronezja", MD: "Mołdawia", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Maroko", MZ: "Mozambik", MM: "Mjanma", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holandia", NC: "Nowa Kaledonia", NZ: "Nowa Zelandia", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Mariany Północne", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestyna", PA: "Panama", PG: "Papua-Nowa Gwinea", PY: "Paragwaj", PE: "Peru", PH: "Filipiny", PN: "Pitcairn", PL: "Polska", PT: "Portugalia", PR: "Portoryko", QA: "Katar", RE: "Reunion", RO: "Rumunia", RU: "Rosja", RW: "Rwanda", SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha", KN: "Saint Kitts i Nevis", LC: "Saint Lucia", PM: "Saint-Pierre i Miquelon", VC: "Saint Vincent i Grenadyny", WS: "Samoa", SM: "San Marino", ST: "Wyspy Świętego Tomasza i Książęca", SA: "Arabia Saudyjska", SN: "Senegal", SC: "Seszele", SL: "Sierra Leone", SG: "Singapur", SK: "Słowacja", SI: "Słowenia", SB: "Wyspy Salomona", SO: "Somalia", ZA: "Południowa Afryka", GS: "Georgia Południowa i Sandwich Południowy", ES: "Hiszpania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard i Jan Mayen", SZ: "Eswatini", SE: "Szwecja", CH: "Szwajcaria", SY: "Syria", TW: "Tajwan", TJ: "Tadżykistan", TZ: "Tanzania", TH: "Tajlandia", TL: "Timor Wschodni", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trynidad i Tobago", TN: "Tunezja", TR: "Turcja", TM: "Turkmenistan", TC: "Turks i Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Zjednoczone Emiraty Arabskie", GB: "Wielka Brytania", US: "Stany Zjednoczone", UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych", UY: "Urugwaj", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Wenezuela", VN: "Wietnam", VG: "Brytyjskie Wyspy Dziewicze", VI: "Wyspy Dziewicze Stanów Zjednoczonych", WF: "Wallis i Futuna", EH: "Sahara Zachodnia", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Wyspy Alandzkie", BQ: "Bonaire, Sint Eustatius i Saba", CW: "Curaçao", GG: "Guernsey", IM: "Wyspa Man", JE: "Jersey", ME: "Czarnogóra", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sudan Południowy", XK: "Kosowo" }, wl = {
  locale: Io,
  countries: Eo
}, Al = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Eo,
  default: wl,
  locale: Io
}, Symbol.toStringTag, { value: "Module" })), Bo = "pt", Po = { AF: "Afeganistão", ZA: "África do Sul", AL: "Albânia", DE: "Alemanha", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antígua e Barbuda", SA: "Arábia Saudita", DZ: "Argélia", AR: "Argentina", AM: "Arménia", AW: "Aruba", AU: "Austrália", AT: "Áustria", AZ: "Azerbaijão", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BE: "Bélgica", BZ: "Belize", BJ: "Benim", BM: "Bermudas", BY: "Bielorrússia", BO: "Bolívia", BA: "Bósnia-Herzegovina", BW: "Botsuana", BR: "Brasil", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", BT: "Butão", CV: "Cabo Verde", KH: "Camboja", CA: "Canadá", QA: "Qatar", KZ: "Cazaquistão", TD: "Chade", CL: "Chile", CN: "China", CY: "Chipre", VA: "Santa Sé", SG: "Singapura", CO: "Colômbia", KM: "Comores", CG: "República Democrática do Congo", CD: "República Popular do Congo", KP: "Coreia do Norte", KR: "Coreia do Sul", CI: "Costa do Marfim", CR: "Costa Rica", HR: "Croácia", CU: "Cuba", CW: "Curaçao", DK: "Dinamarca", DJ: "Djibouti", DM: "Dominica", EG: "Egito", SV: "El Salvador", AE: "Emirados Árabes Unidos", EC: "Equador", ER: "Eritreia", SK: "Eslováquia", SI: "Eslovénia", ES: "Espanha", US: ["Estados Unidos", "Estados Unidos da América"], EE: "Estónia", ET: "Etiópia", FJ: "Fiji", PH: "Filipinas", FI: "Finlândia", FR: "França", GA: "Gabão", GM: "Gâmbia", GH: "Gana", GE: "Geórgia", GS: "Geórgia do Sul e Ilhas Sandwich do Sul", GI: "Gibraltar", GD: "Granada", GR: "Grécia", GL: "Gronelândia", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GY: "Guiana", GF: "Guiana Francesa", GN: "Guiné", GW: "Guiné-Bissau", GQ: "Guiné Equatorial", HT: "Haiti", NL: "Países Baixos", HN: "Honduras", HK: "Hong Kong", HU: "Hungria", YE: "Iémen", BV: "Ilha Bouvet", CX: "Ilha de Natal", IM: "Ilha de Man", NF: "Ilha Norfolk", AX: "Ilhas Åland", KY: "Ilhas Caimão", CC: "Ilhas Cocos (Keeling)", CK: "Ilhas Cook", UM: "Ilhas Distantes dos EUA", HM: "Ilha Heard e Ilhas McDonald", FO: "Ilhas Faroé", FK: "Ilhas Malvinas", MP: "Ilhas Marianas do Norte", MH: "Ilhas Marshall", PN: "Ilhas Pitcairn", SB: "Ilhas Salomão", TC: "Ilhas Turcas e Caicos", VG: "Ilhas Virgens Britânicas", VI: "Ilhas Virgens Americanas", IN: "Índia", ID: "Indonésia", IR: "Irão", IQ: "Iraque", IE: "Irlanda", IS: "Islândia", IL: "Israel", IT: "Itália", JM: "Jamaica", JP: "Japão", JE: "Jersey", JO: "Jordânia", KW: "Koweit", LA: "Laos", LS: "Lesoto", LV: "Letónia", LB: "Líbano", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Lituânia", LU: "Luxemburgo", MO: "Macau", MK: "Macedónia do Norte", MG: "Madagáscar", MY: "Malásia", MW: "Maláui", MV: "Maldivas", ML: "Mali", MT: "Malta", MA: "Marrocos", MQ: "Martinica", MU: "Maurícia", MR: "Mauritânia", YT: "Mayotte", MX: "México", MM: "Mianmar (Birmânia)", FM: "Micronésia", MZ: "Moçambique", MD: "Moldávia", MC: "Mónaco", MN: "Mongólia", ME: "Montenegro", MS: "Monserrate", NA: "Namíbia", NR: "Nauru", NP: "Nepal", NI: "Nicarágua", NE: "Níger", NG: "Nigéria", NU: "Niue", NO: "Noruega", NC: "Nova Caledónia", NZ: "Nova Zelândia", OM: "Omã", BQ: "Países Baixos Caribenhos", PW: "Palau", PA: "Panamá", PG: "Papua-Nova Guiné", PK: "Paquistão", PY: "Paraguai", PE: "Peru", PF: "Polinésia Francesa", PL: "Polónia", PR: "Porto Rico", PT: "Portugal", KE: "Quénia", KG: "Quirguistão", KI: "Quiribati", GB: "Reino Unido", CF: "República Centro-Africana", DO: "República Dominicana", CM: "Camarões", CZ: "Chéquia", RE: "Reunião", RO: "Roménia", RW: "Ruanda", RU: "Rússia", EH: "Saara Ocidental", PM: "Saint Pierre e Miquelon", WS: "Samoa", AS: "Samoa Americana", SM: "San Marino", SH: "Santa Helena", LC: "Santa Lúcia", BL: "São Bartolomeu", KN: "São Cristóvão e Neves", MF: "São Martinho", ST: "São Tomé e Príncipe", VC: "São Vicente e Granadinas", SN: "Senegal", SL: "Serra Leoa", RS: "Sérvia", SC: "Seychelles", SX: "São Martinho", SY: "Síria", SO: "Somália", LK: "Sri Lanka", SZ: "Essuatíni", SD: "Sudão", SS: "Sudão do Sul", SE: "Suécia", CH: "Suíça", SR: "Suriname", SJ: "Svalbard e Jan Mayen", TH: "Tailândia", TW: "Taiwan", TJ: "Tajiquistão", TZ: "Tanzânia", IO: "Território Britânico do Oceano Índico", TF: "Terras Austrais e Antárticas Francesas", PS: "Territórios palestinos", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trindade e Tobago", TN: "Tunísia", TM: "Turquemenistão", TR: "Turquia", TV: "Tuvalu", UA: "Ucrânia", UG: "Uganda", UY: "Uruguai", UZ: "Uzbequistão", VU: "Vanuatu", VE: "Venezuela", VN: "Vietname", WF: "Wallis e Futuna", ZM: "Zâmbia", ZW: "Zimbábue", XK: "Kosovo" }, Nl = {
  locale: Bo,
  countries: Po
}, Dl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Po,
  default: Nl,
  locale: Bo
}, Symbol.toStringTag, { value: "Module" })), Oo = "ro", Go = { AD: "Andorra", AE: "Emiratele Arabe Unite", AF: "Afganistan", AG: "Antigua și Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antarctica", AR: "Argentina", AS: "Samoa Americană", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Insulele Åland", AZ: "Azerbaidjan", BA: "Bosnia și Herțegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgia", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Sfântul Bartolomeu", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Insulele Caraibe Olandeze", BR: "Brazilia", BS: "Bahamas", BT: "Bhutan", BV: "Insula Bouvet", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Canada", CC: "Insulele Cocos (Keeling)", CD: "Congo - Kinshasa", CF: "Republica Centrafricană", CG: "Congo - Brazzaville", CH: "Elveția", CI: "Côte d’Ivoire", CK: "Insulele Cook", CL: "Chile", CM: "Camerun", CN: "China", CO: "Columbia", CR: "Costa Rica", CU: "Cuba", CV: "Capul Verde", CW: "Curaçao", CX: "Insula Christmas", CY: "Cipru", CZ: "Cehia", DE: "Germania", DJ: "Djibouti", DK: "Danemarca", DM: "Dominica", DO: "Republica Dominicană", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egipt", EH: "Sahara Occidentală", ER: "Eritreea", ES: "Spania", ET: "Etiopia", FI: "Finlanda", FJ: "Fiji", FK: "Insulele Falkland", FM: "Micronezia", FO: "Insulele Feroe", FR: "Franța", GA: "Gabon", GB: "Regatul Unit", GD: "Grenada", GE: "Georgia", GF: "Guyana Franceză", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Groenlanda", GM: "Gambia", GN: "Guineea", GP: "Guadelupa", GQ: "Guineea Ecuatorială", GR: "Grecia", GS: "Georgia de Sud și Insulele Sandwich de Sud", GT: "Guatemala", GU: "Guam", GW: "Guineea-Bissau", GY: "Guyana", HK: "R.A.S. Hong Kong a Chinei", HM: "Insula Heard și Insulele McDonald", HN: "Honduras", HR: "Croația", HT: "Haiti", HU: "Ungaria", ID: "Indonezia", IE: "Irlanda", IL: "Israel", IM: "Insula Man", IN: "India", IO: "Teritoriul Britanic din Oceanul Indian", IQ: "Irak", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Jamaica", JO: "Iordania", JP: "Japonia", KE: "Kenya", KG: "Kârgâzstan", KH: "Cambodgia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts și Nevis", KP: "Coreea de Nord", KR: "Coreea de Sud", KW: "Kuweit", KY: "Insulele Cayman", KZ: "Kazahstan", LA: "Laos", LB: "Liban", LC: "Sfânta Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Luxemburg", LV: "Letonia", LY: "Libia", MA: "Maroc", MC: "Monaco", MD: "Republica Moldova", ME: "Muntenegru", MF: "Sfântul Martin", MG: "Madagascar", MH: "Insulele Marshall", MK: "Macedonia de Nord", ML: "Mali", MM: "Myanmar", MN: "Mongolia", MO: "R.A.S. Macao a Chinei", MP: "Insulele Mariane de Nord", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Mexic", MY: "Malaysia", MZ: "Mozambic", NA: "Namibia", NC: "Noua Caledonie", NE: "Niger", NF: "Insula Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Țările de Jos", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Noua Zeelandă", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Polinezia Franceză", PG: "Papua-Noua Guinee", PH: "Filipine", PK: "Pakistan", PL: "Polonia", PM: "Saint-Pierre și Miquelon", PN: "Insulele Pitcairn", PR: "Puerto Rico", PS: "Teritoriile Palestiniene", PT: "Portugalia", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "România", RS: "Serbia", RU: "Rusia", RW: "Rwanda", SA: "Arabia Saudită", SB: "Insulele Solomon", SC: "Seychelles", SD: "Sudan", SE: "Suedia", SG: "Singapore", SH: "Sfânta Elena", SI: "Slovenia", SJ: "Svalbard și Jan Mayen", SK: "Slovacia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudanul de Sud", ST: "Sao Tomé și Príncipe", SV: "El Salvador", SX: "Sint-Maarten", SY: "Siria", SZ: "Eswatini", TC: "Insulele Turks și Caicos", TD: "Ciad", TF: "Teritoriile Australe și Antarctice Franceze", TG: "Togo", TH: "Thailanda", TJ: "Tadjikistan", TK: "Tokelau", TL: "Timorul de Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turcia", TT: "Trinidad și Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Insulele Îndepărtate ale S.U.A.", US: "Statele Unite ale Americii", UY: "Uruguay", UZ: "Uzbekistan", VA: "Statul Cetății Vaticanului", VC: "Saint Vincent și Grenadinele", VE: "Venezuela", VG: "Insulele Virgine Britanice", VI: "Insulele Virgine Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis și Futuna", WS: "Samoa", XK: "Kosovo", YE: "Yemen", YT: "Mayotte", ZA: "Africa de Sud", ZM: "Zambia", ZW: "Zimbabwe" }, Il = {
  locale: Oo,
  countries: Go
}, El = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Go,
  default: Il,
  locale: Oo
}, Symbol.toStringTag, { value: "Module" })), Lo = "ru", Ro = { AU: "Австралия", AT: "Австрия", AZ: "Азербайджан", AX: "Аландские острова", AL: "Албания", DZ: "Алжир", VI: "Виргинские Острова (США)", AS: "Американское Самоа", AI: "Ангилья", AO: "Ангола", AD: "Андорра", AQ: "Антарктида", AG: "Антигуа и Барбуда", AR: "Аргентина", AM: "Армения", AW: "Аруба", AF: "Афганистан", BS: "Багамы", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Белиз", BY: "Беларусь", BE: "Бельгия", BJ: "Бенин", BM: "Бермуды", BG: "Болгария", BO: "Боливия", BQ: "Бонэйр, Синт-Эстатиус и Саба", BA: "Босния и Герцеговина", BW: "Ботсвана", BR: "Бразилия", IO: "Британская территория в Индийском океане", VG: "Виргинские Острова (Великобритания)", BN: "Бруней", BF: "Буркина-Фасо", BI: "Бурунди", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобритания", HU: "Венгрия", VE: "Венесуэла", UM: "Внешние малые острова (США)", TL: "Восточный Тимор", VN: "Вьетнам", GA: "Габон", HT: "Гаити", GY: "Гайана", GM: "Гамбия", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвиана", GN: "Гвинея", GW: "Гвинея-Бисау", DE: "Германия", GG: "Гернси", GI: "Гибралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GL: "Гренландия", GR: "Греция", GE: "Грузия", GU: "Гуам", DK: "Дания", JE: "Джерси", DJ: "Джибути", DM: "Доминика", DO: "Доминиканская Республика", CD: "Демократическая Республика Конго", EG: "Египет", ZM: "Замбия", EH: "САДР", ZW: "Зимбабве", IL: "Израиль", IN: "Индия", ID: "Индонезия", JO: "Иордания", IQ: "Ирак", IR: "Иран", IE: "Ирландия", IS: "Исландия", ES: "Испания", IT: "Италия", YE: "Йемен", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Острова Кайман", KH: "Камбоджа", CM: "Камерун", CA: "Канада", QA: "Катар", KE: "Кения", CY: "Кипр", KG: "Киргизия", KI: "Кирибати", TW: ["Тайвань", "Китайская Республика"], KP: "КНДР (Корейская Народно-Демократическая Республика)", CN: "КНР (Китайская Народная Республика)", CC: "Кокосовые острова", CO: "Колумбия", KM: "Коморы", CR: "Коста-Рика", CI: "Кот-д’Ивуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвия", LS: "Лесото", LR: "Либерия", LB: "Ливан", LY: "Ливия", LT: "Литва", LI: "Лихтенштейн", LU: "Люксембург", MU: "Маврикий", MR: "Мавритания", MG: "Мадагаскар", YT: "Майотта", MO: "Макао", MW: "Малави", MY: "Малайзия", ML: "Мали", MV: "Мальдивы", MT: "Мальта", MA: "Марокко", MQ: "Мартиника", MH: "Маршалловы Острова", MX: "Мексика", FM: "Микронезия", MZ: "Мозамбик", MD: "Молдавия", MC: "Монако", MN: "Монголия", MS: "Монтсеррат", MM: "Мьянма", NA: "Намибия", NR: "Науру", NP: "Непал", NE: "Нигер", NG: "Нигерия", NL: "Нидерланды", NI: "Никарагуа", NU: "Ниуэ", NZ: "Новая Зеландия", NC: "Новая Каледония", NO: "Норвегия", AE: "ОАЭ", OM: "Оман", BV: "Остров Буве", IM: "Остров Мэн", CK: "Острова Кука", NF: "Остров Норфолк", CX: "Остров Рождества", PN: "Острова Питкэрн", SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья", PK: "Пакистан", PW: "Палау", PS: "Государство Палестина", PA: "Панама", PG: "Папуа — Новая Гвинея", PY: "Парагвай", PE: "Перу", PL: "Польша", PT: "Португалия", PR: "Пуэрто-Рико", CG: "Республика Конго", KR: "Республика Корея", RE: "Реюньон", RU: ["Российская Федерация", "Россия"], RW: "Руанда", RO: "Румыния", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе и Принсипи", SA: "Саудовская Аравия", SZ: "Эсватини", MK: "Северная Македония", MP: "Северные Марианские Острова", SC: "Сейшельские Острова", BL: "Сен-Бартелеми", MF: "Сен-Мартен", PM: "Сен-Пьер и Микелон", SN: "Сенегал", VC: "Сент-Винсент и Гренадины", KN: "Сент-Китс и Невис", LC: "Сент-Люсия", RS: "Сербия", SG: "Сингапур", SX: "Синт-Мартен", SY: "Сирия", SK: "Словакия", SI: "Словения", SB: "Соломоновы Острова", SO: "Сомали", SD: "Судан", SR: "Суринам", US: "США", SL: "Сьерра-Леоне", TJ: "Таджикистан", TH: "Таиланд", TZ: "Танзания", TC: "Теркс и Кайкос", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринидад и Тобаго", TV: "Тувалу", TN: "Тунис", TM: "Туркмения", TR: "Турция", UG: "Уганда", UZ: "Узбекистан", UA: "Украина", WF: "Уоллис и Футуна", UY: "Уругвай", FO: "Фареры", FJ: "Фиджи", PH: "Филиппины", FI: "Финляндия", FK: "Фолклендские острова", FR: "Франция", PF: "Французская Полинезия", TF: "Французские Южные и Антарктические Территории", HM: "Херд и Макдональд", HR: "Хорватия", CF: "ЦАР", TD: "Чад", ME: "Черногория", CZ: "Чехия", CL: "Чили", CH: "Швейцария", SE: "Швеция", SJ: "Шпицберген и Ян-Майен", LK: "Шри-Ланка", EC: "Эквадор", GQ: "Экваториальная Гвинея", ER: "Эритрея", EE: "Эстония", ET: "Эфиопия", ZA: "ЮАР", GS: "Южная Георгия и Южные Сандвичевы Острова", SS: "Южный Судан", JM: "Ямайка", JP: "Япония", XK: "Косово" }, Bl = {
  locale: Lo,
  countries: Ro
}, Pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ro,
  default: Bl,
  locale: Lo
}, Symbol.toStringTag, { value: "Module" })), _o = "sk", Fo = { AD: "Andorra", AE: "Spojené arabské emiráty", AF: "Afganistan", AG: "Antigua a Barbuda", AI: "Anguilla", AL: "Albánsko", AM: "Arménsko", AO: "Angola", AQ: "Antarktída", AR: "Argentína", AS: "Americká Samoa", AT: "Rakúsko", AU: "Austrália", AW: "Aruba", AX: "Alandy", AZ: "Azerbajdžan", BA: "Bosna a Hercegovina", BB: "Barbados", BD: "Bangladéš", BE: "Belgicko", BF: "Burkina Faso", BG: "Bulharsko", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Svätý Bartolomej", BM: "Bermudy", BN: "Brunej", BO: "Bolívia", BQ: "Karibské Holandsko", BR: "Brazília", BS: "Bahamy", BT: "Bhután", BV: "Bouvetov ostrov", BW: "Botswana", BY: "Bielorusko", BZ: "Belize", CA: "Kanada", CC: "Kokosové ostrovy", CD: "Konžská demokratická republika", CF: "Stredoafrická republika", CG: "Konžská republika", CH: "Švajčiarsko", CI: "Pobrežie Slonoviny", CK: "Cookove ostrovy", CL: "Čile", CM: "Kamerun", CN: "Čína", CO: "Kolumbia", CR: "Kostarika", CU: "Kuba", CV: "Kapverdy", CW: "Curaçao", CX: "Vianočný ostrov", CY: "Cyprus", CZ: "Česko", DE: "Nemecko", DJ: "Džibutsko", DK: "Dánsko", DM: "Dominika", DO: "Dominikánska republika", DZ: "Alžírsko", EC: "Ekvádor", EE: "Estónsko", EG: "Egypt", EH: "Západná Sahara", ER: "Eritrea", ES: "Španielsko", ET: "Etiópia", FI: "Fínsko", FJ: "Fidži", FK: "Falklandy", FM: "Mikronézia", FO: "Faerské ostrovy", FR: "Francúzsko", GA: "Gabon", GB: "Spojené kráľovstvo", GD: "Grenada", GE: "Gruzínsko", GF: "Francúzska Guayana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltár", GL: "Grónsko", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Rovníková Guinea", GR: "Grécko", GS: "Južná Georgia a Južné Sandwichove ostrovy", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guayana", HK: "Hongkong – OAO Číny", HM: "Heardov ostrov a Macdonaldove ostrovy", HN: "Honduras", HR: "Chorvátsko", HT: "Haiti", HU: "Maďarsko", ID: "Indonézia", IE: "Írsko", IL: "Izrael", IM: "Ostrov Man", IN: "India", IO: "Britské indickooceánske územie", IQ: "Irak", IR: "Irán", IS: "Island", IT: "Taliansko", JE: "Jersey", JM: "Jamajka", JO: "Jordánsko", JP: "Japonsko", KE: "Keňa", KG: "Kirgizsko", KH: "Kambodža", KI: "Kiribati", KM: "Komory", KN: "Svätý Krištof a Nevis", KP: "Severná Kórea", KR: "Južná Kórea", KW: "Kuvajt", KY: "Kajmanie ostrovy", KZ: "Kazachstan", LA: "Laos", LB: "Libanon", LC: "Svätá Lucia", LI: "Lichtenštajnsko", LK: "Srí Lanka", LR: "Libéria", LS: "Lesotho", LT: "Litva", LU: "Luxembursko", LV: "Lotyšsko", LY: "Líbya", MA: "Maroko", MC: "Monako", MD: "Moldavsko", ME: "Čierna Hora", MF: "Svätý Martin (fr.)", MG: "Madagaskar", MH: "Marshallove ostrovy", MK: "Severné Macedónsko", ML: "Mali", MM: "Mjanmarsko", MN: "Mongolsko", MO: "Macao – OAO Číny", MP: "Severné Mariány", MQ: "Martinik", MR: "Mauritánia", MS: "Montserrat", MT: "Malta", MU: "Maurícius", MV: "Maldivy", MW: "Malawi", MX: "Mexiko", MY: "Malajzia", MZ: "Mozambik", NA: "Namíbia", NC: "Nová Kaledónia", NE: "Niger", NF: "Norfolk", NG: "Nigéria", NI: "Nikaragua", NL: "Holandsko", NO: "Nórsko", NP: "Nepál", NR: "Nauru", NU: "Niue", NZ: "Nový Zéland", OM: "Omán", PA: "Panama", PE: "Peru", PF: "Francúzska Polynézia", PG: "Papua Nová Guinea", PH: "Filipíny", PK: "Pakistan", PL: "Poľsko", PM: "Saint Pierre a Miquelon", PN: "Pitcairnove ostrovy", PR: "Portoriko", PS: "Palestínske územia", PT: "Portugalsko", PW: "Palau", PY: "Paraguaj", QA: "Katar", RE: "Réunion", RO: "Rumunsko", RS: "Srbsko", RU: "Rusko", RW: "Rwanda", SA: "Saudská Arábia", SB: "Šalamúnove ostrovy", SC: "Seychely", SD: "Sudán", SE: "Švédsko", SG: "Singapur", SH: "Svätá Helena", SI: "Slovinsko", SJ: "Svalbard a Jan Mayen", SK: "Slovensko", SL: "Sierra Leone", SM: "San Maríno", SN: "Senegal", SO: "Somálsko", SR: "Surinam", SS: "Južný Sudán", ST: "Svätý Tomáš a Princov ostrov", SV: "Salvádor", SX: "Svätý Martin (hol.)", SY: "Sýria", SZ: "Svazijsko", TC: "Turks a Caicos", TD: "Čad", TF: "Francúzske južné a antarktické územia", TG: "Togo", TH: "Thajsko", TJ: "Tadžikistan", TK: "Tokelau", TL: "Východný Timor", TM: "Turkménsko", TN: "Tunisko", TO: "Tonga", TR: "Turecko", TT: "Trinidad a Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzánia", UA: "Ukrajina", UG: "Uganda", UM: "Menšie odľahlé ostrovy USA", US: "Spojené štáty", UY: "Uruguaj", UZ: "Uzbekistan", VA: "Vatikán", VC: "Svätý Vincent a Grenadíny", VE: "Venezuela", VG: "Britské Panenské ostrovy", VI: "Americké Panenské ostrovy", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis a Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južná Afrika", ZM: "Zambia", ZW: "Zimbabwe" }, Ol = {
  locale: _o,
  countries: Fo
}, Gl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Fo,
  default: Ol,
  locale: _o
}, Symbol.toStringTag, { value: "Module" })), Ko = "sl", xo = { AD: "Andora", AE: "Združeni arabski emirati", AF: "Afganistan", AG: "Antigva in Barbuda", AI: "Angvila", AL: "Albanija", AM: "Armenija", AO: "Angola", AQ: "Antarktika", AR: "Argentina", AS: "Ameriška Samoa", AT: "Avstrija", AU: "Avstralija", AW: "Aruba", AX: "Ålandski otoki", AZ: "Azerbajdžan", BA: "Bosna in Hercegovina", BB: "Barbados", BD: "Bangladeš", BE: "Belgija", BF: "Burkina Faso", BG: "Bolgarija", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthélemy", BM: "Bermudi", BN: "Brunej", BO: "Bolivija", BQ: "Nizozemski Karibi", BR: "Brazilija", BS: "Bahami", BT: "Butan", BV: "Bouvetov otok", BW: "Bocvana", BY: "Belorusija", BZ: "Belize", CA: "Kanada", CC: "Kokosovi otoki", CD: "Demokratična republika Kongo", CF: "Centralnoafriška republika", CG: "Kongo - Brazzaville", CH: "Švica", CI: "Slonokoščena obala", CK: "Cookovi otoki", CL: "Čile", CM: "Kamerun", CN: "Kitajska", CO: "Kolumbija", CR: "Kostarika", CU: "Kuba", CV: "Zelenortski otoki", CW: "Curaçao", CX: "Božični otok", CY: "Ciper", CZ: "Češka", DE: "Nemčija", DJ: "Džibuti", DK: "Danska", DM: "Dominika", DO: "Dominikanska republika", DZ: "Alžirija", EC: "Ekvador", EE: "Estonija", EG: "Egipt", EH: "Zahodna Sahara", ER: "Eritreja", ES: "Španija", ET: "Etiopija", FI: "Finska", FJ: "Fidži", FK: "Falklandski otoki", FM: "Mikronezija", FO: "Ferski otoki", FR: "Francija", GA: "Gabon", GB: "Združeno kraljestvo", GD: "Grenada", GE: "Gruzija", GF: "Francoska Gvajana", GG: "Guernsey", GH: "Gana", GI: "Gibraltar", GL: "Grenlandija", GM: "Gambija", GN: "Gvineja", GP: "Gvadalupe", GQ: "Ekvatorialna Gvineja", GR: "Grčija", GS: "Južna Georgia in Južni Sandwichevi otoki", GT: "Gvatemala", GU: "Guam", GW: "Gvineja Bissau", GY: "Gvajana", HK: "Hongkong", HM: "Heardov otok in McDonaldovi otoki", HN: "Honduras", HR: "Hrvaška", HT: "Haiti", HU: "Madžarska", ID: "Indonezija", IE: "Irska", IL: "Izrael", IM: "Otok Man", IN: "Indija", IO: "Britansko ozemlje v Indijskem oceanu", IQ: "Irak", IR: "Iran", IS: "Islandija", IT: "Italija", JE: "Jersey", JM: "Jamajka", JO: "Jordanija", JP: "Japonska", KE: "Kenija", KG: "Kirgizistan", KH: "Kambodža", KI: "Kiribati", KM: "Komori", KN: "Saint Kitts in Nevis", KP: "Severna Koreja", KR: "Južna Koreja", KW: "Kuvajt", KY: "Kajmanski otoki", KZ: "Kazahstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Lihtenštajn", LK: "Šrilanka", LR: "Liberija", LS: "Lesoto", LT: "Litva", LU: "Luksemburg", LV: "Latvija", LY: "Libija", MA: "Maroko", MC: "Monako", MD: "Moldavija", ME: "Črna gora", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshallovi otoki", MK: "Severna Makedonija", ML: "Mali", MM: "Mjanmar (Burma)", MN: "Mongolija", MO: "Macao", MP: "Severni Marianski otoki", MQ: "Martinik", MR: "Mavretanija", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivi", MW: "Malavi", MX: "Mehika", MY: "Malezija", MZ: "Mozambik", NA: "Namibija", NC: "Nova Kaledonija", NE: "Niger", NF: "Norfolški otok", NG: "Nigerija", NI: "Nikaragva", NL: "Nizozemska", NO: "Norveška", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nova Zelandija", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Francoska Polinezija", PG: "Papua Nova Gvineja", PH: "Filipini", PK: "Pakistan", PL: "Poljska", PM: "Saint Pierre in Miquelon", PN: "Pitcairn", PR: "Portoriko", PS: "Palestinsko ozemlje", PT: "Portugalska", PW: "Palau", PY: "Paragvaj", QA: "Katar", RE: "Reunion", RO: "Romunija", RS: "Srbija", RU: "Rusija", RW: "Ruanda", SA: "Saudova Arabija", SB: "Salomonovi otoki", SC: "Sejšeli", SD: "Sudan", SE: "Švedska", SG: "Singapur", SH: "Sveta Helena", SI: "Slovenija", SJ: "Svalbard in Jan Mayen", SK: "Slovaška", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalija", SR: "Surinam", SS: "Južni Sudan", ST: "Sao Tome in Principe", SV: "Salvador", SX: "Sint Maarten", SY: "Sirija", SZ: "Svazi", TC: "Otoki Turks in Caicos", TD: "Čad", TF: "Francosko južno ozemlje", TG: "Togo", TH: "Tajska", TJ: "Tadžikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Turkmenistan", TN: "Tunizija", TO: "Tonga", TR: "Turčija", TT: "Trinidad in Tobago", TV: "Tuvalu", TW: "Tajvan", TZ: "Tanzanija", UA: "Ukrajina", UG: "Uganda", UM: "Stranski zunanji otoki Združenih držav", US: "Združene države Amerike", UY: "Urugvaj", UZ: "Uzbekistan", VA: "Vatikan", VC: "Saint Vincent in Grenadine", VE: "Venezuela", VG: "Britanski Deviški otoki", VI: "Ameriški Deviški otoki", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis in Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južnoafriška republika", ZM: "Zambija", ZW: "Zimbabve" }, Ll = {
  locale: Ko,
  countries: xo
}, Rl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: xo,
  default: Ll,
  locale: Ko
}, Symbol.toStringTag, { value: "Module" })), Ho = "sq", Uo = { AF: "Afganistan", AL: "Shqipëri", DZ: "Algjeri", AS: "Samoa Amerikane", AD: "Andorrë", AO: "Angolë", AI: "Anguilë", AQ: "Antarktidë", AG: "Antigua & Barbuda", AR: "Argjentinë", AM: "Armeni", AW: "Arubë", AU: "Australi", AT: "Austri", AZ: "Azerbajxhan", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bjellorusi", BE: "Belgjikë", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Butan", BO: "Bolivi", BA: "Bosnjë & Hercegovinë", BW: "Botsvanë", BV: "Ishulli Buve", BR: "Brazil", IO: "Territori Britanik i Oqeanit Indian", BN: "Brunej", BG: "Bullgari", BF: "Burkina Faso", BI: "Burund", KH: "Kamboxhia", CM: "Kamerun", CA: "Kanada", CV: "Kepi i Gjelbër", KY: "Ishujt Kajman", CF: "Republika Afrikano-Qendrore", TD: "Çad", CL: "Kili", CN: "Kinë", CX: "Ishulli i Krishtlindjes", CC: "Ishujt Kokos (Kiling)", CO: "Kolumbi", KM: "Komore", CG: "Kongo-Brazavil", CD: "Kongo-Kinshasa", CK: "Ishulli Kuk", CR: "Kosta Rikë", CI: "Bregu i Fildishtë", HR: "Kroaci", CU: "Kubë", CY: "Qipro", CZ: "Republika Çeke", DK: "Danimarkë", DJ: "Xhibut", DM: "Dominikë", DO: "Republika Dominikane", EC: "Ekuador", EG: "Egjipt", SV: "El Salvador", GQ: "Guineja Ekuatoriale", ER: "Eritre", EE: "Estoni", ET: "Etiopi", FK: "Ishujt Folkland", FO: "Ishujt Faroe", FJ: "Fixhi", FI: "Finlandë", FR: "Francë", GF: "Guajana Frënge", PF: "Polinezia Frënge", TF: "Territoret Frënge Jugore", GA: "Gabon", GM: "Gambia", GE: "Gjeorgji", DE: "Gjermani", GH: "Gana", GI: "Gjibraltar", GR: "Greqi", GL: "Groenlandë", GD: "Grenadë", GP: "Guadalup", GU: "Guam", GT: "Guatemalë", GN: "Guine", GW: "Guinea-Bisau", GY: "Guajanë", HT: "Haiti", HM: "Ishujt Hërd & Mekdonald", VA: "Vatikan", HN: "Honduras", HK: "RVA i Hong Kongut Kinë", HU: "Hungari", IS: "Islandë", IN: "Indi", ID: "Indonezi", IR: "Iran", IQ: "Irak", IE: "Irlandë", IL: "Izrael", IT: "Itali", JM: "Xhamajkë", JP: "Japoni", JO: "Jordani", KZ: "Kazakistan", KE: "Kenia", KI: "Kiribati", KP: "Koreja e Veriut", KR: "Koreja e Jugut", KW: "Kuvajt", KG: "Kirgizstan", LA: "Laos", LV: "Letoni", LB: "Liban", LS: "Lesoto", LR: "Liberi", LY: "Libi", LI: "Lihtenshtein", LT: "Lituani", LU: "Luksemburg", MO: "RVA i Makaos Kinë", MG: "Madagaskar", MW: "Malavi", MY: "Malajzi", MV: "Maldive", ML: "Mali", MT: "Maltë", MH: "Ishujt Marshall", MQ: "Martinikë", MR: "Mauritani", MU: "Mauritius", YT: "Majote", MX: "Meksikë", FM: "Mikronezi", MD: "Moldavi", MC: "Monako", MN: "Mongoli", MS: "Montserat", MA: "Marok", MZ: "Mozambik", MM: "Mianmar (Burma)", NA: "Namibi", NR: "Nauru", NP: "Nepal", NL: "Holandë", NC: "Kaledonia e Re", NZ: "Zelandë e Re", NI: "Nikaragua", NE: "Niger", NG: "Nigeri", NU: "Niue", NF: "Ishujt Norfolk", MK: "Maqedoni", MP: "Ishujt Veriorë Mariana", NO: "Norvegji", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Territoret Palestineze", PA: "Panama", PG: "Papua Guineja e Re", PY: "Paraguai", PE: "Peru", PH: "Filipine", PN: "Ishujt Pitkern", PL: "Poloni", PT: "Portugali", PR: "Porto Riko", QA: "Katar", RE: "Reunion", RO: "Rumani", RU: "Rusi", RW: "Ruandë", SH: "Shën Helena", KN: "Shën Kits e Nevis", LC: "Shën Luçia", PM: "Shën Pier dhe Mikëlon", VC: "Shën Vinsent & Grenadinet", WS: "Samoa", SM: "San Marino", ST: "Sao Tome & Prinsipe", SA: "Arabi Saudite", SN: "Senegal", SC: "Sejshelle", SL: "Sierra Leone", SG: "Singapor", SK: "Sllovaki", SI: "Slloveni", SB: "Ishujt Solomon", SO: "Somali", ZA: "Afrikë e Jugut", GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut", ES: "Spanjë", LK: "Sri Lankë", SD: "Sudan", SR: "Surinam", SJ: "Svalbard & Zhan Majen", SZ: "Svaziland", SE: "Suedi", CH: "Zvicër", SY: "Siri", TW: "Tajvan", TJ: "Taxhikistan", TZ: "Tanzani", TH: "Tajlandë", TL: "Timori Lindor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad & Tobago", TN: "Tunizi", TR: "Turqi", TM: "Turkmenistan", TC: "Ishujt Turk & Kaikos", TV: "Tuvalu", UG: "Ugandë", UA: "Ukrainë", AE: "Emiratet e Bashkuara Arabe", GB: "Mbretëria e Bashkuar", US: "Shtetet e Bashkuara të Amerikës", UM: "Ishujt e Përtejmë SHBA-së", UY: "Uruguai", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuelë", VN: "Vietnam", VG: "Ishujt e Virgjër Britanikë", VI: "Ishujt e Virgjër Amerikanë", WF: "Uollis e Futuna", EH: "Sahara Perëndimore", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabve", AX: "Ishujt Aland", BQ: "Karaibet Holandeze", CW: "Kurasao", GG: "Gërnsi", IM: "Ishulli i Robit", JE: "Xhërsi", ME: "Mali i Zi", BL: "Shën Bartolomeo", MF: "Shën Martin", RS: "Serbi", SX: "Shën Martin", SS: "Sudan i Jugut", XK: "Kosovë" }, _l = {
  locale: Ho,
  countries: Uo
}, Fl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Uo,
  default: _l,
  locale: Ho
}, Symbol.toStringTag, { value: "Module" })), Yo = "sr", Wo = { AD: "Андора", AE: "Уједињени Арапски Емирати", AF: "Авганистан", AG: "Антигва и Барбуда", AI: "Ангвила", AL: "Албанија", AM: "Јерменија", AO: "Ангола", AQ: "Антарктик", AR: "Аргентина", AS: "Америчка Самоа", AT: "Аустрија", AU: "Аустралија", AW: "Аруба", AX: "Оландска Острва", AZ: "Азербејџан", BA: "Босна и Херцеговина", BB: "Барбадос", BD: "Бангладеш", BE: "Белгија", BF: "Буркина Фасо", BG: "Бугарска", BH: "Бахреин", BI: "Бурунди", BJ: "Бенин", BL: "Сен Бартелеми", BM: "Бермуда", BN: "Брунеј", BO: "Боливија", BQ: "Карипска Холандија", BR: "Бразил", BS: "Бахами", BT: "Бутан", BV: "Острво Буве", BW: "Боцвана", BY: "Белорусија", BZ: "Белизе", CA: "Канада", CC: "Кокосова (Килингова) Острва", CD: "Конго - Киншаса", CF: "Централноафричка Република", CG: "Конго - Бразавил", CH: "Швајцарска", CI: "Обала Слоноваче", CK: "Кукова Острва", CL: "Чиле", CM: "Камерун", CN: "Кина", CO: "Колумбија", CR: "Костарика", CU: "Куба", CV: "Зеленортска Острва", CW: "Курасао", CX: "Божићно Острво", CY: "Кипар", CZ: "Чешка", DE: "Немачка", DJ: "Џибути", DK: "Данска", DM: "Доминика", DO: "Доминиканска Република", DZ: "Алжир", EC: "Еквадор", EE: "Естонија", EG: "Египат", EH: "Западна Сахара", ER: "Еритреја", ES: "Шпанија", ET: "Етиопија", FI: "Финска", FJ: "Фиџи", FK: "Фокландска Острва", FM: "Микронезија", FO: "Фарска Острва", FR: "Француска", GA: "Габон", GB: "Уједињено Краљевство", GD: "Гренада", GE: "Грузија", GF: "Француска Гвајана", GG: "Гернзи", GH: "Гана", GI: "Гибралтар", GL: "Гренланд", GM: "Гамбија", GN: "Гвинеја", GP: "Гваделуп", GQ: "Екваторијална Гвинеја", GR: "Грчка", GS: "Јужна Џорџија и Јужна Сендвичка Острва", GT: "Гватемала", GU: "Гуам", GW: "Гвинеја-Бисао", GY: "Гвајана", HK: "САР Хонгконг (Кина)", HM: "Острво Херд и Мекдоналдова острва", HN: "Хондурас", HR: "Хрватска", HT: "Хаити", HU: "Мађарска", ID: "Индонезија", IE: "Ирска", IL: "Израел", IM: "Острво Ман", IN: "Индија", IO: "Британска територија Индијског океана", IQ: "Ирак", IR: "Иран", IS: "Исланд", IT: "Италија", JE: "Џерзи", JM: "Јамајка", JO: "Јордан", JP: "Јапан", KE: "Кенија", KG: "Киргистан", KH: "Камбоџа", KI: "Кирибати", KM: "Коморска Острва", KN: "Сент Китс и Невис", KP: "Северна Кореја", KR: "Јужна Кореја", KW: "Кувајт", KY: "Кајманска Острва", KZ: "Казахстан", LA: "Лаос", LB: "Либан", LC: "Света Луција", LI: "Лихтенштајн", LK: "Шри Ланка", LR: "Либерија", LS: "Лесото", LT: "Литванија", LU: "Луксембург", LV: "Летонија", LY: "Либија", MA: "Мароко", MC: "Монако", MD: "Молдавија", ME: "Црна Гора", MF: "Свети Мартин (Француска)", MG: "Мадагаскар", MH: "Маршалска Острва", MK: "Северна Македонија", ML: "Мали", MM: "Мијанмар (Бурма)", MN: "Монголија", MO: "САР Макао (Кина)", MP: "Северна Маријанска Острва", MQ: "Мартиник", MR: "Мауританија", MS: "Монсерат", MT: "Малта", MU: "Маурицијус", MV: "Малдиви", MW: "Малави", MX: "Мексико", MY: "Малезија", MZ: "Мозамбик", NA: "Намибија", NC: "Нова Каледонија", NE: "Нигер", NF: "Острво Норфок", NG: "Нигерија", NI: "Никарагва", NL: "Холандија", NO: "Норвешка", NP: "Непал", NR: "Науру", NU: "Ниуе", NZ: "Нови Зеланд", OM: "Оман", PA: "Панама", PE: "Перу", PF: "Француска Полинезија", PG: "Папуа Нова Гвинеја", PH: "Филипини", PK: "Пакистан", PL: "Пољска", PM: "Сен Пјер и Микелон", PN: "Питкерн", PR: "Порторико", PS: "Палестинске територије", PT: "Португалија", PW: "Палау", PY: "Парагвај", QA: "Катар", RE: "Реинион", RO: "Румунија", RS: "Србија", RU: "Русија", RW: "Руанда", SA: "Саудијска Арабија", SB: "Соломонска Острва", SC: "Сејшели", SD: "Судан", SE: "Шведска", SG: "Сингапур", SH: "Света Јелена", SI: "Словенија", SJ: "Свалбард и Јан Мајен", SK: "Словачка", SL: "Сијера Леоне", SM: "Сан Марино", SN: "Сенегал", SO: "Сомалија", SR: "Суринам", SS: "Јужни Судан", ST: "Сао Томе и Принципе", SV: "Салвадор", SX: "Свети Мартин (Холандија)", SY: "Сирија", SZ: "Свазиленд", TC: "Острва Туркс и Каикос", TD: "Чад", TF: "Француске Јужне Територије", TG: "Того", TH: "Тајланд", TJ: "Таџикистан", TK: "Токелау", TL: "Источни Тимор", TM: "Туркменистан", TN: "Тунис", TO: "Тонга", TR: "Турска", TT: "Тринидад и Тобаго", TV: "Тувалу", TW: "Тајван", TZ: "Танзанија", UA: "Украјина", UG: "Уганда", UM: "Удаљена острва САД", US: "Сједињене Државе", UY: "Уругвај", UZ: "Узбекистан", VA: "Ватикан", VC: "Сент Винсент и Гренадини", VE: "Венецуела", VG: "Британска Девичанска Острва", VI: "Америчка Девичанска Острва", VN: "Вијетнам", VU: "Вануату", WF: "Валис и Футуна", WS: "Самоа", XK: "Косово", YE: "Јемен", YT: "Мајот", ZA: "Јужноафричка Република", ZM: "Замбија", ZW: "Зимбабве" }, Kl = {
  locale: Yo,
  countries: Wo
}, xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Wo,
  default: Kl,
  locale: Yo
}, Symbol.toStringTag, { value: "Module" })), Vo = "sv", jo = { AD: "Andorra", AE: "Förenade Arabemiraten", AF: "Afghanistan", AG: "Antigua och Barbuda", AI: "Anguilla", AL: "Albanien", AM: "Armenien", AO: "Angola", AQ: "Antarktis", AR: "Argentina", AS: "Amerikanska Samoa", AT: "Österrike", AU: "Australien", AW: "Aruba", AX: "Åland", AZ: "Azerbajdzjan", BA: "Bosnien och Hercegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgien", BF: "Burkina Faso", BG: "Bulgarien", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Bonaire, Saint Eustatius och Saba", BR: "Brasilien", BS: "Bahamas", BT: "Bhutan", BV: "Bouvetön", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Kanada", CC: "Kokosöarna", CD: "Demokratiska republiken Kongo", CF: "Centralafrikanska republiken", CG: "Kongo-Brazzaville", CH: "Schweiz", CI: "Elfenbenskusten", CK: "Cooköarna", CL: "Chile", CM: "Kamerun", CN: "Kina", CO: "Colombia", CR: "Costa Rica", CU: "Kuba", CV: "Kap Verde", CW: "Curacao", CX: "Julön", CY: "Cypern", CZ: "Tjeckien", DE: "Tyskland", DJ: "Djibouti", DK: "Danmark", DM: "Dominica", DO: "Dominikanska republiken", DZ: "Algeriet", EC: "Ecuador", EE: "Estland", EG: "Egypten", EH: "Västsahara", ER: "Eritrea", ES: "Spanien", ET: "Etiopien", FI: "Finland", FJ: "Fiji", FK: "Falklandsöarna", FM: "Mikronesiska federationen", FO: "Färöarna", FR: "Frankrike", GA: "Gabon", GB: "Storbritannien", GD: "Grenada", GE: "Georgien", GF: "Franska Guyana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Grönland", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Ekvatorialguinea", GR: "Grekland", GS: "Sydgeorgien och Sydsandwichöarna", GT: "Guatemala", GU: "Guam", GW: "Guinea Bissau", GY: "Guyana", HK: "Hongkong", HM: "Heard- och McDonaldsöarna", HN: "Honduras", HR: "Kroatien", HT: "Haiti", HU: "Ungern", ID: "Indonesien", IE: "Irland", IL: "Israel", IM: "Isle of Man", IN: "Indien", IO: "Brittiska territoriet i Indiska Oceanen", IQ: "Irak", IR: "Iran", IS: "Island", IT: "Italien", JE: "Jersey", JM: "Jamaica", JO: "Jordanien", JP: "Japan", KE: "Kenya", KG: "Kirgizistan", KH: "Kambodja", KI: "Kiribati", KM: "Komorerna", KN: "Saint Kitts och Nevis", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KY: "Caymanöarna", KZ: "Kazakstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Litauen", LU: "Luxemburg", LV: "Lettland", LY: "Libyen", MA: "Marocko", MC: "Monaco", MD: "Moldavien", ME: "Montenegro", MF: "Saint Martin (franska delen)", MG: "Madagaskar", MH: "Marshallöarna", MK: "Nordmakedonien", ML: "Mali", MM: "Burma", MN: "Mongoliet", MO: "Macau", MP: "Nordmarianerna", MQ: "Martinique", MR: "Mauretanien", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldiverna", MW: "Malawi", MX: "Mexiko", MY: "Malaysia", MZ: "Moçambique", NA: "Namibia", NC: "Nya Kaledonien", NE: "Niger", NF: "Norfolkön", NG: "Nigeria", NI: "Nicaragua", NL: "Nederländerna", NO: "Norge", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nya Zeeland", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Franska Polynesien", PG: "Papua Nya Guinea", PH: "Filippinerna", PK: "Pakistan", PL: "Polen", PM: "Saint-Pierre och Miquelon", PN: "Pitcairnöarna", PR: "Puerto Rico", PS: "Palestinska territoriet, ockuperade", PT: "Portugal", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Rumänien", RS: "Serbien", RU: "Ryssland", RW: "Rwanda", SA: "Saudiarabien", SB: "Salomonöarna", SC: "Seychellerna", SD: "Sudan", SE: "Sverige", SG: "Singapore", SH: "Sankta Helena", SI: "Slovenien", SJ: "Svalbard och Jan Mayen", SK: "Slovakien", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Surinam", SS: "Sydsudan", ST: "São Tomé och Príncipe", SV: "El Salvador", SX: "Sint Maarten (nederländska delen)", SY: "Syrien", SZ: "Eswatini", TC: "Turks- och Caicosöarna", TD: "Tchad", TF: "Franska södra territorierna", TG: "Togo", TH: "Thailand", TJ: "Tadzjikistan", TK: "Tokelauöarna", TL: "Östtimor", TM: "Turkmenistan", TN: "Tunisien", TO: "Tonga", TR: "Turkiet", TT: "Trinidad och Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ukraina", UG: "Uganda", UM: "USA:s yttre öar", US: "USA", UY: "Uruguay", UZ: "Uzbekistan", VA: "Vatikanstaten", VC: "Saint Vincent och Grenadinerna", VE: "Venezuela", VG: "Brittiska Jungfruöarna", VI: "Amerikanska Jungfruöarna", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis- och Futunaöarna", WS: "Samoa", YE: "Jemen", YT: "Mayotte", ZA: "Sydafrika", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, Hl = {
  locale: Vo,
  countries: jo
}, Ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: jo,
  default: Hl,
  locale: Vo
}, Symbol.toStringTag, { value: "Module" })), Zo = "th", zo = { BD: "บังกลาเทศ", BE: "เบลเยียม", BF: "บูร์กินาฟาโซ", BG: "บัลแกเรีย", BA: "บอสเนียและเฮอร์เซโกวีนา", BB: "บาร์เบโดส", WF: "วาลลิสและฟุตูนา", BL: "เซนต์บาร์เธเลมี", BM: "เบอร์มิวดา", BN: "บรูไน", BO: "โบลิเวีย", BH: "บาห์เรน", BI: "บุรุนดี", BJ: "เบนิน", BT: "ภูฏาน", JM: "จาเมกา", BV: "เกาะบูเวต", BW: "บอตสวานา", WS: "ซามัว", BR: "บราซิล", BS: "บาฮามาส", JE: "เจอร์ซีย์", BY: "เบลารุส", BZ: "เบลีซ", RU: "รัสเซีย", RW: "รวันดา", RS: "เซอร์เบีย", TL: "ติมอร์ตะวันออก", RE: "เรอูนียง", TM: "เติร์กเมนิสถาน", TJ: "ทาจิกิสถาน", RO: "โรมาเนีย", TK: "โตเกเลา", GW: "กินี-บิสเซา", GU: "กวม", GT: "กัวเตมาลา", GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช", GR: "กรีซ", GQ: "อิเควทอเรียลกินี", GP: "กวาเดอลูป", JP: "ญี่ปุ่น", GY: "กายอานา", GG: "เกิร์นซีย์", GF: "เฟรนช์เกียนา", GE: "จอร์เจีย", GD: "เกรเนดา", GB: "สหราชอาณาจักร", GA: "กาบอง", SV: "เอลซัลวาดอร์", GN: "กินี", GM: "แกมเบีย", GL: "กรีนแลนด์", GI: "ยิบรอลตาร์", GH: "กานา", OM: "โอมาน", TN: "ตูนิเซีย", JO: "จอร์แดน", HR: "โครเอเชีย", HT: "เฮติ", HU: "ฮังการี", HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน", HN: "ฮอนดูรัส", HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์", VE: "เวเนซุเอลา", PR: "เปอร์โตริโก", PS: "ปาเลสไตน์", PW: "ปาเลา", PT: "โปรตุเกส", SJ: "สฟาลบาร์และยานไมเอน", PY: "ปารากวัย", IQ: "อิรัก", PA: "ปานามา", PF: "เฟรนช์โปลินีเซีย", PG: "ปาปัวนิวกินี", PE: "เปรู", PK: "ปากีสถาน", PH: "ฟิลิปปินส์", PN: "พิตแคร์น", PL: "โปแลนด์", PM: "แซงปีแยร์และมีเกอลง", ZM: "แซมเบีย", EH: "ซาฮาราตะวันตก", EE: "เอสโตเนีย", EG: "อียิปต์", ZA: "แอฟริกาใต้", EC: "เอกวาดอร์", IT: "อิตาลี", VN: "เวียดนาม", SB: "หมู่เกาะโซโลมอน", ET: "เอธิโอเปีย", SO: "โซมาเลีย", ZW: "ซิมบับเว", SA: "ซาอุดีอาระเบีย", ES: "สเปน", ER: "เอริเทรีย", ME: "มอนเตเนโกร", MD: "มอลโดวา", MG: "มาดากัสการ์", MF: "เซนต์มาติน", MA: "โมร็อกโก", MC: "โมนาโก", UZ: "อุซเบกิสถาน", MM: "เมียนม่าร์ [พม่า]", ML: "มาลี", MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน", MN: "มองโกเลีย", MH: "หมู่เกาะมาร์แชลล์", MK: "มาซิโดเนีย", MU: "มอริเชียส", MT: "มอลตา", MW: "มาลาวี", MV: "มัลดีฟส์", MQ: "มาร์ตินีก", MP: "หมู่เกาะนอร์เทิร์นมาเรียนา", MS: "มอนต์เซอร์รัต", MR: "มอริเตเนีย", IM: "เกาะแมน", UG: "ยูกันดา", TZ: "แทนซาเนีย", MY: "มาเลเซีย", MX: "เม็กซิโก", IL: "อิสราเอล", FR: "ฝรั่งเศส", IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี", SH: "เซนต์เฮเลนา", FI: "ฟินแลนด์", FJ: "ฟิจิ", FK: "หมู่เกาะฟอล์กแลนด์", FM: "ไมโครนีเซีย", FO: "หมู่เกาะแฟโร", NI: "นิการากัว", NL: "เนเธอร์แลนด์", NO: "นอร์เวย์", NA: "นามิเบีย", VU: "วานูอาตู", NC: "นิวแคลิโดเนีย", NE: "ไนเจอร์", NF: "เกาะนอร์ฟอล์ก", NG: "ไนจีเรีย", NZ: "นิวซีแลนด์", NP: "เนปาล", NR: "นาอูรู", NU: "นีอูเอ", CK: "หมู่เกาะคุก", CI: "ไอวอรี่โคสต์", CH: "สวิตเซอร์แลนด์", CO: "โคลอมเบีย", CN: "จีน", CM: "แคเมอรูน", CL: "ชิลี", CC: "หมู่เกาะโคโคส", CA: "แคนาดา", CG: "คองโก-บราซซาวิล", CF: "สาธารณรัฐแอฟริกากลาง", CD: "คองโก-กินชาซา", CZ: "สาธารณรัฐเช็ก", CY: "ไซปรัส", CX: "เกาะคริสต์มาส", CR: "คอสตาริกา", CV: "เคปเวิร์ด", CU: "คิวบา", SZ: "สวาซิแลนด์", SY: "ซีเรีย", KG: "คีร์กีซสถาน", KE: "เคนยา", SR: "ซูรินาเม", KI: "คิริบาส", KH: "กัมพูชา", KN: "เซนต์คิตส์และเนวิส", KM: "คอโมโรส", ST: "เซาตูเมและปรินซิปี", SK: "สโลวะเกีย", KR: "เกาหลีใต้", SI: "สโลวีเนีย", KP: "เกาหลีเหนือ", KW: "คูเวต", SN: "เซเนกัล", SM: "ซานมารีโน", SL: "เซียร์ราลีโอน", SC: "เซเชลส์", KZ: "คาซัคสถาน", KY: "หมู่เกาะเคย์แมน", SG: "สิงคโปร์", SE: "สวีเดน", SD: "ซูดาน", DO: "สาธารณรัฐโดมินิกัน", DM: "โดมินิกา", DJ: "จิบูตี", DK: "เดนมาร์ก", VG: "หมู่เกาะบริติชเวอร์จิน", DE: "เยอรมนี", YE: "เยเมน", DZ: "แอลจีเรีย", US: "สหรัฐอเมริกา", UY: "อุรุกวัย", YT: "มายอต", UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง", LB: "เลบานอน", LC: "เซนต์ลูเซีย", LA: "ลาว", TV: "ตูวาลู", TW: "ไต้หวัน", TT: "ตรินิแดดและโตเบโก", TR: "ตุรกี", LK: "ศรีลังกา", LI: "ลิกเตนสไตน์", LV: "ลัตเวีย", TO: "ตองกา", LT: "ลิทัวเนีย", LU: "ลักเซมเบิร์ก", LR: "ไลบีเรีย", LS: "เลโซโท", TH: "ไทย", TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์", TG: "โตโก", TD: "ชาด", TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส", LY: "ลิเบีย", VA: "วาติกัน", VC: "เซนต์วินเซนต์และเกรนาดีนส์", AE: "สหรัฐอาหรับเอมิเรตส์", AD: "อันดอร์รา", AG: "แอนติกาและบาร์บูดา", AF: "อัฟกานิสถาน", AI: "แองกวิลลา", VI: "หมู่เกาะยูเอสเวอร์จิน", IS: "ไอซ์แลนด์", IR: "อิหร่าน", AM: "อาร์เมเนีย", AL: "แอลเบเนีย", AO: "แองโกลา", AQ: "แอนตาร์กติกา", AS: "อเมริกันซามัว", AR: "อาร์เจนตินา", AU: "ออสเตรเลีย", AT: "ออสเตรีย", AW: "อารูบา", IN: "อินเดีย", AX: "หมู่เกาะโอลันด์", AZ: "อาเซอร์ไบจาน", IE: "ไอร์แลนด์", ID: "อินโดนีเซีย", UA: "ยูเครน", QA: "กาตาร์", MZ: "โมซัมบิก", BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา", CW: "คูราเซา", SX: "Sint Maarten (ส่วนดัตช์)", SS: "ซูดานใต้", XK: "โคโซโว" }, Yl = {
  locale: Zo,
  countries: zo
}, Wl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: zo,
  default: Yl,
  locale: Zo
}, Symbol.toStringTag, { value: "Module" })), Jo = "tr", Qo = { AD: "Andorra", AE: "Birleşik Arap Emirlikleri", AF: "Afganistan", AG: "Antigua ve Barbuda", AI: "Anguilla", AL: "Arnavutluk", AM: "Ermenistan", AO: "Angola", AQ: "Antarktika", AR: "Arjantin", AS: "Amerikan Samoası", AT: "Avusturya", AU: "Avustralya", AW: "Aruba", AX: "Åland Adaları", AZ: "Azerbaycan", BA: "Bosna Hersek", BB: "Barbados", BD: "Bangladeş", BE: "Belçika", BF: "Burkina Faso", BG: "Bulgaristan", BH: "Bahreyn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthelemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivya", BQ: "Karayip Hollanda", BR: "Brezilya", BS: "Bahamalar", BT: "Butan", BV: "Bouvet Adası", BW: "Botsvana", BY: "Beyaz Rusya", BZ: "Belize", CA: "Kanada", CC: "Cocos (Keeling) Adaları", CD: "Kongo - Kinşasa", CF: "Orta Afrika Cumhuriyeti", CG: "Kongo - Brazavil", CH: "İsviçre", CI: "Fildişi Sahili", CK: "Cook Adaları", CL: "Şili", CM: "Kamerun", CN: "Çin", CO: "Kolombiya", CR: "Kosta Rika", CU: "Küba", CV: "Cape Verde", CW: "Curaçao", CX: "Christmas Adası", CY: "Güney Kıbrıs Rum Kesimi", CZ: "Çek Cumhuriyeti", DE: "Almanya", DJ: "Cibuti", DK: "Danimarka", DM: "Dominika", DO: "Dominik Cumhuriyeti", DZ: "Cezayir", EC: "Ekvador", EE: "Estonya", EG: "Mısır", EH: "Batı Sahara", ER: "Eritre", ES: "İspanya", ET: "Etiyopya", FI: "Finlandiya", FJ: "Fiji", FK: "Falkland Adaları", FM: "Mikronezya", FO: "Faroe Adaları", FR: "Fransa", GA: "Gabon", GB: "Birleşik Krallık", GD: "Grenada", GE: "Gürcistan", GF: "Fransız Guyanası", GG: "Guernsey", GH: "Gana", GI: "Cebelitarık", GL: "Grönland", GM: "Gambiya", GN: "Gine", GP: "Guadalupe", GQ: "Ekvator Ginesi", GR: "Yunanistan", GS: "Güney Georgia ve Güney Sandwich Adaları", GT: "Guatemala", GU: "Guam", GW: "Gine-Bissau", GY: "Guyana", HK: "Çin Hong Kong ÖYB", HM: "Heard Adası ve McDonald Adaları", HN: "Honduras", HR: "Hırvatistan", HT: "Haiti", HU: "Macaristan", ID: "Endonezya", IE: "İrlanda", IL: "İsrail", IM: "Man Adası", IN: "Hindistan", IO: "Britanya Hint Okyanusu Toprakları", IQ: "Irak", IR: "İran", IS: "İzlanda", IT: "İtalya", JE: "Jersey", JM: "Jamaika", JO: "Ürdün", JP: "Japonya", KE: "Kenya", KG: "Kırgızistan", KH: "Kamboçya", KI: "Kiribati", KM: "Komorlar", KN: "Saint Kitts ve Nevis", KP: "Kuzey Kore", KR: "Güney Kore", KW: "Kuveyt", KY: "Cayman Adaları", KZ: "Kazakistan", LA: "Laos", LB: "Lübnan", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberya", LS: "Lesoto", LT: "Litvanya", LU: "Lüksemburg", LV: "Letonya", LY: "Libya", MA: "Fas", MC: "Monako", MD: "Moldova", ME: "Karadağ", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshall Adaları", MK: "Kuzey Makedonya", ML: "Mali", MM: "Myanmar (Burma)", MN: "Moğolistan", MO: "Çin Makao ÖYB", MP: "Kuzey Mariana Adaları", MQ: "Martinik", MR: "Moritanya", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivler", MW: "Malavi", MX: "Meksika", MY: "Malezya", MZ: "Mozambik", NA: "Namibya", NC: "Yeni Kaledonya", NE: "Nijer", NF: "Norfolk Adası", NG: "Nijerya", NI: "Nikaragua", NL: "Hollanda", NO: "Norveç", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Yeni Zelanda", OM: "Umman", PA: "Panama", PE: "Peru", PF: "Fransız Polinezyası", PG: "Papua Yeni Gine", PH: "Filipinler", PK: "Pakistan", PL: "Polonya", PM: "Saint Pierre ve Miquelon", PN: "Pitcairn Adaları", PR: "Porto Riko", PS: "Filistin Bölgeleri", PT: "Portekiz", PW: "Palau", PY: "Paraguay", QA: "Katar", RE: "Réunion", RO: "Romanya", RS: "Sırbistan", RU: "Rusya", RW: "Ruanda", SA: "Suudi Arabistan", SB: "Solomon Adaları", SC: "Seyşeller", SD: "Sudan", SE: "İsveç", SG: "Singapur", SH: "Saint Helena", SI: "Slovenya", SJ: "Svalbard ve Jan Mayen Adaları", SK: "Slovakya", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somali", SR: "Surinam", SS: "Güney Sudan", ST: "São Tomé ve Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Suriye", SZ: "Svaziland", TC: "Turks ve Caicos Adaları", TD: "Çad", TF: "Fransız Güney Toprakları", TG: "Togo", TH: "Tayland", TJ: "Tacikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Türkmenistan", TN: "Tunus", TO: "Tonga", TR: "Türkiye", TT: "Trinidad ve Tobago", TV: "Tuvalu", TW: "Tayvan", TZ: "Tanzanya", UA: "Ukrayna", UG: "Uganda", UM: "ABD Uzak Adaları", US: ["ABD", "A.B.D.", "Amerika Birleşik Devletleri", "Birleşik Devletler", "Amerika"], UY: "Uruguay", UZ: "Özbekistan", VA: "Vatikan", VC: "Saint Vincent ve Grenadinler", VE: "Venezuela", VG: "Britanya Virjin Adaları", VI: "ABD Virjin Adaları", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis ve Futuna Adaları", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Güney Afrika", ZM: "Zambiya", ZW: "Zimbabve", XK: "Kosova" }, Vl = {
  locale: Jo,
  countries: Qo
}, jl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Qo,
  default: Vl,
  locale: Jo
}, Symbol.toStringTag, { value: "Module" })), qo = "uk", Xo = { AU: "Австралія", AT: "Австрія", AZ: "Азербайджан", AX: "Аландські Острови", AL: "Албанія", DZ: "Алжир", AS: "Американське Самоа", AI: "Ангілья", AO: "Ангола", AD: "Андорра", AQ: "Антарктика", AG: "Антигуа і Барбуда", MO: "Макао", AR: "Аргентина", AM: "Вірменія", AW: "Аруба", AF: "Афганістан", BS: "Багамські Острови", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Беліз", BE: "Бельгія", BJ: "Бенін", BM: "Бермудські Острови", BY: "Білорусь", BG: "Болгарія", BO: "Болівія", BA: "Боснія і Герцеговина", BW: "Ботсвана", BR: "Бразилія", IO: "Британська Територія в Індійському Океані", VG: "Британські Віргінські Острови", BN: "Бруней-Даруссалам", BF: "Буркіна-Фасо", BI: "Бурунді", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобританія", VE: "Венесуела", VI: "Віргінські Острови (США)", WF: "Волліс і Футуна", VN: "В'єтнам", UM: "Зовнішні Віддалені Острови (США)", GA: "Габон", HT: "Гаїті", GY: "Гаяна", GM: "Гамбія", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвіана", GN: "Гвінея", GW: "Гвінея-Бісау", GG: "Гернсі", GI: "Гібралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GR: "Греція", GE: "Грузія", GU: "Гуам", GL: "Гренландія", DK: "Данія", JE: "Джерсі", DJ: "Джибуті", DM: "Домініка", DO: "Домініканська Республіка", CD: "Демократична Республіка Конго", EC: "Еквадор", GQ: "Екваторіальна Гвінея", ER: "Еритрея", EE: "Естонія", ET: "Ефіопія", EG: "Єгипет", YE: "Ємен", ZM: "Замбія", ZW: "Зімбабве", IL: "Ізраїль", IN: "Індія", ID: "Індонезія", IQ: "Ірак", IR: "Іран", IE: "Ірландія", IS: "Ісландія", ES: "Іспанія", IT: "Італія", JO: "Йорданія", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Кайманові Острови", KH: "Камбоджа", CM: "Камерун", CA: "Канада", BQ: "Карибські Нідерланди", QA: "Катар", KE: "Кенія", CY: "Кіпр", KI: "Кірибаті", KG: "Киргизстан", TW: "Тайвань, Провінція Китаю", KP: "Корейська Народно-Демократична Республіка", CN: "Китай", CC: "Кокосові Острови", CO: "Колумбія", KM: "Комори", XK: "Косово", CR: "Коста-Рика", CI: "Кот-Д'Івуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвія", LS: "Лесото", LR: "Ліберія", LB: "Ліван", LY: "Лівія", LT: "Литва", LI: "Ліхтенштейн", LU: "Люксембург", MU: "Маврикій", MR: "Мавританія", MG: "Мадагаскар", YT: "Майотта", MW: "Малаві", MY: "Малайзія", ML: "Малі", MV: "Мальдіви", MT: "Мальта", MA: "Марокко", MQ: "Мартиніка", MH: "Маршаллові Острови", MX: "Мексика", FM: "Мікронезія", MZ: "Мозамбік", MD: "Молдова", MC: "Монако", MN: "Монголія", MS: "Монтсеррат", MM: "М'янма", NA: "Намібія", NR: "Науру", NP: "Непал", NE: "Нігер", NG: "Нігерія", NL: "Нідерланди", NI: "Нікарагуа", DE: "Німеччина", NU: "Ніуе", NZ: "Нова Зеландія", NC: "Нова Каледонія", NO: "Норвегія", AE: "Об'єднані Арабські Емірати", OM: "Оман", BV: "Острів Буве", HM: "Острів Герд і Острови Макдоналд", IM: "Острів Мен", NF: "Острів Норфолк", CX: "Острів Різдва", CK: "Острови Кука", SH: "Острів Святої Єлени", TC: "Острови Теркс і Кайкос", PK: "Пакистан", PW: "Палау", PS: "Палестина", PA: "Панама", PG: "Папуа-Нова Гвінея", ZA: "Південна Африка", PY: "Парагвай", PE: "Перу", GS: "Південна Джорджія та Південні Сандвічеві Острови", KR: "Республіка Корея", SS: "Південний Судан", MK: "Північна Македонія", MP: "Північні Маріанські Острови", PN: "Піткерн", PL: "Польща", PT: "Португалія", PR: "Пуерто-Рико", CG: "Конго", RE: "Реюньйон", RU: "Росія", RW: "Руанда", RO: "Румунія", EH: "Західна Сахара", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе і Принсіпі", SA: "Саудівська Аравія", SZ: "Есватіні", SJ: "Острови Шпіцберген та Ян-Маєн", SC: "Сейшельські Острови", BL: "Сен-Бартелемі", MF: "Сен-Мартен", PM: "Сен-П'єр і Мікелон", SN: "Сенегал", VC: "Сент-Вінсент і Гренадіни", KN: "Сент-Кітс і Невіс", LC: "Сент-Люсія", RS: "Сербія", SG: "Сингапур", SX: "Сінт-Мартен", SY: "Сирія", SK: "Словаччина", SI: "Словенія", SB: "Соломонові Острови", SO: "Сомалі", SD: "Судан", SR: "Суринам", TL: "Тимор-Лешті", US: "США", SL: "Сьєрра-Леоне", TJ: "Таджикистан", TH: "Таїланд", TZ: "Танзанія", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринідад і Тобаго", TV: "Тувалу", TN: "Туніс", TM: "Туркменистан", TR: "Туреччина", UG: "Уганда", HU: "Угорщина", UZ: "Узбекистан", UA: "Україна", UY: "Уругвай", FO: "Фарерські Острови", FJ: "Фіджі", PH: "Філіппіни", FI: "Фінляндія", FK: "Фолклендські Острови", FR: "Франція", PF: "Французька Полінезія", TF: "Французькі Південні і Антарктичні Території", HR: "Хорватія", CF: "Центральноафриканська Республіка", TD: "Чад", ME: "Чорногорія", CZ: "Чехія", CL: "Чилі", CH: "Швейцарія", SE: "Швеція", LK: "Шри-Ланка", JM: "Ямайка", JP: "Японія" }, Zl = {
  locale: qo,
  countries: Xo
}, zl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Xo,
  default: Zl,
  locale: qo
}, Symbol.toStringTag, { value: "Module" })), $o = "zh", es = { AD: "安道尔", AE: "阿联酋", AF: "阿富汗", AG: "安提瓜和巴布达", AI: "安圭拉", AL: "阿尔巴尼亚", AM: "亚美尼亚", AO: "安哥拉", AQ: "南极洲", AR: "阿根廷", AS: "美属萨摩亚", AT: "奥地利", AU: "澳大利亚", AW: "阿鲁巴", AX: "奥兰", AZ: "阿塞拜疆", BA: "波黑", BB: "巴巴多斯", BD: "孟加拉国", BE: "比利时", BF: "布基纳法索", BG: "保加利亚", BH: "巴林", BI: "布隆迪", BJ: "贝宁", BL: "圣巴泰勒米", BM: "百慕大", BN: "文莱", BO: "玻利维亚", BQ: "荷兰加勒比区", BR: "巴西", BS: "巴哈马", BT: "不丹", BV: "布韦岛", BW: "博茨瓦纳", BY: "白俄罗斯", BZ: "伯利兹", CA: "加拿大", CC: "科科斯（基林）群岛", CD: "刚果（金）", CF: "中非", CG: "刚果（布）", CH: "瑞士", CI: "科特迪瓦", CK: "库克群岛", CL: "智利", CM: "喀麦隆", CN: "中国", CO: "哥伦比亚", CR: "哥斯达黎加", CU: "古巴", CV: "佛得角", CW: "库拉索", CX: "圣诞岛", CY: "塞浦路斯", CZ: "捷克", DE: "德国", DJ: "吉布提", DK: "丹麦", DM: "多米尼克", DO: "多米尼加", DZ: "阿尔及利亚", EC: "厄瓜多尔", EE: "爱沙尼亚", EG: "埃及", EH: "阿拉伯撒哈拉民主共和国", ER: "厄立特里亚", ES: "西班牙", ET: "埃塞俄比亚", FI: "芬兰", FJ: "斐济", FK: "福克兰群岛", FM: "密克罗尼西亚联邦", FO: "法罗群岛", FR: "法国", GA: "加蓬", GB: "英国", GD: "格林纳达", GE: "格鲁吉亚", GF: "法属圭亚那", GG: "根西", GH: "加纳", GI: "直布罗陀", GL: "格陵兰", GM: "冈比亚", GN: "几内亚", GP: "瓜德罗普", GQ: "赤道几内亚", GR: "希腊", GS: "南乔治亚和南桑威奇群岛", GT: "危地马拉", GU: "关岛", GW: "几内亚比绍", GY: "圭亚那", HK: "香港", HM: "赫德岛和麦克唐纳群岛", HN: "洪都拉斯", HR: "克罗地亚", HT: "海地", HU: "匈牙利", ID: "印尼", IE: "爱尔兰", IL: "以色列", IM: "马恩岛", IN: "印度", IO: "英属印度洋领地", IQ: "伊拉克", IR: "伊朗", IS: "冰岛", IT: "意大利", JE: "泽西", JM: "牙买加", JO: "约旦", JP: "日本", KE: "肯尼亚", KG: "吉尔吉斯斯坦", KH: "柬埔寨", KI: "基里巴斯", KM: "科摩罗", KN: "圣基茨和尼维斯", KP: "朝鲜", KR: "韩国", KW: "科威特", KY: "开曼群岛", KZ: "哈萨克斯坦", LA: "老挝", LB: "黎巴嫩", LC: "圣卢西亚", LI: "列支敦士登", LK: "斯里兰卡", LR: "利比里亚", LS: "莱索托", LT: "立陶宛", LU: "卢森堡", LV: "拉脱维亚", LY: "利比亚", MA: "摩洛哥", MC: "摩纳哥", MD: "摩尔多瓦", ME: "黑山", MF: "法属圣马丁", MG: "马达加斯加", MH: "马绍尔群岛", MK: "北马其顿", ML: "马里", MM: "缅甸", MN: "蒙古", MO: "澳门", MP: "北马里亚纳群岛", MQ: "马提尼克", MR: "毛里塔尼亚", MS: "蒙特塞拉特", MT: "马耳他", MU: "毛里求斯", MV: "马尔代夫", MW: "马拉维", MX: "墨西哥", MY: "马来西亚", MZ: "莫桑比克", NA: "纳米比亚", NC: "新喀里多尼亚", NE: "尼日尔", NF: "诺福克岛", NG: "尼日利亚", NI: "尼加拉瓜", NL: "荷兰", NO: "挪威", NP: "尼泊尔", NR: "瑙鲁", NU: "纽埃", NZ: "新西兰", OM: "阿曼", PA: "巴拿马", PE: "秘鲁", PF: "法属波利尼西亚", PG: "巴布亚新几内亚", PH: "菲律宾", PK: "巴基斯坦", PL: "波兰", PM: "圣皮埃尔和密克隆", PN: "皮特凯恩群岛", PR: "波多黎各", PS: "巴勒斯坦", PT: "葡萄牙", PW: "帕劳", PY: "巴拉圭", QA: "卡塔尔", RE: "留尼汪", RO: "罗马尼亚", RS: "塞尔维亚", RU: "俄罗斯", RW: "卢旺达", SA: "沙特阿拉伯", SB: "所罗门群岛", SC: "塞舌尔", SD: "苏丹", SE: "瑞典", SG: "新加坡", SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚", SI: "斯洛文尼亚", SJ: "斯瓦尔巴和扬马延", SK: "斯洛伐克", SL: "塞拉利昂", SM: "圣马力诺", SN: "塞内加尔", SO: "索马里", SR: "苏里南", SS: "南苏丹", ST: "圣多美和普林西比", SV: "萨尔瓦多", SX: "荷属圣马丁", SY: "叙利亚", SZ: "斯威士兰", TC: "特克斯和凯科斯群岛", TD: "乍得", TF: "法属南部领地", TG: "多哥", TH: "泰国", TJ: "塔吉克斯坦", TK: "托克劳", TL: "东帝汶", TM: "土库曼斯坦", TN: "突尼斯", TO: "汤加", TR: "土耳其", TT: "特立尼达和多巴哥", TV: "图瓦卢", TW: "中国台湾省", TZ: "坦桑尼亚", UA: "乌克兰", UG: "乌干达", UM: "美国本土外小岛屿", US: "美国", UY: "乌拉圭", UZ: "乌兹别克斯坦", VA: "梵蒂冈", VC: "圣文森特和格林纳丁斯", VE: "委内瑞拉", VG: "英属维尔京群岛", VI: "美属维尔京群岛", VN: "越南", VU: "瓦努阿图", WF: "瓦利斯和富图纳", WS: "萨摩亚", XK: "科索沃", YE: "也门", YT: "马约特", ZA: "南非", ZM: "赞比亚", ZW: "津巴布韦" }, Jl = {
  locale: $o,
  countries: es
}, Ql = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: es,
  default: Jl,
  locale: $o
}, Symbol.toStringTag, { value: "Module" })), ql = {
  ar: Qu,
  cs: Xu,
  da: el,
  de: tl,
  el: nl,
  en: ol,
  es: ul,
  fr: cl,
  hi: pl,
  hu: hl,
  id: gl,
  it: Sl,
  ja: Ml,
  nl: Cl,
  no: Tl,
  pl: Al,
  pt: Dl,
  ro: El,
  ru: Pl,
  sk: Gl,
  sl: Rl,
  sq: Fl,
  sr: xl,
  sv: Ul,
  th: Wl,
  tr: jl,
  uk: zl,
  zh: Ql
};
Object.values(ql).forEach((a) => {
  Ar.registerLocale(a.default);
});
const as = (a, r) => {
  const n = qi(r);
  switch (a) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case zr.Taiwan:
      return Ar.getName(a, n, { select: "alias" });
    default:
      return Ar.getName(a, n, { select: "official" });
  }
}, rg = (a = Da.ENGLISH) => Object.values(zr).map((r) => ({
  id: r,
  caption: as(r, a) ?? ""
})), ng = (a, r = Da.ENGLISH) => as(a, r) ?? "";
var Re = /* @__PURE__ */ ((a) => (a.Email = "email", a.FirstName = "first_name", a.Surname = "surname", a.Country = "country", a.City = "city", a.Neighborhood = "neighborhood", a.StreetAddress = "street_address", a.StreetNumber = "street_number", a.Postcode = "postcode", a.PhoneNumber = "phone_number", a.CompanyName = "company_name", a.TaxNumber = "tax_number", a.State = "state", a))(Re || {});
const Xl = {
  [Re.Email]: "public_pages_purchase.contact_slug.email",
  [Re.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [Re.Surname]: "public_pages_purchase.contact_slug.last_name",
  [Re.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [Re.Country]: "public_pages_purchase.contact_slug.country",
  [Re.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [Re.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [Re.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [Re.City]: "public_pages_purchase.contact_slug.city",
  [Re.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [Re.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [Re.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [Re.State]: "public_pages_purchase.contact_slug.state_province"
}, $l = (a) => W.t(Xl[a]), ig = (a) => {
  const { slug: r, fieldName: n } = a;
  return Object.values(Re).includes(r) ? $l(r) : n;
};
var ec = /* @__PURE__ */ ((a) => (a.ARGENTINE_PESO = "ars", a.AUSTRALIAN_DOLLAR = "aud", a.BULGARIAN_LEV = "bgn", a.BRAZILIAN_REAL = "brl", a.CANADIAN_DOLLAR = "cad", a.CENTRAL_AFRICAN_FRANC = "xaf", a.CHILEAN_PESO = "clp", a.CHINESE_YUAN = "cny", a.COLOMBIAN_PESO = "cop", a.CZECH_CROWN = "czk", a.DANISH_KRONE = "dkk", a.EGYPTIAN_POUND = "egp", a.EURO = "eur", a.GHANAIAN_CEDI = "ghs", a.GUINEAN_FRANC = "gnf", a.HONG_KONG_DOLLAR = "hkd", a.HUNGARIAN_FORINT = "huf", a.ICELANDIC_KRONA = "isk", a.INDIAN_RUPEE = "inr", a.INDONESIAN_RUPIAH = "idr", a.ISRAELI_NEW_SHEKEL = "ils", a.JAPANESE_YEN = "jpy", a.KENYAN_SHILLING = "kes", a.MALAWIAN_KWACHA = "mwk", a.MALAYSIAN_RINGGIT = "myr", a.MEXICAN_PESO = "mxn", a.MOROCCAN_DIRHAM = "mad", a.NEW_ZEALAND_DOLLAR = "nzd", a.NIGERIAN_NAIRA = "ngn", a.NORWEGIAN_KRONE = "nok", a.PHILIPPINE_PESO = "php", a.POLISH_ZLOTY = "pln", a.POUND_STERLING = "gbp", a.ROMANIA_LEI = "ron", a.RUSSIAN_RUBLE = "rub", a.RWANDAN_FRANC = "rwf", a.SAO_TOME_AND_PRINCIPE_DOBRA = "std", a.SAUDI_RIYAL = "sar", a.SIERRA_LEONEAN_LEONE = "sll", a.SINGAPORE_DOLLAR = "sgd", a.SOUTH_AFRICAN_RAND = "zar", a.SRI_LANKAN_RUPEE = "lkr", a.SWEDISH_KRONA = "sek", a.SWISS_FRANC = "chf", a.TANZANIAN_SHILLING = "tzs", a.THAI_BAHT = "thb", a.TURKISH_LIRA = "try", a.UGANDAN_SHILLING = "ugx", a.US_DOLLAR = "usd", a.UNITED_ARAB_EMIRATES_DIRHAM = "aed", a.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", a.ZAMBIAN_KWACHA = "zmw", a.SERBIAN_DINAR = "rsd", a.UKRAINIAN_HRYVNIA = "uah", a.ALBANIAN_LEK = "all", a.VIETNAM_DONG = "vnd", a.PERUVIAN_SOL = "pen", a))(ec || {});
const or = (a, r) => new Date(
  new Intl.DateTimeFormat(ie.ENGLISH, {
    timeZone: r,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(a)
), Ce = (a, r) => a ? a instanceof Date ? or(a, r) : a.match(/([-+]\d+:?\d+)$/) ? or(new Date(a), r) : new Date(a) : or(/* @__PURE__ */ new Date(), r), Ca = (a) => {
  const r = function(n) {
    return (n < 10 ? "0" : "") + n;
  };
  return a.getFullYear() + "-" + r(a.getMonth() + 1) + "-" + r(a.getDate()) + "T" + r(a.getHours()) + ":" + r(a.getMinutes()) + ":" + r(a.getSeconds());
}, ac = (a) => {
  switch (a) {
    case wr.dateFirst:
      return "en-GB";
    case wr.monthFirst:
      return "en-US";
    default:
      return;
  }
}, Bn = (a, r) => (typeof a == "string" ? new Date(a) : a).toLocaleString(ac(r == null ? void 0 : r.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: r == null ? void 0 : r.timeZone
}), og = (a, r) => {
  if (!r && !a) return "";
  const e = new Intl.DateTimeFormat(a, {
    timeZone: r,
    timeZoneName: "shortOffset"
  }).formatToParts(/* @__PURE__ */ new Date()).find((i) => i.type === "timeZoneName");
  if (e)
    return e.value.replace("GMT", "UTC");
}, Dt = (a, r) => Ce(a, r);
var Ze = {}, sr = {}, ur = {}, Pn;
function ts() {
  return Pn || (Pn = 1, (function(a) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a.instanceOfHashable = a.guessType = a.guessObjectType = a.TYPE_MAP = void 0, a.TYPE_MAP = {
      Array: "array",
      Int8Array: "typedarray",
      Uint8Array: "typedarray",
      Uint8ClampedArray: "typedarray",
      Int16Array: "typedarray",
      Uint16Array: "typedarray",
      Int32Array: "typedarray",
      Uint32Array: "typedarray",
      Float32Array: "typedarray",
      Float64Array: "typedarray",
      BigUint64Array: "typedarray",
      BigInt64Array: "typedarray",
      Buffer: "typedarray",
      Map: "map",
      Set: "set",
      Date: "date",
      String: "string",
      Number: "number",
      BigInt: "bigint",
      Boolean: "boolean",
      Object: "object"
    };
    const r = (e) => {
      var o;
      if (e === null)
        return "null";
      if ((0, a.instanceOfHashable)(e))
        return "hashable";
      const i = ((o = e == null ? void 0 : e.constructor) == null ? void 0 : o.name) ?? "unknown";
      return a.TYPE_MAP[i] || "unknown";
    };
    a.guessObjectType = r;
    const n = (e) => {
      const i = typeof e;
      return i !== "object" ? i : (0, a.guessObjectType)(e);
    };
    a.guessType = n;
    const t = (e) => typeof e.toHashableString == "function";
    a.instanceOfHashable = t;
  })(ur)), ur;
}
var On;
function tc() {
  return On || (On = 1, (function(a) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a._mapSort = a._map = a._objectSort = a._object = a._setCoerce = a._set = a._setSort = a._setSortCoerce = a._typedArray = a._typedArraySort = a._array = a._arraySort = a._date = a._dateCoerce = a._functionTrim = a._functionTrimCoerce = a._function = a._functionCoerce = a._null = a._nullCoerce = a._undefined = a._undefinedCoerce = a._symbol = a._symbolCoerce = a._boolean = a._booleanCoerce = a._bigInt = a._bigIntCoerce = a._number = a._numberCoerce = a._stringTrim = a._stringTrimCoerce = a._string = a._stringCoerce = a._hashable = a.PREFIX = void 0;
    const r = ts();
    a.PREFIX = {
      string: "<:s>",
      number: "<:n>",
      bigint: "<:bi>",
      boolean: "<:b>",
      symbol: "<:smbl>",
      undefined: "<:undf>",
      null: "<:null>",
      function: "<:func>",
      array: "",
      date: "<:date>",
      set: "<:set>",
      map: "<:map>"
    };
    function n(E) {
      return E.toHashableString();
    }
    a._hashable = n;
    function t(E) {
      return E;
    }
    a._stringCoerce = t;
    function e(E) {
      return a.PREFIX.string + ":" + E;
    }
    a._string = e;
    function i(E) {
      return E.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
    }
    a._stringTrimCoerce = i;
    function o(E) {
      return a.PREFIX.string + ":" + E.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
    }
    a._stringTrim = o;
    function s(E) {
      return E.toString();
    }
    a._numberCoerce = s;
    function u(E) {
      return `${a.PREFIX.number}:${E}`;
    }
    a._number = u;
    function l(E) {
      return E.toString();
    }
    a._bigIntCoerce = l;
    function c(E) {
      return `${a.PREFIX.bigint}:${E.toString()}`;
    }
    a._bigInt = c;
    function d(E) {
      return E ? "1" : "0";
    }
    a._booleanCoerce = d;
    function h(E) {
      return a.PREFIX.boolean + ":" + E.toString();
    }
    a._boolean = h;
    function p() {
      return a.PREFIX.symbol;
    }
    a._symbolCoerce = p;
    function g(E) {
      return a.PREFIX.symbol + ":" + E.toString();
    }
    a._symbol = g;
    function S() {
      return "";
    }
    a._undefinedCoerce = S;
    function b() {
      return a.PREFIX.undefined;
    }
    a._undefined = b;
    function w() {
      return "";
    }
    a._nullCoerce = w;
    function T() {
      return a.PREFIX.null;
    }
    a._null = T;
    function k(E) {
      return E.name + "=>" + E.toString();
    }
    a._functionCoerce = k;
    function N(E) {
      return a.PREFIX.function + ":" + E.name + "=>" + E.toString();
    }
    a._function = N;
    function M(E) {
      return E.name + "=>" + E.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
    }
    a._functionTrimCoerce = M;
    function y(E) {
      return a.PREFIX.function + ":" + E.name + "=>" + E.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
    }
    a._functionTrim = y;
    function D(E) {
      return E.toISOString();
    }
    a._dateCoerce = D;
    function I(E) {
      return a.PREFIX.date + ":" + E.toISOString();
    }
    a._date = I;
    function P(E) {
      const U = this;
      return "[" + E.map((j) => U[(0, r.guessType)(j)](j)).sort().toString() + "]";
    }
    a._arraySort = P;
    function B(E) {
      const U = this;
      return "[" + E.map((j) => U[(0, r.guessType)(j)](j)).toString() + "]";
    }
    a._array = B;
    function K(E) {
      const U = this;
      return "[" + Array.prototype.slice.call(E).map((V) => U[(0, r.guessType)(V)](V)).sort().toString() + "]";
    }
    a._typedArraySort = K;
    function Q(E) {
      const U = this;
      return "[" + Array.prototype.slice.call(E).map((V) => U[(0, r.guessType)(V)](V)).toString() + "]";
    }
    a._typedArray = Q;
    function Z(E) {
      return P.call(this, Array.from(E));
    }
    a._setSortCoerce = Z;
    function z(E) {
      return `${a.PREFIX.set}:${P.call(this, Array.from(E))}`;
    }
    a._setSort = z;
    function x(E) {
      return `${a.PREFIX.set}:${B.call(this, Array.from(E))}`;
    }
    a._set = x;
    function Y(E) {
      return B.call(this, Array.from(E));
    }
    a._setCoerce = Y;
    function L(E) {
      const U = this, j = Object.keys(E), V = [];
      for (const re of j) {
        const he = E[re], ve = (0, r.guessType)(he);
        V.push(re + ":" + U[ve](he));
      }
      return "{" + V.toString() + "}";
    }
    a._object = L;
    function H(E) {
      const U = this, j = Object.keys(E).sort(), V = [];
      for (const re of j) {
        const he = E[re], ve = (0, r.guessType)(he);
        V.push(re + ":" + U[ve](he));
      }
      return "{" + V.toString() + "}";
    }
    a._objectSort = H;
    function X(E) {
      const U = this, j = Array.from(E), V = [];
      for (const re of j) {
        const [he, ve] = re;
        V.push([U[(0, r.guessType)(he)](he), U[(0, r.guessType)(ve)](ve)]);
      }
      return "[" + V.join(";") + "]";
    }
    a._map = X;
    function J(E) {
      const U = this, j = Array.from(E), V = [];
      for (const re of j) {
        const [he, ve] = re;
        V.push([U[(0, r.guessType)(he)](he), U[(0, r.guessType)(ve)](ve)]);
      }
      return "[" + V.sort().join(";") + "]";
    }
    a._mapSort = J;
  })(sr)), sr;
}
var Gn;
function rc() {
  if (Gn) return Ze;
  Gn = 1;
  var a = Ze && Ze.__createBinding || (Object.create ? (function(o, s, u, l) {
    l === void 0 && (l = u);
    var c = Object.getOwnPropertyDescriptor(s, u);
    (!c || ("get" in c ? !s.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return s[u];
    } }), Object.defineProperty(o, l, c);
  }) : (function(o, s, u, l) {
    l === void 0 && (l = u), o[l] = s[u];
  })), r = Ze && Ze.__setModuleDefault || (Object.create ? (function(o, s) {
    Object.defineProperty(o, "default", { enumerable: !0, value: s });
  }) : function(o, s) {
    o.default = s;
  }), n = Ze && Ze.__importStar || function(o) {
    if (o && o.__esModule) return o;
    var s = {};
    if (o != null) for (var u in o) u !== "default" && Object.prototype.hasOwnProperty.call(o, u) && a(s, o, u);
    return r(s, o), s;
  };
  Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.objectSorter = void 0;
  const t = n(tc()), e = ts(), i = (o) => {
    const { sort: s, coerce: u, trim: l } = {
      sort: !0,
      coerce: !0,
      trim: !1,
      ...o
    }, c = {
      array: typeof s == "boolean" ? s : (s == null ? void 0 : s.array) ?? !1,
      typedArray: typeof s == "boolean" ? !1 : (s == null ? void 0 : s.typedArray) ?? !1,
      object: typeof s == "boolean" ? s : (s == null ? void 0 : s.object) ?? !1,
      set: typeof s == "boolean" ? s : (s == null ? void 0 : s.set) ?? !1,
      map: typeof s == "boolean" ? s : (s == null ? void 0 : s.map) ?? !1
    }, d = {
      boolean: typeof u == "boolean" ? u : (u == null ? void 0 : u.boolean) ?? !1,
      number: typeof u == "boolean" ? u : (u == null ? void 0 : u.number) ?? !1,
      bigint: typeof u == "boolean" ? u : (u == null ? void 0 : u.bigint) ?? !1,
      string: typeof u == "boolean" ? u : (u == null ? void 0 : u.string) ?? !1,
      undefined: typeof u == "boolean" ? u : (u == null ? void 0 : u.undefined) ?? !1,
      null: typeof u == "boolean" ? u : (u == null ? void 0 : u.null) ?? !1,
      symbol: typeof u == "boolean" ? u : (u == null ? void 0 : u.symbol) ?? !1,
      function: typeof u == "boolean" ? u : (u == null ? void 0 : u.function) ?? !1,
      date: typeof u == "boolean" ? u : (u == null ? void 0 : u.date) ?? !1,
      set: typeof u == "boolean" ? u : (u == null ? void 0 : u.set) ?? !1
    }, h = {
      string: typeof l == "boolean" ? l : (l == null ? void 0 : l.string) ?? !1,
      function: typeof l == "boolean" ? l : (l == null ? void 0 : l.function) ?? !1
    }, p = {
      // eslint-disable-next-line @typescript-eslint/ban-types
      unknown: function(b) {
        var k;
        const w = ((k = b.constructor) == null ? void 0 : k.name) ?? "unknonw";
        let T = "unknown";
        return typeof b.toString == "function" ? T = b.toString() : Object.keys(b).length > 0 && (T = JSON.stringify(b)), `<:${w}>:${T}`;
      }
    };
    p.hashable = t._hashable.bind(p), h.string ? p.string = d.string ? t._stringTrimCoerce.bind(p) : t._stringTrim.bind(p) : p.string = d.string ? t._stringCoerce.bind(p) : t._string.bind(p), p.number = d.number ? t._numberCoerce.bind(p) : t._number.bind(p), p.bigint = d.bigint ? t._bigIntCoerce.bind(p) : t._bigInt.bind(p), p.boolean = d.boolean ? t._booleanCoerce.bind(p) : t._boolean.bind(p), p.symbol = d.symbol ? t._symbolCoerce.bind(p) : t._symbol.bind(p), p.undefined = d.undefined ? t._undefinedCoerce.bind(p) : t._undefined.bind(p), p.null = d.null ? t._nullCoerce.bind(p) : t._null.bind(p), h.function ? p.function = d.function ? t._functionTrimCoerce.bind(p) : t._functionTrim.bind(p) : p.function = d.function ? t._functionCoerce.bind(p) : t._function.bind(p), p.date = d.date ? t._dateCoerce.bind(p) : t._date.bind(p), p.array = c.array ? t._arraySort.bind(p) : t._array.bind(p), p.typedarray = c.typedArray ? t._typedArraySort.bind(p) : t._typedArray.bind(p), c.set ? p.set = d.set ? t._setSortCoerce.bind(p) : t._setSort.bind(p) : p.set = d.set ? t._setCoerce.bind(p) : t._set.bind(p), p.object = c.object ? t._objectSort.bind(p) : t._object.bind(p), p.map = c.map ? t._mapSort.bind(p) : t._map.bind(p);
    function g(S) {
      return p[(0, e.guessType)(S)](S);
    }
    return g;
  };
  return Ze.objectSorter = i, Ze;
}
var Ln = rc();
const nc = Qe.error, ic = Qe.success, oc = Qe.loading, sc = Qe.custom, zt = (a) => {
  const r = {
    id: "mock-id",
    type: "blank",
    message: a,
    visible: !0,
    ariaProps: { role: "status", "aria-live": "polite" },
    pauseDuration: 0,
    createdAt: 0,
    dismissed: !1
  };
  let n;
  return typeof a == "string" ? n = a : typeof a == "function" ? n = JSON.stringify(Ln.objectSorter()(a(r))) : typeof a == "object" && (n = JSON.stringify(Ln.objectSorter()(a))), n;
};
Qe.error = (a, r) => nc(a, {
  id: zt(a),
  ...r
});
Qe.success = (a, r) => ic(a, {
  id: zt(a),
  ...r
});
Qe.loading = (a, r) => oc(a, {
  id: zt(a),
  ...r
});
Qe.custom = (a, r) => sc(a, {
  id: zt(a),
  ...r
});
async function uc(a, r) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(a), r && Qe.success(r);
  } catch {
    Qe.error(W.t("public_pages_purchase.copy_clipboard_error"));
  }
}
const sg = (a) => Number(a), ug = (a) => Number(a), lg = (a) => a / 100, cg = (a) => Number(a) * 100, lc = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", cc = "flex items-center justify-center gap-2", dc = (a) => "href" in a, pc = ({
  as: a = "a",
  href: r,
  isFetching: n,
  className: t,
  children: e,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || n ? /* @__PURE__ */ v("button", { className: t, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ v(Nr, { buttonTextClassName: i, isFetching: n, children: e }) }) : /* @__PURE__ */ v(a, { className: t, href: r, ...o, children: /* @__PURE__ */ v(Nr, { buttonTextClassName: i, isFetching: n, children: e }) }), Nr = ({
  children: a,
  isFetching: r,
  buttonTextClassName: n
}) => /* @__PURE__ */ v(
  "div",
  {
    className: A(
      "flex items-center justify-center gap-2 truncate",
      r && "opacity-0",
      n
    ),
    children: a
  }
), Oa = ({
  width: a = "small",
  isFetching: r,
  backgroundColor: n,
  color: t,
  hoverColor: e,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: s,
  loaderType: u,
  testAttributePostfix: l,
  className: c,
  buttonTextClassName: d,
  loaderClassName: h,
  as: p,
  ...g
}) => {
  const S = g, b = A(
    kr(
      lc,
      cc,
      n,
      t,
      e,
      i,
      a === "small" ? "px-4" : "px-10",
      o && `border ${o}`,
      s,
      r && "pointer-events-none select-none"
    ),
    c
  ), w = A(
    kr("absolute", r ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    h
  );
  if (dc(S)) {
    const { "aria-disabled": T, ...k } = S;
    return /* @__PURE__ */ v(
      pc,
      {
        as: p,
        isFetching: r,
        "aria-disabled": T || r,
        className: A(b, T && "bg-text-secondary/50 pointer-events-none"),
        ...k,
        ...Tr(!!l, `${l}`),
        children: /* @__PURE__ */ _(Ue, { children: [
          /* @__PURE__ */ v(Gt, { small: !0, type: u, className: w }),
          S.children
        ] })
      }
    );
  } else {
    const { disabled: T, ...k } = S;
    return /* @__PURE__ */ _(
      "button",
      {
        disabled: r || T,
        className: A(b, T && "bg-text-secondary/50 pointer-events-none"),
        ...k,
        ...Tr(!!l, `${l}`),
        children: [
          /* @__PURE__ */ v(Gt, { small: !0, type: u, className: w }),
          /* @__PURE__ */ v(Nr, { buttonTextClassName: d, isFetching: r, children: S.children })
        ]
      }
    );
  }
}, dg = (a) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-text-primary/50",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary",
    ...a
  }
);
var Ua = /* @__PURE__ */ ((a) => (a.danger = "danger", a.blue = "blue", a))(Ua || {});
const fc = (a) => {
  switch (a) {
    case Ua.danger:
      return "hover:text-danger";
    case Ua.blue:
      return "hover:text-brand-primary";
    default:
      return "text-brand-primary";
  }
}, hc = (a) => {
  switch (a) {
    case Ua.danger:
      return "hover:border-danger";
    case Ua.blue:
      return "hover:border-brand-primary";
    default:
      return "border-brand-primary";
  }
}, pg = ({
  neutralType: a = Ua.blue,
  ...r
}) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-text-primary",
    hoverColor: fc(a),
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-background-secondary",
    borderColor: "border-text-secondary/30",
    hoverBorderColor: hc(a),
    ...r
  }
), fg = (a) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-text-primary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-transparent",
    hoverBackgroundColor: "hover:bg-text-primary",
    borderColor: "border-text-primary",
    loaderType: "dark",
    ...a
  }
), hg = (a) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-green",
    hoverBackgroundColor: "hover:bg-green",
    ...a
  }
), Rn = ({ selected: a, ...r }) => /* @__PURE__ */ v(
  Oa,
  {
    color: a ? "text-brand-primary" : "text-text-primary",
    hoverColor: a ? "hover:text-brand-primary" : "hover:text-text-primary",
    backgroundColor: a ? "bg-brand-primary/10" : "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary/10",
    borderColor: a ? "border-brand-primary" : "border-text-secondary/30",
    hoverBorderColor: "border-brand-primary",
    type: "button",
    ...r
  }
), rs = (a) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-brand-primary",
    hoverBackgroundColor: "hover:bg-brand-primary-hover",
    ...a
  }
), ns = (a) => /* @__PURE__ */ v(
  Oa,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-danger",
    hoverBackgroundColor: "hover:bg-danger",
    ...a
  }
);
function mc({
  active: a,
  isFetching: r,
  iconClassName: n,
  menuButtonClassName: t,
  dataTestAttributes: e,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ v(
    cu,
    {
      disabled: r,
      className: A(
        !i && "hover:bg-brand-primary focus-ring group h-[30px] rounded-lg px-3 py-1 transition-colors lg:h-[20px]",
        !i && (a ? "bg-brand-primary" : "bg-background-primary"),
        r && "pointer-events-none animate-pulse",
        t
      ),
      ...e,
      ...o,
      children: typeof i == "function" ? (s) => i({ ...s, active: a }) : i ?? /* @__PURE__ */ v(
        yu,
        {
          className: A(
            "group-hover:fill-background-secondary",
            a && "fill-background-secondary",
            n
          )
        }
      )
    }
  );
}
const mg = ({
  menuItems: a,
  anchor: r = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: n,
  toggleOnHover: t = !0,
  ...e
}) => {
  const { show: i, close: o, delayOpen: s, delayClose: u } = zi();
  return /* @__PURE__ */ v(du, { children: ({ open: l, close: c }) => /* @__PURE__ */ _(Ue, { children: [
    /* @__PURE__ */ v(
      mc,
      {
        ...e,
        active: t && i || l,
        onMouseEnter: s,
        onMouseLeave: u
      }
    ),
    /* @__PURE__ */ v(
      xa,
      {
        show: t && i || l,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ v(
          pu,
          {
            onClick: () => {
              c(), o();
            },
            static: !0,
            anchor: r,
            className: A(
              "bg-background-secondary border-background-tertiary overflow-hidden rounded-lg border shadow-lg focus:outline-hidden",
              n
            ),
            portal: !0,
            onMouseEnter: s,
            onMouseLeave: u,
            children: a
          }
        )
      }
    )
  ] }) });
}, gc = "group aria-pressed:text-brand-primary hover:text-brand-primary flex items-center gap-2 w-full px-4 py-3 lg:py-2 text-left text-sm transition-colors border-b border-background-tertiary last:border-0", gg = ({
  dataTestAttributes: a,
  onClick: r,
  label: n,
  buttonClassName: t,
  labelClassName: e,
  children: i,
  ...o
}) => /* @__PURE__ */ v(fu, { ...o, children: i || (({ focus: s }) => /* @__PURE__ */ v(
  "button",
  {
    onClick: r,
    "aria-pressed": s,
    type: "button",
    className: A(
      gc,
      o.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed",
      t
    ),
    ...a,
    children: /* @__PURE__ */ v("span", { className: e, children: n })
  }
)) }, "action-settings"), vc = (a) => {
  switch (a) {
    case "success":
      return "border-green";
    case "error":
      return "border-danger";
    default:
      return "border-brand-primary";
  }
}, Sc = (a) => {
  switch (a) {
    case "success":
      return "hover:fill-green group-focus-visible:fill-green";
    case "error":
      return "hover:fill-danger group-focus-visible:fill-danger";
    default:
      return "hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  }
}, is = ({
  t: a,
  afterClose: r,
  className: n,
  titleClassName: t,
  buttonClassName: e,
  hideCloseButton: i
}) => {
  const o = Ae(null), s = vc(a.type), u = Sc(a.type);
  return /* @__PURE__ */ _(
    "div",
    {
      className: A(
        "bg-background-secondary text-text-tertiary flex max-w-[350px] items-center gap-2.5 rounded-lg border px-2.5 py-2 shadow-lg",
        a.visible ? "animate-toast-enter" : "animate-toast-leave",
        s,
        n
      ),
      "data-test-id": `toast-${a.type}`,
      children: [
        a.icon,
        /* @__PURE__ */ v("div", { className: A("break-words", t), children: a.message }),
        !i && /* @__PURE__ */ v(
          "button",
          {
            ref: o,
            className: A("group h-fit outline-hidden", e),
            onClick: () => {
              Pu.dismiss(a.id), r && r();
            },
            children: /* @__PURE__ */ v(
              yt,
              {
                className: A("fill-fill-primary main-transition-colors", u)
              }
            )
          }
        )
      ]
    }
  );
}, vg = ({
  className: a,
  titleClassName: r,
  buttonClassName: n,
  afterClose: t
}) => /* @__PURE__ */ v(
  Ou,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ v(ku, { className: "fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ v(Cu, { className: "fill-danger h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      }
    },
    children: (e) => /* @__PURE__ */ v(
      is,
      {
        t: e,
        className: a,
        titleClassName: r,
        buttonClassName: n,
        afterClose: t
      }
    )
  }
), Sg = ({
  className: a,
  titleClassName: r,
  buttonClassName: n
} = {}) => ({ infoToast: Ha(
  (e, i, o, s) => Qe.custom(
    (u) => /* @__PURE__ */ v(
      is,
      {
        t: { ...u, message: e },
        className: a,
        titleClassName: r,
        buttonClassName: n,
        afterClose: o,
        hideCloseButton: s
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ v(Wi, { className: "fill-brand-primary h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
      ...i
    }
  ),
  []
) }), bg = ({
  options: a,
  selected: r,
  onChange: n,
  disabled: t,
  error: e,
  label: i,
  required: o,
  className: s,
  labelClassName: u,
  optionsWrapperClassName: l,
  optionWrapperClassName: c,
  selectedOptionWrapperClassName: d,
  optionClassName: h,
  inputClassName: p
}) => /* @__PURE__ */ _("div", { className: A("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ v(Pa, { label: i, labelClassName: u, required: o }),
  /* @__PURE__ */ v("ul", { className: A("flex items-center gap-5", l), children: a ? a.map((g) => /* @__PURE__ */ v(
    Zr,
    {
      label: g.tooltipLabel ?? "",
      disabled: !g.showTooltip,
      children: /* @__PURE__ */ v(
        "li",
        {
          className: A(
            c,
            g.id === r && d
          ),
          children: /* @__PURE__ */ _(
            "label",
            {
              className: A(
                "r relative flex w-fit items-center gap-2",
                !t && "cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ v(
                  "input",
                  {
                    className: A(
                      "border-2 outline-hidden",
                      t ? "border-fill-primary/70" : "border-fill-primary",
                      "h-[20px] w-[20px] rounded-full",
                      g.id === r ? "bg-background-secondary" : "bg-transparent",
                      "main-transition-colors focus-ring shrink-0 appearance-none",
                      p
                    ),
                    disabled: t || g.disabled,
                    checked: g.id === r,
                    value: g.caption,
                    onChange: () => n(g.id),
                    type: "radio"
                  }
                ),
                /* @__PURE__ */ v(
                  "svg",
                  {
                    width: 20,
                    height: 20,
                    className: A(
                      "main-transition-colors absolute",
                      g.id === r ? "fill-green" : "fill-transparent",
                      t && "opacity-70"
                    ),
                    children: /* @__PURE__ */ v(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ _("div", { className: "flex items-center gap-3", children: [
                  g.caption && /* @__PURE__ */ v(
                    "span",
                    {
                      className: A(
                        "main-transition-colors",
                        g.id === r ? "text-text-primary" : "text-text-primary/50",
                        t && "opacity-70",
                        h,
                        "text-left"
                      ),
                      children: g.caption
                    }
                  ),
                  g.additionalInfo
                ] })
              ]
            }
          )
        }
      )
    },
    g.id
  )) : /* @__PURE__ */ _(Ue, { children: [
    /* @__PURE__ */ v(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ v(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ v(Sa, { error: e })
] });
function Jr({
  arrowButtonClassName: a,
  open: r,
  isDisabled: n,
  As: t = Yr
}) {
  return /* @__PURE__ */ v(
    t,
    {
      as: "div",
      role: "button",
      className: A(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        a
      ),
      disabled: n,
      children: /* @__PURE__ */ v(
        Vi,
        {
          className: A("stroke-text-primary main-transition", r && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function Qr({ onClick: a, closeButtonClassName: r, isDisabled: n }) {
  return /* @__PURE__ */ v(
    "button",
    {
      type: "button",
      className: A(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        r
      ),
      onClick: a,
      disabled: n,
      children: /* @__PURE__ */ v(yt, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function bc({
  children: a,
  selectedData: r,
  virtual: n,
  disabled: t,
  onClose: e,
  onChange: i
}) {
  return /* @__PURE__ */ v(
    xi,
    {
      immediate: !0,
      multiple: !0,
      value: r,
      virtual: n,
      onChange: (o) => i((o == null ? void 0 : o.filter((s) => s.id !== void 0).map((s) => s.id)) ?? []),
      disabled: t,
      onClose: e,
      children: ({ open: o }) => a(o)
    }
  );
}
function Mc({
  children: a,
  selectedData: r,
  virtual: n,
  disabled: t,
  onClose: e,
  onChange: i
}) {
  return /* @__PURE__ */ v(
    xi,
    {
      immediate: !0,
      value: r,
      virtual: n,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: t,
      onClose: e,
      children: ({ open: o }) => a(o)
    }
  );
}
const os = "text-[16px] sm:text-sm", qr = "px-4 py-2.5";
function ss({
  isDisabled: a,
  open: r,
  hasError: n,
  className: t,
  placeholder: e,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: s,
  onChange: u,
  inputRef: l,
  dataTest: c
}) {
  return /* @__PURE__ */ v(
    hu,
    {
      ref: l,
      className: A(
        "w-full truncate",
        os,
        "flex items-center justify-between",
        qr,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        a ? "bg-skeleton-primary/20" : "bg-background-secondary",
        r ? "border-brand-primary" : n ? "border-danger" : "border-text-secondary/30",
        o && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        t
      ),
      onChange: (d) => u == null ? void 0 : u(d.target.value),
      onKeyDown: (d) => d.stopPropagation(),
      onFocus: s,
      displayValue: i ? () => i : void 0,
      placeholder: e ?? W.t("public_pages_purchase.form_select.select"),
      ...c
    }
  );
}
function Xr({ loaderWrapperClassName: a, loaderClassName: r }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: A(
        "flex h-full items-center justify-center",
        "scale-75",
        a
      ),
      children: /* @__PURE__ */ v(Gt, { className: A(r) })
    }
  );
}
const $r = ({
  item: a,
  optionClassName: r,
  optionIconWrapperClassName: n,
  optionRef: t,
  as: e
}) => {
  const i = (a == null ? void 0 : a.customCaption) ?? (a == null ? void 0 : a.caption), o = ({ disabled: u, selected: l }) => A(
    "bg-background-secondary text-text-primary",
    qr,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    l && "bg-brand-primary text-background-secondary",
    u && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    r,
    a == null ? void 0 : a.className
  ), s = ({ selected: u }) => /* @__PURE__ */ _(Ue, { children: [
    i,
    /* @__PURE__ */ _("div", { className: A("flex items-center gap-3", n), children: [
      u && /* @__PURE__ */ v(
        Tu,
        {
          className: kr(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      a == null ? void 0 : a.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ v(
    e,
    {
      disabled: a == null ? void 0 : a.disabled,
      ref: t,
      value: a,
      className: o,
      "data-test-id": a == null ? void 0 : a.dataTestAttribute,
      children: s
    },
    a == null ? void 0 : a.id
  );
}, Jt = Mt(
  ({ children: a, style: r, optionsClassName: n, as: t, optionsProps: e }, i) => /* @__PURE__ */ v(
    t,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: i,
      style: r,
      className: A(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        os,
        n
      ),
      ...e,
      children: a
    }
  )
);
Jt.displayName = "ListOptionsWrapper";
const _n = 240, us = () => ({
  id: void 0,
  caption: W.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), en = (a, r) => {
  let n = 0;
  return a && (a.querySelectorAll('[role="option"]').forEach((e) => {
    n += e.getBoundingClientRect().height;
  }), n = r ? Math.min(n, _n) || _n : 42), n;
};
function ls({
  optionsClassName: a,
  data: r,
  loaderWrapperClassName: n,
  loaderClassName: t,
  asOptions: e,
  asOption: i,
  ...o
}) {
  const [s, u] = de(null), l = en(s, r);
  return /* @__PURE__ */ v(
    Jt,
    {
      as: e,
      ref: u,
      optionsClassName: a,
      style: { height: l },
      children: ({ option: c }) => r ? $r({ ...o, as: i, item: c }) : /* @__PURE__ */ v(
        Xr,
        {
          loaderWrapperClassName: n,
          loaderClassName: t
        }
      )
    }
  );
}
const cs = (a, r) => (r == null ? void 0 : r.find((n) => n.id === a)) ?? null, ds = (a) => {
  const [r, n] = de(""), [t, e] = de(a);
  return Ne(() => {
    const i = r === "" ? a : (a == null ? void 0 : a.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(r.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    e(() => i);
  }, [a, r]), { filteredData: t, setFilteredData: e, query: r, setQuery: n };
}, ps = (a = []) => ({
  options: a.length > 0 ? a : [us()],
  disabled: (r) => (r == null ? void 0 : r.disabled) ?? !1
});
function Mg({
  label: a,
  data: r,
  staticData: n,
  onChange: t,
  labelClassName: e,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: u,
  required: l,
  description: c,
  className: d,
  containerClassName: h,
  closeButtonClassName: p,
  arrowButtonClassName: g,
  fieldClassName: S,
  disabled: b,
  withoutCloseIcon: w,
  onOpen: T,
  onClose: k,
  dataTest: N,
  wrapperProps: M,
  loaderClassName: y,
  loaderWrapperClassName: D,
  inputWrapperClassName: I,
  inputRef: P,
  statusIcon: B,
  statusIconClassName: K,
  ...Q
}) {
  const [Z, z] = de(!1);
  Ne(() => {
    Z && T && (T(), z(!1));
  }, [Z]);
  const x = cs(i, r ?? n) ?? null, { filteredData: Y, setQuery: L } = ds(r), H = i !== void 0, E = b || o || H && (!r && !n), U = H && !w && !E;
  return /* @__PURE__ */ _("div", { className: A("relative flex flex-col gap-1", h), children: [
    /* @__PURE__ */ v(
      Mc,
      {
        selectedData: x,
        virtual: ps(Y),
        onChange: t,
        disabled: E,
        onClose: () => {
          L(""), k == null || k();
        },
        children: (j) => /* @__PURE__ */ _(Ue, { children: [
          /* @__PURE__ */ _(Wr, { className: A("relative flex flex-col gap-1", S), children: [
            /* @__PURE__ */ v(
              Pa,
              {
                wrapperAs: "label",
                wrapperProps: M,
                label: a,
                required: l,
                labelClassName: A("text-sm font-medium", e)
              }
            ),
            /* @__PURE__ */ _(Yr, { as: "button", className: A("relative", I), children: [
              /* @__PURE__ */ v(
                ss,
                {
                  dataTest: N,
                  inputRef: P,
                  isDisabled: E,
                  hasError: !!u,
                  open: j,
                  className: d,
                  placeholder: s,
                  selectedCaption: (x == null ? void 0 : x.caption) ?? "",
                  isPreFetching: o,
                  onFocus: () => z(!0),
                  onChange: (V) => {
                    z(!0), L(V);
                  }
                }
              ),
              B ? /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    K
                  ),
                  children: B
                }
              ) : /* @__PURE__ */ v(
                Jr,
                {
                  isDisabled: E,
                  arrowButtonClassName: A(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    g
                  ),
                  open: j
                }
              )
            ] }),
            U && /* @__PURE__ */ v(
              Qr,
              {
                isDisabled: E,
                closeButtonClassName: A(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  p
                ),
                onClick: () => t(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ v(
            ls,
            {
              asOptions: Ui,
              asOption: Hi,
              data: Y,
              ...Q
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ v(Sa, { error: u, description: c })
  ] });
}
function yg({
  data: a,
  staticData: r,
  onChange: n,
  value: t,
  isPreFetching: e,
  placeholder: i,
  required: o,
  description: s,
  className: u,
  closeButtonClassName: l,
  arrowButtonClassName: c,
  fieldClassName: d,
  disabled: h,
  withoutCloseIcon: p,
  onOpen: g,
  onClose: S,
  dataTest: b,
  wrapperProps: w,
  loaderClassName: T,
  loaderWrapperClassName: k,
  captionClassName: N,
  inputRef: M,
  optionsClassName: y,
  ...D
}) {
  const [I, P] = de(!1);
  Ne(() => {
    I && g && (g(), P(!1));
  }, [I]);
  const B = cs(t, a ?? r) ?? null, K = t !== void 0, z = h || e || K && (!a && !r), x = K && !p && !z, Y = qa(() => {
    if (a)
      return a.length > 0 ? a : [us()];
  }, [a]), [L, H] = de(null), X = en(L, a);
  return /* @__PURE__ */ v(
    Vr,
    {
      value: B,
      onChange: (J) => {
        J !== null && n(J == null ? void 0 : J.id);
      },
      disabled: z,
      children: ({ open: J }) => /* @__PURE__ */ _(Ue, { children: [
        /* @__PURE__ */ _(Wr, { className: A("relative flex w-fit flex-col gap-1", d), children: [
          /* @__PURE__ */ _(
            Ot,
            {
              className: A(
                "inline-grid w-fit",
                "pr-6",
                x && "pr-10",
                "focus-ring rounded-md outline-hidden",
                u
              ),
              children: [
                /* @__PURE__ */ v(
                  "span",
                  {
                    className: A(
                      "text-start truncate underline decoration-dashed",
                      N
                    ),
                    children: (B == null ? void 0 : B.caption) ?? i ?? W.t("public_pages_purchase.form_select.select")
                  }
                ),
                /* @__PURE__ */ v(
                  Jr,
                  {
                    As: Ot,
                    isDisabled: z,
                    arrowButtonClassName: A(
                      "absolute bottom-0 right-0",
                      "h-6 w-4",
                      c
                    ),
                    open: J
                  }
                )
              ]
            }
          ),
          x && /* @__PURE__ */ v(
            Qr,
            {
              isDisabled: z,
              closeButtonClassName: A(
                "absolute bottom-0 right-5 ",
                "h-6 w-4",
                l
              ),
              onClick: () => n(void 0)
            }
          )
        ] }),
        /* @__PURE__ */ v(
          Jt,
          {
            ref: H,
            style: { height: X },
            as: jr,
            optionsClassName: A("h-fit w-fit outline-hidden", y),
            children: Y ? Y.map(
              (E) => $r({
                item: E,
                as: Yi,
                optionClassName: D == null ? void 0 : D.optionClassName,
                optionIconWrapperClassName: D == null ? void 0 : D.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ v(
              Xr,
              {
                loaderWrapperClassName: A("p-2", k),
                loaderClassName: T
              }
            )
          }
        )
      ] })
    }
  );
}
function Cg({
  label: a,
  data: r,
  staticData: n,
  onChange: t,
  labelClassName: e,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: u,
  required: l,
  description: c,
  className: d,
  containerClassName: h,
  closeButtonClassName: p,
  arrowButtonClassName: g,
  fieldClassName: S,
  disabled: b,
  withoutCloseIcon: w,
  onOpen: T,
  onClose: k,
  dataTest: N,
  wrapperProps: M,
  loaderClassName: y,
  loaderWrapperClassName: D,
  hideSelectedValues: I,
  inputWrapperClassName: P,
  inputRef: B,
  ...K
}) {
  const [Q, Z] = de(!1);
  Ne(() => {
    Q && T && (T(), Z(!1));
  }, [Q]);
  const z = qa(
    () => {
      var U;
      return ((U = r ?? n) == null ? void 0 : U.filter((j) => i == null ? void 0 : i.includes(j.id))) ?? [];
    },
    [r, n, i]
  ), { filteredData: x, setQuery: Y } = ds(r), L = i.length > 0, J = b || o || L && (!r && !n), E = L && !w && !J;
  return /* @__PURE__ */ _("div", { className: A("relative flex flex-col gap-1", h), children: [
    /* @__PURE__ */ v(
      bc,
      {
        selectedData: z,
        virtual: ps(x),
        onChange: t,
        disabled: J,
        onClose: () => {
          Y(""), k == null || k();
        },
        children: (U) => /* @__PURE__ */ _(Ue, { children: [
          /* @__PURE__ */ _(Wr, { className: A("flex flex-col gap-1", S), children: [
            /* @__PURE__ */ v(
              Pa,
              {
                wrapperAs: "label",
                wrapperProps: M,
                label: a,
                required: l,
                labelClassName: A("text-sm font-medium", e)
              }
            ),
            /* @__PURE__ */ _(Yr, { as: "div", className: A("relative", P), children: [
              /* @__PURE__ */ v(
                ss,
                {
                  dataTest: N,
                  inputRef: B,
                  isDisabled: J,
                  hasError: !!u,
                  open: U,
                  className: d,
                  placeholder: s,
                  isPreFetching: o,
                  selectedCaption: I ? "" : z.map((j) => j.caption).join(", "),
                  onFocus: () => Z(!0),
                  onChange: (j) => {
                    Z(!0), Y(j);
                  }
                }
              ),
              /* @__PURE__ */ v(
                Jr,
                {
                  isDisabled: J,
                  arrowButtonClassName: A(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    g
                  ),
                  open: U
                }
              )
            ] }),
            E && /* @__PURE__ */ v(
              Qr,
              {
                isDisabled: J,
                closeButtonClassName: A(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  p
                ),
                onClick: () => t([])
              }
            )
          ] }),
          /* @__PURE__ */ v(
            ls,
            {
              asOptions: Ui,
              asOption: Hi,
              data: x,
              ...K
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ v(Sa, { error: u, description: c })
  ] });
}
function kg({
  value: a,
  onChange: r,
  children: n,
  optionsClassName: t,
  data: e,
  loaderClassName: i,
  loaderWrapperClassName: o,
  optionClassName: s,
  optionIconWrapperClassName: u,
  disabled: l,
  buttonClassName: c,
  optionsProps: d
}) {
  const h = e == null ? void 0 : e.find((b) => b.id === a), [p, g] = de(null), S = en(p, e);
  return /* @__PURE__ */ v(Vr, { disabled: l, value: h, onChange: (b) => r(b == null ? void 0 : b.id), children: ({ open: b }) => /* @__PURE__ */ _(Ue, { children: [
    /* @__PURE__ */ v(
      Ot,
      {
        className: A(
          "ring-brand-primary outline-hidden focus-visible:ring-2",
          c
        ),
        children: n(b)
      }
    ),
    /* @__PURE__ */ v(
      Jt,
      {
        ref: g,
        style: { height: S },
        as: jr,
        optionsClassName: A("h-fit outline-hidden", t),
        optionsProps: d,
        children: e ? e.map(
          (w) => $r({
            item: w,
            as: Yi,
            optionClassName: s,
            optionIconWrapperClassName: u
          })
        ) : /* @__PURE__ */ v(
          Xr,
          {
            loaderWrapperClassName: o,
            loaderClassName: i
          }
        )
      }
    )
  ] }) });
}
function Tg({ amount: a, className: r }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: A(
        "text-background-secondary bg-green flex min-h-6 min-w-6 items-center justify-center rounded-full p-1 text-xs",
        r
      ),
      children: a
    }
  );
}
const wg = ({
  children: a,
  className: r,
  color: n = "blue",
  showHint: t = !0,
  ...e
}) => /* @__PURE__ */ _("div", { className: A("flex items-center gap-0.5", r), children: [
  a,
  t && /* @__PURE__ */ v(
    Zr,
    {
      mode: "click",
      ...e,
      className: A("focus-ring rounded-full"),
      popoverClassName: A("!max-w-[200px] sm:!max-w-[350px]", e.popoverClassName),
      wrapperClassName: "m-1",
      children: (i) => /* @__PURE__ */ v(
        Wi,
        {
          className: A(
            `group-focus-visible:fill-${n} h-[16px] w-[16px]`,
            i ? `fill-${n}` : "fill-fill-primary"
          )
        }
      )
    }
  )
] });
var lr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Fn;
function yc() {
  return Fn || (Fn = 1, (function(a) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (i = e(i, t(s)));
        }
        return i;
      }
      function t(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var s in i)
          r.call(i, s) && i[s] && (o = e(o, s));
        return o;
      }
      function e(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      a.exports ? (n.default = n, a.exports = n) : window.classNames = n;
    })();
  })(lr)), lr.exports;
}
var Cc = yc();
const Pe = /* @__PURE__ */ Zt(Cc);
function O(a, r) {
  if (r.length < a)
    throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + r.length + " present");
}
function Qt(a) {
  return O(1, arguments), a instanceof Date || Ba(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
}
function R(a) {
  O(1, arguments);
  var r = Object.prototype.toString.call(a);
  return a instanceof Date || Ba(a) === "object" && r === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || r === "[object Number]" ? new Date(a) : ((typeof a == "string" || r === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function ft(a) {
  if (O(1, arguments), !Qt(a) && typeof a != "number")
    return !1;
  var r = R(a);
  return !isNaN(Number(r));
}
function q(a) {
  if (a === null || a === !0 || a === !1)
    return NaN;
  var r = Number(a);
  return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
}
function an(a, r) {
  O(2, arguments);
  var n = R(a).getTime(), t = q(r);
  return new Date(n + t);
}
function fs(a, r) {
  O(2, arguments);
  var n = q(r);
  return an(a, -n);
}
var kc = 864e5;
function Tc(a) {
  O(1, arguments);
  var r = R(a), n = r.getTime();
  r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
  var t = r.getTime(), e = n - t;
  return Math.floor(e / kc) + 1;
}
function Ya(a) {
  O(1, arguments);
  var r = 1, n = R(a), t = n.getUTCDay(), e = (t < r ? 7 : 0) + t - r;
  return n.setUTCDate(n.getUTCDate() - e), n.setUTCHours(0, 0, 0, 0), n;
}
function hs(a) {
  O(1, arguments);
  var r = R(a), n = r.getUTCFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(n + 1, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var e = Ya(t), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Ya(i);
  return r.getTime() >= e.getTime() ? n + 1 : r.getTime() >= o.getTime() ? n : n - 1;
}
function wc(a) {
  O(1, arguments);
  var r = hs(a), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var t = Ya(n);
  return t;
}
var Ac = 6048e5;
function ms(a) {
  O(1, arguments);
  var r = R(a), n = Ya(r).getTime() - wc(r).getTime();
  return Math.round(n / Ac) + 1;
}
var Nc = {};
function Ga() {
  return Nc;
}
function Ia(a, r) {
  var n, t, e, i, o, s, u, l;
  O(1, arguments);
  var c = Ga(), d = q((n = (t = (e = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : c.weekStartsOn) !== null && t !== void 0 ? t : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = R(a), p = h.getUTCDay(), g = (p < d ? 7 : 0) + p - d;
  return h.setUTCDate(h.getUTCDate() - g), h.setUTCHours(0, 0, 0, 0), h;
}
function tn(a, r) {
  var n, t, e, i, o, s, u, l;
  O(1, arguments);
  var c = R(a), d = c.getUTCFullYear(), h = Ga(), p = q((n = (t = (e = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : h.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d + 1, 0, p), g.setUTCHours(0, 0, 0, 0);
  var S = Ia(g, r), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(d, 0, p), b.setUTCHours(0, 0, 0, 0);
  var w = Ia(b, r);
  return c.getTime() >= S.getTime() ? d + 1 : c.getTime() >= w.getTime() ? d : d - 1;
}
function Dc(a, r) {
  var n, t, e, i, o, s, u, l;
  O(1, arguments);
  var c = Ga(), d = q((n = (t = (e = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : c.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = tn(a, r), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(h, 0, d), p.setUTCHours(0, 0, 0, 0);
  var g = Ia(p, r);
  return g;
}
var Ic = 6048e5;
function gs(a, r) {
  O(1, arguments);
  var n = R(a), t = Ia(n, r).getTime() - Dc(n, r).getTime();
  return Math.round(t / Ic) + 1;
}
function fe(a, r) {
  for (var n = a < 0 ? "-" : "", t = Math.abs(a).toString(); t.length < r; )
    t = "0" + t;
  return n + t;
}
var pa = {
  // Year
  y: function(r, n) {
    var t = r.getUTCFullYear(), e = t > 0 ? t : 1 - t;
    return fe(n === "yy" ? e % 100 : e, n.length);
  },
  // Month
  M: function(r, n) {
    var t = r.getUTCMonth();
    return n === "M" ? String(t + 1) : fe(t + 1, 2);
  },
  // Day of the month
  d: function(r, n) {
    return fe(r.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(r, n) {
    var t = r.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(r, n) {
    return fe(r.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(r, n) {
    return fe(r.getUTCHours(), n.length);
  },
  // Minute
  m: function(r, n) {
    return fe(r.getUTCMinutes(), n.length);
  },
  // Second
  s: function(r, n) {
    return fe(r.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(r, n) {
    var t = n.length, e = r.getUTCMilliseconds(), i = Math.floor(e * Math.pow(10, t - 3));
    return fe(i, n.length);
  }
}, La = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ec = {
  // Era
  G: function(r, n, t) {
    var e = r.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(e, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return t.era(e, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(e, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(r, n, t) {
    if (n === "yo") {
      var e = r.getUTCFullYear(), i = e > 0 ? e : 1 - e;
      return t.ordinalNumber(i, {
        unit: "year"
      });
    }
    return pa.y(r, n);
  },
  // Local week-numbering year
  Y: function(r, n, t, e) {
    var i = tn(r, e), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = o % 100;
      return fe(s, 2);
    }
    return n === "Yo" ? t.ordinalNumber(o, {
      unit: "year"
    }) : fe(o, n.length);
  },
  // ISO week-numbering year
  R: function(r, n) {
    var t = hs(r);
    return fe(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, n) {
    var t = r.getUTCFullYear();
    return fe(t, n.length);
  },
  // Quarter
  Q: function(r, n, t) {
    var e = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(e);
      // 01, 02, 03, 04
      case "QQ":
        return fe(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, n, t) {
    var e = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(e);
      // 01, 02, 03, 04
      case "qq":
        return fe(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, n, t) {
    var e = r.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return pa.M(r, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(r, n, t) {
    var e = r.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(e + 1);
      // 01, 02, ..., 12
      case "LL":
        return fe(e + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(r, n, t, e) {
    var i = gs(r, e);
    return n === "wo" ? t.ordinalNumber(i, {
      unit: "week"
    }) : fe(i, n.length);
  },
  // ISO week of year
  I: function(r, n, t) {
    var e = ms(r);
    return n === "Io" ? t.ordinalNumber(e, {
      unit: "week"
    }) : fe(e, n.length);
  },
  // Day of the month
  d: function(r, n, t) {
    return n === "do" ? t.ordinalNumber(r.getUTCDate(), {
      unit: "date"
    }) : pa.d(r, n);
  },
  // Day of year
  D: function(r, n, t) {
    var e = Tc(r);
    return n === "Do" ? t.ordinalNumber(e, {
      unit: "dayOfYear"
    }) : fe(e, n.length);
  },
  // Day of week
  E: function(r, n, t) {
    var e = r.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, n, t, e) {
    var i = r.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return fe(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, n, t, e) {
    var i = r.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return fe(o, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, n, t) {
    var e = r.getUTCDay(), i = e === 0 ? 7 : e;
    switch (n) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return fe(i, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, n, t) {
    var e = r.getUTCHours(), i = e / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, n, t) {
    var e = r.getUTCHours(), i;
    switch (e === 12 ? i = La.noon : e === 0 ? i = La.midnight : i = e / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, n, t) {
    var e = r.getUTCHours(), i;
    switch (e >= 17 ? i = La.evening : e >= 12 ? i = La.afternoon : e >= 4 ? i = La.morning : i = La.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, n, t) {
    if (n === "ho") {
      var e = r.getUTCHours() % 12;
      return e === 0 && (e = 12), t.ordinalNumber(e, {
        unit: "hour"
      });
    }
    return pa.h(r, n);
  },
  // Hour [0-23]
  H: function(r, n, t) {
    return n === "Ho" ? t.ordinalNumber(r.getUTCHours(), {
      unit: "hour"
    }) : pa.H(r, n);
  },
  // Hour [0-11]
  K: function(r, n, t) {
    var e = r.getUTCHours() % 12;
    return n === "Ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : fe(e, n.length);
  },
  // Hour [1-24]
  k: function(r, n, t) {
    var e = r.getUTCHours();
    return e === 0 && (e = 24), n === "ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : fe(e, n.length);
  },
  // Minute
  m: function(r, n, t) {
    return n === "mo" ? t.ordinalNumber(r.getUTCMinutes(), {
      unit: "minute"
    }) : pa.m(r, n);
  },
  // Second
  s: function(r, n, t) {
    return n === "so" ? t.ordinalNumber(r.getUTCSeconds(), {
      unit: "second"
    }) : pa.s(r, n);
  },
  // Fraction of second
  S: function(r, n) {
    return pa.S(r, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return xn(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ya(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ya(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return xn(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ya(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ya(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Kn(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ya(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Kn(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ya(o, ":");
    }
  },
  // Seconds timestamp
  t: function(r, n, t, e) {
    var i = e._originalDate || r, o = Math.floor(i.getTime() / 1e3);
    return fe(o, n.length);
  },
  // Milliseconds timestamp
  T: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTime();
    return fe(o, n.length);
  }
};
function Kn(a, r) {
  var n = a > 0 ? "-" : "+", t = Math.abs(a), e = Math.floor(t / 60), i = t % 60;
  if (i === 0)
    return n + String(e);
  var o = r;
  return n + String(e) + o + fe(i, 2);
}
function xn(a, r) {
  if (a % 60 === 0) {
    var n = a > 0 ? "-" : "+";
    return n + fe(Math.abs(a) / 60, 2);
  }
  return ya(a, r);
}
function ya(a, r) {
  var n = r || "", t = a > 0 ? "-" : "+", e = Math.abs(a), i = fe(Math.floor(e / 60), 2), o = fe(e % 60, 2);
  return t + i + n + o;
}
var Hn = function(r, n) {
  switch (r) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, vs = function(r, n) {
  switch (r) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Bc = function(r, n) {
  var t = r.match(/(P+)(p+)?/) || [], e = t[1], i = t[2];
  if (!i)
    return Hn(r, n);
  var o;
  switch (e) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Hn(e, n)).replace("{{time}}", vs(i, n));
}, Dr = {
  p: vs,
  P: Bc
};
function Lt(a) {
  var r = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
  return r.setUTCFullYear(a.getFullYear()), a.getTime() - r.getTime();
}
var Pc = ["D", "DD"], Oc = ["YY", "YYYY"];
function Ss(a) {
  return Pc.indexOf(a) !== -1;
}
function bs(a) {
  return Oc.indexOf(a) !== -1;
}
function Rt(a, r, n) {
  if (a === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Gc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Lc = function(r, n, t) {
  var e, i = Gc[r];
  return typeof i == "string" ? e = i : n === 1 ? e = i.one : e = i.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + e : e + " ago" : e;
};
function cr(a) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.width ? String(r.width) : a.defaultWidth, t = a.formats[n] || a.formats[a.defaultWidth];
    return t;
  };
}
var Rc = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, _c = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Fc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kc = {
  date: cr({
    formats: Rc,
    defaultWidth: "full"
  }),
  time: cr({
    formats: _c,
    defaultWidth: "full"
  }),
  dateTime: cr({
    formats: Fc,
    defaultWidth: "full"
  })
}, xc = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Hc = function(r, n, t, e) {
  return xc[r];
};
function tt(a) {
  return function(r, n) {
    var t = n != null && n.context ? String(n.context) : "standalone", e;
    if (t === "formatting" && a.formattingValues) {
      var i = a.defaultFormattingWidth || a.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      e = a.formattingValues[o] || a.formattingValues[i];
    } else {
      var s = a.defaultWidth, u = n != null && n.width ? String(n.width) : a.defaultWidth;
      e = a.values[u] || a.values[s];
    }
    var l = a.argumentCallback ? a.argumentCallback(r) : r;
    return e[l];
  };
}
var Uc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Wc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Vc = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, jc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Zc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, zc = function(r, n) {
  var t = Number(r), e = t % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Jc = {
  ordinalNumber: zc,
  era: tt({
    values: Uc,
    defaultWidth: "wide"
  }),
  quarter: tt({
    values: Yc,
    defaultWidth: "wide",
    argumentCallback: function(r) {
      return r - 1;
    }
  }),
  month: tt({
    values: Wc,
    defaultWidth: "wide"
  }),
  day: tt({
    values: Vc,
    defaultWidth: "wide"
  }),
  dayPeriod: tt({
    values: jc,
    defaultWidth: "wide",
    formattingValues: Zc,
    defaultFormattingWidth: "wide"
  })
};
function rt(a) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.width, e = t && a.matchPatterns[t] || a.matchPatterns[a.defaultMatchWidth], i = r.match(e);
    if (!i)
      return null;
    var o = i[0], s = t && a.parsePatterns[t] || a.parsePatterns[a.defaultParseWidth], u = Array.isArray(s) ? qc(s, function(d) {
      return d.test(o);
    }) : Qc(s, function(d) {
      return d.test(o);
    }), l;
    l = a.valueCallback ? a.valueCallback(u) : u, l = n.valueCallback ? n.valueCallback(l) : l;
    var c = r.slice(o.length);
    return {
      value: l,
      rest: c
    };
  };
}
function Qc(a, r) {
  for (var n in a)
    if (a.hasOwnProperty(n) && r(a[n]))
      return n;
}
function qc(a, r) {
  for (var n = 0; n < a.length; n++)
    if (r(a[n]))
      return n;
}
function Xc(a) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.match(a.matchPattern);
    if (!t) return null;
    var e = t[0], i = r.match(a.parsePattern);
    if (!i) return null;
    var o = a.valueCallback ? a.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = r.slice(e.length);
    return {
      value: o,
      rest: s
    };
  };
}
var $c = /^(\d+)(th|st|nd|rd)?/i, ed = /\d+/i, ad = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, td = {
  any: [/^b/i, /^(a|c)/i]
}, rd = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, nd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, id = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, od = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, sd = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ud = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ld = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, cd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dd = {
  ordinalNumber: Xc({
    matchPattern: $c,
    parsePattern: ed,
    valueCallback: function(r) {
      return parseInt(r, 10);
    }
  }),
  era: rt({
    matchPatterns: ad,
    defaultMatchWidth: "wide",
    parsePatterns: td,
    defaultParseWidth: "any"
  }),
  quarter: rt({
    matchPatterns: rd,
    defaultMatchWidth: "wide",
    parsePatterns: nd,
    defaultParseWidth: "any",
    valueCallback: function(r) {
      return r + 1;
    }
  }),
  month: rt({
    matchPatterns: id,
    defaultMatchWidth: "wide",
    parsePatterns: od,
    defaultParseWidth: "any"
  }),
  day: rt({
    matchPatterns: sd,
    defaultMatchWidth: "wide",
    parsePatterns: ud,
    defaultParseWidth: "any"
  }),
  dayPeriod: rt({
    matchPatterns: ld,
    defaultMatchWidth: "any",
    parsePatterns: cd,
    defaultParseWidth: "any"
  })
}, Xa = {
  code: "en-US",
  formatDistance: Lc,
  formatLong: Kc,
  formatRelative: Hc,
  localize: Jc,
  match: dd,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, pd = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fd = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hd = /^'([^]*?)'?$/, md = /''/g, gd = /[a-zA-Z]/;
function Un(a, r, n) {
  var t, e, i, o, s, u, l, c, d, h, p, g, S, b, w, T, k, N;
  O(2, arguments);
  var M = String(r), y = Ga(), D = (t = (e = n == null ? void 0 : n.locale) !== null && e !== void 0 ? e : y.locale) !== null && t !== void 0 ? t : Xa, I = q((i = (o = (s = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (l = n.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : y.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = y.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var P = q((p = (g = (S = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (w = n.locale) === null || w === void 0 || (T = w.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && S !== void 0 ? S : y.weekStartsOn) !== null && g !== void 0 ? g : (k = y.locale) === null || k === void 0 || (N = k.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(P >= 0 && P <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!D.localize)
    throw new RangeError("locale must contain localize property");
  if (!D.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var B = R(a);
  if (!ft(B))
    throw new RangeError("Invalid time value");
  var K = Lt(B), Q = fs(B, K), Z = {
    firstWeekContainsDate: I,
    weekStartsOn: P,
    locale: D,
    _originalDate: B
  }, z = M.match(fd).map(function(x) {
    var Y = x[0];
    if (Y === "p" || Y === "P") {
      var L = Dr[Y];
      return L(x, D.formatLong);
    }
    return x;
  }).join("").match(pd).map(function(x) {
    if (x === "''")
      return "'";
    var Y = x[0];
    if (Y === "'")
      return vd(x);
    var L = Ec[Y];
    if (L)
      return !(n != null && n.useAdditionalWeekYearTokens) && bs(x) && Rt(x, r, String(a)), !(n != null && n.useAdditionalDayOfYearTokens) && Ss(x) && Rt(x, r, String(a)), L(Q, x, D.localize, Z);
    if (Y.match(gd))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
    return x;
  }).join("");
  return z;
}
function vd(a) {
  var r = a.match(hd);
  return r ? r[1].replace(md, "'") : a;
}
var Sd = 6e4;
function Ir(a, r) {
  O(2, arguments);
  var n = q(r);
  return an(a, n * Sd);
}
var bd = 36e5;
function Md(a, r) {
  O(2, arguments);
  var n = q(r);
  return an(a, n * bd);
}
function $a(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  return isNaN(t) ? /* @__PURE__ */ new Date(NaN) : (t && n.setDate(n.getDate() + t), n);
}
function _t(a, r) {
  O(2, arguments);
  var n = q(r), t = n * 7;
  return $a(a, t);
}
function qe(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  if (isNaN(t))
    return /* @__PURE__ */ new Date(NaN);
  if (!t)
    return n;
  var e = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  var o = i.getDate();
  return e >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), e), n);
}
function Ms(a, r) {
  O(2, arguments);
  var n = q(r), t = n * 3;
  return qe(a, t);
}
function Wa(a, r) {
  O(2, arguments);
  var n = q(r);
  return qe(a, n * 12);
}
function yd(a, r) {
  O(2, arguments);
  var n = q(r);
  return $a(a, -n);
}
function Yn(a, r) {
  O(2, arguments);
  var n = q(r);
  return _t(a, -n);
}
function Va(a, r) {
  O(2, arguments);
  var n = q(r);
  return qe(a, -n);
}
function Cd(a, r) {
  O(2, arguments);
  var n = q(r);
  return Ms(a, -n);
}
function ht(a, r) {
  O(2, arguments);
  var n = q(r);
  return Wa(a, -n);
}
function Wn(a) {
  O(1, arguments);
  var r = R(a), n = r.getSeconds();
  return n;
}
function ta(a) {
  O(1, arguments);
  var r = R(a), n = r.getMinutes();
  return n;
}
function ra(a) {
  O(1, arguments);
  var r = R(a), n = r.getHours();
  return n;
}
function kd(a) {
  O(1, arguments);
  var r = R(a), n = r.getDay();
  return n;
}
function Vn(a) {
  O(1, arguments);
  var r = R(a), n = r.getDate();
  return n;
}
function ys(a, r) {
  var n, t, e, i, o, s, u, l;
  O(1, arguments);
  var c = Ga(), d = q((n = (t = (e = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : c.weekStartsOn) !== null && t !== void 0 ? t : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = R(a), p = h.getDay(), g = (p < d ? 7 : 0) + p - d;
  return h.setDate(h.getDate() - g), h.setHours(0, 0, 0, 0), h;
}
function Ft(a) {
  return O(1, arguments), ys(a, {
    weekStartsOn: 1
  });
}
function Td(a) {
  O(1, arguments);
  var r = R(a), n = r.getFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setFullYear(n + 1, 0, 4), t.setHours(0, 0, 0, 0);
  var e = Ft(t), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var o = Ft(i);
  return r.getTime() >= e.getTime() ? n + 1 : r.getTime() >= o.getTime() ? n : n - 1;
}
function wd(a) {
  O(1, arguments);
  var r = Td(a), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0);
  var t = Ft(n);
  return t;
}
var Ad = 6048e5;
function Nd(a) {
  O(1, arguments);
  var r = R(a), n = Ft(r).getTime() - wd(r).getTime();
  return Math.round(n / Ad) + 1;
}
function Oe(a) {
  O(1, arguments);
  var r = R(a), n = r.getMonth();
  return n;
}
function _a(a) {
  O(1, arguments);
  var r = R(a), n = Math.floor(r.getMonth() / 3) + 1;
  return n;
}
function $(a) {
  return O(1, arguments), R(a).getFullYear();
}
function Er(a) {
  O(1, arguments);
  var r = R(a), n = r.getTime();
  return n;
}
function Dd(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  return n.setSeconds(t), n;
}
function It(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  return n.setMinutes(t), n;
}
function Et(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  return n.setHours(t), n;
}
function Id(a) {
  O(1, arguments);
  var r = R(a), n = r.getFullYear(), t = r.getMonth(), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(n, t + 1, 0), e.setHours(0, 0, 0, 0), e.getDate();
}
function _e(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r), e = n.getFullYear(), i = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(e, t, 15), o.setHours(0, 0, 0, 0);
  var s = Id(o);
  return n.setMonth(t, Math.min(i, s)), n;
}
function Ra(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r), e = Math.floor(n.getMonth() / 3) + 1, i = t - e;
  return _e(n, n.getMonth() + i * 3);
}
function ca(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(t), n);
}
function jn(a) {
  O(1, arguments);
  var r;
  if (a && typeof a.forEach == "function")
    r = a;
  else if (Ba(a) === "object" && a !== null)
    r = Array.prototype.slice.call(a);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(t) {
    var e = R(t);
    (n === void 0 || n > e || isNaN(e.getDate())) && (n = e);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Zn(a) {
  O(1, arguments);
  var r;
  if (a && typeof a.forEach == "function")
    r = a;
  else if (Ba(a) === "object" && a !== null)
    r = Array.prototype.slice.call(a);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(t) {
    var e = R(t);
    (n === void 0 || n < e || isNaN(Number(e))) && (n = e);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function na(a) {
  O(1, arguments);
  var r = R(a);
  return r.setHours(0, 0, 0, 0), r;
}
var Ed = 864e5;
function mt(a, r) {
  O(2, arguments);
  var n = na(a), t = na(r), e = n.getTime() - Lt(n), i = t.getTime() - Lt(t);
  return Math.round((e - i) / Ed);
}
function Kt(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r), e = n.getFullYear() - t.getFullYear(), i = n.getMonth() - t.getMonth();
  return e * 12 + i;
}
function xt(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getFullYear() - t.getFullYear();
}
function Cs(a) {
  O(1, arguments);
  var r = R(a);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Br(a) {
  O(1, arguments);
  var r = R(a), n = r.getMonth(), t = n - n % 3;
  return r.setMonth(t, 1), r.setHours(0, 0, 0, 0), r;
}
function ks(a) {
  O(1, arguments);
  var r = R(a), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(r.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Pr(a) {
  O(1, arguments);
  var r = R(a);
  return r.setHours(23, 59, 59, 999), r;
}
function Bd(a) {
  O(1, arguments);
  var r = R(a), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function Pd(a) {
  O(1, arguments);
  var r = R(a), n = r.getFullYear();
  return r.setFullYear(n + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function Od(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getTime() === t.getTime();
}
function Gd(a, r) {
  O(2, arguments);
  var n = na(a), t = na(r);
  return n.getTime() === t.getTime();
}
function Ld(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getFullYear() === t.getFullYear() && n.getMonth() === t.getMonth();
}
function Rd(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getFullYear() === t.getFullYear();
}
function _d(a, r) {
  O(2, arguments);
  var n = Br(a), t = Br(r);
  return n.getTime() === t.getTime();
}
function va(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getTime() > t.getTime();
}
function ha(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r);
  return n.getTime() < t.getTime();
}
function gt(a, r) {
  O(2, arguments);
  var n = R(a).getTime(), t = R(r.start).getTime(), e = R(r.end).getTime();
  if (!(t <= e))
    throw new RangeError("Invalid interval");
  return n >= t && n <= e;
}
function zn(a, r) {
  var n = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (!n) {
    if (Array.isArray(a) || (n = Fu(a)) || r) {
      n && (a = n);
      var t = 0, e = function() {
      };
      return {
        s: e,
        n: function() {
          return t >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[t++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: e
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(a);
    },
    n: function() {
      var l = n.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Fd(a, r) {
  if (a == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && (a[n] = r[n]);
  return a;
}
function F(a) {
  if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function Or(a, r) {
  return Or = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, t) {
    return n.__proto__ = t, n;
  }, Or(a, r);
}
function oe(a, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(a, "prototype", {
    writable: !1
  }), r && Or(a, r);
}
function Ht(a) {
  return Ht = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ht(a);
}
function Ts() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ts = function() {
    return !!a;
  })();
}
function Kd(a, r) {
  if (r && (Ba(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return F(a);
}
function se(a) {
  var r = Ts();
  return function() {
    var n, t = Ht(a);
    if (r) {
      var e = Ht(this).constructor;
      n = Reflect.construct(t, arguments, e);
    } else n = t.apply(this, arguments);
    return Kd(this, n);
  };
}
var xd = 10, ws = /* @__PURE__ */ (function() {
  function a() {
    te(this, a), G(this, "priority", void 0), G(this, "subPriority", 0);
  }
  return ae(a, [{
    key: "validate",
    value: function(n, t) {
      return !0;
    }
  }]), a;
})(), Hd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n(t, e, i, o, s) {
    var u;
    return te(this, n), u = r.call(this), u.value = t, u.validateValue = e, u.setValue = i, u.priority = o, s && (u.subPriority = s), u;
  }
  return ae(n, [{
    key: "validate",
    value: function(e, i) {
      return this.validateValue(e, this.value, i);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return this.setValue(e, i, this.value, o);
    }
  }]), n;
})(ws), Ud = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", xd), G(F(t), "subPriority", -1), t;
  }
  return ae(n, [{
    key: "set",
    value: function(e, i) {
      if (i.timestampIsSet)
        return e;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), o.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), o;
    }
  }]), n;
})(ws), le = /* @__PURE__ */ (function() {
  function a() {
    te(this, a), G(this, "incompatibleTokens", void 0), G(this, "priority", void 0), G(this, "subPriority", void 0);
  }
  return ae(a, [{
    key: "run",
    value: function(n, t, e, i) {
      var o = this.parse(n, t, e, i);
      return o ? {
        setter: new Hd(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, t, e) {
      return !0;
    }
  }]), a;
})(), Yd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 140), G(F(t), "incompatibleTokens", ["R", "u", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(e, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return o.era(e, {
            width: "wide"
          }) || o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.era = o, e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), rn = 6e4, nn = 36e5, Wd = 1e3, Te = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ea = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function we(a, r) {
  return a && {
    value: r(a.value),
    rest: a.rest
  };
}
function ye(a, r) {
  var n = r.match(a);
  return n ? {
    value: parseInt(n[0], 10),
    rest: r.slice(n[0].length)
  } : null;
}
function aa(a, r) {
  var n = r.match(a);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  var t = n[1] === "+" ? 1 : -1, e = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: t * (e * nn + i * rn + o * Wd),
    rest: r.slice(n[0].length)
  };
}
function As(a) {
  return ye(Te.anyDigitsSigned, a);
}
function ke(a, r) {
  switch (a) {
    case 1:
      return ye(Te.singleDigit, r);
    case 2:
      return ye(Te.twoDigits, r);
    case 3:
      return ye(Te.threeDigits, r);
    case 4:
      return ye(Te.fourDigits, r);
    default:
      return ye(new RegExp("^\\d{1," + a + "}"), r);
  }
}
function Ut(a, r) {
  switch (a) {
    case 1:
      return ye(Te.singleDigitSigned, r);
    case 2:
      return ye(Te.twoDigitsSigned, r);
    case 3:
      return ye(Te.threeDigitsSigned, r);
    case 4:
      return ye(Te.fourDigitsSigned, r);
    default:
      return ye(new RegExp("^-?\\d{1," + a + "}"), r);
  }
}
function on(a) {
  switch (a) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Ns(a, r) {
  var n = r > 0, t = n ? r : 1 - r, e;
  if (t <= 50)
    e = a || 100;
  else {
    var i = t + 50, o = Math.floor(i / 100) * 100, s = a >= i % 100;
    e = a + o - (s ? 100 : 0);
  }
  return n ? e : 1 - e;
}
function Ds(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
var Vd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 130), G(F(t), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return we(ke(4, e), s);
        case "yo":
          return we(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return we(ke(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = Ns(o.year, s);
        return e.setUTCFullYear(u, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var l = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(l, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), jd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 130), G(F(t), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return we(ke(4, e), s);
        case "Yo":
          return we(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return we(ke(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      var u = tn(e, s);
      if (o.isTwoDigitYear) {
        var l = Ns(o.year, u);
        return e.setUTCFullYear(l, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ia(e, s);
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(c, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ia(e, s);
    }
  }]), n;
})(le), Zd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 130), G(F(t), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      return Ut(i === "R" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Ya(s);
    }
  }]), n;
})(le), zd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 130), G(F(t), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      return Ut(i === "u" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), Jd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 120), G(F(t), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return ke(i.length, e);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), Qd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 120), G(F(t), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return ke(i.length, e);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), qd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), G(F(t), "priority", 110), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "M":
          return we(ye(Te.month, e), s);
        // 01, 02, ..., 12
        case "MM":
          return we(ke(2, e), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return we(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return o.month(e, {
            width: "wide",
            context: "formatting"
          }) || o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), Xd = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 110), G(F(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "L":
          return we(ye(Te.month, e), s);
        // 01, 02, ..., 12
        case "LL":
          return we(ke(2, e), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return we(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return o.month(e, {
            width: "wide",
            context: "standalone"
          }) || o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le);
function $d(a, r, n) {
  O(2, arguments);
  var t = R(a), e = q(r), i = gs(t, n) - e;
  return t.setUTCDate(t.getUTCDate() - i * 7), t;
}
var ep = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 100), G(F(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "w":
          return ye(Te.week, e);
        case "wo":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return Ia($d(e, o, s), s);
    }
  }]), n;
})(le);
function ap(a, r) {
  O(2, arguments);
  var n = R(a), t = q(r), e = ms(n) - t;
  return n.setUTCDate(n.getUTCDate() - e * 7), n;
}
var tp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 100), G(F(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "I":
          return ye(Te.week, e);
        case "Io":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return Ya(ap(e, o));
    }
  }]), n;
})(le), rp = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], np = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ip = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "subPriority", 1), G(F(t), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "d":
          return ye(Te.date, e);
        case "do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = Ds(o), u = e.getUTCMonth();
      return s ? i >= 1 && i <= np[u] : i >= 1 && i <= rp[u];
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCDate(o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), op = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "subpriority", 1), G(F(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return ye(Te.dayOfYear, e);
        case "Do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = Ds(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(0, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le);
function sn(a, r, n) {
  var t, e, i, o, s, u, l, c;
  O(2, arguments);
  var d = Ga(), h = q((t = (e = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && e !== void 0 ? e : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = R(a), g = q(r), S = p.getUTCDay(), b = g % 7, w = (b + 7) % 7, T = (w < h ? 7 : 0) + g - S;
  return p.setUTCDate(p.getUTCDate() + T), p;
}
var sp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = sn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), up = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o, s) {
      var u = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        // 3
        case "e":
        case "ee":
          return we(ke(i.length, e), u);
        // 3rd
        case "eo":
          return we(o.ordinalNumber(e, {
            unit: "day"
          }), u);
        // Tue
        case "eee":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = sn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), lp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o, s) {
      var u = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        // 3
        case "c":
        case "cc":
          return we(ke(i.length, e), u);
        // 3rd
        case "co":
          return we(o.ordinalNumber(e, {
            unit: "day"
          }), u);
        // Tue
        case "ccc":
          return o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return o.day(e, {
            width: "wide",
            context: "standalone"
          }) || o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = sn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le);
function cp(a, r) {
  O(2, arguments);
  var n = q(r);
  n % 7 === 0 && (n = n - 7);
  var t = 1, e = R(a), i = e.getUTCDay(), o = n % 7, s = (o + 7) % 7, u = (s < t ? 7 : 0) + n - i;
  return e.setUTCDate(e.getUTCDate() + u), e;
}
var dp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 90), G(F(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l === 0 ? 7 : l;
      };
      switch (i) {
        // 2
        case "i":
        case "ii":
          return ke(i.length, e);
        // 2nd
        case "io":
          return o.ordinalNumber(e, {
            unit: "day"
          });
        // Tue
        case "iii":
          return we(o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return we(o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return we(o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tuesday
        case "iiii":
        default:
          return we(o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e = cp(e, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(le), pp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 80), G(F(t), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(on(o), 0, 0, 0), e;
    }
  }]), n;
})(le), fp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 80), G(F(t), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(on(o), 0, 0, 0), e;
    }
  }]), n;
})(le), hp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 80), G(F(t), "incompatibleTokens", ["a", "b", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(on(o), 0, 0, 0), e;
    }
  }]), n;
})(le), mp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 70), G(F(t), "incompatibleTokens", ["H", "K", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "h":
          return ye(Te.hour12h, e);
        case "ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(le), gp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 70), G(F(t), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "H":
          return ye(Te.hour23h, e);
        case "Ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(le), vp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 70), G(F(t), "incompatibleTokens", ["h", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "K":
          return ye(Te.hour11h, e);
        case "Ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(le), Sp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 70), G(F(t), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "k":
          return ye(Te.hour24h, e);
        case "ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return e.setUTCHours(s, 0, 0, 0), e;
    }
  }]), n;
})(le), bp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 60), G(F(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "m":
          return ye(Te.minute, e);
        case "mo":
          return o.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMinutes(o, 0, 0), e;
    }
  }]), n;
})(le), Mp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 50), G(F(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "s":
          return ye(Te.second, e);
        case "so":
          return o.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCSeconds(o, 0), e;
    }
  }]), n;
})(le), yp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 30), G(F(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return we(ke(i.length, e), o);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMilliseconds(o), e;
    }
  }]), n;
})(le), Cp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 10), G(F(t), "incompatibleTokens", ["t", "T", "x"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "X":
          return aa(ea.basicOptionalMinutes, e);
        case "XX":
          return aa(ea.basic, e);
        case "XXXX":
          return aa(ea.basicOptionalSeconds, e);
        case "XXXXX":
          return aa(ea.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return aa(ea.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), n;
})(le), kp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 10), G(F(t), "incompatibleTokens", ["t", "T", "X"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "x":
          return aa(ea.basicOptionalMinutes, e);
        case "xx":
          return aa(ea.basic, e);
        case "xxxx":
          return aa(ea.basicOptionalSeconds, e);
        case "xxxxx":
          return aa(ea.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return aa(ea.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), n;
})(le), Tp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 40), G(F(t), "incompatibleTokens", "*"), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e) {
      return As(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(le), wp = /* @__PURE__ */ (function(a) {
  oe(n, a);
  var r = se(n);
  function n() {
    var t;
    te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), G(F(t), "priority", 20), G(F(t), "incompatibleTokens", "*"), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e) {
      return As(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(le), Ap = {
  G: new Yd(),
  y: new Vd(),
  Y: new jd(),
  R: new Zd(),
  u: new zd(),
  Q: new Jd(),
  q: new Qd(),
  M: new qd(),
  L: new Xd(),
  w: new ep(),
  I: new tp(),
  d: new ip(),
  D: new op(),
  E: new sp(),
  e: new up(),
  c: new lp(),
  i: new dp(),
  a: new pp(),
  b: new fp(),
  B: new hp(),
  h: new mp(),
  H: new gp(),
  K: new vp(),
  k: new Sp(),
  m: new bp(),
  s: new Mp(),
  S: new yp(),
  X: new Cp(),
  x: new kp(),
  t: new Tp(),
  T: new wp()
}, Np = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Dp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ip = /^'([^]*?)'?$/, Ep = /''/g, Bp = /\S/, Pp = /[a-zA-Z]/;
function dr(a, r, n, t) {
  var e, i, o, s, u, l, c, d, h, p, g, S, b, w, T, k, N, M;
  O(3, arguments);
  var y = String(a), D = String(r), I = Ga(), P = (e = (i = t == null ? void 0 : t.locale) !== null && i !== void 0 ? i : I.locale) !== null && e !== void 0 ? e : Xa;
  if (!P.match)
    throw new RangeError("locale must contain match property");
  var B = q((o = (s = (u = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (c = t.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && u !== void 0 ? u : I.firstWeekContainsDate) !== null && s !== void 0 ? s : (h = I.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(B >= 1 && B <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var K = q((g = (S = (b = (w = t == null ? void 0 : t.weekStartsOn) !== null && w !== void 0 ? w : t == null || (T = t.locale) === null || T === void 0 || (k = T.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && b !== void 0 ? b : I.weekStartsOn) !== null && S !== void 0 ? S : (N = I.locale) === null || N === void 0 || (M = N.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(K >= 0 && K <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (D === "")
    return y === "" ? R(n) : /* @__PURE__ */ new Date(NaN);
  var Q = {
    firstWeekContainsDate: B,
    weekStartsOn: K,
    locale: P
  }, Z = [new Ud()], z = D.match(Dp).map(function(ue) {
    var ne = ue[0];
    if (ne in Dr) {
      var Ge = Dr[ne];
      return Ge(ue, P.formatLong);
    }
    return ue;
  }).join("").match(Np), x = [], Y = zn(z), L;
  try {
    var H = function() {
      var ne = L.value;
      !(t != null && t.useAdditionalWeekYearTokens) && bs(ne) && Rt(ne, D, a), !(t != null && t.useAdditionalDayOfYearTokens) && Ss(ne) && Rt(ne, D, a);
      var Ge = ne[0], ee = Ap[Ge];
      if (ee) {
        var pe = ee.incompatibleTokens;
        if (Array.isArray(pe)) {
          var Le = x.find(function(la) {
            return pe.includes(la.token) || la.token === Ge;
          });
          if (Le)
            throw new RangeError("The format string mustn't contain `".concat(Le.fullToken, "` and `").concat(ne, "` at the same time"));
        } else if (ee.incompatibleTokens === "*" && x.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ne, "` and any other token at the same time"));
        x.push({
          token: Ge,
          fullToken: ne
        });
        var ua = ee.run(y, ne, P.match, Q);
        if (!ua)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        Z.push(ua.setter), y = ua.rest;
      } else {
        if (Ge.match(Pp))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ge + "`");
        if (ne === "''" ? ne = "'" : Ge === "'" && (ne = Op(ne)), y.indexOf(ne) === 0)
          y = y.slice(ne.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Y.s(); !(L = Y.n()).done; ) {
      var X = H();
      if (Ba(X) === "object") return X.v;
    }
  } catch (ue) {
    Y.e(ue);
  } finally {
    Y.f();
  }
  if (y.length > 0 && Bp.test(y))
    return /* @__PURE__ */ new Date(NaN);
  var J = Z.map(function(ue) {
    return ue.priority;
  }).sort(function(ue, ne) {
    return ne - ue;
  }).filter(function(ue, ne, Ge) {
    return Ge.indexOf(ue) === ne;
  }).map(function(ue) {
    return Z.filter(function(ne) {
      return ne.priority === ue;
    }).sort(function(ne, Ge) {
      return Ge.subPriority - ne.subPriority;
    });
  }).map(function(ue) {
    return ue[0];
  }), E = R(n);
  if (isNaN(E.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var U = fs(E, Lt(E)), j = {}, V = zn(J), re;
  try {
    for (V.s(); !(re = V.n()).done; ) {
      var he = re.value;
      if (!he.validate(U, Q))
        return /* @__PURE__ */ new Date(NaN);
      var ve = he.set(U, j, Q);
      Array.isArray(ve) ? (U = ve[0], Fd(j, ve[1])) : U = ve;
    }
  } catch (ue) {
    V.e(ue);
  } finally {
    V.f();
  }
  return U;
}
function Op(a) {
  return a.match(Ip)[1].replace(Ep, "'");
}
function Gp(a, r) {
  var n;
  O(1, arguments);
  var t = q((n = void 0) !== null && n !== void 0 ? n : 2);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof a == "string" || Object.prototype.toString.call(a) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var e = Fp(a), i;
  if (e.date) {
    var o = Kp(e.date, t);
    i = xp(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), u = 0, l;
  if (e.time && (u = Hp(e.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (l = Up(e.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var c = new Date(s + u), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()), d.setHours(c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()), d;
  }
  return new Date(s + u + l);
}
var wt = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Lp = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Rp = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, _p = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Fp(a) {
  var r = {}, n = a.split(wt.dateTimeDelimiter), t;
  if (n.length > 2)
    return r;
  if (/:/.test(n[0]) ? t = n[0] : (r.date = n[0], t = n[1], wt.timeZoneDelimiter.test(r.date) && (r.date = a.split(wt.timeZoneDelimiter)[0], t = a.substr(r.date.length, a.length))), t) {
    var e = wt.timezone.exec(t);
    e ? (r.time = t.replace(e[1], ""), r.timezone = e[1]) : r.time = t;
  }
  return r;
}
function Kp(a, r) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"), t = a.match(n);
  if (!t) return {
    year: NaN,
    restDateString: ""
  };
  var e = t[1] ? parseInt(t[1]) : null, i = t[2] ? parseInt(t[2]) : null;
  return {
    year: i === null ? e : i * 100,
    restDateString: a.slice((t[1] || t[2]).length)
  };
}
function xp(a, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  var n = a.match(Lp);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var t = !!n[4], e = nt(n[1]), i = nt(n[2]) - 1, o = nt(n[3]), s = nt(n[4]), u = nt(n[5]) - 1;
  if (t)
    return Zp(r, s, u) ? Yp(r, s, u) : /* @__PURE__ */ new Date(NaN);
  var l = /* @__PURE__ */ new Date(0);
  return !Vp(r, i, o) || !jp(r, e) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(r, i, Math.max(e, o)), l);
}
function nt(a) {
  return a ? parseInt(a) : 1;
}
function Hp(a) {
  var r = a.match(Rp);
  if (!r) return NaN;
  var n = pr(r[1]), t = pr(r[2]), e = pr(r[3]);
  return zp(n, t, e) ? n * nn + t * rn + e * 1e3 : NaN;
}
function pr(a) {
  return a && parseFloat(a.replace(",", ".")) || 0;
}
function Up(a) {
  if (a === "Z") return 0;
  var r = a.match(_p);
  if (!r) return 0;
  var n = r[1] === "+" ? -1 : 1, t = parseInt(r[2]), e = r[3] && parseInt(r[3]) || 0;
  return Jp(t, e) ? n * (t * nn + e * rn) : NaN;
}
function Yp(a, r, n) {
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(a, 0, 4);
  var e = t.getUTCDay() || 7, i = (r - 1) * 7 + n + 1 - e;
  return t.setUTCDate(t.getUTCDate() + i), t;
}
var Wp = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Is(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
function Vp(a, r, n) {
  return r >= 0 && r <= 11 && n >= 1 && n <= (Wp[r] || (Is(a) ? 29 : 28));
}
function jp(a, r) {
  return r >= 1 && r <= (Is(a) ? 366 : 365);
}
function Zp(a, r, n) {
  return r >= 1 && r <= 53 && n >= 0 && n <= 6;
}
function zp(a, r, n) {
  return a === 24 ? r === 0 && n === 0 : n >= 0 && n < 60 && r >= 0 && r < 60 && a >= 0 && a < 25;
}
function Jp(a, r) {
  return r >= 0 && r <= 59;
}
function Qp(a, r) {
  a.prototype = Object.create(r.prototype), a.prototype.constructor = a, Gr(a, r);
}
function Gr(a, r) {
  return Gr = Object.setPrototypeOf || function(t, e) {
    return t.__proto__ = e, t;
  }, Gr(a, r);
}
function qp(a, r) {
  if (a == null) return {};
  var n = {}, t = Object.keys(a), e, i;
  for (i = 0; i < t.length; i++)
    e = t[i], !(r.indexOf(e) >= 0) && (n[e] = a[e]);
  return n;
}
function Jn(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function Xp(a, r, n) {
  return a === r ? !0 : a.correspondingElement ? a.correspondingElement.classList.contains(n) : a.classList.contains(n);
}
function $p(a, r, n) {
  if (a === r)
    return !0;
  for (; a.parentNode || a.host; ) {
    if (a.parentNode && Xp(a, r, n))
      return !0;
    a = a.parentNode || a.host;
  }
  return a;
}
function ef(a) {
  return document.documentElement.clientWidth <= a.clientX || document.documentElement.clientHeight <= a.clientY;
}
var af = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var r = !1, n = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), t = function() {
    };
    return window.addEventListener("testPassiveEventSupport", t, n), window.removeEventListener("testPassiveEventSupport", t, n), r;
  }
};
function tf(a) {
  return a === void 0 && (a = 0), function() {
    return ++a;
  };
}
var rf = tf(), Lr, At = {}, fr = {}, nf = ["touchstart", "touchmove"], of = "ignore-react-onclickoutside";
function Qn(a, r) {
  var n = {}, t = nf.indexOf(r) !== -1;
  return t && Lr && (n.passive = !a.props.preventDefault), n;
}
function qt(a, r) {
  var n, t, e = a.displayName || a.name || "Component";
  return t = n = /* @__PURE__ */ (function(i) {
    Qp(o, i);
    function o(u) {
      var l;
      return l = i.call(this, u) || this, l.__outsideClickHandler = function(c) {
        if (typeof l.__clickOutsideHandlerProp == "function") {
          l.__clickOutsideHandlerProp(c);
          return;
        }
        var d = l.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(c);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(c);
          return;
        }
        throw new Error("WrappedComponent: " + e + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, l.__getComponentNode = function() {
        var c = l.getInstance();
        return typeof c.setClickOutsideRef == "function" ? c.setClickOutsideRef() : Ru(c);
      }, l.enableOnClickOutside = function() {
        if (!(typeof document > "u" || fr[l._uid])) {
          typeof Lr > "u" && (Lr = af()), fr[l._uid] = !0;
          var c = l.props.eventTypes;
          c.forEach || (c = [c]), At[l._uid] = function(d) {
            if (l.componentNode !== null && !(l.initTimeStamp > d.timeStamp) && (l.props.preventDefault && d.preventDefault(), l.props.stopPropagation && d.stopPropagation(), !(l.props.excludeScrollbar && ef(d)))) {
              var h = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              $p(h, l.componentNode, l.props.outsideClickIgnoreClass) === document && l.__outsideClickHandler(d);
            }
          }, c.forEach(function(d) {
            document.addEventListener(d, At[l._uid], Qn(Jn(l), d));
          });
        }
      }, l.disableOnClickOutside = function() {
        delete fr[l._uid];
        var c = At[l._uid];
        if (c && typeof document < "u") {
          var d = l.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(h) {
            return document.removeEventListener(h, c, Qn(Jn(l), h));
          }), delete At[l._uid];
        }
      }, l.getRef = function(c) {
        return l.instanceRef = c;
      }, l._uid = rf(), l.initTimeStamp = performance.now(), l;
    }
    var s = o.prototype;
    return s.getInstance = function() {
      if (a.prototype && !a.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, s.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var c = qp(l, ["excludeScrollbar"]);
      return a.prototype && a.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, gu(a, c);
    }, o;
  })(vu), n.displayName = "OnClickOutside(" + e + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: of,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return a.getClass ? a.getClass() : a;
  }, t;
}
var Es = me.createContext(), Bs = me.createContext();
function sf(a) {
  var r = a.children, n = me.useState(null), t = n[0], e = n[1], i = me.useRef(!1);
  me.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = me.useCallback(function(s) {
    i.current || e(s);
  }, []);
  return /* @__PURE__ */ me.createElement(Es.Provider, {
    value: t
  }, /* @__PURE__ */ me.createElement(Bs.Provider, {
    value: o
  }, r));
}
var Ps = function(r) {
  return Array.isArray(r) ? r[0] : r;
}, Os = function(r) {
  if (typeof r == "function") {
    for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), e = 1; e < n; e++)
      t[e - 1] = arguments[e];
    return r.apply(void 0, t);
  }
}, Rr = function(r, n) {
  if (typeof r == "function")
    return Os(r, n);
  r != null && (r.current = n);
}, qn = function(r) {
  return r.reduce(function(n, t) {
    var e = t[0], i = t[1];
    return n[e] = i, n;
  }, {});
}, Xn = typeof window < "u" && window.document && window.document.createElement ? me.useLayoutEffect : me.useEffect, xe = "top", Ve = "bottom", je = "right", He = "left", un = "auto", Ct = [xe, Ve, je, He], ja = "start", vt = "end", uf = "clippingParents", Gs = "viewport", it = "popper", lf = "reference", $n = /* @__PURE__ */ Ct.reduce(function(a, r) {
  return a.concat([r + "-" + ja, r + "-" + vt]);
}, []), Ls = /* @__PURE__ */ [].concat(Ct, [un]).reduce(function(a, r) {
  return a.concat([r, r + "-" + ja, r + "-" + vt]);
}, []), cf = "beforeRead", df = "read", pf = "afterRead", ff = "beforeMain", hf = "main", mf = "afterMain", gf = "beforeWrite", vf = "write", Sf = "afterWrite", bf = [cf, df, pf, ff, hf, mf, gf, vf, Sf];
function sa(a) {
  return a ? (a.nodeName || "").toLowerCase() : null;
}
function Ye(a) {
  if (a == null)
    return window;
  if (a.toString() !== "[object Window]") {
    var r = a.ownerDocument;
    return r && r.defaultView || window;
  }
  return a;
}
function Ea(a) {
  var r = Ye(a).Element;
  return a instanceof r || a instanceof Element;
}
function We(a) {
  var r = Ye(a).HTMLElement;
  return a instanceof r || a instanceof HTMLElement;
}
function ln(a) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = Ye(a).ShadowRoot;
  return a instanceof r || a instanceof ShadowRoot;
}
function Mf(a) {
  var r = a.state;
  Object.keys(r.elements).forEach(function(n) {
    var t = r.styles[n] || {}, e = r.attributes[n] || {}, i = r.elements[n];
    !We(i) || !sa(i) || (Object.assign(i.style, t), Object.keys(e).forEach(function(o) {
      var s = e[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function yf(a) {
  var r = a.state, n = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow), function() {
    Object.keys(r.elements).forEach(function(t) {
      var e = r.elements[t], i = r.attributes[t] || {}, o = Object.keys(r.styles.hasOwnProperty(t) ? r.styles[t] : n[t]), s = o.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !We(e) || !sa(e) || (Object.assign(e.style, s), Object.keys(i).forEach(function(u) {
        e.removeAttribute(u);
      }));
    });
  };
}
const Cf = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Mf,
  effect: yf,
  requires: ["computeStyles"]
};
function ia(a) {
  return a.split("-")[0];
}
var Ta = Math.max, Yt = Math.min, Za = Math.round;
function _r() {
  var a = navigator.userAgentData;
  return a != null && a.brands && Array.isArray(a.brands) ? a.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function Rs() {
  return !/^((?!chrome|android).)*safari/i.test(_r());
}
function za(a, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  var t = a.getBoundingClientRect(), e = 1, i = 1;
  r && We(a) && (e = a.offsetWidth > 0 && Za(t.width) / a.offsetWidth || 1, i = a.offsetHeight > 0 && Za(t.height) / a.offsetHeight || 1);
  var o = Ea(a) ? Ye(a) : window, s = o.visualViewport, u = !Rs() && n, l = (t.left + (u && s ? s.offsetLeft : 0)) / e, c = (t.top + (u && s ? s.offsetTop : 0)) / i, d = t.width / e, h = t.height / i;
  return {
    width: d,
    height: h,
    top: c,
    right: l + d,
    bottom: c + h,
    left: l,
    x: l,
    y: c
  };
}
function cn(a) {
  var r = za(a), n = a.offsetWidth, t = a.offsetHeight;
  return Math.abs(r.width - n) <= 1 && (n = r.width), Math.abs(r.height - t) <= 1 && (t = r.height), {
    x: a.offsetLeft,
    y: a.offsetTop,
    width: n,
    height: t
  };
}
function _s(a, r) {
  var n = r.getRootNode && r.getRootNode();
  if (a.contains(r))
    return !0;
  if (n && ln(n)) {
    var t = r;
    do {
      if (t && a.isSameNode(t))
        return !0;
      t = t.parentNode || t.host;
    } while (t);
  }
  return !1;
}
function da(a) {
  return Ye(a).getComputedStyle(a);
}
function kf(a) {
  return ["table", "td", "th"].indexOf(sa(a)) >= 0;
}
function ba(a) {
  return ((Ea(a) ? a.ownerDocument : (
    // $FlowFixMe[prop-missing]
    a.document
  )) || window.document).documentElement;
}
function Xt(a) {
  return sa(a) === "html" ? a : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    a.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    a.parentNode || // DOM Element detected
    (ln(a) ? a.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ba(a)
  );
}
function ei(a) {
  return !We(a) || // https://github.com/popperjs/popper-core/issues/837
  da(a).position === "fixed" ? null : a.offsetParent;
}
function Tf(a) {
  var r = /firefox/i.test(_r()), n = /Trident/i.test(_r());
  if (n && We(a)) {
    var t = da(a);
    if (t.position === "fixed")
      return null;
  }
  var e = Xt(a);
  for (ln(e) && (e = e.host); We(e) && ["html", "body"].indexOf(sa(e)) < 0; ) {
    var i = da(e);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || r && i.willChange === "filter" || r && i.filter && i.filter !== "none")
      return e;
    e = e.parentNode;
  }
  return null;
}
function kt(a) {
  for (var r = Ye(a), n = ei(a); n && kf(n) && da(n).position === "static"; )
    n = ei(n);
  return n && (sa(n) === "html" || sa(n) === "body" && da(n).position === "static") ? r : n || Tf(a) || r;
}
function dn(a) {
  return ["top", "bottom"].indexOf(a) >= 0 ? "x" : "y";
}
function lt(a, r, n) {
  return Ta(a, Yt(r, n));
}
function wf(a, r, n) {
  var t = lt(a, r, n);
  return t > n ? n : t;
}
function Fs() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ks(a) {
  return Object.assign({}, Fs(), a);
}
function xs(a, r) {
  return r.reduce(function(n, t) {
    return n[t] = a, n;
  }, {});
}
var Af = function(r, n) {
  return r = typeof r == "function" ? r(Object.assign({}, n.rects, {
    placement: n.placement
  })) : r, Ks(typeof r != "number" ? r : xs(r, Ct));
};
function Nf(a) {
  var r, n = a.state, t = a.name, e = a.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = ia(n.placement), u = dn(s), l = [He, je].indexOf(s) >= 0, c = l ? "height" : "width";
  if (!(!i || !o)) {
    var d = Af(e.padding, n), h = cn(i), p = u === "y" ? xe : He, g = u === "y" ? Ve : je, S = n.rects.reference[c] + n.rects.reference[u] - o[u] - n.rects.popper[c], b = o[u] - n.rects.reference[u], w = kt(i), T = w ? u === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, k = S / 2 - b / 2, N = d[p], M = T - h[c] - d[g], y = T / 2 - h[c] / 2 + k, D = lt(N, y, M), I = u;
    n.modifiersData[t] = (r = {}, r[I] = D, r.centerOffset = D - y, r);
  }
}
function Df(a) {
  var r = a.state, n = a.options, t = n.element, e = t === void 0 ? "[data-popper-arrow]" : t;
  e != null && (typeof e == "string" && (e = r.elements.popper.querySelector(e), !e) || _s(r.elements.popper, e) && (r.elements.arrow = e));
}
const If = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Nf,
  effect: Df,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ja(a) {
  return a.split("-")[1];
}
var Ef = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Bf(a, r) {
  var n = a.x, t = a.y, e = r.devicePixelRatio || 1;
  return {
    x: Za(n * e) / e || 0,
    y: Za(t * e) / e || 0
  };
}
function ai(a) {
  var r, n = a.popper, t = a.popperRect, e = a.placement, i = a.variation, o = a.offsets, s = a.position, u = a.gpuAcceleration, l = a.adaptive, c = a.roundOffsets, d = a.isFixed, h = o.x, p = h === void 0 ? 0 : h, g = o.y, S = g === void 0 ? 0 : g, b = typeof c == "function" ? c({
    x: p,
    y: S
  }) : {
    x: p,
    y: S
  };
  p = b.x, S = b.y;
  var w = o.hasOwnProperty("x"), T = o.hasOwnProperty("y"), k = He, N = xe, M = window;
  if (l) {
    var y = kt(n), D = "clientHeight", I = "clientWidth";
    if (y === Ye(n) && (y = ba(n), da(y).position !== "static" && s === "absolute" && (D = "scrollHeight", I = "scrollWidth")), y = y, e === xe || (e === He || e === je) && i === vt) {
      N = Ve;
      var P = d && y === M && M.visualViewport ? M.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[D]
      );
      S -= P - t.height, S *= u ? 1 : -1;
    }
    if (e === He || (e === xe || e === Ve) && i === vt) {
      k = je;
      var B = d && y === M && M.visualViewport ? M.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[I]
      );
      p -= B - t.width, p *= u ? 1 : -1;
    }
  }
  var K = Object.assign({
    position: s
  }, l && Ef), Q = c === !0 ? Bf({
    x: p,
    y: S
  }, Ye(n)) : {
    x: p,
    y: S
  };
  if (p = Q.x, S = Q.y, u) {
    var Z;
    return Object.assign({}, K, (Z = {}, Z[N] = T ? "0" : "", Z[k] = w ? "0" : "", Z.transform = (M.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + S + "px)" : "translate3d(" + p + "px, " + S + "px, 0)", Z));
  }
  return Object.assign({}, K, (r = {}, r[N] = T ? S + "px" : "", r[k] = w ? p + "px" : "", r.transform = "", r));
}
function Pf(a) {
  var r = a.state, n = a.options, t = n.gpuAcceleration, e = t === void 0 ? !0 : t, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, u = s === void 0 ? !0 : s, l = {
    placement: ia(r.placement),
    variation: Ja(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: e,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, ai(Object.assign({}, l, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: o,
    roundOffsets: u
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, ai(Object.assign({}, l, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const Of = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Pf,
  data: {}
};
var Nt = {
  passive: !0
};
function Gf(a) {
  var r = a.state, n = a.instance, t = a.options, e = t.scroll, i = e === void 0 ? !0 : e, o = t.resize, s = o === void 0 ? !0 : o, u = Ye(r.elements.popper), l = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return i && l.forEach(function(c) {
    c.addEventListener("scroll", n.update, Nt);
  }), s && u.addEventListener("resize", n.update, Nt), function() {
    i && l.forEach(function(c) {
      c.removeEventListener("scroll", n.update, Nt);
    }), s && u.removeEventListener("resize", n.update, Nt);
  };
}
const Lf = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Gf,
  data: {}
};
var Rf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Bt(a) {
  return a.replace(/left|right|bottom|top/g, function(r) {
    return Rf[r];
  });
}
var _f = {
  start: "end",
  end: "start"
};
function ti(a) {
  return a.replace(/start|end/g, function(r) {
    return _f[r];
  });
}
function pn(a) {
  var r = Ye(a), n = r.pageXOffset, t = r.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: t
  };
}
function fn(a) {
  return za(ba(a)).left + pn(a).scrollLeft;
}
function Ff(a, r) {
  var n = Ye(a), t = ba(a), e = n.visualViewport, i = t.clientWidth, o = t.clientHeight, s = 0, u = 0;
  if (e) {
    i = e.width, o = e.height;
    var l = Rs();
    (l || !l && r === "fixed") && (s = e.offsetLeft, u = e.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + fn(a),
    y: u
  };
}
function Kf(a) {
  var r, n = ba(a), t = pn(a), e = (r = a.ownerDocument) == null ? void 0 : r.body, i = Ta(n.scrollWidth, n.clientWidth, e ? e.scrollWidth : 0, e ? e.clientWidth : 0), o = Ta(n.scrollHeight, n.clientHeight, e ? e.scrollHeight : 0, e ? e.clientHeight : 0), s = -t.scrollLeft + fn(a), u = -t.scrollTop;
  return da(e || n).direction === "rtl" && (s += Ta(n.clientWidth, e ? e.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: u
  };
}
function hn(a) {
  var r = da(a), n = r.overflow, t = r.overflowX, e = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + e + t);
}
function Hs(a) {
  return ["html", "body", "#document"].indexOf(sa(a)) >= 0 ? a.ownerDocument.body : We(a) && hn(a) ? a : Hs(Xt(a));
}
function ct(a, r) {
  var n;
  r === void 0 && (r = []);
  var t = Hs(a), e = t === ((n = a.ownerDocument) == null ? void 0 : n.body), i = Ye(t), o = e ? [i].concat(i.visualViewport || [], hn(t) ? t : []) : t, s = r.concat(o);
  return e ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(ct(Xt(o)))
  );
}
function Fr(a) {
  return Object.assign({}, a, {
    left: a.x,
    top: a.y,
    right: a.x + a.width,
    bottom: a.y + a.height
  });
}
function xf(a, r) {
  var n = za(a, !1, r === "fixed");
  return n.top = n.top + a.clientTop, n.left = n.left + a.clientLeft, n.bottom = n.top + a.clientHeight, n.right = n.left + a.clientWidth, n.width = a.clientWidth, n.height = a.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ri(a, r, n) {
  return r === Gs ? Fr(Ff(a, n)) : Ea(r) ? xf(r, n) : Fr(Kf(ba(a)));
}
function Hf(a) {
  var r = ct(Xt(a)), n = ["absolute", "fixed"].indexOf(da(a).position) >= 0, t = n && We(a) ? kt(a) : a;
  return Ea(t) ? r.filter(function(e) {
    return Ea(e) && _s(e, t) && sa(e) !== "body";
  }) : [];
}
function Uf(a, r, n, t) {
  var e = r === "clippingParents" ? Hf(a) : [].concat(r), i = [].concat(e, [n]), o = i[0], s = i.reduce(function(u, l) {
    var c = ri(a, l, t);
    return u.top = Ta(c.top, u.top), u.right = Yt(c.right, u.right), u.bottom = Yt(c.bottom, u.bottom), u.left = Ta(c.left, u.left), u;
  }, ri(a, o, t));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Us(a) {
  var r = a.reference, n = a.element, t = a.placement, e = t ? ia(t) : null, i = t ? Ja(t) : null, o = r.x + r.width / 2 - n.width / 2, s = r.y + r.height / 2 - n.height / 2, u;
  switch (e) {
    case xe:
      u = {
        x: o,
        y: r.y - n.height
      };
      break;
    case Ve:
      u = {
        x: o,
        y: r.y + r.height
      };
      break;
    case je:
      u = {
        x: r.x + r.width,
        y: s
      };
      break;
    case He:
      u = {
        x: r.x - n.width,
        y: s
      };
      break;
    default:
      u = {
        x: r.x,
        y: r.y
      };
  }
  var l = e ? dn(e) : null;
  if (l != null) {
    var c = l === "y" ? "height" : "width";
    switch (i) {
      case ja:
        u[l] = u[l] - (r[c] / 2 - n[c] / 2);
        break;
      case vt:
        u[l] = u[l] + (r[c] / 2 - n[c] / 2);
        break;
    }
  }
  return u;
}
function St(a, r) {
  r === void 0 && (r = {});
  var n = r, t = n.placement, e = t === void 0 ? a.placement : t, i = n.strategy, o = i === void 0 ? a.strategy : i, s = n.boundary, u = s === void 0 ? uf : s, l = n.rootBoundary, c = l === void 0 ? Gs : l, d = n.elementContext, h = d === void 0 ? it : d, p = n.altBoundary, g = p === void 0 ? !1 : p, S = n.padding, b = S === void 0 ? 0 : S, w = Ks(typeof b != "number" ? b : xs(b, Ct)), T = h === it ? lf : it, k = a.rects.popper, N = a.elements[g ? T : h], M = Uf(Ea(N) ? N : N.contextElement || ba(a.elements.popper), u, c, o), y = za(a.elements.reference), D = Us({
    reference: y,
    element: k,
    placement: e
  }), I = Fr(Object.assign({}, k, D)), P = h === it ? I : y, B = {
    top: M.top - P.top + w.top,
    bottom: P.bottom - M.bottom + w.bottom,
    left: M.left - P.left + w.left,
    right: P.right - M.right + w.right
  }, K = a.modifiersData.offset;
  if (h === it && K) {
    var Q = K[e];
    Object.keys(B).forEach(function(Z) {
      var z = [je, Ve].indexOf(Z) >= 0 ? 1 : -1, x = [xe, Ve].indexOf(Z) >= 0 ? "y" : "x";
      B[Z] += Q[x] * z;
    });
  }
  return B;
}
function Yf(a, r) {
  r === void 0 && (r = {});
  var n = r, t = n.placement, e = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, u = n.allowedAutoPlacements, l = u === void 0 ? Ls : u, c = Ja(t), d = c ? s ? $n : $n.filter(function(g) {
    return Ja(g) === c;
  }) : Ct, h = d.filter(function(g) {
    return l.indexOf(g) >= 0;
  });
  h.length === 0 && (h = d);
  var p = h.reduce(function(g, S) {
    return g[S] = St(a, {
      placement: S,
      boundary: e,
      rootBoundary: i,
      padding: o
    })[ia(S)], g;
  }, {});
  return Object.keys(p).sort(function(g, S) {
    return p[g] - p[S];
  });
}
function Wf(a) {
  if (ia(a) === un)
    return [];
  var r = Bt(a);
  return [ti(a), r, ti(r)];
}
function Vf(a) {
  var r = a.state, n = a.options, t = a.name;
  if (!r.modifiersData[t]._skip) {
    for (var e = n.mainAxis, i = e === void 0 ? !0 : e, o = n.altAxis, s = o === void 0 ? !0 : o, u = n.fallbackPlacements, l = n.padding, c = n.boundary, d = n.rootBoundary, h = n.altBoundary, p = n.flipVariations, g = p === void 0 ? !0 : p, S = n.allowedAutoPlacements, b = r.options.placement, w = ia(b), T = w === b, k = u || (T || !g ? [Bt(b)] : Wf(b)), N = [b].concat(k).reduce(function(V, re) {
      return V.concat(ia(re) === un ? Yf(r, {
        placement: re,
        boundary: c,
        rootBoundary: d,
        padding: l,
        flipVariations: g,
        allowedAutoPlacements: S
      }) : re);
    }, []), M = r.rects.reference, y = r.rects.popper, D = /* @__PURE__ */ new Map(), I = !0, P = N[0], B = 0; B < N.length; B++) {
      var K = N[B], Q = ia(K), Z = Ja(K) === ja, z = [xe, Ve].indexOf(Q) >= 0, x = z ? "width" : "height", Y = St(r, {
        placement: K,
        boundary: c,
        rootBoundary: d,
        altBoundary: h,
        padding: l
      }), L = z ? Z ? je : He : Z ? Ve : xe;
      M[x] > y[x] && (L = Bt(L));
      var H = Bt(L), X = [];
      if (i && X.push(Y[Q] <= 0), s && X.push(Y[L] <= 0, Y[H] <= 0), X.every(function(V) {
        return V;
      })) {
        P = K, I = !1;
        break;
      }
      D.set(K, X);
    }
    if (I)
      for (var J = g ? 3 : 1, E = function(re) {
        var he = N.find(function(ve) {
          var ue = D.get(ve);
          if (ue)
            return ue.slice(0, re).every(function(ne) {
              return ne;
            });
        });
        if (he)
          return P = he, "break";
      }, U = J; U > 0; U--) {
        var j = E(U);
        if (j === "break") break;
      }
    r.placement !== P && (r.modifiersData[t]._skip = !0, r.placement = P, r.reset = !0);
  }
}
const jf = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Vf,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ni(a, r, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: a.top - r.height - n.y,
    right: a.right - r.width + n.x,
    bottom: a.bottom - r.height + n.y,
    left: a.left - r.width - n.x
  };
}
function ii(a) {
  return [xe, je, Ve, He].some(function(r) {
    return a[r] >= 0;
  });
}
function Zf(a) {
  var r = a.state, n = a.name, t = r.rects.reference, e = r.rects.popper, i = r.modifiersData.preventOverflow, o = St(r, {
    elementContext: "reference"
  }), s = St(r, {
    altBoundary: !0
  }), u = ni(o, t), l = ni(s, e, i), c = ii(u), d = ii(l);
  r.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: l,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const zf = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Zf
};
function Jf(a, r, n) {
  var t = ia(a), e = [He, xe].indexOf(t) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, r, {
    placement: a
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * e, [He, je].indexOf(t) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function Qf(a) {
  var r = a.state, n = a.options, t = a.name, e = n.offset, i = e === void 0 ? [0, 0] : e, o = Ls.reduce(function(c, d) {
    return c[d] = Jf(d, r.rects, i), c;
  }, {}), s = o[r.placement], u = s.x, l = s.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += u, r.modifiersData.popperOffsets.y += l), r.modifiersData[t] = o;
}
const qf = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Qf
};
function Xf(a) {
  var r = a.state, n = a.name;
  r.modifiersData[n] = Us({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const $f = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Xf,
  data: {}
};
function eh(a) {
  return a === "x" ? "y" : "x";
}
function ah(a) {
  var r = a.state, n = a.options, t = a.name, e = n.mainAxis, i = e === void 0 ? !0 : e, o = n.altAxis, s = o === void 0 ? !1 : o, u = n.boundary, l = n.rootBoundary, c = n.altBoundary, d = n.padding, h = n.tether, p = h === void 0 ? !0 : h, g = n.tetherOffset, S = g === void 0 ? 0 : g, b = St(r, {
    boundary: u,
    rootBoundary: l,
    padding: d,
    altBoundary: c
  }), w = ia(r.placement), T = Ja(r.placement), k = !T, N = dn(w), M = eh(N), y = r.modifiersData.popperOffsets, D = r.rects.reference, I = r.rects.popper, P = typeof S == "function" ? S(Object.assign({}, r.rects, {
    placement: r.placement
  })) : S, B = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), K = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, Q = {
    x: 0,
    y: 0
  };
  if (y) {
    if (i) {
      var Z, z = N === "y" ? xe : He, x = N === "y" ? Ve : je, Y = N === "y" ? "height" : "width", L = y[N], H = L + b[z], X = L - b[x], J = p ? -I[Y] / 2 : 0, E = T === ja ? D[Y] : I[Y], U = T === ja ? -I[Y] : -D[Y], j = r.elements.arrow, V = p && j ? cn(j) : {
        width: 0,
        height: 0
      }, re = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : Fs(), he = re[z], ve = re[x], ue = lt(0, D[Y], V[Y]), ne = k ? D[Y] / 2 - J - ue - he - B.mainAxis : E - ue - he - B.mainAxis, Ge = k ? -D[Y] / 2 + J + ue + ve + B.mainAxis : U + ue + ve + B.mainAxis, ee = r.elements.arrow && kt(r.elements.arrow), pe = ee ? N === "y" ? ee.clientTop || 0 : ee.clientLeft || 0 : 0, Le = (Z = K == null ? void 0 : K[N]) != null ? Z : 0, ua = L + ne - Le - pe, la = L + Ge - Le, et = lt(p ? Yt(H, ua) : H, L, p ? Ta(X, la) : X);
      y[N] = et, Q[N] = et - L;
    }
    if (s) {
      var Mn, iu = N === "x" ? xe : He, ou = N === "x" ? Ve : je, Ma = y[M], Tt = M === "y" ? "height" : "width", yn = Ma + b[iu], Cn = Ma - b[ou], nr = [xe, He].indexOf(w) !== -1, kn = (Mn = K == null ? void 0 : K[M]) != null ? Mn : 0, Tn = nr ? yn : Ma - D[Tt] - I[Tt] - kn + B.altAxis, wn = nr ? Ma + D[Tt] + I[Tt] - kn - B.altAxis : Cn, An = p && nr ? wf(Tn, Ma, wn) : lt(p ? Tn : yn, Ma, p ? wn : Cn);
      y[M] = An, Q[M] = An - Ma;
    }
    r.modifiersData[t] = Q;
  }
}
const th = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ah,
  requiresIfExists: ["offset"]
};
function rh(a) {
  return {
    scrollLeft: a.scrollLeft,
    scrollTop: a.scrollTop
  };
}
function nh(a) {
  return a === Ye(a) || !We(a) ? pn(a) : rh(a);
}
function ih(a) {
  var r = a.getBoundingClientRect(), n = Za(r.width) / a.offsetWidth || 1, t = Za(r.height) / a.offsetHeight || 1;
  return n !== 1 || t !== 1;
}
function oh(a, r, n) {
  n === void 0 && (n = !1);
  var t = We(r), e = We(r) && ih(r), i = ba(r), o = za(a, e, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (t || !t && !n) && ((sa(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  hn(i)) && (s = nh(r)), We(r) ? (u = za(r, !0), u.x += r.clientLeft, u.y += r.clientTop) : i && (u.x = fn(i))), {
    x: o.left + s.scrollLeft - u.x,
    y: o.top + s.scrollTop - u.y,
    width: o.width,
    height: o.height
  };
}
function sh(a) {
  var r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), t = [];
  a.forEach(function(i) {
    r.set(i.name, i);
  });
  function e(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var u = r.get(s);
        u && e(u);
      }
    }), t.push(i);
  }
  return a.forEach(function(i) {
    n.has(i.name) || e(i);
  }), t;
}
function uh(a) {
  var r = sh(a);
  return bf.reduce(function(n, t) {
    return n.concat(r.filter(function(e) {
      return e.phase === t;
    }));
  }, []);
}
function lh(a) {
  var r;
  return function() {
    return r || (r = new Promise(function(n) {
      Promise.resolve().then(function() {
        r = void 0, n(a());
      });
    })), r;
  };
}
function ch(a) {
  var r = a.reduce(function(n, t) {
    var e = n[t.name];
    return n[t.name] = e ? Object.assign({}, e, t, {
      options: Object.assign({}, e.options, t.options),
      data: Object.assign({}, e.data, t.data)
    }) : t, n;
  }, {});
  return Object.keys(r).map(function(n) {
    return r[n];
  });
}
var oi = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function si() {
  for (var a = arguments.length, r = new Array(a), n = 0; n < a; n++)
    r[n] = arguments[n];
  return !r.some(function(t) {
    return !(t && typeof t.getBoundingClientRect == "function");
  });
}
function dh(a) {
  a === void 0 && (a = {});
  var r = a, n = r.defaultModifiers, t = n === void 0 ? [] : n, e = r.defaultOptions, i = e === void 0 ? oi : e;
  return function(s, u, l) {
    l === void 0 && (l = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, oi, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, d = [], h = !1, p = {
      state: c,
      setOptions: function(w) {
        var T = typeof w == "function" ? w(c.options) : w;
        S(), c.options = Object.assign({}, i, c.options, T), c.scrollParents = {
          reference: Ea(s) ? ct(s) : s.contextElement ? ct(s.contextElement) : [],
          popper: ct(u)
        };
        var k = uh(ch([].concat(t, c.options.modifiers)));
        return c.orderedModifiers = k.filter(function(N) {
          return N.enabled;
        }), g(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var w = c.elements, T = w.reference, k = w.popper;
          if (si(T, k)) {
            c.rects = {
              reference: oh(T, kt(k), c.options.strategy === "fixed"),
              popper: cn(k)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(B) {
              return c.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var N = 0; N < c.orderedModifiers.length; N++) {
              if (c.reset === !0) {
                c.reset = !1, N = -1;
                continue;
              }
              var M = c.orderedModifiers[N], y = M.fn, D = M.options, I = D === void 0 ? {} : D, P = M.name;
              typeof y == "function" && (c = y({
                state: c,
                options: I,
                name: P,
                instance: p
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: lh(function() {
        return new Promise(function(b) {
          p.forceUpdate(), b(c);
        });
      }),
      destroy: function() {
        S(), h = !0;
      }
    };
    if (!si(s, u))
      return p;
    p.setOptions(l).then(function(b) {
      !h && l.onFirstUpdate && l.onFirstUpdate(b);
    });
    function g() {
      c.orderedModifiers.forEach(function(b) {
        var w = b.name, T = b.options, k = T === void 0 ? {} : T, N = b.effect;
        if (typeof N == "function") {
          var M = N({
            state: c,
            name: w,
            instance: p,
            options: k
          }), y = function() {
          };
          d.push(M || y);
        }
      });
    }
    function S() {
      d.forEach(function(b) {
        return b();
      }), d = [];
    }
    return p;
  };
}
var ph = [Lf, $f, Of, Cf, qf, jf, th, If, zf], fh = /* @__PURE__ */ dh({
  defaultModifiers: ph
}), hr, ui;
function hh() {
  if (ui) return hr;
  ui = 1;
  var a = typeof Element < "u", r = typeof Map == "function", n = typeof Set == "function", t = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function e(i, o) {
    if (i === o) return !0;
    if (i && o && typeof i == "object" && typeof o == "object") {
      if (i.constructor !== o.constructor) return !1;
      var s, u, l;
      if (Array.isArray(i)) {
        if (s = i.length, s != o.length) return !1;
        for (u = s; u-- !== 0; )
          if (!e(i[u], o[u])) return !1;
        return !0;
      }
      var c;
      if (r && i instanceof Map && o instanceof Map) {
        if (i.size !== o.size) return !1;
        for (c = i.entries(); !(u = c.next()).done; )
          if (!o.has(u.value[0])) return !1;
        for (c = i.entries(); !(u = c.next()).done; )
          if (!e(u.value[1], o.get(u.value[0]))) return !1;
        return !0;
      }
      if (n && i instanceof Set && o instanceof Set) {
        if (i.size !== o.size) return !1;
        for (c = i.entries(); !(u = c.next()).done; )
          if (!o.has(u.value[0])) return !1;
        return !0;
      }
      if (t && ArrayBuffer.isView(i) && ArrayBuffer.isView(o)) {
        if (s = i.length, s != o.length) return !1;
        for (u = s; u-- !== 0; )
          if (i[u] !== o[u]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === o.source && i.flags === o.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof o.valueOf == "function") return i.valueOf() === o.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof o.toString == "function") return i.toString() === o.toString();
      if (l = Object.keys(i), s = l.length, s !== Object.keys(o).length) return !1;
      for (u = s; u-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(o, l[u])) return !1;
      if (a && i instanceof Element) return !1;
      for (u = s; u-- !== 0; )
        if (!((l[u] === "_owner" || l[u] === "__v" || l[u] === "__o") && i.$$typeof) && !e(i[l[u]], o[l[u]]))
          return !1;
      return !0;
    }
    return i !== i && o !== o;
  }
  return hr = function(o, s) {
    try {
      return e(o, s);
    } catch (u) {
      if ((u.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw u;
    }
  }, hr;
}
var mh = hh();
const gh = /* @__PURE__ */ Zt(mh);
var vh = [], Sh = function(r, n, t) {
  t === void 0 && (t = {});
  var e = me.useRef(null), i = {
    onFirstUpdate: t.onFirstUpdate,
    placement: t.placement || "bottom",
    strategy: t.strategy || "absolute",
    modifiers: t.modifiers || vh
  }, o = me.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = o[0], u = o[1], l = me.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(p) {
        var g = p.state, S = Object.keys(g.elements);
        Gu.flushSync(function() {
          u({
            styles: qn(S.map(function(b) {
              return [b, g.styles[b] || {}];
            })),
            attributes: qn(S.map(function(b) {
              return [b, g.attributes[b]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = me.useMemo(function() {
    var h = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [l, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return gh(e.current, h) ? e.current || h : (e.current = h, h);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, l]), d = me.useRef();
  return Xn(function() {
    d.current && d.current.setOptions(c);
  }, [c]), Xn(function() {
    if (!(r == null || n == null)) {
      var h = t.createPopper || fh, p = h(r, n, c);
      return d.current = p, function() {
        p.destroy(), d.current = null;
      };
    }
  }, [r, n, t.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
}, bh = function() {
}, Mh = function() {
  return Promise.resolve(null);
}, yh = [];
function Ch(a) {
  var r = a.placement, n = r === void 0 ? "bottom" : r, t = a.strategy, e = t === void 0 ? "absolute" : t, i = a.modifiers, o = i === void 0 ? yh : i, s = a.referenceElement, u = a.onFirstUpdate, l = a.innerRef, c = a.children, d = me.useContext(Es), h = me.useState(null), p = h[0], g = h[1], S = me.useState(null), b = S[0], w = S[1];
  me.useEffect(function() {
    Rr(l, p);
  }, [l, p]);
  var T = me.useMemo(function() {
    return {
      placement: n,
      strategy: e,
      onFirstUpdate: u,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: b != null,
        options: {
          element: b
        }
      }])
    };
  }, [n, e, u, o, b]), k = Sh(s || d, p, T), N = k.state, M = k.styles, y = k.forceUpdate, D = k.update, I = me.useMemo(function() {
    return {
      ref: g,
      style: M.popper,
      placement: N ? N.placement : n,
      hasPopperEscaped: N && N.modifiersData.hide ? N.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: N && N.modifiersData.hide ? N.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: M.arrow,
        ref: w
      },
      forceUpdate: y || bh,
      update: D || Mh
    };
  }, [g, w, n, N, M, D, y]);
  return Ps(c)(I);
}
var mr, li;
function kh() {
  if (li) return mr;
  li = 1;
  var a = process.env.NODE_ENV !== "production", r = function() {
  };
  if (a) {
    var n = function(e, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var u = 0, l = "Warning: " + e.replace(/%s/g, function() {
        return i[u++];
      });
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
    r = function(t, e, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (e === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      t || n.apply(null, [e].concat(i));
    };
  }
  return mr = r, mr;
}
var Th = kh();
const wh = /* @__PURE__ */ Zt(Th);
function Ah(a) {
  var r = a.children, n = a.innerRef, t = me.useContext(Bs), e = me.useCallback(function(i) {
    Rr(n, i), Os(t, i);
  }, [n, t]);
  return me.useEffect(function() {
    return function() {
      return Rr(n, null);
    };
  }, []), me.useEffect(function() {
    wh(!!t, "`Reference` should not be used outside of a `Manager` component.");
  }, [t]), Ps(r)({
    ref: e
  });
}
function Nh(a, r) {
  if (O(2, arguments), Ba(r) !== "object" || r === null)
    throw new RangeError("values parameter must be an object");
  var n = R(a);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.year != null && n.setFullYear(r.year), r.month != null && (n = _e(n, r.month)), r.date != null && n.setDate(q(r.date)), r.hours != null && n.setHours(q(r.hours)), r.minutes != null && n.setMinutes(q(r.minutes)), r.seconds != null && n.setSeconds(q(r.seconds)), r.milliseconds != null && n.setMilliseconds(q(r.milliseconds)), n);
}
function ci(a, r) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(a);
    r && (t = t.filter((function(e) {
      return Object.getOwnPropertyDescriptor(a, e).enumerable;
    }))), n.push.apply(n, t);
  }
  return n;
}
function Wt(a) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ci(Object(n), !0).forEach((function(t) {
      f(a, t, n[t]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : ci(Object(n)).forEach((function(t) {
      Object.defineProperty(a, t, Object.getOwnPropertyDescriptor(n, t));
    }));
  }
  return a;
}
function Kr(a) {
  return Kr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Kr(a);
}
function De(a, r) {
  if (!(a instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function di(a, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(a, Ys(t.key), t);
  }
}
function Ie(a, r, n) {
  return r && di(a.prototype, r), n && di(a, n), Object.defineProperty(a, "prototype", { writable: !1 }), a;
}
function f(a, r, n) {
  return (r = Ys(r)) in a ? Object.defineProperty(a, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : a[r] = n, a;
}
function Qa() {
  return Qa = Object.assign ? Object.assign.bind() : function(a) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (a[t] = n[t]);
    }
    return a;
  }, Qa.apply(this, arguments);
}
function Ee(a, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), r && xr(a, r);
}
function Vt(a) {
  return Vt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Vt(a);
}
function xr(a, r) {
  return xr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, t) {
    return n.__proto__ = t, n;
  }, xr(a, r);
}
function m(a) {
  if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function Be(a) {
  var r = (function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
      }))), !0;
    } catch {
      return !1;
    }
  })();
  return function() {
    var n, t = Vt(a);
    if (r) {
      var e = Vt(this).constructor;
      n = Reflect.construct(t, arguments, e);
    } else n = t.apply(this, arguments);
    return (function(i, o) {
      if (o && (typeof o == "object" || typeof o == "function")) return o;
      if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return m(i);
    })(this, n);
  };
}
function bt(a) {
  return (function(r) {
    if (Array.isArray(r)) return gr(r);
  })(a) || (function(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
  })(a) || (function(r, n) {
    if (r) {
      if (typeof r == "string") return gr(r, n);
      var t = Object.prototype.toString.call(r).slice(8, -1);
      if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return gr(r, n);
    }
  })(a) || (function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  })();
}
function gr(a, r) {
  (r == null || r > a.length) && (r = a.length);
  for (var n = 0, t = new Array(r); n < r; n++) t[n] = a[n];
  return t;
}
function Ys(a) {
  var r = (function(n, t) {
    if (typeof n != "object" || n === null) return n;
    var e = n[Symbol.toPrimitive];
    if (e !== void 0) {
      var i = e.call(n, t);
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(n);
  })(a, "string");
  return typeof r == "symbol" ? r : String(r);
}
var pi = function(a, r) {
  switch (a) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    default:
      return r.date({ width: "full" });
  }
}, fi = function(a, r) {
  switch (a) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    default:
      return r.time({ width: "full" });
  }
}, Dh = { p: fi, P: function(a, r) {
  var n, t = a.match(/(P+)(p+)?/) || [], e = t[1], i = t[2];
  if (!i) return pi(a, r);
  switch (e) {
    case "P":
      n = r.dateTime({ width: "short" });
      break;
    case "PP":
      n = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      n = r.dateTime({ width: "long" });
      break;
    default:
      n = r.dateTime({ width: "full" });
  }
  return n.replace("{{date}}", pi(e, r)).replace("{{time}}", fi(i, r));
} }, dt = 12, Ih = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function ge(a) {
  var r = a ? typeof a == "string" || a instanceof String ? Gp(a) : R(a) : /* @__PURE__ */ new Date();
  return fa(r) ? r : null;
}
function fa(a, r) {
  return r = r || /* @__PURE__ */ new Date("1/1/1000"), ft(a) && !ha(a, r);
}
function Me(a, r, n) {
  if (n === "en") return Un(a, r, { awareOfUnicodeTokens: !0 });
  var t = Aa(n);
  return n && !t && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !t && wa() && Aa(wa()) && (t = Aa(wa())), Un(a, r, { locale: t || null, awareOfUnicodeTokens: !0 });
}
function Xe(a, r) {
  var n = r.dateFormat, t = r.locale;
  return a && Me(a, Array.isArray(n) ? n[0] : n, t) || "";
}
function hi(a, r) {
  var n = r.hour, t = n === void 0 ? 0 : n, e = r.minute, i = e === void 0 ? 0 : e, o = r.second;
  return Et(It(Dd(a, o === void 0 ? 0 : o), i), t);
}
function oa(a, r, n) {
  var t = Aa(r || wa());
  return ys(a, { locale: t, weekStartsOn: n });
}
function ga(a) {
  return Cs(a);
}
function st(a) {
  return ks(a);
}
function mi(a) {
  return Br(a);
}
function gi() {
  return na(ge());
}
function ma(a, r) {
  return a && r ? Rd(a, r) : !a && !r;
}
function ze(a, r) {
  return a && r ? Ld(a, r) : !a && !r;
}
function jt(a, r) {
  return a && r ? _d(a, r) : !a && !r;
}
function Se(a, r) {
  return a && r ? Gd(a, r) : !a && !r;
}
function ka(a, r) {
  return a && r ? Od(a, r) : !a && !r;
}
function Pt(a, r, n) {
  var t, e = na(r), i = Pr(n);
  try {
    t = gt(a, { start: e, end: i });
  } catch {
    t = !1;
  }
  return t;
}
function wa() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Aa(a) {
  if (typeof a == "string") {
    var r = typeof window < "u" ? window : globalThis;
    return r.__localeData__ ? r.__localeData__[a] : null;
  }
  return a;
}
function mn(a, r) {
  return Me(_e(ge(), a), "LLLL", r);
}
function Ws(a, r) {
  return Me(_e(ge(), a), "LLL", r);
}
function $t(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.excludeDateIntervals, o = r.includeDates, s = r.includeDateIntervals, u = r.filterDate;
  return er(a, { minDate: n, maxDate: t }) || e && e.some((function(l) {
    return Se(a, l);
  })) || i && i.some((function(l) {
    var c = l.start, d = l.end;
    return gt(a, { start: c, end: d });
  })) || o && !o.some((function(l) {
    return Se(a, l);
  })) || s && !s.some((function(l) {
    var c = l.start, d = l.end;
    return gt(a, { start: c, end: d });
  })) || u && !u(ge(a)) || !1;
}
function gn(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeDates, t = r.excludeDateIntervals;
  return t && t.length > 0 ? t.some((function(e) {
    var i = e.start, o = e.end;
    return gt(a, { start: i, end: o });
  })) : n && n.some((function(e) {
    return Se(a, e);
  })) || !1;
}
function Vs(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return er(a, { minDate: Cs(n), maxDate: Bd(t) }) || e && e.some((function(s) {
    return ze(a, s);
  })) || i && !i.some((function(s) {
    return ze(a, s);
  })) || o && !o(ge(a)) || !1;
}
function vr(a, r, n, t) {
  var e = $(a), i = Oe(a), o = $(r), s = Oe(r), u = $(t);
  return e === o && e === u ? i <= n && n <= s : e < o ? u === e && i <= n || u === o && s >= n || u < o && u > e : void 0;
}
function Eh(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return er(a, { minDate: n, maxDate: t }) || e && e.some((function(s) {
    return jt(a, s);
  })) || i && !i.some((function(s) {
    return jt(a, s);
  })) || o && !o(ge(a)) || !1;
}
function Sr(a, r, n) {
  if (!ft(r) || !ft(n)) return !1;
  var t = $(r), e = $(n);
  return t <= a && e >= a;
}
function js(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate, s = new Date(a, 0, 1);
  return er(s, { minDate: ks(n), maxDate: Pd(t) }) || e && e.some((function(u) {
    return ma(s, u);
  })) || i && !i.some((function(u) {
    return ma(s, u);
  })) || o && !o(ge(s)) || !1;
}
function br(a, r, n, t) {
  var e = $(a), i = _a(a), o = $(r), s = _a(r), u = $(t);
  return e === o && e === u ? i <= n && n <= s : e < o ? u === e && i <= n || u === o && s >= n || u < o && u > e : void 0;
}
function er(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate;
  return n && mt(a, n) < 0 || t && mt(a, t) > 0;
}
function vi(a, r) {
  return r.some((function(n) {
    return ra(n) === ra(a) && ta(n) === ta(a);
  }));
}
function Si(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeTimes, t = r.includeTimes, e = r.filterTime;
  return n && vi(a, n) || t && !vi(a, t) || e && !e(a) || !1;
}
function bi(a, r) {
  var n = r.minTime, t = r.maxTime;
  if (!n || !t) throw new Error("Both minTime and maxTime props required");
  var e, i = ge(), o = Et(It(i, ta(a)), ra(a)), s = Et(It(i, ta(n)), ra(n)), u = Et(It(i, ta(t)), ra(t));
  try {
    e = !gt(o, { start: s, end: u });
  } catch {
    e = !1;
  }
  return e;
}
function Mi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.includeDates, e = Va(a, 1);
  return n && Kt(n, e) > 0 || t && t.every((function(i) {
    return Kt(i, e) > 0;
  })) || !1;
}
function yi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, t = r.includeDates, e = qe(a, 1);
  return n && Kt(e, n) > 0 || t && t.every((function(i) {
    return Kt(e, i) > 0;
  })) || !1;
}
function Ci(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.includeDates, e = ht(a, 1);
  return n && xt(n, e) > 0 || t && t.every((function(i) {
    return xt(i, e) > 0;
  })) || !1;
}
function ki(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, t = r.includeDates, e = Wa(a, 1);
  return n && xt(e, n) > 0 || t && t.every((function(i) {
    return xt(e, i) > 0;
  })) || !1;
}
function Zs(a) {
  var r = a.minDate, n = a.includeDates;
  if (n && r) {
    var t = n.filter((function(e) {
      return mt(e, r) >= 0;
    }));
    return jn(t);
  }
  return n ? jn(n) : r;
}
function zs(a) {
  var r = a.maxDate, n = a.includeDates;
  if (n && r) {
    var t = n.filter((function(e) {
      return mt(e, r) <= 0;
    }));
    return Zn(t);
  }
  return n ? Zn(n) : r;
}
function Ti() {
  for (var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), t = 0, e = a.length; t < e; t++) {
    var i = a[t];
    if (Qt(i)) {
      var o = Me(i, "MM.dd.yyyy"), s = n.get(o) || [];
      s.includes(r) || (s.push(r), n.set(o, s));
    } else if (Kr(i) === "object") {
      var u = Object.keys(i), l = u[0], c = i[u[0]];
      if (typeof l == "string" && c.constructor === Array) for (var d = 0, h = c.length; d < h; d++) {
        var p = Me(c[d], "MM.dd.yyyy"), g = n.get(p) || [];
        g.includes(l) || (g.push(l), n.set(p, g));
      }
    }
  }
  return n;
}
function Bh() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return a.forEach((function(t) {
    var e = t.date, i = t.holidayName;
    if (Qt(e)) {
      var o = Me(e, "MM.dd.yyyy"), s = n.get(o) || {};
      if (!("className" in s) || s.className !== r || (u = s.holidayNames, l = [i], u.length !== l.length || !u.every((function(d, h) {
        return d === l[h];
      })))) {
        var u, l;
        s.className = r;
        var c = s.holidayNames;
        s.holidayNames = c ? [].concat(bt(c), [i]) : [i], n.set(o, s);
      }
    }
  })), n;
}
function Ph(a, r, n, t, e) {
  for (var i = e.length, o = [], s = 0; s < i; s++) {
    var u = Ir(Md(a, ra(e[s])), ta(e[s])), l = Ir(a, (n + 1) * t);
    va(u, r) && ha(u, l) && o.push(e[s]);
  }
  return o;
}
function wi(a) {
  return a < 10 ? "0".concat(a) : "".concat(a);
}
function Fa(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : dt, n = Math.ceil($(a) / r) * r;
  return { startPeriod: n - (r - 1), endPeriod: n };
}
function Ai(a) {
  var r = a.getSeconds(), n = a.getMilliseconds();
  return R(a.getTime() - 1e3 * r - n);
}
function Oh(a, r, n, t) {
  for (var e = [], i = 0; i < 2 * r + 1; i++) {
    var o = a + r - i, s = !0;
    n && (s = $(n) <= o), t && s && (s = $(t) >= o), s && e.push(o);
  }
  return e;
}
var Gh = qt((function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    De(this, n), f(m(e = r.call(this, t)), "renderOptions", (function() {
      var u = e.props.year, l = e.state.yearsList.map((function(h) {
        return C.createElement("div", { className: u === h ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: h, onClick: e.onChange.bind(m(e), h), "aria-selected": u === h ? "true" : void 0 }, u === h ? C.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", h);
      })), c = e.props.minDate ? $(e.props.minDate) : null, d = e.props.maxDate ? $(e.props.maxDate) : null;
      return d && e.state.yearsList.find((function(h) {
        return h === d;
      })) || l.unshift(C.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears }, C.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), c && e.state.yearsList.find((function(h) {
        return h === c;
      })) || l.push(C.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears }, C.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), l;
    })), f(m(e), "onChange", (function(u) {
      e.props.onChange(u);
    })), f(m(e), "handleClickOutside", (function() {
      e.props.onCancel();
    })), f(m(e), "shiftYears", (function(u) {
      var l = e.state.yearsList.map((function(c) {
        return c + u;
      }));
      e.setState({ yearsList: l });
    })), f(m(e), "incrementYears", (function() {
      return e.shiftYears(1);
    })), f(m(e), "decrementYears", (function() {
      return e.shiftYears(-1);
    }));
    var i = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = i || (o ? 10 : 5);
    return e.state = { yearsList: Oh(e.props.year, s, e.props.minDate, e.props.maxDate) }, e.dropdownRef = Su(), e;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    var t = this.dropdownRef.current;
    if (t) {
      var e = t.children ? Array.from(t.children) : null, i = e ? e.find((function(o) {
        return o.ariaSelected;
      })) : null;
      t.scrollTop = i ? i.offsetTop + (i.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var t = Pe({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return C.createElement("div", { className: t, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
})()), Lh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), f(m(t), "renderSelectOptions", (function() {
      for (var s = t.props.minDate ? $(t.props.minDate) : 1900, u = t.props.maxDate ? $(t.props.maxDate) : 2100, l = [], c = s; c <= u; c++) l.push(C.createElement("option", { key: c, value: c }, c));
      return l;
    })), f(m(t), "onSelectChange", (function(s) {
      t.onChange(s.target.value);
    })), f(m(t), "renderSelectMode", (function() {
      return C.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    })), f(m(t), "renderReadView", (function(s) {
      return C.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(u) {
        return t.toggleDropdown(u);
      } }, C.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), C.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year));
    })), f(m(t), "renderDropdown", (function() {
      return C.createElement(Gh, { key: "dropdown", year: t.props.year, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableYearDropdown: t.props.scrollableYearDropdown, yearDropdownItemNumber: t.props.yearDropdownItemNumber });
    })), f(m(t), "renderScrollMode", (function() {
      var s = t.state.dropdownVisible, u = [t.renderReadView(!s)];
      return s && u.unshift(t.renderDropdown()), u;
    })), f(m(t), "onChange", (function(s) {
      t.toggleDropdown(), s !== t.props.year && t.props.onChange(s);
    })), f(m(t), "toggleDropdown", (function(s) {
      t.setState({ dropdownVisible: !t.state.dropdownVisible }, (function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, s);
      }));
    })), f(m(t), "handleYearChange", (function(s, u) {
      t.onSelect(s, u), t.setOpen();
    })), f(m(t), "onSelect", (function(s, u) {
      t.props.onSelect && t.props.onSelect(s, u);
    })), f(m(t), "setOpen", (function() {
      t.props.setOpen && t.props.setOpen(!0);
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return C.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})(), Rh = qt((function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "isSelectedMonth", (function(s) {
      return t.props.month === s;
    })), f(m(t), "renderOptions", (function() {
      return t.props.monthNames.map((function(s, u) {
        return C.createElement("div", { className: t.isSelectedMonth(u) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: t.onChange.bind(m(t), u), "aria-selected": t.isSelectedMonth(u) ? "true" : void 0 }, t.isSelectedMonth(u) ? C.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      }));
    })), f(m(t), "onChange", (function(s) {
      return t.props.onChange(s);
    })), f(m(t), "handleClickOutside", (function() {
      return t.props.onCancel();
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    return C.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
})()), _h = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), f(m(t), "renderSelectOptions", (function(s) {
      return s.map((function(u, l) {
        return C.createElement("option", { key: l, value: l }, u);
      }));
    })), f(m(t), "renderSelectMode", (function(s) {
      return C.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(u) {
        return t.onChange(u.target.value);
      } }, t.renderSelectOptions(s));
    })), f(m(t), "renderReadView", (function(s, u) {
      return C.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown }, C.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), C.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, u[t.props.month]));
    })), f(m(t), "renderDropdown", (function(s) {
      return C.createElement(Rh, { key: "dropdown", month: t.props.month, monthNames: s, onChange: t.onChange, onCancel: t.toggleDropdown });
    })), f(m(t), "renderScrollMode", (function(s) {
      var u = t.state.dropdownVisible, l = [t.renderReadView(!u, s)];
      return u && l.unshift(t.renderDropdown(s)), l;
    })), f(m(t), "onChange", (function(s) {
      t.toggleDropdown(), s !== t.props.month && t.props.onChange(s);
    })), f(m(t), "toggleDropdown", (function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t, e = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return Ws(o, e.props.locale);
    } : function(o) {
      return mn(o, e.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode(i);
        break;
      case "select":
        t = this.renderSelectMode(i);
    }
    return C.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})();
function Fh(a, r) {
  for (var n = [], t = ga(a), e = ga(r); !va(t, e); ) n.push(ge(t)), t = qe(t, 1);
  return n;
}
var Kh = qt((function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "renderOptions", (function() {
      return e.state.monthYearsList.map((function(i) {
        var o = Er(i), s = ma(e.props.date, i) && ze(e.props.date, i);
        return C.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: e.onChange.bind(m(e), o), "aria-selected": s ? "true" : void 0 }, s ? C.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", Me(i, e.props.dateFormat, e.props.locale));
      }));
    })), f(m(e), "onChange", (function(i) {
      return e.props.onChange(i);
    })), f(m(e), "handleClickOutside", (function() {
      e.props.onCancel();
    })), e.state = { monthYearsList: Fh(e.props.minDate, e.props.maxDate) }, e;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t = Pe({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return C.createElement("div", { className: t }, this.renderOptions());
  } }]), n;
})()), xh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), f(m(t), "renderSelectOptions", (function() {
      for (var s = ga(t.props.minDate), u = ga(t.props.maxDate), l = []; !va(s, u); ) {
        var c = Er(s);
        l.push(C.createElement("option", { key: c, value: c }, Me(s, t.props.dateFormat, t.props.locale))), s = qe(s, 1);
      }
      return l;
    })), f(m(t), "onSelectChange", (function(s) {
      t.onChange(s.target.value);
    })), f(m(t), "renderSelectMode", (function() {
      return C.createElement("select", { value: Er(ga(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    })), f(m(t), "renderReadView", (function(s) {
      var u = Me(t.props.date, t.props.dateFormat, t.props.locale);
      return C.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(l) {
        return t.toggleDropdown(l);
      } }, C.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), C.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, u));
    })), f(m(t), "renderDropdown", (function() {
      return C.createElement(Kh, { key: "dropdown", date: t.props.date, dateFormat: t.props.dateFormat, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown, locale: t.props.locale });
    })), f(m(t), "renderScrollMode", (function() {
      var s = t.state.dropdownVisible, u = [t.renderReadView(!s)];
      return s && u.unshift(t.renderDropdown()), u;
    })), f(m(t), "onChange", (function(s) {
      t.toggleDropdown();
      var u = ge(parseInt(s));
      ma(t.props.date, u) && ze(t.props.date, u) || t.props.onChange(u);
    })), f(m(t), "toggleDropdown", (function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return C.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})(), Hh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "dayEl", C.createRef()), f(m(t), "handleClick", (function(s) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(s);
    })), f(m(t), "handleMouseEnter", (function(s) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(s);
    })), f(m(t), "handleOnKeyDown", (function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), t.props.handleOnKeyDown(s);
    })), f(m(t), "isSameDay", (function(s) {
      return Se(t.props.day, s);
    })), f(m(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !(t.isSameDay(t.props.selected) || t.isSameWeek(t.props.selected)) && (t.isSameDay(t.props.preSelection) || t.isSameWeek(t.props.preSelection));
    })), f(m(t), "isDisabled", (function() {
      return $t(t.props.day, t.props);
    })), f(m(t), "isExcluded", (function() {
      return gn(t.props.day, t.props);
    })), f(m(t), "isStartOfWeek", (function() {
      return Se(t.props.day, oa(t.props.day, t.props.locale, t.props.calendarStartDay));
    })), f(m(t), "isSameWeek", (function(s) {
      return t.props.showWeekPicker && Se(s, oa(t.props.day, t.props.locale, t.props.calendarStartDay));
    })), f(m(t), "getHighLightedClass", (function() {
      var s = t.props, u = s.day, l = s.highlightDates;
      if (!l) return !1;
      var c = Me(u, "MM.dd.yyyy");
      return l.get(c);
    })), f(m(t), "getHolidaysClass", (function() {
      var s = t.props, u = s.day, l = s.holidays;
      if (!l) return !1;
      var c = Me(u, "MM.dd.yyyy");
      return l.has(c) ? [l.get(c).className] : void 0;
    })), f(m(t), "isInRange", (function() {
      var s = t.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && Pt(u, l, c);
    })), f(m(t), "isInSelectingRange", (function() {
      var s, u = t.props, l = u.day, c = u.selectsStart, d = u.selectsEnd, h = u.selectsRange, p = u.selectsDisabledDaysInRange, g = u.startDate, S = u.endDate, b = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return !(!(c || d || h) || !b || !p && t.isDisabled()) && (c && S && (ha(b, S) || ka(b, S)) ? Pt(l, b, S) : (d && g && (va(b, g) || ka(b, g)) || !(!h || !g || S || !va(b, g) && !ka(b, g))) && Pt(l, g, b));
    })), f(m(t), "isSelectingRangeStart", (function() {
      var s;
      if (!t.isInSelectingRange()) return !1;
      var u = t.props, l = u.day, c = u.startDate, d = u.selectsStart, h = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return Se(l, d ? h : c);
    })), f(m(t), "isSelectingRangeEnd", (function() {
      var s;
      if (!t.isInSelectingRange()) return !1;
      var u = t.props, l = u.day, c = u.endDate, d = u.selectsEnd, h = u.selectsRange, p = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return Se(l, d || h ? p : c);
    })), f(m(t), "isRangeStart", (function() {
      var s = t.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && Se(l, u);
    })), f(m(t), "isRangeEnd", (function() {
      var s = t.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && Se(c, u);
    })), f(m(t), "isWeekend", (function() {
      var s = kd(t.props.day);
      return s === 0 || s === 6;
    })), f(m(t), "isAfterMonth", (function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === Oe(t.props.day);
    })), f(m(t), "isBeforeMonth", (function() {
      return t.props.month !== void 0 && (Oe(t.props.day) + 1) % 12 === t.props.month;
    })), f(m(t), "isCurrentDay", (function() {
      return t.isSameDay(ge());
    })), f(m(t), "isSelected", (function() {
      return t.isSameDay(t.props.selected) || t.isSameWeek(t.props.selected);
    })), f(m(t), "getClassNames", (function(s) {
      var u, l = t.props.dayClassName ? t.props.dayClassName(s) : void 0;
      return Pe("react-datepicker__day", l, "react-datepicker__day--" + Me(t.props.day, "ddd", u), { "react-datepicker__day--disabled": t.isDisabled(), "react-datepicker__day--excluded": t.isExcluded(), "react-datepicker__day--selected": t.isSelected(), "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(), "react-datepicker__day--range-start": t.isRangeStart(), "react-datepicker__day--range-end": t.isRangeEnd(), "react-datepicker__day--in-range": t.isInRange(), "react-datepicker__day--in-selecting-range": t.isInSelectingRange(), "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(), "react-datepicker__day--today": t.isCurrentDay(), "react-datepicker__day--weekend": t.isWeekend(), "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth() }, t.getHighLightedClass("react-datepicker__day--highlighted"), t.getHolidaysClass());
    })), f(m(t), "getAriaLabel", (function() {
      var s = t.props, u = s.day, l = s.ariaLabelPrefixWhenEnabled, c = l === void 0 ? "Choose" : l, d = s.ariaLabelPrefixWhenDisabled, h = d === void 0 ? "Not available" : d, p = t.isDisabled() || t.isExcluded() ? h : c;
      return "".concat(p, " ").concat(Me(u, "PPPP", t.props.locale));
    })), f(m(t), "getTitle", (function() {
      var s = t.props, u = s.day, l = s.holidays, c = l === void 0 ? /* @__PURE__ */ new Map() : l, d = Me(u, "MM.dd.yyyy");
      return c.has(d) && c.get(d).holidayNames.length > 0 ? c.get(d).holidayNames.join(", ") : "";
    })), f(m(t), "getTabIndex", (function(s, u) {
      var l = s || t.props.selected, c = u || t.props.preSelection;
      return (!t.props.showWeekPicker || !t.props.showWeekNumber && t.isStartOfWeek()) && (t.isKeyboardSelected() || t.isSameDay(l) && Se(c, l)) ? 0 : -1;
    })), f(m(t), "handleFocusDay", (function() {
      var s, u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      t.getTabIndex() === 0 && !u.isInputFocused && t.isSameDay(t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), t.props.inline && !t.props.shouldFocusDayInline && (l = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (l = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (l = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (l = !1)), l && ((s = t.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    })), f(m(t), "renderDayContents", (function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Vn(t.props.day), t.props.day) : Vn(t.props.day);
    })), f(m(t), "render", (function() {
      return C.createElement("div", { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.handleMouseEnter, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() }, t.renderDayContents(), t.getTitle() !== "" && C.createElement("span", { className: "holiday-overlay" }, t.getTitle()));
    })), t;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusDay(t);
  } }]), n;
})(), Uh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "weekNumberEl", C.createRef()), f(m(t), "handleClick", (function(s) {
      t.props.onClick && t.props.onClick(s);
    })), f(m(t), "handleOnKeyDown", (function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), t.props.handleOnKeyDown(s);
    })), f(m(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !Se(t.props.date, t.props.selected) && Se(t.props.date, t.props.preSelection);
    })), f(m(t), "getTabIndex", (function() {
      return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Se(t.props.date, t.props.selected) && Se(t.props.preSelection, t.props.selected)) ? 0 : -1;
    })), f(m(t), "handleFocusWeekNumber", (function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = !1;
      t.getTabIndex() === 0 && !s.isInputFocused && Se(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (u = !0), t.props.inline && !t.props.shouldFocusDayInline && (u = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (u = !0)), u && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
    })), t;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusWeekNumber(t);
  } }, { key: "render", value: function() {
    var t = this.props, e = t.weekNumber, i = t.ariaLabelPrefix, o = i === void 0 ? "week " : i, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!t.onClick, "react-datepicker__week-number--selected": Se(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return C.createElement("div", { ref: this.weekNumberEl, className: Pe(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, e);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), n;
})(), Yh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "handleDayClick", (function(s, u) {
      t.props.onDayClick && t.props.onDayClick(s, u);
    })), f(m(t), "handleDayMouseEnter", (function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    })), f(m(t), "handleWeekClick", (function(s, u, l) {
      if (typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(s, u, l), t.props.showWeekPicker) {
        var c = oa(s, t.props.locale, t.props.calendarStartDay);
        t.handleDayClick(c, l);
      }
      t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    })), f(m(t), "formatWeekNumber", (function(s) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(s) : (function(u, l) {
        var c = wa() && Aa(wa());
        return Nd(u, c ? { locale: c } : null);
      })(s);
    })), f(m(t), "renderDays", (function() {
      var s = oa(t.props.day, t.props.locale, t.props.calendarStartDay), u = [], l = t.formatWeekNumber(s);
      if (t.props.showWeekNumber) {
        var c = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(m(t), s, l) : void 0;
        u.push(C.createElement(Uh, { key: "W", weekNumber: l, date: s, onClick: c, selected: t.props.selected, preSelection: t.props.preSelection, ariaLabelPrefix: t.props.ariaLabelPrefix, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef }));
      }
      return u.concat([0, 1, 2, 3, 4, 5, 6].map((function(d) {
        var h = $a(s, d);
        return C.createElement(Hh, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: h.valueOf(), day: h, month: t.props.month, onClick: t.handleDayClick.bind(m(t), h), onMouseEnter: t.handleDayMouseEnter.bind(m(t), h), minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, renderDayContents: t.props.renderDayContents, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart, locale: t.props.locale });
      })));
    })), f(m(t), "startOfWeek", (function() {
      return oa(t.props.day, t.props.locale, t.props.calendarStartDay);
    })), f(m(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !Se(t.startOfWeek(), t.props.selected) && Se(t.startOfWeek(), t.props.preSelection);
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t = { "react-datepicker__week": !0, "react-datepicker__week--selected": Se(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return C.createElement("div", { className: Pe(t) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
})(), Js = "two_columns", Qs = "three_columns", qs = "four_columns", Mr = f(f(f({}, Js, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), Qs, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), qs, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function Ni(a, r) {
  return a ? qs : r ? Js : Qs;
}
var Wh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "MONTH_REFS", bt(Array(12)).map((function() {
      return C.createRef();
    }))), f(m(t), "QUARTER_REFS", bt(Array(4)).map((function() {
      return C.createRef();
    }))), f(m(t), "isDisabled", (function(s) {
      return $t(s, t.props);
    })), f(m(t), "isExcluded", (function(s) {
      return gn(s, t.props);
    })), f(m(t), "handleDayClick", (function(s, u) {
      t.props.onDayClick && t.props.onDayClick(s, u, t.props.orderInDisplay);
    })), f(m(t), "handleDayMouseEnter", (function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    })), f(m(t), "handleMouseLeave", (function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    })), f(m(t), "isRangeStartMonth", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate;
      return !(!c || !d) && ze(_e(l, s), c);
    })), f(m(t), "isRangeStartQuarter", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate;
      return !(!c || !d) && jt(Ra(l, s), c);
    })), f(m(t), "isRangeEndMonth", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate;
      return !(!c || !d) && ze(_e(l, s), d);
    })), f(m(t), "isRangeEndQuarter", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate;
      return !(!c || !d) && jt(Ra(l, s), d);
    })), f(m(t), "isInSelectingRangeMonth", (function(s) {
      var u, l = t.props, c = l.day, d = l.selectsStart, h = l.selectsEnd, p = l.selectsRange, g = l.startDate, S = l.endDate, b = (u = t.props.selectingDate) !== null && u !== void 0 ? u : t.props.preSelection;
      return !(!(d || h || p) || !b) && (d && S ? vr(b, S, s, c) : (h && g || !(!p || !g || S)) && vr(g, b, s, c));
    })), f(m(t), "isSelectingMonthRangeStart", (function(s) {
      var u;
      if (!t.isInSelectingRangeMonth(s)) return !1;
      var l = t.props, c = l.day, d = l.startDate, h = l.selectsStart, p = _e(c, s), g = (u = t.props.selectingDate) !== null && u !== void 0 ? u : t.props.preSelection;
      return ze(p, h ? g : d);
    })), f(m(t), "isSelectingMonthRangeEnd", (function(s) {
      var u;
      if (!t.isInSelectingRangeMonth(s)) return !1;
      var l = t.props, c = l.day, d = l.endDate, h = l.selectsEnd, p = l.selectsRange, g = _e(c, s), S = (u = t.props.selectingDate) !== null && u !== void 0 ? u : t.props.preSelection;
      return ze(g, h || p ? S : d);
    })), f(m(t), "isInSelectingRangeQuarter", (function(s) {
      var u, l = t.props, c = l.day, d = l.selectsStart, h = l.selectsEnd, p = l.selectsRange, g = l.startDate, S = l.endDate, b = (u = t.props.selectingDate) !== null && u !== void 0 ? u : t.props.preSelection;
      return !(!(d || h || p) || !b) && (d && S ? br(b, S, s, c) : (h && g || !(!p || !g || S)) && br(g, b, s, c));
    })), f(m(t), "isWeekInMonth", (function(s) {
      var u = t.props.day, l = $a(s, 6);
      return ze(s, u) || ze(l, u);
    })), f(m(t), "isCurrentMonth", (function(s, u) {
      return $(s) === $(ge()) && u === Oe(ge());
    })), f(m(t), "isCurrentQuarter", (function(s, u) {
      return $(s) === $(ge()) && u === _a(ge());
    })), f(m(t), "isSelectedMonth", (function(s, u, l) {
      return Oe(l) === u && $(s) === $(l);
    })), f(m(t), "isSelectedQuarter", (function(s, u, l) {
      return _a(s) === u && $(s) === $(l);
    })), f(m(t), "renderWeeks", (function() {
      for (var s = [], u = t.props.fixedHeight, l = 0, c = !1, d = oa(ga(t.props.day), t.props.locale, t.props.calendarStartDay); s.push(C.createElement(Yh, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, key: l, day: d, month: Oe(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, onWeekSelect: t.props.onWeekSelect, formatWeekNumber: t.props.formatWeekNumber, locale: t.props.locale, minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, showWeekNumber: t.props.showWeekNumbers, showWeekPicker: t.props.showWeekPicker, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, setOpen: t.props.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, renderDayContents: t.props.renderDayContents, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, calendarStartDay: t.props.calendarStartDay, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart })), !c; ) {
        l++, d = _t(d, 1);
        var h = u && l >= 6, p = !u && !t.isWeekInMonth(d);
        if (h || p) {
          if (!t.props.peekNextMonth) break;
          c = !0;
        }
      }
      return s;
    })), f(m(t), "onMonthClick", (function(s, u) {
      t.handleDayClick(ga(_e(t.props.day, u)), s);
    })), f(m(t), "onMonthMouseEnter", (function(s) {
      t.handleDayMouseEnter(ga(_e(t.props.day, s)));
    })), f(m(t), "handleMonthNavigation", (function(s, u) {
      t.isDisabled(u) || t.isExcluded(u) || (t.props.setPreSelection(u), t.MONTH_REFS[s].current && t.MONTH_REFS[s].current.focus());
    })), f(m(t), "onMonthKeyDown", (function(s, u) {
      var l = t.props, c = l.selected, d = l.preSelection, h = l.disabledKeyboardNavigation, p = l.showTwoColumnMonthYearPicker, g = l.showFourColumnMonthYearPicker, S = l.setPreSelection, b = s.key;
      if (b !== "Tab" && s.preventDefault(), !h) {
        var w = Ni(g, p), T = Mr[w].verticalNavigationOffset, k = Mr[w].grid;
        switch (b) {
          case "Enter":
            t.onMonthClick(s, u), S(c);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(u === 11 ? 0 : u + 1, qe(d, 1));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(u === 0 ? 11 : u - 1, Va(d, 1));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(k[0].includes(u) ? u + 12 - T : u - T, Va(d, T));
            break;
          case "ArrowDown":
            t.handleMonthNavigation(k[k.length - 1].includes(u) ? u - 12 + T : u + T, qe(d, T));
        }
      }
    })), f(m(t), "onQuarterClick", (function(s, u) {
      t.handleDayClick(mi(Ra(t.props.day, u)), s);
    })), f(m(t), "onQuarterMouseEnter", (function(s) {
      t.handleDayMouseEnter(mi(Ra(t.props.day, s)));
    })), f(m(t), "handleQuarterNavigation", (function(s, u) {
      t.isDisabled(u) || t.isExcluded(u) || (t.props.setPreSelection(u), t.QUARTER_REFS[s - 1].current && t.QUARTER_REFS[s - 1].current.focus());
    })), f(m(t), "onQuarterKeyDown", (function(s, u) {
      var l = s.key;
      if (!t.props.disabledKeyboardNavigation) switch (l) {
        case "Enter":
          t.onQuarterClick(s, u), t.props.setPreSelection(t.props.selected);
          break;
        case "ArrowRight":
          t.handleQuarterNavigation(u === 4 ? 1 : u + 1, Ms(t.props.preSelection, 1));
          break;
        case "ArrowLeft":
          t.handleQuarterNavigation(u === 1 ? 4 : u - 1, Cd(t.props.preSelection, 1));
      }
    })), f(m(t), "getMonthClassNames", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate, h = u.selected, p = u.minDate, g = u.maxDate, S = u.preSelection, b = u.monthClassName, w = u.excludeDates, T = u.includeDates, k = b ? b(_e(l, s)) : void 0, N = _e(l, s);
      return Pe("react-datepicker__month-text", "react-datepicker__month-".concat(s), k, { "react-datepicker__month-text--disabled": (p || g || w || T) && Vs(N, t.props), "react-datepicker__month-text--selected": t.isSelectedMonth(l, s, h), "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && Oe(S) === s, "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": vr(c, d, s, l), "react-datepicker__month-text--range-start": t.isRangeStartMonth(s), "react-datepicker__month-text--range-end": t.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": t.isCurrentMonth(l, s) });
    })), f(m(t), "getTabIndex", (function(s) {
      var u = Oe(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== u ? "-1" : "0";
    })), f(m(t), "getQuarterTabIndex", (function(s) {
      var u = _a(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== u ? "-1" : "0";
    })), f(m(t), "getAriaLabel", (function(s) {
      var u = t.props, l = u.chooseDayAriaLabelPrefix, c = l === void 0 ? "Choose" : l, d = u.disabledDayAriaLabelPrefix, h = d === void 0 ? "Not available" : d, p = u.day, g = _e(p, s), S = t.isDisabled(g) || t.isExcluded(g) ? h : c;
      return "".concat(S, " ").concat(Me(g, "MMMM yyyy"));
    })), f(m(t), "getQuarterClassNames", (function(s) {
      var u = t.props, l = u.day, c = u.startDate, d = u.endDate, h = u.selected, p = u.minDate, g = u.maxDate, S = u.preSelection, b = u.disabledKeyboardNavigation;
      return Pe("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (p || g) && Eh(Ra(l, s), t.props), "react-datepicker__quarter-text--selected": t.isSelectedQuarter(l, s, h), "react-datepicker__quarter-text--keyboard-selected": !b && _a(S) === s, "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": br(c, d, s, l), "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(s) });
    })), f(m(t), "getMonthContent", (function(s) {
      var u = t.props, l = u.showFullMonthYearPicker, c = u.renderMonthContent, d = u.locale, h = u.day, p = Ws(s, d), g = mn(s, d);
      return c ? c(s, p, g, h) : l ? g : p;
    })), f(m(t), "getQuarterContent", (function(s) {
      var u = t.props, l = u.renderQuarterContent, c = (function(d, h) {
        return Me(Ra(ge(), d), "QQQ", h);
      })(s, u.locale);
      return l ? l(s, c) : c;
    })), f(m(t), "renderMonths", (function() {
      var s = t.props, u = s.showTwoColumnMonthYearPicker, l = s.showFourColumnMonthYearPicker, c = s.day, d = s.selected;
      return Mr[Ni(l, u)].grid.map((function(h, p) {
        return C.createElement("div", { className: "react-datepicker__month-wrapper", key: p }, h.map((function(g, S) {
          return C.createElement("div", { ref: t.MONTH_REFS[g], key: S, onClick: function(b) {
            t.onMonthClick(b, g);
          }, onKeyDown: function(b) {
            t.onMonthKeyDown(b, g);
          }, onMouseEnter: function() {
            return t.onMonthMouseEnter(g);
          }, tabIndex: t.getTabIndex(g), className: t.getMonthClassNames(g), role: "option", "aria-label": t.getAriaLabel(g), "aria-current": t.isCurrentMonth(c, g) ? "date" : void 0, "aria-selected": t.isSelectedMonth(c, g, d) }, t.getMonthContent(g));
        })));
      }));
    })), f(m(t), "renderQuarters", (function() {
      var s = t.props, u = s.day, l = s.selected;
      return C.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map((function(c, d) {
        return C.createElement("div", { key: d, ref: t.QUARTER_REFS[d], role: "option", onClick: function(h) {
          t.onQuarterClick(h, c);
        }, onKeyDown: function(h) {
          t.onQuarterKeyDown(h, c);
        }, onMouseEnter: function() {
          return t.onQuarterMouseEnter(c);
        }, className: t.getQuarterClassNames(c), "aria-selected": t.isSelectedQuarter(u, c, l), tabIndex: t.getQuarterTabIndex(c), "aria-current": t.isCurrentQuarter(u, c) ? "date" : void 0 }, t.getQuarterContent(c));
      })));
    })), f(m(t), "getClassNames", (function() {
      var s = t.props, u = s.selectingDate, l = s.selectsStart, c = s.selectsEnd, d = s.showMonthYearPicker, h = s.showQuarterYearPicker, p = s.showWeekPicker;
      return Pe("react-datepicker__month", { "react-datepicker__month--selecting-range": u && (l || c) }, { "react-datepicker__monthPicker": d }, { "react-datepicker__quarterPicker": h }, { "react-datepicker__weekPicker": p });
    })), t;
  }
  return Ie(n, [{ key: "render", value: function() {
    var t = this.props, e = t.showMonthYearPicker, i = t.showQuarterYearPicker, o = t.day, s = t.ariaLabelPrefix, u = s === void 0 ? "month " : s;
    return C.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(u, " ").concat(Me(o, "yyyy-MM")), role: "listbox" }, e ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
})(), Xs = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    var t;
    De(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return f(m(t = r.call.apply(r, [this].concat(i))), "state", { height: null }), f(m(t), "scrollToTheSelectedTime", (function() {
      requestAnimationFrame((function() {
        t.list && (t.list.scrollTop = t.centerLi && n.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - t.header.clientHeight : t.list.clientHeight, t.centerLi));
      }));
    })), f(m(t), "handleClick", (function(s) {
      (t.props.minTime || t.props.maxTime) && bi(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Si(s, t.props) || t.props.onChange(s);
    })), f(m(t), "isSelectedTime", (function(s) {
      return t.props.selected && (u = t.props.selected, l = s, Ai(u).getTime() === Ai(l).getTime());
      var u, l;
    })), f(m(t), "isDisabledTime", (function(s) {
      return (t.props.minTime || t.props.maxTime) && bi(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Si(s, t.props);
    })), f(m(t), "liClasses", (function(s) {
      var u = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(s) : void 0];
      return t.isSelectedTime(s) && u.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(s) && u.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (60 * ra(s) + ta(s)) % t.props.intervals != 0 && u.push("react-datepicker__time-list-item--injected"), u.join(" ");
    })), f(m(t), "handleOnKeyDown", (function(s, u) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && t.handleClick(u), t.props.handleOnKeyDown(s);
    })), f(m(t), "renderTimes", (function() {
      for (var s = [], u = t.props.format ? t.props.format : "p", l = t.props.intervals, c = t.props.selected || t.props.openToDate || ge(), d = na(c), h = t.props.injectTimes && t.props.injectTimes.sort((function(k, N) {
        return k - N;
      })), p = 60 * (function(k) {
        var N = new Date(k.getFullYear(), k.getMonth(), k.getDate()), M = new Date(k.getFullYear(), k.getMonth(), k.getDate(), 24);
        return Math.round((+M - +N) / 36e5);
      })(c), g = p / l, S = 0; S < g; S++) {
        var b = Ir(d, S * l);
        if (s.push(b), h) {
          var w = Ph(d, b, S, l, h);
          s = s.concat(w);
        }
      }
      var T = s.reduce((function(k, N) {
        return N.getTime() <= c.getTime() ? N : k;
      }), s[0]);
      return s.map((function(k, N) {
        return C.createElement("li", { key: N, onClick: t.handleClick.bind(m(t), k), className: t.liClasses(k), ref: function(M) {
          k === T && (t.centerLi = M);
        }, onKeyDown: function(M) {
          t.handleOnKeyDown(M, k);
        }, tabIndex: k === T ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(k) ? "true" : void 0, "aria-disabled": t.isDisabledTime(k) ? "true" : void 0 }, Me(k, u, t.props.locale));
      }));
    })), t;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t = this, e = this.state.height;
    return C.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, C.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      t.header = i;
    } }, C.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), C.createElement("div", { className: "react-datepicker__time" }, C.createElement("div", { className: "react-datepicker__time-box" }, C.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      t.list = i;
    }, style: e ? { height: e } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
})();
f(Xs, "calcCenterPosition", (function(a, r) {
  return r.offsetTop - (a / 2 - r.clientHeight / 2);
}));
var Vh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "YEAR_REFS", bt(Array(e.props.yearItemNumber)).map((function() {
      return C.createRef();
    }))), f(m(e), "isDisabled", (function(i) {
      return $t(i, e.props);
    })), f(m(e), "isExcluded", (function(i) {
      return gn(i, e.props);
    })), f(m(e), "selectingDate", (function() {
      var i;
      return (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
    })), f(m(e), "updateFocusOnPaginate", (function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(m(e));
      window.requestAnimationFrame(o);
    })), f(m(e), "handleYearClick", (function(i, o) {
      e.props.onDayClick && e.props.onDayClick(i, o);
    })), f(m(e), "handleYearNavigation", (function(i, o) {
      var s = e.props, u = s.date, l = s.yearItemNumber, c = Fa(u, l).startPeriod;
      e.isDisabled(o) || e.isExcluded(o) || (e.props.setPreSelection(o), i - c == -1 ? e.updateFocusOnPaginate(l - 1) : i - c === l ? e.updateFocusOnPaginate(0) : e.YEAR_REFS[i - c].current.focus());
    })), f(m(e), "isSameDay", (function(i, o) {
      return Se(i, o);
    })), f(m(e), "isCurrentYear", (function(i) {
      return i === $(ge());
    })), f(m(e), "isRangeStart", (function(i) {
      return e.props.startDate && e.props.endDate && ma(ca(ge(), i), e.props.startDate);
    })), f(m(e), "isRangeEnd", (function(i) {
      return e.props.startDate && e.props.endDate && ma(ca(ge(), i), e.props.endDate);
    })), f(m(e), "isInRange", (function(i) {
      return Sr(i, e.props.startDate, e.props.endDate);
    })), f(m(e), "isInSelectingRange", (function(i) {
      var o = e.props, s = o.selectsStart, u = o.selectsEnd, l = o.selectsRange, c = o.startDate, d = o.endDate;
      return !(!(s || u || l) || !e.selectingDate()) && (s && d ? Sr(i, e.selectingDate(), d) : (u && c || !(!l || !c || d)) && Sr(i, c, e.selectingDate()));
    })), f(m(e), "isSelectingRangeStart", (function(i) {
      if (!e.isInSelectingRange(i)) return !1;
      var o = e.props, s = o.startDate, u = o.selectsStart, l = ca(ge(), i);
      return ma(l, u ? e.selectingDate() : s);
    })), f(m(e), "isSelectingRangeEnd", (function(i) {
      if (!e.isInSelectingRange(i)) return !1;
      var o = e.props, s = o.endDate, u = o.selectsEnd, l = o.selectsRange, c = ca(ge(), i);
      return ma(c, u || l ? e.selectingDate() : s);
    })), f(m(e), "isKeyboardSelected", (function(i) {
      var o = st(ca(e.props.date, i));
      return !e.props.disabledKeyboardNavigation && !e.props.inline && !Se(o, st(e.props.selected)) && Se(o, st(e.props.preSelection));
    })), f(m(e), "onYearClick", (function(i, o) {
      var s = e.props.date;
      e.handleYearClick(st(ca(s, o)), i);
    })), f(m(e), "onYearKeyDown", (function(i, o) {
      var s = i.key;
      if (!e.props.disabledKeyboardNavigation) switch (s) {
        case "Enter":
          e.onYearClick(i, o), e.props.setPreSelection(e.props.selected);
          break;
        case "ArrowRight":
          e.handleYearNavigation(o + 1, Wa(e.props.preSelection, 1));
          break;
        case "ArrowLeft":
          e.handleYearNavigation(o - 1, ht(e.props.preSelection, 1));
      }
    })), f(m(e), "getYearClassNames", (function(i) {
      var o = e.props, s = o.minDate, u = o.maxDate, l = o.selected, c = o.excludeDates, d = o.includeDates, h = o.filterDate;
      return Pe("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === $(l), "react-datepicker__year-text--disabled": (s || u || c || d || h) && js(i, e.props), "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(i), "react-datepicker__year-text--range-start": e.isRangeStart(i), "react-datepicker__year-text--range-end": e.isRangeEnd(i), "react-datepicker__year-text--in-range": e.isInRange(i), "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(i), "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(i), "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(i), "react-datepicker__year-text--today": e.isCurrentYear(i) });
    })), f(m(e), "getYearTabIndex", (function(i) {
      return e.props.disabledKeyboardNavigation ? "-1" : i === $(e.props.preSelection) ? "0" : "-1";
    })), f(m(e), "getYearContainerClassNames", (function() {
      var i = e.props, o = i.selectingDate, s = i.selectsStart, u = i.selectsEnd, l = i.selectsRange;
      return Pe("react-datepicker__year", { "react-datepicker__year--selecting-range": o && (s || u || l) });
    })), f(m(e), "getYearContent", (function(i) {
      return e.props.renderYearContent ? e.props.renderYearContent(i) : i;
    })), e;
  }
  return Ie(n, [{ key: "render", value: function() {
    for (var t = this, e = [], i = this.props, o = i.date, s = i.yearItemNumber, u = i.onYearMouseEnter, l = i.onYearMouseLeave, c = Fa(o, s), d = c.startPeriod, h = c.endPeriod, p = function(S) {
      e.push(C.createElement("div", { ref: t.YEAR_REFS[S - d], onClick: function(b) {
        t.onYearClick(b, S);
      }, onKeyDown: function(b) {
        t.onYearKeyDown(b, S);
      }, tabIndex: t.getYearTabIndex(S), className: t.getYearClassNames(S), onMouseEnter: function(b) {
        return u(b, S);
      }, onMouseLeave: function(b) {
        return l(b, S);
      }, key: S, "aria-current": t.isCurrentYear(S) ? "date" : void 0 }, t.getYearContent(S)));
    }, g = d; g <= h; g++) p(g);
    return C.createElement("div", { className: this.getYearContainerClassNames() }, C.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, e));
  } }]), n;
})(), jh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "onTimeChange", (function(i) {
      e.setState({ time: i });
      var o = e.props.date, s = o instanceof Date && !isNaN(o) ? o : /* @__PURE__ */ new Date();
      s.setHours(i.split(":")[0]), s.setMinutes(i.split(":")[1]), e.props.onChange(s);
    })), f(m(e), "renderTimeInput", (function() {
      var i = e.state.time, o = e.props, s = o.date, u = o.timeString, l = o.customTimeInput;
      return l ? C.cloneElement(l, { date: s, value: i, onChange: e.onTimeChange }) : C.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(c) {
        e.onTimeChange(c.target.value || u);
      } });
    })), e.state = { time: e.props.timeString }, e;
  }
  return Ie(n, [{ key: "render", value: function() {
    return C.createElement("div", { className: "react-datepicker__input-time-container" }, C.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), C.createElement("div", { className: "react-datepicker-time__input-container" }, C.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(t, e) {
    return t.timeString !== e.time ? { time: t.timeString } : null;
  } }]), n;
})();
function Zh(a) {
  var r = a.className, n = a.children, t = a.showPopperArrow, e = a.arrowProps, i = e === void 0 ? {} : e;
  return C.createElement("div", { className: r }, t && C.createElement("div", Qa({ className: "react-datepicker__triangle" }, i)), n);
}
var zh = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Jh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "handleClickOutside", (function(i) {
      e.props.onClickOutside(i);
    })), f(m(e), "setClickOutsideRef", (function() {
      return e.containerRef.current;
    })), f(m(e), "handleDropdownFocus", (function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return zh.some((function(s) {
          return o.indexOf(s) >= 0;
        }));
      })(i.target) && e.props.onDropdownFocus();
    })), f(m(e), "getDateInView", (function() {
      var i = e.props, o = i.preSelection, s = i.selected, u = i.openToDate, l = Zs(e.props), c = zs(e.props), d = ge(), h = u || s || o;
      return h || (l && ha(d, l) ? l : c && va(d, c) ? c : d);
    })), f(m(e), "increaseMonth", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: qe(o, 1) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), f(m(e), "decreaseMonth", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: Va(o, 1) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), f(m(e), "handleDayClick", (function(i, o, s) {
      e.props.onSelect(i, o, s), e.props.setPreSelection && e.props.setPreSelection(i);
    })), f(m(e), "handleDayMouseEnter", (function(i) {
      e.setState({ selectingDate: i }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(i);
    })), f(m(e), "handleMonthMouseLeave", (function() {
      e.setState({ selectingDate: null }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
    })), f(m(e), "handleYearMouseEnter", (function(i, o) {
      e.setState({ selectingDate: ca(ge(), o) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(i, o);
    })), f(m(e), "handleYearMouseLeave", (function(i, o) {
      e.props.onYearMouseLeave && e.props.onYearMouseLeave(i, o);
    })), f(m(e), "handleYearChange", (function(i) {
      e.props.onYearChange && (e.props.onYearChange(i), e.setState({ isRenderAriaLiveMessage: !0 })), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(i), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(i);
    })), f(m(e), "handleMonthChange", (function(i) {
      e.handleCustomMonthChange(i), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(i), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(i);
    })), f(m(e), "handleCustomMonthChange", (function(i) {
      e.props.onMonthChange && (e.props.onMonthChange(i), e.setState({ isRenderAriaLiveMessage: !0 }));
    })), f(m(e), "handleMonthYearChange", (function(i) {
      e.handleYearChange(i), e.handleMonthChange(i);
    })), f(m(e), "changeYear", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: ca(s, i) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), f(m(e), "changeMonth", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: _e(s, i) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), f(m(e), "changeMonthYear", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: ca(_e(s, Oe(i)), $(i)) };
      }), (function() {
        return e.handleMonthYearChange(e.state.date);
      }));
    })), f(m(e), "header", (function() {
      var i = oa(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.state.date, e.props.locale, e.props.calendarStartDay), o = [];
      return e.props.showWeekNumbers && o.push(C.createElement("div", { key: "W", className: "react-datepicker__day-name" }, e.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map((function(s) {
        var u = $a(i, s), l = e.formatWeekday(u, e.props.locale), c = e.props.weekDayClassName ? e.props.weekDayClassName(u) : void 0;
        return C.createElement("div", { key: s, className: Pe("react-datepicker__day-name", c) }, l);
      })));
    })), f(m(e), "formatWeekday", (function(i, o) {
      return e.props.formatWeekDay ? (function(s, u, l) {
        return u(Me(s, "EEEE", l));
      })(i, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? (function(s, u) {
        return Me(s, "EEE", u);
      })(i, o) : (function(s, u) {
        return Me(s, "EEEEEE", u);
      })(i, o);
    })), f(m(e), "decreaseYear", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: ht(o, e.props.showYearPicker ? e.props.yearItemNumber : 1) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), f(m(e), "clearSelectingDate", (function() {
      e.setState({ selectingDate: null });
    })), f(m(e), "renderPreviousButton", (function() {
      if (!e.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case e.props.showMonthYearPicker:
            i = Ci(e.state.date, e.props);
            break;
          case e.props.showYearPicker:
            i = (function(w) {
              var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = T.minDate, N = T.yearItemNumber, M = N === void 0 ? dt : N, y = Fa(st(ht(w, M)), M).endPeriod, D = k && $(k);
              return D && D > y || !1;
            })(e.state.date, e.props);
            break;
          default:
            i = Mi(e.state.date, e.props);
        }
        if ((e.props.forceShowMonthNavigation || e.props.showDisabledMonthNavigation || !i) && !e.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = e.decreaseMonth;
          (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (s = e.decreaseYear), i && e.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), s = null);
          var u = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, l = e.props, c = l.previousMonthButtonLabel, d = l.previousYearButtonLabel, h = e.props, p = h.previousMonthAriaLabel, g = p === void 0 ? typeof c == "string" ? c : "Previous Month" : p, S = h.previousYearAriaLabel, b = S === void 0 ? typeof d == "string" ? d : "Previous Year" : S;
          return C.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: e.props.handleOnKeyDown, "aria-label": u ? b : g }, C.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, u ? e.props.previousYearButtonLabel : e.props.previousMonthButtonLabel));
        }
      }
    })), f(m(e), "increaseYear", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: Wa(o, e.props.showYearPicker ? e.props.yearItemNumber : 1) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), f(m(e), "renderNextButton", (function() {
      if (!e.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case e.props.showMonthYearPicker:
            i = ki(e.state.date, e.props);
            break;
          case e.props.showYearPicker:
            i = (function(w) {
              var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = T.maxDate, N = T.yearItemNumber, M = N === void 0 ? dt : N, y = Fa(Wa(w, M), M).startPeriod, D = k && $(k);
              return D && D < y || !1;
            })(e.state.date, e.props);
            break;
          default:
            i = yi(e.state.date, e.props);
        }
        if ((e.props.forceShowMonthNavigation || e.props.showDisabledMonthNavigation || !i) && !e.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          e.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var s = e.increaseMonth;
          (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (s = e.increaseYear), i && e.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), s = null);
          var u = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, l = e.props, c = l.nextMonthButtonLabel, d = l.nextYearButtonLabel, h = e.props, p = h.nextMonthAriaLabel, g = p === void 0 ? typeof c == "string" ? c : "Next Month" : p, S = h.nextYearAriaLabel, b = S === void 0 ? typeof d == "string" ? d : "Next Year" : S;
          return C.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: e.props.handleOnKeyDown, "aria-label": u ? b : g }, C.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, u ? e.props.nextYearButtonLabel : e.props.nextMonthButtonLabel));
        }
      }
    })), f(m(e), "renderCurrentMonth", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.state.date, o = ["react-datepicker__current-month"];
      return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), C.createElement("div", { className: o.join(" ") }, Me(i, e.props.dateFormat, e.props.locale));
    })), f(m(e), "renderYearDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showYearDropdown && !i) return C.createElement(Lh, { adjustDateOnChange: e.props.adjustDateOnChange, date: e.state.date, onSelect: e.props.onSelect, setOpen: e.props.setOpen, dropdownMode: e.props.dropdownMode, onChange: e.changeYear, minDate: e.props.minDate, maxDate: e.props.maxDate, year: $(e.state.date), scrollableYearDropdown: e.props.scrollableYearDropdown, yearDropdownItemNumber: e.props.yearDropdownItemNumber });
    })), f(m(e), "renderMonthDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showMonthDropdown && !i) return C.createElement(_h, { dropdownMode: e.props.dropdownMode, locale: e.props.locale, onChange: e.changeMonth, month: Oe(e.state.date), useShortMonthInDropdown: e.props.useShortMonthInDropdown });
    })), f(m(e), "renderMonthYearDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showMonthYearDropdown && !i) return C.createElement(xh, { dropdownMode: e.props.dropdownMode, locale: e.props.locale, dateFormat: e.props.dateFormat, onChange: e.changeMonthYear, minDate: e.props.minDate, maxDate: e.props.maxDate, date: e.state.date, scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown });
    })), f(m(e), "handleTodayButtonClick", (function(i) {
      e.props.onSelect(gi(), i), e.props.setPreSelection && e.props.setPreSelection(gi());
    })), f(m(e), "renderTodayButton", (function() {
      if (e.props.todayButton && !e.props.showTimeSelectOnly) return C.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
        return e.handleTodayButtonClick(i);
      } }, e.props.todayButton);
    })), f(m(e), "renderDefaultHeader", (function(i) {
      var o = i.monthDate, s = i.i;
      return C.createElement("div", { className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, e.renderCurrentMonth(o), C.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus }, e.renderMonthDropdown(s !== 0), e.renderMonthYearDropdown(s !== 0), e.renderYearDropdown(s !== 0)), C.createElement("div", { className: "react-datepicker__day-names" }, e.header(o)));
    })), f(m(e), "renderCustomHeader", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, s = i.i;
      if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly) return null;
      var u = Mi(e.state.date, e.props), l = yi(e.state.date, e.props), c = Ci(e.state.date, e.props), d = ki(e.state.date, e.props), h = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
      return C.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus }, e.props.renderCustomHeader(Wt(Wt({}, e.state), {}, { customHeaderCount: s, monthDate: o, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: l, prevYearButtonDisabled: c, nextYearButtonDisabled: d })), h && C.createElement("div", { className: "react-datepicker__day-names" }, e.header(o)));
    })), f(m(e), "renderYearHeader", (function() {
      var i = e.state.date, o = e.props, s = o.showYearPicker, u = Fa(i, o.yearItemNumber), l = u.startPeriod, c = u.endPeriod;
      return C.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(l, " - ").concat(c) : $(i));
    })), f(m(e), "renderHeader", (function(i) {
      switch (!0) {
        case e.props.renderCustomHeader !== void 0:
          return e.renderCustomHeader(i);
        case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
          return e.renderYearHeader(i);
        default:
          return e.renderDefaultHeader(i);
      }
    })), f(m(e), "renderMonths", (function() {
      var i;
      if (!e.props.showTimeSelectOnly && !e.props.showYearPicker) {
        for (var o = [], s = e.props.showPreviousMonths ? e.props.monthsShown - 1 : 0, u = Va(e.state.date, s), l = (i = e.props.monthSelectedIn) !== null && i !== void 0 ? i : s, c = 0; c < e.props.monthsShown; ++c) {
          var d = qe(u, c - l + s), h = "month-".concat(c), p = c < e.props.monthsShown - 1, g = c > 0;
          o.push(C.createElement("div", { key: h, ref: function(S) {
            e.monthContainer = S;
          }, className: "react-datepicker__month-container" }, e.renderHeader({ monthDate: d, i: c }), C.createElement(Wh, { chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: e.props.weekAriaLabelPrefix, ariaLabelPrefix: e.props.monthAriaLabelPrefix, onChange: e.changeMonthYear, day: d, dayClassName: e.props.dayClassName, calendarStartDay: e.props.calendarStartDay, monthClassName: e.props.monthClassName, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, onWeekSelect: e.props.onWeekSelect, orderInDisplay: c, formatWeekNumber: e.props.formatWeekNumber, locale: e.props.locale, minDate: e.props.minDate, maxDate: e.props.maxDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, highlightDates: e.props.highlightDates, holidays: e.props.holidays, selectingDate: e.state.selectingDate, includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, inline: e.props.inline, shouldFocusDayInline: e.props.shouldFocusDayInline, fixedHeight: e.props.fixedHeight, filterDate: e.props.filterDate, preSelection: e.props.preSelection, setPreSelection: e.props.setPreSelection, selected: e.props.selected, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, showWeekNumbers: e.props.showWeekNumbers, startDate: e.props.startDate, endDate: e.props.endDate, peekNextMonth: e.props.peekNextMonth, setOpen: e.props.setOpen, shouldCloseOnSelect: e.props.shouldCloseOnSelect, renderDayContents: e.props.renderDayContents, renderMonthContent: e.props.renderMonthContent, renderQuarterContent: e.props.renderQuarterContent, renderYearContent: e.props.renderYearContent, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, showMonthYearPicker: e.props.showMonthYearPicker, showFullMonthYearPicker: e.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: e.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: e.props.showFourColumnMonthYearPicker, showYearPicker: e.props.showYearPicker, showQuarterYearPicker: e.props.showQuarterYearPicker, showWeekPicker: e.props.showWeekPicker, isInputFocused: e.props.isInputFocused, containerRef: e.containerRef, monthShowsDuplicateDaysEnd: p, monthShowsDuplicateDaysStart: g })));
        }
        return o;
      }
    })), f(m(e), "renderYears", (function() {
      if (!e.props.showTimeSelectOnly) return e.props.showYearPicker ? C.createElement("div", { className: "react-datepicker__year--container" }, e.renderHeader(), C.createElement(Vh, Qa({ onDayClick: e.handleDayClick, selectingDate: e.state.selectingDate, clearSelectingDate: e.clearSelectingDate, date: e.state.date }, e.props, { onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))) : void 0;
    })), f(m(e), "renderTimeSection", (function() {
      if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly)) return C.createElement(Xs, { selected: e.props.selected, openToDate: e.props.openToDate, onChange: e.props.onTimeChange, timeClassName: e.props.timeClassName, format: e.props.timeFormat, includeTimes: e.props.includeTimes, intervals: e.props.timeIntervals, minTime: e.props.minTime, maxTime: e.props.maxTime, excludeTimes: e.props.excludeTimes, filterTime: e.props.filterTime, timeCaption: e.props.timeCaption, todayButton: e.props.todayButton, showMonthDropdown: e.props.showMonthDropdown, showMonthYearDropdown: e.props.showMonthYearDropdown, showYearDropdown: e.props.showYearDropdown, withPortal: e.props.withPortal, monthRef: e.state.monthContainer, injectTimes: e.props.injectTimes, locale: e.props.locale, handleOnKeyDown: e.props.handleOnKeyDown, showTimeSelectOnly: e.props.showTimeSelectOnly });
    })), f(m(e), "renderInputTimeSection", (function() {
      var i = new Date(e.props.selected), o = fa(i) && e.props.selected ? "".concat(wi(i.getHours()), ":").concat(wi(i.getMinutes())) : "";
      if (e.props.showTimeInput) return C.createElement(jh, { date: i, timeString: o, timeInputLabel: e.props.timeInputLabel, onChange: e.props.onTimeChange, customTimeInput: e.props.customTimeInput });
    })), f(m(e), "renderAriaLiveRegion", (function() {
      var i, o = Fa(e.state.date, e.props.yearItemNumber), s = o.startPeriod, u = o.endPeriod;
      return i = e.props.showYearPicker ? "".concat(s, " - ").concat(u) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? $(e.state.date) : "".concat(mn(Oe(e.state.date), e.props.locale), " ").concat($(e.state.date)), C.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && i);
    })), f(m(e), "renderChildren", (function() {
      if (e.props.children) return C.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
    })), e.containerRef = C.createRef(), e.state = { date: e.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, e;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    var t = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void t.setState({ monthContainer: t.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(t) {
    var e = this;
    if (!this.props.preSelection || Se(this.props.preSelection, t.preSelection) && this.props.monthSelectedIn === t.monthSelectedIn) this.props.openToDate && !Se(this.props.openToDate, t.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var i = !ze(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, (function() {
        return i && e.handleCustomMonthChange(e.state.date);
      }));
    }
  } }, { key: "render", value: function() {
    var t = this.props.container || Zh;
    return C.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, C.createElement(t, { className: Pe("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: dt };
  } }]), n;
})(), Qh = function(a) {
  var r = a.icon, n = a.className, t = n === void 0 ? "" : n, e = a.onClick, i = "react-datepicker__calendar-icon";
  return C.isValidElement(r) ? C.cloneElement(r, { className: "".concat(r.props.className || "", " ").concat(i, " ").concat(t), onClick: function(o) {
    typeof r.props.onClick == "function" && r.props.onClick(o), typeof e == "function" && e(o);
  } }) : typeof r == "string" ? C.createElement("i", { className: "".concat(i, " ").concat(r, " ").concat(t), "aria-hidden": "true", onClick: e }) : C.createElement("svg", { className: "".concat(i, " ").concat(t), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: e }, C.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, $s = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), (e = r.call(this, t)).el = document.createElement("div"), e;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return Lu.createPortal(this.props.children, this.el);
  } }]), n;
})(), qh = function(a) {
  return !a.disabled && a.tabIndex !== -1;
}, eu = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "getTabChildren", (function() {
      return Array.prototype.slice.call(e.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(qh);
    })), f(m(e), "handleFocusStart", (function() {
      var i = e.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    })), f(m(e), "handleFocusEnd", (function() {
      var i = e.getTabChildren();
      i && i.length > 1 && i[0].focus();
    })), e.tabLoopRef = C.createRef(), e;
  }
  return Ie(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? C.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, C.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, C.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
})(), Xh = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n() {
    return De(this, n), r.apply(this, arguments);
  }
  return Ie(n, [{ key: "render", value: function() {
    var t, e = this.props, i = e.className, o = e.wrapperClassName, s = e.hidePopper, u = e.popperComponent, l = e.popperModifiers, c = e.popperPlacement, d = e.popperProps, h = e.targetComponent, p = e.enableTabLoop, g = e.popperOnKeyDown, S = e.portalId, b = e.portalHost;
    if (!s) {
      var w = Pe("react-datepicker-popper", i);
      t = C.createElement(Ch, Qa({ modifiers: l, placement: c }, d), (function(k) {
        var N = k.ref, M = k.style, y = k.placement, D = k.arrowProps;
        return C.createElement(eu, { enableTabLoop: p }, C.createElement("div", { ref: N, style: M, className: w, "data-placement": y, onKeyDown: g }, C.cloneElement(u, { arrowProps: D })));
      }));
    }
    this.props.popperContainer && (t = C.createElement(this.props.popperContainer, {}, t)), S && !s && (t = C.createElement($s, { portalId: S, portalHost: b }, t));
    var T = Pe("react-datepicker-wrapper", o);
    return C.createElement(sf, { className: "react-datepicker-manager" }, C.createElement(Ah, null, (function(k) {
      var N = k.ref;
      return C.createElement("div", { ref: N, className: T }, h);
    })), t);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
})(), Di = "react-datepicker-ignore-onclickoutside", $h = qt(Jh), yr = "Date input not valid.", ar = (function(a) {
  Ee(n, C.Component);
  var r = Be(n);
  function n(t) {
    var e;
    return De(this, n), f(m(e = r.call(this, t)), "getPreSelection", (function() {
      return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : ge();
    })), f(m(e), "modifyHolidays", (function() {
      var i;
      return (i = e.props.holidays) === null || i === void 0 ? void 0 : i.reduce((function(o, s) {
        var u = new Date(s.date);
        return ft(u) ? [].concat(bt(o), [Wt(Wt({}, s), {}, { date: u })]) : o;
      }), []);
    })), f(m(e), "calcInitialState", (function() {
      var i, o = e.getPreSelection(), s = Zs(e.props), u = zs(e.props), l = s && ha(o, na(s)) ? s : u && va(o, Pr(u)) ? u : o;
      return { open: e.props.startOpen || !1, preventFocus: !1, preSelection: (i = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && i !== void 0 ? i : l, highlightDates: Ti(e.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    })), f(m(e), "clearPreventFocusTimeout", (function() {
      e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
    })), f(m(e), "setFocus", (function() {
      e.input && e.input.focus && e.input.focus({ preventScroll: !0 });
    })), f(m(e), "setBlur", (function() {
      e.input && e.input.blur && e.input.blur(), e.cancelFocusInput();
    })), f(m(e), "setOpen", (function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      e.setState({ open: i, preSelection: i && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection, lastPreSelectChange: Cr }, (function() {
        i || e.setState((function(s) {
          return { focused: !!o && s.focused };
        }), (function() {
          !o && e.setBlur(), e.setState({ inputValue: null });
        }));
      }));
    })), f(m(e), "inputOk", (function() {
      return Qt(e.state.preSelection);
    })), f(m(e), "isCalendarOpen", (function() {
      return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
    })), f(m(e), "handleFocus", (function(i) {
      e.state.preventFocus || (e.props.onFocus(i), e.props.preventOpenOnFocus || e.props.readOnly || e.setOpen(!0)), e.setState({ focused: !0 });
    })), f(m(e), "sendFocusBackToInput", (function() {
      e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, (function() {
        e.preventFocusTimeout = setTimeout((function() {
          e.setFocus(), e.setState({ preventFocus: !1 });
        }));
      }));
    })), f(m(e), "cancelFocusInput", (function() {
      clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = null;
    })), f(m(e), "deferFocusInput", (function() {
      e.cancelFocusInput(), e.inputFocusTimeout = setTimeout((function() {
        return e.setFocus();
      }), 1);
    })), f(m(e), "handleDropdownFocus", (function() {
      e.cancelFocusInput();
    })), f(m(e), "handleBlur", (function(i) {
      (!e.state.open || e.props.withPortal || e.props.showTimeInput) && e.props.onBlur(i), e.setState({ focused: !1 });
    })), f(m(e), "handleCalendarClickOutside", (function(i) {
      e.props.inline || e.setOpen(!1), e.props.onClickOutside(i), e.props.withPortal && i.preventDefault();
    })), f(m(e), "handleChange", (function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) o[s] = arguments[s];
      var u = o[0];
      if (!e.props.onChangeRaw || (e.props.onChangeRaw.apply(m(e), o), typeof u.isDefaultPrevented == "function" && !u.isDefaultPrevented())) {
        e.setState({ inputValue: u.target.value, lastPreSelectChange: em });
        var l, c, d, h, p, g, S, b, w = (l = u.target.value, c = e.props.dateFormat, d = e.props.locale, h = e.props.strictParsing, p = e.props.minDate, g = null, S = Aa(d) || Aa(wa()), b = !0, Array.isArray(c) ? (c.forEach((function(T) {
          var k = dr(l, T, /* @__PURE__ */ new Date(), { locale: S });
          h && (b = fa(k, p) && l === Me(k, T, d)), fa(k, p) && b && (g = k);
        })), g) : (g = dr(l, c, /* @__PURE__ */ new Date(), { locale: S }), h ? b = fa(g) && l === Me(g, c, d) : fa(g) || (c = c.match(Ih).map((function(T) {
          var k = T[0];
          return k === "p" || k === "P" ? S ? (0, Dh[k])(T, S.formatLong) : k : T;
        })).join(""), l.length > 0 && (g = dr(l, c.slice(0, l.length), /* @__PURE__ */ new Date())), fa(g) || (g = new Date(l))), fa(g) && b ? g : null));
        e.props.showTimeSelectOnly && e.props.selected && w && !Se(w, e.props.selected) && (w = Nh(e.props.selected, { hours: ra(w), minutes: ta(w), seconds: Wn(w) })), !w && u.target.value || (e.props.showWeekPicker && (w = oa(w, e.props.locale, e.props.calendarStartDay)), e.setSelected(w, u, !0));
      }
    })), f(m(e), "handleSelect", (function(i, o, s) {
      if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.props.showWeekPicker && (i = oa(i, e.props.locale, e.props.calendarStartDay)), e.setSelected(i, o, !1, s), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect) e.setPreSelection(i);
      else if (!e.props.inline) {
        e.props.selectsRange || e.setOpen(!1);
        var u = e.props, l = u.startDate, c = u.endDate;
        !l || c || ha(i, l) || e.setOpen(!1);
      }
    })), f(m(e), "setSelected", (function(i, o, s, u) {
      var l = i;
      if (e.props.showYearPicker) {
        if (l !== null && js($(l), e.props)) return;
      } else if (e.props.showMonthYearPicker) {
        if (l !== null && Vs(l, e.props)) return;
      } else if (l !== null && $t(l, e.props)) return;
      var c = e.props, d = c.onChange, h = c.selectsRange, p = c.startDate, g = c.endDate;
      if (!ka(e.props.selected, l) || e.props.allowSameDay || h) if (l !== null && (!e.props.selected || s && (e.props.showTimeSelect || e.props.showTimeSelectOnly || e.props.showTimeInput) || (l = hi(l, { hour: ra(e.props.selected), minute: ta(e.props.selected), second: Wn(e.props.selected) })), e.props.inline || e.setState({ preSelection: l }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: u })), h) {
        var S = p && !g, b = p && g;
        !p && !g ? d([l, null], o) : S && (ha(l, p) ? d([l, null], o) : d([p, l], o)), b && d([l, null], o);
      } else d(l, o);
      s || (e.props.onSelect(l, o), e.setState({ inputValue: null }));
    })), f(m(e), "setPreSelection", (function(i) {
      var o = e.props.minDate !== void 0, s = e.props.maxDate !== void 0, u = !0;
      if (i) {
        e.props.showWeekPicker && (i = oa(i, e.props.locale, e.props.calendarStartDay));
        var l = na(i);
        if (o && s) u = Pt(i, e.props.minDate, e.props.maxDate);
        else if (o) {
          var c = na(e.props.minDate);
          u = va(i, c) || ka(l, c);
        } else if (s) {
          var d = Pr(e.props.maxDate);
          u = ha(i, d) || ka(l, d);
        }
      }
      u && e.setState({ preSelection: i });
    })), f(m(e), "toggleCalendar", (function() {
      e.setOpen(!e.state.open);
    })), f(m(e), "handleTimeChange", (function(i) {
      var o = e.props.selected ? e.props.selected : e.getPreSelection(), s = e.props.selected ? i : hi(o, { hour: ra(i), minute: ta(i) });
      e.setState({ preSelection: s }), e.props.onChange(s), e.props.shouldCloseOnSelect && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
    })), f(m(e), "onInputClick", (function() {
      e.props.disabled || e.props.readOnly || e.setOpen(!0), e.props.onInputClick();
    })), f(m(e), "onInputKeyDown", (function(i) {
      e.props.onKeyDown(i);
      var o = i.key;
      if (e.state.open || e.props.inline || e.props.preventOpenOnFocus) {
        if (e.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var s = e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', u = e.calendar.componentNode && e.calendar.componentNode.querySelector(s);
            return void (u && u.focus({ preventScroll: !0 }));
          }
          var l = ge(e.state.preSelection);
          o === "Enter" ? (i.preventDefault(), e.inputOk() && e.state.lastPreSelectChange === Cr ? (e.handleSelect(l, i), !e.props.shouldCloseOnSelect && e.setPreSelection(l)) : e.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), e.sendFocusBackToInput(), e.setOpen(!1)) : o === "Tab" && e.setOpen(!1), e.inputOk() || e.props.onInputError({ code: 1, msg: yr });
        }
      } else o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || e.onInputClick();
    })), f(m(e), "onPortalKeyDown", (function(i) {
      i.key === "Escape" && (i.preventDefault(), e.setState({ preventFocus: !0 }, (function() {
        e.setOpen(!1), setTimeout((function() {
          e.setFocus(), e.setState({ preventFocus: !1 });
        }));
      })));
    })), f(m(e), "onDayKeyDown", (function(i) {
      e.props.onKeyDown(i);
      var o = i.key, s = ge(e.state.preSelection);
      if (o === "Enter") i.preventDefault(), e.handleSelect(s, i), !e.props.shouldCloseOnSelect && e.setPreSelection(s);
      else if (o === "Escape") i.preventDefault(), e.setOpen(!1), e.inputOk() || e.props.onInputError({ code: 1, msg: yr });
      else if (!e.props.disabledKeyboardNavigation) {
        var u;
        switch (o) {
          case "ArrowLeft":
            u = e.props.showWeekPicker ? Yn(s, 1) : yd(s, 1);
            break;
          case "ArrowRight":
            u = e.props.showWeekPicker ? _t(s, 1) : $a(s, 1);
            break;
          case "ArrowUp":
            u = Yn(s, 1);
            break;
          case "ArrowDown":
            u = _t(s, 1);
            break;
          case "PageUp":
            u = Va(s, 1);
            break;
          case "PageDown":
            u = qe(s, 1);
            break;
          case "Home":
            u = ht(s, 1);
            break;
          case "End":
            u = Wa(s, 1);
            break;
          default:
            u = null;
        }
        if (!u) return void (e.props.onInputError && e.props.onInputError({ code: 1, msg: yr }));
        if (i.preventDefault(), e.setState({ lastPreSelectChange: Cr }), e.props.adjustDateOnChange && e.setSelected(u), e.setPreSelection(u), e.props.inline) {
          var l = Oe(s), c = Oe(u), d = $(s), h = $(u);
          l !== c || d !== h ? e.setState({ shouldFocusDayInline: !0 }) : e.setState({ shouldFocusDayInline: !1 });
        }
      }
    })), f(m(e), "onPopperKeyDown", (function(i) {
      i.key === "Escape" && (i.preventDefault(), e.sendFocusBackToInput());
    })), f(m(e), "onClearClick", (function(i) {
      i && i.preventDefault && i.preventDefault(), e.sendFocusBackToInput(), e.props.selectsRange ? e.props.onChange([null, null], i) : e.props.onChange(null, i), e.setState({ inputValue: null });
    })), f(m(e), "clear", (function() {
      e.onClearClick();
    })), f(m(e), "onScroll", (function(i) {
      typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(i) && e.setOpen(!1);
    })), f(m(e), "renderCalendar", (function() {
      return e.props.inline || e.isCalendarOpen() ? C.createElement($h, { ref: function(i) {
        e.calendar = i;
      }, locale: e.props.locale, calendarStartDay: e.props.calendarStartDay, chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: e.props.weekAriaLabelPrefix, monthAriaLabelPrefix: e.props.monthAriaLabelPrefix, adjustDateOnChange: e.props.adjustDateOnChange, setOpen: e.setOpen, shouldCloseOnSelect: e.props.shouldCloseOnSelect, dateFormat: e.props.dateFormatCalendar, useWeekdaysShort: e.props.useWeekdaysShort, formatWeekDay: e.props.formatWeekDay, dropdownMode: e.props.dropdownMode, selected: e.props.selected, preSelection: e.state.preSelection, onSelect: e.handleSelect, onWeekSelect: e.props.onWeekSelect, openToDate: e.props.openToDate, minDate: e.props.minDate, maxDate: e.props.maxDate, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, startDate: e.props.startDate, endDate: e.props.endDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, filterDate: e.props.filterDate, onClickOutside: e.handleCalendarClickOutside, formatWeekNumber: e.props.formatWeekNumber, highlightDates: e.state.highlightDates, holidays: Bh(e.modifyHolidays()), includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, includeTimes: e.props.includeTimes, injectTimes: e.props.injectTimes, inline: e.props.inline, shouldFocusDayInline: e.state.shouldFocusDayInline, peekNextMonth: e.props.peekNextMonth, showMonthDropdown: e.props.showMonthDropdown, showPreviousMonths: e.props.showPreviousMonths, useShortMonthInDropdown: e.props.useShortMonthInDropdown, showMonthYearDropdown: e.props.showMonthYearDropdown, showWeekNumbers: e.props.showWeekNumbers, showYearDropdown: e.props.showYearDropdown, withPortal: e.props.withPortal, forceShowMonthNavigation: e.props.forceShowMonthNavigation, showDisabledMonthNavigation: e.props.showDisabledMonthNavigation, scrollableYearDropdown: e.props.scrollableYearDropdown, scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown, todayButton: e.props.todayButton, weekLabel: e.props.weekLabel, outsideClickIgnoreClass: Di, fixedHeight: e.props.fixedHeight, monthsShown: e.props.monthsShown, monthSelectedIn: e.state.monthSelectedIn, onDropdownFocus: e.handleDropdownFocus, onMonthChange: e.props.onMonthChange, onYearChange: e.props.onYearChange, dayClassName: e.props.dayClassName, weekDayClassName: e.props.weekDayClassName, monthClassName: e.props.monthClassName, timeClassName: e.props.timeClassName, showDateSelect: e.props.showDateSelect, showTimeSelect: e.props.showTimeSelect, showTimeSelectOnly: e.props.showTimeSelectOnly, onTimeChange: e.handleTimeChange, timeFormat: e.props.timeFormat, timeIntervals: e.props.timeIntervals, minTime: e.props.minTime, maxTime: e.props.maxTime, excludeTimes: e.props.excludeTimes, filterTime: e.props.filterTime, timeCaption: e.props.timeCaption, className: e.props.calendarClassName, container: e.props.calendarContainer, yearItemNumber: e.props.yearItemNumber, yearDropdownItemNumber: e.props.yearDropdownItemNumber, previousMonthAriaLabel: e.props.previousMonthAriaLabel, previousMonthButtonLabel: e.props.previousMonthButtonLabel, nextMonthAriaLabel: e.props.nextMonthAriaLabel, nextMonthButtonLabel: e.props.nextMonthButtonLabel, previousYearAriaLabel: e.props.previousYearAriaLabel, previousYearButtonLabel: e.props.previousYearButtonLabel, nextYearAriaLabel: e.props.nextYearAriaLabel, nextYearButtonLabel: e.props.nextYearButtonLabel, timeInputLabel: e.props.timeInputLabel, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, renderCustomHeader: e.props.renderCustomHeader, popperProps: e.props.popperProps, renderDayContents: e.props.renderDayContents, renderMonthContent: e.props.renderMonthContent, renderQuarterContent: e.props.renderQuarterContent, renderYearContent: e.props.renderYearContent, onDayMouseEnter: e.props.onDayMouseEnter, onMonthMouseLeave: e.props.onMonthMouseLeave, onYearMouseEnter: e.props.onYearMouseEnter, onYearMouseLeave: e.props.onYearMouseLeave, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, showTimeInput: e.props.showTimeInput, showMonthYearPicker: e.props.showMonthYearPicker, showFullMonthYearPicker: e.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: e.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: e.props.showFourColumnMonthYearPicker, showYearPicker: e.props.showYearPicker, showQuarterYearPicker: e.props.showQuarterYearPicker, showWeekPicker: e.props.showWeekPicker, showPopperArrow: e.props.showPopperArrow, excludeScrollbar: e.props.excludeScrollbar, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, isInputFocused: e.state.focused, customTimeInput: e.props.customTimeInput, setPreSelection: e.setPreSelection }, e.props.children) : null;
    })), f(m(e), "renderAriaLiveRegion", (function() {
      var i, o = e.props, s = o.dateFormat, u = o.locale, l = e.props.showTimeInput || e.props.showTimeSelect ? "PPPPp" : "PPPP";
      return i = e.props.selectsRange ? "Selected start date: ".concat(Xe(e.props.startDate, { dateFormat: l, locale: u }), ". ").concat(e.props.endDate ? "End date: " + Xe(e.props.endDate, { dateFormat: l, locale: u }) : "") : e.props.showTimeSelectOnly ? "Selected time: ".concat(Xe(e.props.selected, { dateFormat: s, locale: u })) : e.props.showYearPicker ? "Selected year: ".concat(Xe(e.props.selected, { dateFormat: "yyyy", locale: u })) : e.props.showMonthYearPicker ? "Selected month: ".concat(Xe(e.props.selected, { dateFormat: "MMMM yyyy", locale: u })) : e.props.showQuarterYearPicker ? "Selected quarter: ".concat(Xe(e.props.selected, { dateFormat: "yyyy, QQQ", locale: u })) : "Selected date: ".concat(Xe(e.props.selected, { dateFormat: l, locale: u })), C.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, i);
    })), f(m(e), "renderDateInput", (function() {
      var i, o = Pe(e.props.className, f({}, Di, e.state.open)), s = e.props.customInput || C.createElement("input", { type: "text" }), u = e.props.customInputRef || "ref", l = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? (function(c, d, h) {
        if (!c) return "";
        var p = Xe(c, h), g = d ? Xe(d, h) : "";
        return "".concat(p, " - ").concat(g);
      })(e.props.startDate, e.props.endDate, e.props) : Xe(e.props.selected, e.props);
      return C.cloneElement(s, (f(f(f(f(f(f(f(f(f(f(i = {}, u, (function(c) {
        e.input = c;
      })), "value", l), "onBlur", e.handleBlur), "onChange", e.handleChange), "onClick", e.onInputClick), "onFocus", e.handleFocus), "onKeyDown", e.onInputKeyDown), "id", e.props.id), "name", e.props.name), "form", e.props.form), f(f(f(f(f(f(f(f(f(f(i, "autoFocus", e.props.autoFocus), "placeholder", e.props.placeholderText), "disabled", e.props.disabled), "autoComplete", e.props.autoComplete), "className", Pe(s.props.className, o)), "title", e.props.title), "readOnly", e.props.readOnly), "required", e.props.required), "tabIndex", e.props.tabIndex), "aria-describedby", e.props.ariaDescribedBy), f(f(f(i, "aria-invalid", e.props.ariaInvalid), "aria-labelledby", e.props.ariaLabelledBy), "aria-required", e.props.ariaRequired)));
    })), f(m(e), "renderClearButton", (function() {
      var i = e.props, o = i.isClearable, s = i.disabled, u = i.selected, l = i.startDate, c = i.endDate, d = i.clearButtonTitle, h = i.clearButtonClassName, p = h === void 0 ? "" : h, g = i.ariaLabelClose, S = g === void 0 ? "Close" : g;
      return !o || u == null && l == null && c == null ? null : C.createElement("button", { type: "button", className: Pe("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": S, onClick: e.onClearClick, title: d, tabIndex: -1 });
    })), e.state = e.calcInitialState(), e.preventFocusTimeout = null, e;
  }
  return Ie(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(t, e) {
    var i, o;
    t.inline && (i = t.selected, o = this.props.selected, i && o ? Oe(i) !== Oe(o) || $(i) !== $(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: Ti(this.props.highlightDates) }), e.focused || ka(t.selected, this.props.selected) || this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), e.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var t = this.props, e = t.showIcon, i = t.icon, o = t.calendarIconClassname, s = t.toggleCalendarOnIconClick, u = this.state.open;
    return C.createElement("div", { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") }, e && C.createElement(Qh, Qa({ icon: i, className: "".concat(o, " ").concat(u && "react-datepicker-ignore-onclickoutside") }, s ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var t = this.renderCalendar();
    if (this.props.inline) return t;
    if (this.props.withPortal) {
      var e = this.state.open ? C.createElement(eu, { enableTabLoop: this.props.enableTabLoop }, C.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)) : null;
      return this.state.open && this.props.portalId && (e = C.createElement($s, { portalId: this.props.portalId, portalHost: this.props.portalHost }, e)), C.createElement("div", null, this.renderInputContainer(), e);
    }
    return C.createElement(Xh, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: t, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: dt, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), n;
})(), em = "input", Cr = "navigate";
const am = (a) => {
  const r = new Date(0, 0, 0, 0, 0), { hours: n, minutes: t, seconds: e } = rm(a);
  return r.setHours(Number(n)), r.setMinutes(Number(t)), r.setSeconds(Number(e)), r;
}, Ii = (a) => {
  const r = a.getHours(), n = a.getMinutes(), t = a.getSeconds();
  return r * 3600 + n * 60 + t;
}, tm = (a) => {
  const r = Math.floor(a / 3600), n = Math.floor(a % 3600 / 60);
  return {
    hours: r < 10 ? `0${r}` : String(r),
    minutes: n < 10 ? `0${n}` : String(n)
  };
}, rm = (a) => {
  const { hours: r, minutes: n } = tm(a), t = a % 60;
  return {
    hours: r,
    minutes: n,
    seconds: t < 10 ? `0${t}` : String(t)
  };
}, tr = Mt(function({
  error: r,
  label: n,
  labelClassName: t,
  labelRightElement: e,
  htmlFor: i,
  nativeLabelProps: o,
  value: s,
  onChange: u,
  onFocus: l,
  maxLength: c,
  placeholder: d,
  isPreFetching: h,
  required: p,
  description: g,
  className: S,
  addonBefore: b,
  addonAfter: w,
  inputClassName: T,
  success: k,
  addonAfterClassName: N,
  addonBeforeClassName: M,
  statusIcon: y,
  statusIconClassName: D,
  labelContentWrapperClassName: I,
  errorAndDescriptionClassName: P,
  descriptionClassName: B,
  errorClassName: K,
  ...Q
}, Z) {
  const z = A(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    h ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), x = A(qr, y && "pr-9");
  return /* @__PURE__ */ _(
    "label",
    {
      className: A("flex flex-col gap-1 text-sm font-medium", S),
      ...o,
      children: [
        /* @__PURE__ */ v(
          Pa,
          {
            label: n,
            labelClassName: t,
            labelRightElement: e,
            required: p
          }
        ),
        /* @__PURE__ */ _(
          "div",
          {
            className: A(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              h && "animate-pulse",
              I
            ),
            children: [
              b && /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    z,
                    M
                  ),
                  children: b
                }
              ),
              /* @__PURE__ */ v(
                "input",
                {
                  ref: Z,
                  className: A(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    x,
                    r ? "border-danger" : k ? "border-green" : "border-text-secondary/30",
                    h ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    b && "rounded-l-none",
                    w && "rounded-r-none",
                    T
                  ),
                  type: Q.type || "text",
                  value: s,
                  onChange: u,
                  onFocus: l,
                  maxLength: c,
                  placeholder: d,
                  spellCheck: !1,
                  disabled: Q.disabled || h,
                  ...Q
                }
              ),
              w && /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    z,
                    N
                  ),
                  children: w
                }
              ),
              y && /* @__PURE__ */ v(
                "div",
                {
                  className: A(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    D
                  ),
                  children: y
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ v(
          Sa,
          {
            description: g,
            error: r,
            className: P,
            descriptionClassName: B,
            errorClassName: K
          }
        )
      ]
    }
  );
});
function Ag({
  inputRef: a,
  label: r,
  labelClassName: n,
  required: t,
  value: e,
  onChange: i,
  onFocus: o,
  maxLength: s,
  error: u,
  placeholder: l,
  onClear: c,
  description: d,
  testAttributePostfix: h,
  isPreFetching: p,
  searchIconClassName: g,
  closeIconClassName: S,
  errorAndDescriptionClassName: b,
  descriptionClassName: w,
  errorClassName: T,
  showSearchIcon: k,
  ...N
}) {
  return /* @__PURE__ */ _("label", { className: `${N.className} relative flex flex-col gap-1 text-sm font-medium`, children: [
    /* @__PURE__ */ v(Pa, { label: r, labelClassName: n, required: t }),
    (e === "" || k) && /* @__PURE__ */ v(
      wu,
      {
        className: A(
          "z-1 absolute right-4 h-[21px] w-[21px] translate-y-1/2 scale-75",
          r && "top-[24px]",
          g
        )
      }
    ),
    e !== "" && /* @__PURE__ */ v(
      yt,
      {
        onClick: c,
        className: A(
          "z-1 fill-text-primary absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer",
          r && "top-[24px]",
          S
        )
      }
    ),
    /* @__PURE__ */ v(
      "input",
      {
        ref: a,
        className: `text-text-primary main-transition-colors bg-background-secondary relative w-full rounded-lg border ${u ? "border-danger" : "border-text-secondary/30"} focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden ${p ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent" : "disabled:bg-background-tertiary/40"} ${N.inputClassName || ""}`,
        onKeyDown: (M) => N.type === "number" && ["e", "E", "+", "-"].includes(M.key) && M.preventDefault(),
        type: N.type || "text",
        disabled: N.disabled || p,
        value: e,
        onChange: i,
        onFocus: o,
        maxLength: s,
        placeholder: l || W.t("public_pages_purchase.input.search"),
        spellCheck: !1,
        ...Tr(!!h, `${h}`)
      }
    ),
    /* @__PURE__ */ v(
      Sa,
      {
        description: d,
        error: u,
        className: b,
        descriptionClassName: w,
        errorClassName: T
      }
    )
  ] });
}
const Ng = ({
  onChange: a,
  value: r = "",
  addonBefore: n,
  withCopyButton: t,
  buttonClassName: e,
  linkIconClassName: i,
  scheme: o = "https://",
  ...s
}) => {
  const u = r.replace(o, "");
  return /* @__PURE__ */ v(
    tr,
    {
      type: "url",
      addonBefore: n || o,
      value: u,
      onChange: ({ target: { value: c } }) => {
        if (!c || c === o) return a("");
        a(o + c.replace(o, ""));
      },
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: t && /* @__PURE__ */ v(
        "button",
        {
          type: "button",
          onClick: async (c) => {
            c.preventDefault(), await uc(r, W.t("public_pages_purchase.copy_clipboard"));
          },
          className: A(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            e
          ),
          children: /* @__PURE__ */ v(
            Au,
            {
              className: A(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                i
              )
            }
          )
        }
      ),
      ...s
    }
  );
}, Dg = ({
  value: a,
  onChange: r,
  type: n = "float",
  toFixed: t = 2,
  max: e,
  min: i,
  onBlur: o,
  ...s
}) => {
  const [u, l] = de(a.toString());
  return Ne(() => {
    l(a.toString());
  }, [a]), /* @__PURE__ */ v(
    tr,
    {
      value: u,
      onChange: (h) => {
        const p = h.target.value;
        if (n === "integer")
          /^[0-9]*$/.test(p) && l(p);
        else {
          const g = p.replace(",", "."), S = new RegExp(`^-?\\d*(\\.\\d{0,${t}})?$`);
          g.match(S) !== null && l(g);
        }
      },
      onBlur: (h) => {
        let p;
        n === "integer" ? p = parseInt(u, 10) || 0 : p = parseFloat(u) || 0, e !== void 0 && (p = Math.min(p, e)), i !== void 0 && (p = Math.max(p, i)), n === "integer" && (p = Math.max(0, p)), r(p), l(n === "integer" ? p.toString() : p.toFixed(t)), o == null || o(h, p);
      },
      min: n === "integer" ? "0" : void 0,
      type: "text",
      ...s
    }
  );
}, nm = "react-international-phone-", au = (...a) => a.filter((r) => !!r).join(" ").trim(), im = (...a) => au(...a).split(" ").map((r) => `${nm}${r}`).join(" "), Ke = ({ addPrefix: a, rawClassNames: r }) => au(im(...a), ...r), $e = (a) => a.replace(/\D/g, ""), Ei = 35, om = ({
  value: a,
  mask: r,
  maskSymbol: n,
  allowMoreDigitsThanMaskAllows: t,
  offset: e = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (a.length < e) return a;
  const o = a.slice(0, e), s = a.slice(e);
  let u = o, l = 0;
  for (const d of r.split("")) {
    if (l >= s.length) {
      if (!i && d !== n) {
        u += d;
        continue;
      }
      break;
    }
    d === n ? (u += s[l], l += 1) : u += d;
  }
  let c = $e(u);
  return t && c.length < a.length && (u += a.slice(c.length), c = $e(u)), c.length >= Ei && (u = u.slice(0, -(c.length - Ei) || void 0)), u;
}, sm = (a, r) => {
  const n = a.style.display;
  n !== "block" && (a.style.display = "block");
  const t = a.getBoundingClientRect(), e = r.getBoundingClientRect(), i = e.top - t.top, o = t.bottom - e.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? a.scrollTop += i : a.scrollTop -= o), a.style.display = n;
}, Je = (a) => {
  const [r, n, t, e, i, o, s] = a;
  return {
    name: r,
    regions: n,
    iso2: t,
    dialCode: e,
    format: i,
    priority: o,
    areaCodes: s
  };
}, um = (a) => `Field "${a}" is not supported`, Ka = ({
  value: a,
  field: r,
  countries: n,
  defaultCountry: t
}) => {
  if (["regions", "priority"].includes(r))
    throw new Error(um(r));
  const e = n.find((i) => {
    const o = Je(i);
    return a === o[r];
  }) || n.find((i) => {
    const o = Je(i);
    return t.toLocaleLowerCase() === o[r];
  });
  if (e)
    return Je(e);
}, Bi = ({
  phone: a,
  countries: r,
  currentCountryIso2: n,
  defaultCountry: t
}) => {
  var u;
  const e = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!a)
    return e;
  const i = $e(a);
  if (!i)
    return e;
  let o = e;
  const s = ({
    country: l,
    fullDialCodeMatch: c,
    areaCodeMatch: d
  }) => {
    var g, S;
    const h = l.dialCode === ((g = o.country) == null ? void 0 : g.dialCode), p = (l.priority ?? 0) < (((S = o.country) == null ? void 0 : S.priority) ?? 0);
    (!h || p) && (o = { country: l, fullDialCodeMatch: c, areaCodeMatch: d });
  };
  for (const l of r) {
    const c = Je(l), { dialCode: d, areaCodes: h } = c;
    if (i.startsWith(d)) {
      const p = o.country ? Number(d) >= Number(o.country.dialCode) : !0;
      if (h) {
        const g = i.substring(d.length);
        for (const S of h)
          if (g.startsWith(S))
            return {
              country: c,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (p || d === i || !o.fullDialCodeMatch) && s({
        country: c,
        fullDialCodeMatch: !0,
        areaCodeMatch: h ? !h : void 0
      });
    }
    o.fullDialCodeMatch || i.length < d.length && d.startsWith(i) && (!o.country || Number(d) <= Number(o.country.dialCode)) && s({ country: c, fullDialCodeMatch: !1 });
  }
  if (n) {
    const l = Ka({
      value: n,
      field: "iso2",
      countries: r,
      defaultCountry: t
    });
    !!o && !!l && // different countries with same dial code
    ((u = o.country) == null ? void 0 : u.dialCode) === l.dialCode && o.country !== l && // full dial code match (without area code)
    o.fullDialCodeMatch && !o.areaCodeMatch && (o = {
      country: l,
      areaCodeMatch: l != null && l.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return o;
}, lm = ({
  phone: a,
  dialCode: r,
  prefix: n = "+",
  charAfterDialCode: t = " "
}) => {
  if (!a || !r)
    return a;
  let e = a;
  return e.startsWith(n) && (e = e.replace(n, "")), e.startsWith(r) ? (e = e.replace(r, ""), e.startsWith(t) && (e = e.replace(t, "")), e) : a;
}, Pi = ({
  phone: a,
  dialCode: r,
  prefix: n = "+",
  charAfterDialCode: t = " "
}) => `${n}${r}${t}${lm({
  phone: a,
  dialCode: r,
  charAfterDialCode: t,
  prefix: n
})}`, cm = (a, r) => {
  const n = r.disableDialCodeAndPrefix ? !1 : r.forceDialCode, t = r.disableDialCodeAndPrefix ? !1 : r.insertDialCodeOnEmpty;
  let e = a;
  const i = (l) => r.trimNonDigitsEnd ? l.trim() : l;
  if (!e)
    return t && !e.length || n ? i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`) : i(e);
  if (e = $e(e), e === r.dialCode && !r.disableDialCodeAndPrefix)
    return i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
  if (r.dialCode.startsWith(e) && !r.disableDialCodeAndPrefix)
    return i(n ? `${r.prefix}${r.dialCode}${r.charAfterDialCode}` : `${r.prefix}${e}`);
  if (!e.startsWith(r.dialCode) && !r.disableDialCodeAndPrefix) {
    if (n)
      return i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
    if (e.length < r.dialCode.length)
      return i(`${r.prefix}${e}`);
  }
  const o = () => {
    let l = r.dialCode.length;
    r.disableDialCodeAndPrefix && (l = 0);
    const c = e.slice(0, l), d = e.slice(l);
    return {
      phoneLeftSide: c,
      phoneRightSide: d
    };
  };
  let { phoneLeftSide: s, phoneRightSide: u } = o();
  return s = `${r.prefix}${s}${r.charAfterDialCode}`, u = om({
    value: u,
    mask: r.mask,
    maskSymbol: r.maskChar,
    allowMoreDigitsThanMaskAllows: r.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: r.trimNonDigitsEnd
  }), r.disableDialCodeAndPrefix && (s = ""), i(`${s}${u}`);
}, ot = (a) => /\d/.test(a), dm = ({
  phoneBeforeInput: a,
  phoneAfterInput: r,
  phoneAfterFormatted: n,
  cursorPositionAfterInput: t,
  leftOffset: e = 0,
  deletion: i
}) => {
  if (t < e)
    return e;
  if (!a)
    return n.length;
  const o = i === "backward";
  if (t === 0 && r.length > 0 && n.length > 0) {
    if (o) return 0;
    for (let d = 0; d < n.length; d += 1)
      if (ot(n[d]))
        return d;
    return n.length;
  }
  if (r.length < a.length && r.length === 1)
    return n.length;
  let s = null;
  for (let d = t - 1; d >= 0; d -= 1)
    if (ot(r[d])) {
      s = d;
      break;
    }
  if (s === null)
    return t !== 0 ? t : n.length;
  let u = 0;
  for (let d = 0; d < s; d += 1)
    ot(r[d]) && (u += 1);
  o && (u -= 1);
  let l = 0, c = 0;
  for (let d = 0; d < n.length && (l += 1, ot(n[d]) && (c += 1), c !== u + 1); d += 1)
    ;
  for (; !ot(n[l]) && l < n.length; )
    l += 1;
  return o && (l += 1), l;
}, vn = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], Hr = "fr", pm = ".", fm = {
  defaultCountry: Hr,
  initialCountry: Hr,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: vn,
  dontShowDialCodePrefillOnFocus: !1
}, hm = (a, r) => {
  const n = parseInt(a, 16);
  return Number(n + r).toString(16);
}, mm = "abcdefghijklmnopqrstuvwxyz", gm = "1f1e6", Oi = mm.split("").reduce((a, r, n) => ({
  ...a,
  // construct alphabet by incrementing A letter codepoint value
  [r]: hm(gm, n)
}), {}), vm = (a) => [Oi[a[0]], Oi[a[1]]].join("-"), tu = ({
  iso2: a,
  size: r = "24px",
  protocol: n = "https",
  disableLazyLoading: t,
  className: e,
  ...i
}) => {
  if (!a)
    return /* @__PURE__ */ v("img", { width: r, height: r, ...i });
  const o = vm(a), s = `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ v(
    "img",
    {
      alt: a,
      className: Ke({
        addPrefix: ["flag-emoji"],
        rawClassNames: [e]
      }),
      src: s,
      width: r,
      height: r,
      draggable: !1,
      "data-country": a,
      loading: t ? void 0 : "lazy",
      ...i
    }
  );
}, ru = ({
  show: a,
  dialCodePrefix: r = "+",
  selectedCountry: n,
  countries: t = vn,
  onSelect: e,
  onClose: i,
  searchInputPlaceholder: o,
  ...s
}) => {
  const u = Ae(null), l = Ae(null), c = Ae(), [d, h] = de(""), p = qa(() => {
    if (d) {
      const y = d.toLowerCase();
      return t.filter(([D]) => D.toLowerCase().includes(y));
    } else
      return t;
  }, [t, d]), g = Ha(
    (y) => p.findIndex((D) => Je(D).iso2 === y),
    [p]
  ), [S, b] = de(g(n)), w = () => {
    c.current !== n && b(g(n));
  }, T = Ha(
    (y) => {
      b(g(y.iso2)), e == null || e(y);
    },
    [e, g]
  ), k = (y) => {
    const D = p.length - 1, I = (P) => y === "prev" ? P - 1 : y === "next" ? P + 1 : y === "last" ? D : 0;
    b((P) => {
      const B = I(P);
      return B < 0 ? 0 : B > D ? D : B;
    });
  }, N = (y) => {
    if (y.stopPropagation(), y.key === "Enter") {
      const D = Je(p[S]);
      T(D);
      return;
    }
    if (y.key === "Escape") {
      i == null || i();
      return;
    }
    if (y.key === "ArrowUp") {
      y.preventDefault(), k("prev");
      return;
    }
    if (y.key === "ArrowDown") {
      y.preventDefault(), k("next");
      return;
    }
    if (y.key === "PageUp") {
      y.preventDefault(), k("first");
      return;
    }
    if (y.key === "PageDown") {
      y.preventDefault(), k("last");
      return;
    }
    y.key === " " && y.preventDefault();
  }, M = Ha(() => {
    if (!l.current || S === void 0 || !p[S])
      return;
    const y = Je(p[S]).iso2;
    if (y === c.current) return;
    const D = l.current.querySelector(`[data-country="${y}"]`);
    D && (sm(l.current, D), c.current = y);
  }, [S, p]);
  return Ne(() => {
    M();
  }, [S, M]), Ne(() => {
    u.current && (a ? Promise.resolve().then(() => {
      var y;
      return (y = u.current) == null ? void 0 : y.focus();
    }) : w());
  }, [a]), Ne(() => {
    w();
  }, [n]), /* @__PURE__ */ _(
    "div",
    {
      className: Ke({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: a ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${p[S] && Je(p[S]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ v(
          "input",
          {
            ref: u,
            className: Ke({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: o || "",
            style: s.searchInputStyle,
            type: "text",
            value: d,
            onChange: (y) => h(y.target.value),
            onKeyDown: N
          }
        ),
        d && /* @__PURE__ */ v(
          yt,
          {
            onClick: () => h(""),
            className: Ke({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ v(
          "ul",
          {
            ref: l,
            role: "listbox",
            className: Ke({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: p.map((y, D) => {
              const I = Je(y), P = I.iso2 === n, B = D === S;
              return /* @__PURE__ */ _(
                "li",
                {
                  "data-country": I.iso2,
                  "data-focused": B,
                  role: "option",
                  "aria-selected": P,
                  "aria-label": `${I.name} ${r}${I.dialCode}`,
                  id: `${I.iso2}-option`,
                  className: Ke({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      P && "country-selector-dropdown__list-item--selected",
                      B && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => T(I),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ v(
                      tu,
                      {
                        iso2: I.iso2,
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ v(
                      "span",
                      {
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: I.name
                      }
                    ),
                    /* @__PURE__ */ _(
                      "span",
                      {
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          r,
                          I.dialCode
                        ]
                      }
                    )
                  ]
                },
                I.iso2
              );
            })
          }
        )
      ]
    }
  );
}, Sm = ({
  selectedCountry: a,
  onSelect: r,
  disabled: n,
  hideDropdown: t,
  defaultCountry: e = Hr,
  countries: i = vn,
  renderButtonWrapper: o,
  ...s
}) => {
  const [u, l] = de(!1), c = qa(() => {
    if (a)
      return Ka({
        value: a,
        field: "iso2",
        countries: i,
        defaultCountry: e
      });
  }, [i, e, a]), d = Ae(null), h = (g) => {
    g.key && ["ArrowUp", "ArrowDown"].includes(g.key) && (g.preventDefault(), l(!0));
  }, p = () => {
    const g = {
      title: c == null ? void 0 : c.name,
      onClick: () => l((b) => !b),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (b) => b.preventDefault(),
      onKeyDown: h,
      disabled: t || n,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": u
    }, S = /* @__PURE__ */ _(
      "div",
      {
        className: Ke({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ v(
            tu,
            {
              iso2: a,
              className: Ke({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  n && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: a ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !t && /* @__PURE__ */ v(
            "div",
            {
              className: Ke({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  n && "country-selector-button__dropdown-arrow--disabled",
                  u && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: S,
      rootProps: g
    }) : /* @__PURE__ */ v(
      "button",
      {
        ...g,
        type: "button",
        className: Ke({
          addPrefix: [
            "country-selector-button",
            u && "country-selector-button--active",
            n && "country-selector-button--disabled",
            t && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": a,
        style: s.buttonStyle,
        children: S
      }
    );
  };
  return /* @__PURE__ */ _(
    "div",
    {
      className: Ke({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: d,
      children: [
        p(),
        /* @__PURE__ */ v(
          ru,
          {
            show: u,
            countries: i,
            onSelect: (g) => {
              l(!1), r == null || r(g);
            },
            selectedCountry: a,
            onClose: () => {
              l(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, bm = () => {
  const a = Ae(), r = Ae(Date.now());
  return {
    check: () => {
      const t = Date.now(), e = a.current ? t - r.current : void 0;
      return a.current = r.current, r.current = t, e;
    }
  };
}, Mm = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function ym(a, r) {
  const { size: n, overrideLastItemDebounceMS: t, onChange: e } = {
    ...Mm,
    ...r
  }, [i, o] = de(a), [s, u] = de([i]), [l, c] = de(0), d = bm();
  return [i, (S, b) => {
    if (
      // compare entries if passed value is object
      typeof S == "object" && Object.entries(S).toString() === Object.entries(i).toString() || S === i
    )
      return;
    const w = t > 0, T = d.check(), k = w && T !== void 0 ? T > t : !0;
    if (
      // use value of config.overrideLastItem if passed
      (b == null ? void 0 : b.overrideLastItem) !== void 0 ? b.overrideLastItem : !k
    )
      u((M) => [...M.slice(0, l), S]);
    else {
      const M = s.length >= n;
      u((y) => [...y.slice(M ? 1 : 0, l + 1), S]), M || c((y) => y + 1);
    }
    o(S), e == null || e(S);
  }, () => {
    if (l <= 0)
      return { success: !1 };
    const S = s[l - 1];
    return o(S), c((b) => b - 1), e == null || e(S), { success: !0, value: S };
  }, () => {
    if (l + 1 >= s.length)
      return { success: !1 };
    const S = s[l + 1];
    return o(S), c((b) => b + 1), e == null || e(S), { success: !0, value: S };
  }];
}
const Cm = pm, Fe = fm, km = ({
  defaultCountry: a = Fe.defaultCountry,
  initialCountry: r = Fe.initialCountry,
  value: n = Fe.value,
  countries: t = Fe.countries,
  prefix: e = Fe.prefix,
  defaultMask: i = Fe.defaultMask,
  allowMoreDigitsThanMaskAllows: o = Fe.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = Fe.charAfterDialCode,
  historySaveDebounceMS: u = Fe.historySaveDebounceMS,
  disableCountryGuess: l = Fe.disableCountryGuess,
  disableDialCodePrefill: c = Fe.disableDialCodePrefill,
  forceDialCode: d = Fe.forceDialCode,
  disableDialCodeAndPrefix: h = Fe.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: p = Fe.dontShowDialCodePrefillOnFocus,
  onChange: g
}) => {
  const S = n || "", b = h ? !1 : !l, w = Ae(null), T = ({
    value: L,
    country: H,
    trimNonDigitsEnd: X,
    insertDialCodeOnEmpty: J,
    forceDisableCountryGuess: E
  }) => {
    const j = !E && b ? Bi({
      phone: L,
      countries: t,
      currentCountryIso2: H.iso2,
      defaultCountry: a
    }) : void 0, V = (j == null ? void 0 : j.country) ?? H;
    return { phone: V ? cm(L, {
      prefix: e,
      mask: V.format || i,
      maskChar: Cm,
      dialCode: V.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: X,
      charAfterDialCode: s,
      forceDialCode: d,
      insertDialCodeOnEmpty: J,
      disableDialCodeAndPrefix: h
    }) : L, countryGuessResult: j, formatCountry: V };
  }, k = (L) => {
    typeof document < "u" && document.activeElement === w.current && Promise.resolve().then(() => {
      var H;
      (H = w.current) == null || H.setSelectionRange(L, L);
    });
  }, N = Ha(
    ({ phone: L, country: H }) => g == null ? void 0 : g({
      phone: L,
      unformatedPhone: $e(L),
      country: H,
      prefix: e
    }),
    [g, e]
  ), [{ phone: M, country: y }, D, I, P] = ym(
    () => {
      const H = Bi({
        phone: S,
        countries: t,
        currentCountryIso2: r,
        defaultCountry: a
      }).country || Ka({
        value: r,
        field: "iso2",
        countries: t,
        defaultCountry: a
      });
      H || console.error(
        `[react-international-phone]: can not find a country with "${a}" iso2 code`
      );
      const X = H || // set "us" if user provided not valid country
      Je(t.find((E) => Je(E).iso2 === a)), J = T({
        value: S,
        country: X,
        insertDialCodeOnEmpty: p ? !c : !1
      }).phone;
      return k(J.length), {
        phone: J,
        country: X.iso2
      };
    },
    {
      overrideLastItemDebounceMS: u,
      onChange: N
    }
  ), B = qa(() => Ka({
    value: y,
    field: "iso2",
    countries: t,
    defaultCountry: a
  }), [t, y, a]), K = Ha(() => {
    var L;
    p || (L = w == null ? void 0 : w.current) != null && L.value || N == null || N({
      phone: Pi({
        phone: M,
        dialCode: B.dialCode,
        charAfterDialCode: s,
        prefix: e
      }),
      country: y
    });
  }, [
    s,
    y,
    B,
    N,
    M,
    e,
    p
  ]), Q = (L, {
    deletion: H,
    cursorPosition: X,
    insertDialCodeOnEmpty: J,
    inserted: E
  } = {}) => {
    var ue;
    let U = L, j = X;
    d && !h && B && // dial code has been changed
    !$e(L).startsWith(B.dialCode) && L && (E && L.startsWith(e) && // cursor position was set to 0 before the input
    L.length - (X ?? 0) === 0 ? U = L : (U = M, j = 0));
    const { phone: V, countryGuessResult: re } = T({
      value: U,
      country: B,
      trimNonDigitsEnd: H === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: J,
      forceDisableCountryGuess: d && !!H && $e(U).length < B.dialCode.length
    });
    let he = B;
    b && (re != null && re.country) && re.country.name !== y && re.fullDialCodeMatch && (he = re.country);
    const ve = dm({
      cursorPositionAfterInput: j ?? 0,
      phoneBeforeInput: M,
      phoneAfterInput: L,
      phoneAfterFormatted: V,
      leftOffset: d ? e.length + (((ue = B == null ? void 0 : B.dialCode) == null ? void 0 : ue.length) ?? 0) + s.length : 0,
      deletion: H
    });
    return D({
      phone: V,
      country: he.iso2
    }), k(ve), V;
  };
  Ne(() => {
    const L = w.current;
    if (!L) return;
    const H = (X) => {
      if (!X.key) return;
      const J = X.ctrlKey, E = X.shiftKey, U = X.key.toLowerCase() === "z";
      !J || !U || (E ? P() : I());
    };
    return L.addEventListener("keydown", H), () => {
      L.removeEventListener("keydown", H);
    };
  }, [w, I, P]);
  const Z = (L) => {
    L.preventDefault();
    const H = L.nativeEvent.inputType, X = () => {
      if ((H == null ? void 0 : H.toLocaleLowerCase().includes("delete")) ?? !1)
        return H != null && H.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, J = H == null ? void 0 : H.startsWith("insertFrom"), E = Q(L.target.value, {
      deletion: X(),
      inserted: J,
      cursorPosition: L.target.selectionStart ?? 0
    });
    return h && B ? Pi({
      phone: E,
      dialCode: B.dialCode,
      charAfterDialCode: s,
      prefix: e
    }) : E;
  }, z = (L) => {
    const H = Ka({
      value: L,
      field: "iso2",
      countries: t,
      defaultCountry: a
    });
    if (!H) return;
    const X = h ? "" : `${e}${H.dialCode}${s}`;
    D({
      phone: X,
      country: H.iso2
    }), Promise.resolve().then(() => {
      var J;
      (J = w.current) == null || J.focus();
    });
  }, [x, Y] = de(!1);
  return Ne(() => {
    if (!x) {
      Y(!0), S !== M && (N == null || N({ phone: M, country: y }));
      return;
    }
    $e(S) !== $e(M) && Q($e(S));
  }, [S]), Ne(() => {
    if (!M && r) {
      const L = Ka({
        value: r,
        field: "iso2",
        countries: t,
        defaultCountry: a
      });
      D({
        phone: M,
        country: (L == null ? void 0 : L.iso2) || a
      });
    }
  }, [r]), {
    phone: M,
    // Formatted phone string.
    country: y,
    // Current country iso code.
    setCountry: z,
    // Country setter.
    handlePhoneValueChange: Z,
    // Change handler for input component
    onFocus: K,
    inputRef: w
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, Ig = ({
  label: a,
  labelClassName: r,
  required: n,
  value: t,
  onChange: e,
  error: i,
  wrapperClassName: o,
  inputClassName: s,
  listClassName: u,
  searchInputClassName: l,
  clearSearchInputClassName: c,
  listItemClassName: d,
  listItemCountryNameClassName: h,
  countrySelectorDropdownClassName: p,
  countrySelectorClassName: g,
  buttonClassName: S,
  listboxButtonClassName: b,
  listboxOptionsClassName: w,
  initialCountry: T,
  ...k
}) => {
  const N = Ae(null), M = Ae(null), y = Ae(null), { country: D, setCountry: I, phone: P, handlePhoneValueChange: B, onFocus: K, inputRef: Q } = km({
    value: t,
    onChange: ({ unformatedPhone: Z }) => e(Z),
    initialCountry: T == null ? void 0 : T.toLowerCase()
  });
  return /* @__PURE__ */ v("div", { className: o, children: /* @__PURE__ */ v(Vr, { children: ({ open: Z }) => {
    var z;
    return /* @__PURE__ */ _(Ue, { children: [
      /* @__PURE__ */ _("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ v(
          Pa,
          {
            label: a,
            required: n,
            labelClassName: A("text-sm font-medium", r)
          }
        ),
        /* @__PURE__ */ _(
          "div",
          {
            ref: M,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ _(
                Ot,
                {
                  ref: y,
                  as: "div",
                  role: "button",
                  disabled: k.disabled,
                  className: A(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    b,
                    k.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ v(
                      Sm,
                      {
                        className: A("flex", g),
                        buttonStyle: { border: "none" },
                        buttonClassName: A(
                          k.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          S
                        ),
                        hideDropdown: !0,
                        disabled: k.disabled,
                        selectedCountry: D,
                        defaultCountry: T == null ? void 0 : T.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ v(
                      Vi,
                      {
                        className: `transition-transform duration-300 ${Z && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ v(
                tr,
                {
                  ref: Q,
                  type: "tel",
                  placeholder: W.t("public_pages_purchase.input.phone_number"),
                  inputClassName: A(
                    "pl-16",
                    Z && "border-brand-primary",
                    s
                  ),
                  value: P,
                  onChange: B,
                  onFocus: K,
                  error: i,
                  ...k
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ v(
        jr,
        {
          className: A("focus-visible:outline-hidden", w),
          children: /* @__PURE__ */ v(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: N,
              style: {
                width: `${(z = Q.current) == null ? void 0 : z.clientWidth}px`
              },
              children: /* @__PURE__ */ v("div", { children: /* @__PURE__ */ v(
                ru,
                {
                  className: A(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    p
                  ),
                  listClassName: A(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    u
                  ),
                  searchInputClassName: A(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    l
                  ),
                  clearSearchInputClassName: A(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    c
                  ),
                  listItemClassName: A(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    d
                  ),
                  listItemCountryNameClassName: A(
                    "truncate",
                    h
                  ),
                  searchInputPlaceholder: W.t("public_pages_purchase.input.phone_search"),
                  show: Z,
                  selectedCountry: D,
                  onSelect: (x) => {
                    var Y;
                    I(x.iso2), (Y = y.current) == null || Y.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
}, Tm = (a) => {
  const r = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return a.split(/([^\w])/g).map((n) => r[n] || n).join("");
}, wm = (a, r) => {
  const n = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, t = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, e = (s, u) => s.split(/([ :/])/).map(
    (l) => l.split("").map((c) => u[c] || c).join("")
  ).join(""), i = e(a, t), o = e(r, n);
  return {
    timeFormat: i,
    dateFormat: o
  };
}, Eg = ({
  seconds: a,
  onChangeSeconds: r,
  containerClassName: n,
  userDateFormat: t,
  userTimeFormat: e,
  classNameCustomInput: i,
  wrapperClassName: o,
  showTimeSelect: s = !0,
  showTimeSelectOnly: u = !0,
  timeIntervals: l = 15,
  ...c
}) => {
  const { timeFormat: d } = t && e ? wm(e, t) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ v("div", { className: A("w-min", n), children: /* @__PURE__ */ v(
      ar,
      {
        disabled: c.disabled || c.isPreFetching,
        selected: typeof a == "number" ? am(a) : null,
        onChange: (h) => {
          h && r(Ii(h));
        },
        showTimeSelect: s,
        showTimeSelectOnly: u,
        timeIntervals: l,
        timeCaption: W.t("public_pages_purchase.date_picker.time"),
        timeFormat: d,
        dateFormat: d,
        placeholderText: Tm(d),
        customInput: /* @__PURE__ */ v(tr, { className: A("w-32", i), ...c }),
        timeClassName: (h) => a === Ii(h) ? "text-brand-primary" : "text-text-primary",
        wrapperClassName: A("time-only", o)
      }
    ) })
  );
};
var Ur = /* @__PURE__ */ ((a) => (a.DateSince = "dateSince", a.DateTill = "dateTill", a))(Ur || {}), pt = /* @__PURE__ */ ((a) => (a.Last30Days = "last_30_days", a.ThisMonth = "this_month", a.LastMonth = "last_month", a))(pt || {}), Na = /* @__PURE__ */ ((a) => (a.AllTime = "all_time", a.Last3Months = "last_3_months", a.EvaluationPeriod = "evaluation_period", a))(Na || {});
const rr = Mt(
  ({
    onClick: a,
    error: r,
    label: n,
    labelClassName: t,
    required: e,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: s,
    children: u,
    value: l
  }, c) => /* @__PURE__ */ _("div", { className: A("flex flex-col gap-1", i), children: [
    /* @__PURE__ */ v(Pa, { label: n, labelClassName: t, required: e }),
    /* @__PURE__ */ _("button", { onClick: a, ref: c, type: "button", className: o, children: [
      u(l),
      /* @__PURE__ */ v(
        Nu,
        {
          className: A(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            l ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ v(Sa, { error: r, description: s })
  ] })
);
rr.displayName = "ButtonInput";
const Sn = ({
  date: a,
  prevMonthButtonDisabled: r,
  nextMonthButtonDisabled: n,
  increaseMonth: t,
  decreaseMonth: e,
  intlLocale: i
}) => /* @__PURE__ */ _("div", { className: "flex items-center justify-between px-2 py-2", children: [
  /* @__PURE__ */ v(
    "button",
    {
      onClick: e,
      disabled: r,
      type: "button",
      className: A(
        "group rounded-full outline-hidden  ",
        r && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ v(Du, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  ),
  /* @__PURE__ */ v("span", { className: "text-text-primary text-base", children: new Intl.DateTimeFormat(i, {
    month: "long",
    year: "numeric"
  }).format(a) }),
  /* @__PURE__ */ v(
    "button",
    {
      onClick: t,
      disabled: n,
      type: "button",
      className: A(
        "group rounded-full outline-hidden ",
        n && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ v(ji, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  )
] }), bn = (a, r) => {
  Ne(() => {
    (async () => {
      try {
        if (a) {
          let t;
          switch (a) {
            case ie.ENGLISH:
            case "en":
              t = await import("./index-B34WKmlg.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.FRENCH:
            case "fr":
              t = await import("./index-Bkzpf0y3.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.SPANISH:
            case "es":
              t = await import("./index-LH4r2exy.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.ITALIAN:
            case "it":
              t = await import("./index-C1Uqx_1M.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.PORTUGUESE:
            case "pt":
              t = await import("./index-DfRPlt1W.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.DEUTSCH:
            case "de":
              t = await import("./index-X93YSI-c.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.DUTCH:
            case "nl":
              t = await import("./index-aCZ4hjHe.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.RUSSIAN:
            case "ru":
              t = await import("./index-hJ0ltz-F.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.JAPANESE:
            case "ja":
              t = await import("./index-BltSz9Uc.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.ARABIC:
            case "ar":
              t = await import("./index-Cy0wos8x.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.TURKISH:
            case "tr":
              t = await import("./index-yT1rBmvM.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.CHINESE:
            case "zh":
              t = await import("./index-CHCjEkMq.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.SWEDISH:
            case "sv":
              t = await import("./index-_7WAPcik.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.ROMANIAN:
            case "ro":
              t = await import("./index-BlProebU.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.CZECH:
            case "cs":
              t = await import("./index-S6Atorvp.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.HUNGARIAN:
            case "hu":
              t = await import("./index-ocQC-I0_.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.SLOVAK:
            case "sk":
              t = await import("./index-DiYjcyEW.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.DANISH:
            case "da":
              t = await import("./index-vzYADXLF.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.INDONESIAN:
            case "id":
              t = await import("./index-Cc4tE6ob.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.POLISH:
            case "pl":
              t = await import("./index-DLcAM-M4.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.GREEK:
            case "el":
              t = await import("./index-CTDt37Kj.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.SERBIAN:
            case "sr":
              t = await import("./index-IFmwLizB.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.NORWEGIAN:
            case "no":
              t = await import("./index-C8rF4sgO.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.THAI:
            case "th":
              t = await import("./index-D-VNpT4U.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.SLOVENIAN:
            case "sl":
              t = await import("./index-D-05hs8V.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.UKRAINIAN:
            case "uk":
              t = await import("./index-DSrl2sIC.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.ALBANIA:
            case "sq":
              t = await import("./index-DiFamVAt.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case ie.HINDI:
            case "hi":
              t = await import("./index-BooqZgBr.mjs").then((e) => e.i).then((e) => e.default);
              break;
            default:
              t = await import("./index-B34WKmlg.mjs").then((e) => e.i).then((e) => e.default);
              break;
          }
          t && r(t);
        } else {
          const t = await import("./index-B34WKmlg.mjs").then((e) => e.i).then((e) => e.default);
          r(t);
        }
      } catch (t) {
        console.error("Error loading locale:", t), r(Xa);
      }
    })();
  }, [a, r]);
}, Bg = ({
  value: a,
  onChange: r,
  error: n,
  label: t,
  required: e,
  placeholder: i,
  description: o,
  customProps: s,
  wrapperButtonInputClassName: u,
  labelClassName: l,
  timezone: c,
  intlLocale: d,
  disableApplyButton: h,
  ...p
}) => {
  const [g, S] = de(
    a && Ce(a, c) || null
  ), [b, w] = de(
    a && Ce(a, c) || null
  ), [T, k] = de(Xa), N = Ae(null);
  return Ne(() => {
    a && !g && !b && c && (S(Ce(a, c)), w(Ce(a, c)));
  }, [a, c, g, b]), bn(d, k), /* @__PURE__ */ v("div", { children: /* @__PURE__ */ v(
    ar,
    {
      ref: N,
      selected: g,
      showTimeSelect: !0,
      dayClassName: (M) => g && b && M.toDateString() === b.toDateString() && g.toDateString() !== b.toDateString() ? "text-brand-primary/50" : "",
      timeClassName: (M) => g && b && M.getTime() === b.getTime() && g.getTime() !== b.getTime() ? "text-brand-primary/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        S(b);
      },
      timeFormat: "HH:mm",
      timeIntervals: 15,
      timeCaption: W.t("public_pages_purchase.date_picker.time"),
      timeInputLabel: W.t("public_pages_purchase.date_picker.time"),
      onChange: (M) => {
        M && S(M);
      },
      locale: T,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ v(
        rr,
        {
          error: n,
          label: t,
          required: e,
          wrapperButtonInputClassName: u,
          buttonInputClassName: `flex group justify-between min-w-[250px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${n ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          description: o,
          labelClassName: l,
          children: () => /* @__PURE__ */ v("span", { children: b ? new Intl.DateTimeFormat(d, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hourCycle: "h23",
            minute: "2-digit"
          }).format(b) : /* @__PURE__ */ v("span", { className: "text-text-tertiary/70", children: i }) })
        }
      ),
      renderCustomHeader: ({
        date: M,
        decreaseMonth: y,
        increaseMonth: D,
        prevMonthButtonDisabled: I,
        nextMonthButtonDisabled: P
      }) => /* @__PURE__ */ v(
        Sn,
        {
          date: M,
          decreaseMonth: y,
          increaseMonth: D,
          prevMonthButtonDisabled: I,
          nextMonthButtonDisabled: P,
          intlLocale: d
        }
      ),
      ...p,
      ...s,
      children: /* @__PURE__ */ _("div", { className: "flex w-full justify-center gap-5 sm:col-span-2", children: [
        /* @__PURE__ */ v(
          rs,
          {
            disabled: !g || (h == null ? void 0 : h(g)),
            onClick: () => {
              var M;
              g && ((M = N.current) == null || M.setOpen(!1), w(g), r(Ca(g)));
            },
            width: "large",
            children: W.t("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ v(
          ns,
          {
            onClick: () => {
              var M;
              (M = N.current) == null || M.setOpen(!1), w(null), r(null);
            },
            width: "large",
            children: W.t("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
}, Am = {
  [pt.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [pt.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [pt.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, Nm = {
  [Na.AllTime]: "public_pages_purchase.date_picker.all_time",
  [Na.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [Na.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, Dm = (a) => W.t(Am[a]), Im = (a) => W.t(Nm[a]);
function Gi(a, r) {
  var n = a.getFullYear() - r.getFullYear() || a.getMonth() - r.getMonth() || a.getDate() - r.getDate() || a.getHours() - r.getHours() || a.getMinutes() - r.getMinutes() || a.getSeconds() - r.getSeconds() || a.getMilliseconds() - r.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Em(a, r) {
  O(2, arguments);
  var n = R(a), t = R(r), e = Gi(n, t), i = Math.abs(mt(n, t));
  n.setDate(n.getDate() - e * i);
  var o = +(Gi(n, t) === -e), s = e * (i - o);
  return s === 0 ? 0 : s;
}
const Bm = (a, r, n) => (a && r && Em(r, a) > n && (a = new Date(r.getTime() - n * 24 * 60 * 60 * 1e3)), [a, r]), Pm = (a) => Object.values(Na).includes(
  a
), Om = ({
  activeFilter: a,
  setDateRange: r,
  timezone: n,
  customFilters: t
}) => {
  var i;
  if (Pm(a)) {
    const o = (i = t.find((s) => s.slug === a)) == null ? void 0 : i.handler;
    o && r(o());
  } else
    switch (a) {
      case "last_30_days": {
        const o = Ce("", n);
        o.setHours(23, 59, 59, 999);
        const s = new Date(o);
        s.setDate(s.getDate() - 30), s.setHours(0, 0, 0, 0), r([s, o]);
        break;
      }
      case "this_month": {
        const o = Ce("", n), s = o.getFullYear(), u = o.getMonth(), l = new Date(s, u, 1), c = new Date(s, u + 1, 0);
        r([l, c]);
        break;
      }
      case "last_month": {
        const o = Ce("", n), s = o.getFullYear(), u = o.getMonth(), l = new Date(s, u - 1, 1), c = new Date(s, u, 0);
        r([l, c]);
        break;
      }
    }
}, Gm = (a, r) => {
  const n = Ce("", r);
  return n.setHours(23, 59, 59, 999), [Ce(a, r), n];
}, Lm = (a) => {
  const r = Ce("", a);
  r.setHours(23, 59, 59, 999);
  const n = Ce("", a);
  return n.setMonth(n.getMonth() - 3), n.setHours(0, 0, 0, 0), [n, r];
}, Li = (a, r) => ({
  slug: Na.AllTime,
  handler: () => Gm(a, r)
}), Pg = (a) => ({
  slug: Na.Last3Months,
  handler: () => Lm(a)
}), Rm = (a) => (a.setHours(0, 0, 0, 0), a), nu = (a) => (a.setHours(23, 59, 59, 999), a), Og = ({
  date: a,
  light: r,
  getDefaultDate: n,
  small: t,
  customFilters: e,
  filtersDisabled: i,
  onChange: o,
  placeholder: s,
  error: u,
  description: l,
  disabled: c,
  label: d,
  required: h,
  maxDate: p,
  minDate: g,
  wrapperButtonInputClassName: S,
  intlLocale: b,
  createdAt: w,
  timezone: T,
  dateFormat: k,
  customProps: N,
  labelClassName: M,
  maxInterval: y,
  showActionsSideBar: D = !0
}) => {
  const I = Ae(null), [P, B] = de(Xa), K = qa(
    () => (g && Ca(g)) ?? w,
    [g, w]
  ), Q = (ee) => !b || !K || !ee ? ee : Dt(K) > Dt(ee) ? K : ee, [Z, z] = a, x = Q(a[0]), [Y, L] = de(), [H, X] = de(), [J, E] = de([
    x && Ce(x, T) || null,
    z && Ce(z, T) || null
  ]), [U, j] = J, [V, re] = de(
    x && Ce(x, T) || null
  ), [he, ve] = de(
    z && Ce(z, T) || null
  );
  Ne(() => {
    !T || !K || Om({
      activeFilter: H,
      timezone: T,
      setDateRange: E,
      customFilters: e || [Li(K, T)]
    });
  }, [Y, H, e, K]), bn(b, B), Ne(() => {
    if (x && z && T) {
      const ee = Ce(x, T), pe = Ce(z, T);
      E([ee, pe]), re(ee), ve(pe);
    }
  }, [a, x, z, T]);
  const ue = /* @__PURE__ */ _("div", { className: "flex w-full flex-col gap-3 px-2 sm:flex-row sm:gap-5", children: [
    /* @__PURE__ */ _("div", { className: "flex w-fit sm:w-full", children: [
      /* @__PURE__ */ _("span", { className: "text-text-secondary pr-1", children: [
        W.t("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ v("span", { className: "text-text-primary", children: U ? Bn(U, { dateFormat: k }) : "-" })
    ] }),
    /* @__PURE__ */ _("div", { className: "flex w-fit sm:w-full sm:pl-2", children: [
      /* @__PURE__ */ _("span", { className: "text-text-secondary pr-1", children: [
        W.t("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ v("span", { className: "text-text-primary", children: j ? Bn(j, { dateFormat: k }) : "-" })
    ] })
  ] }), ne = /* @__PURE__ */ _(Ue, { children: [
    /* @__PURE__ */ v(
      ns,
      {
        disabled: c,
        onClick: () => {
          var ee;
          if ((ee = I.current) == null || ee.setOpen(!1), n) {
            const [pe, Le] = n(), ua = Q(pe) ?? void 0, la = Ce(ua, T), et = Ce(Le, T);
            ve(et), re(la), o([
              Ca(la),
              Ca(et)
            ]);
          } else
            ve(null), re(null), o([null, null]);
          L(void 0);
        },
        className: "w-full",
        children: W.t("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ v(
      rs,
      {
        disabled: !J[0] || !J[1] || c,
        className: "w-full",
        onClick: () => {
          var Le;
          const [ee, pe] = J;
          ee && pe ? (re(ee), ve(pe), L(H), Rm(ee), nu(pe), o([Ca(ee), Ca(pe)])) : o([null, null]), (Le = I.current) == null || Le.setOpen(!1);
        },
        children: W.t("public_pages_purchase.date_picker.apply")
      }
    )
  ] });
  return /* @__PURE__ */ v("div", { children: /* @__PURE__ */ v(
    ar,
    {
      ref: I,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: U,
      startDate: U,
      className: "w-full",
      calendarClassName: "date-range-picker",
      popperClassName: "react-datepicker-bottom",
      onCalendarClose: () => {
        E([V, he]), X(Y);
      },
      calendarContainer: D ? (ee) => /* @__PURE__ */ _(
        "div",
        {
          ...ee,
          className: A(
            "flex flex-col justify-center gap-4 sm:flex-row sm:gap-5",
            ee.className
          ),
          children: [
            /* @__PURE__ */ _("div", { className: "flex flex-col gap-4 md:mb-4", children: [
              /* @__PURE__ */ v("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: ee.children }),
              ue
            ] }),
            /* @__PURE__ */ _("div", { className: "sm:border-text-secondary/30 flex w-full flex-col items-center justify-center gap-5 border-transparent sm:m-auto sm:border-t sm:p-2 md:w-fit md:border-l md:border-t-0 md:pl-5", children: [
              /* @__PURE__ */ _("ul", { className: "hidden w-1/2 gap-5 sm:flex sm:flex-col md:w-full", children: [
                Object.values(pt).map((pe) => /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v(
                  Rn,
                  {
                    className: "w-full",
                    disabled: !T || i || c,
                    onClick: () => {
                      X(pe);
                    },
                    selected: pe === H,
                    children: Dm(pe)
                  }
                ) }, pe)),
                (e || [Li(K, T)]).map(
                  (pe) => /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v(
                    Rn,
                    {
                      className: "w-full",
                      disabled: i || c,
                      onClick: () => {
                        X(pe.slug);
                      },
                      selected: pe.slug === H,
                      children: Im(pe.slug)
                    }
                  ) }, pe.slug)
                )
              ] }),
              /* @__PURE__ */ v("div", { className: "flex w-full justify-between gap-3 sm:w-1/2 md:w-full", children: ne })
            ] })
          ]
        }
      ) : (ee) => /* @__PURE__ */ _("div", { ...ee, children: [
        /* @__PURE__ */ v("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: ee.children }),
        ue,
        /* @__PURE__ */ v("div", { className: "flex w-full justify-center gap-3", children: ne })
      ] }),
      endDate: j,
      minDate: Dt(K, T),
      maxDate: p,
      dateFormat: "MMMM d, yyyy",
      onChange: (ee) => {
        if (ee) {
          X(void 0);
          const [pe, Le] = ee;
          E(y ? Bm(pe, Le, y) : [pe, Le]);
        }
      },
      locale: P,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ v(
        rr,
        {
          buttonInputClassName: `flex group justify-between ${t ? "" : "min-w-[150px] lg:min-w-[200px]"} w-full py-2.5 px-4 text-sm font-medium ${r ? "text-[rgb(var(--text-tertiary))]" : "text-text-primary"} border ${u ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          wrapperButtonInputClassName: S,
          labelClassName: M,
          error: u,
          label: d,
          required: h,
          description: l,
          children: () => /* @__PURE__ */ v("span", { className: "text-start whitespace-nowrap", children: V && he ? /* @__PURE__ */ _(Ue, { children: [
            /* @__PURE__ */ v("span", { className: "hidden lg:inline", children: `${new Intl.DateTimeFormat(b, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(V)} - ${new Intl.DateTimeFormat(b, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(he)}
              ` }),
            /* @__PURE__ */ v("span", { className: "inline lg:hidden", children: `${new Intl.DateTimeFormat(b, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(V)} - ${new Intl.DateTimeFormat(b, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(he)}
              ` })
          ] }) : /* @__PURE__ */ v("span", { className: "text-text-tertiary/70", children: s || W.t("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: ee,
        decreaseMonth: pe,
        increaseMonth: Le,
        prevMonthButtonDisabled: ua,
        nextMonthButtonDisabled: la
      }) => /* @__PURE__ */ v(
        Sn,
        {
          date: ee,
          decreaseMonth: pe,
          increaseMonth: Le,
          prevMonthButtonDisabled: ua,
          nextMonthButtonDisabled: la,
          intlLocale: b
        }
      ),
      ...N
    }
  ) });
}, Gg = ({
  mode: a = Ur.DateSince,
  value: r,
  onChange: n,
  description: t,
  error: e,
  label: i,
  required: o,
  placeholder: s,
  maxDate: u,
  minDate: l,
  wrapperButtonInputClassName: c,
  disabled: d,
  timezone: h,
  intlLocale: p,
  createdAt: g,
  labelClassName: S,
  customProps: b
}) => {
  const [w, T] = de(
    r && Ce(r, h) || null
  ), [k, N] = de(), [M, y] = de(Xa), D = g && h ? Dt(g, h) : null;
  return bn(p, y), Ne(() => {
    if (!h) return;
    const I = r ? Ce(r, h) : null;
    (!w || (I == null ? void 0 : I.toISOString()) !== w.toISOString()) && T(I);
  }, [r, h, w]), /* @__PURE__ */ v("div", { children: /* @__PURE__ */ v(
    ar,
    {
      selected: w,
      dateFormat: "MMMM d, yyyy",
      onChange: (I) => {
        I && ((w ? I.toDateString() === w.toDateString() : !1) ? (T(null), n(null)) : (T(I), a === Ur.DateTill && nu(I), n(Ca(I))));
      },
      onChangeRaw: (I) => {
        k === I.target.ariaLabel ? (T(null), n(null)) : N(I.target.ariaLabel);
      },
      locale: M,
      minDate: l || D,
      maxDate: u,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ v(
        rr,
        {
          description: t,
          buttonInputClassName: `flex group justify-between min-w-[200px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${d ? "bg-background-tertiary/40" : "bg-background-secondary focus:border-brand-primary"} ${e ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          error: e,
          label: i,
          required: o,
          wrapperButtonInputClassName: c,
          labelClassName: S,
          children: (I) => /* @__PURE__ */ v("span", { className: "text-start", children: I || /* @__PURE__ */ v("span", { className: "text-text-tertiary/70", children: s }) })
        }
      ),
      renderCustomHeader: ({
        date: I,
        decreaseMonth: P,
        increaseMonth: B,
        prevMonthButtonDisabled: K,
        nextMonthButtonDisabled: Q
      }) => /* @__PURE__ */ v(
        Sn,
        {
          date: I,
          decreaseMonth: P,
          increaseMonth: B,
          prevMonthButtonDisabled: K,
          nextMonthButtonDisabled: Q,
          intlLocale: p
        }
      ),
      disabled: d,
      ...b
    }
  ) });
}, Ri = ({
  children: a,
  isLast: r,
  className: n,
  isLink: t,
  onClick: e
}) => {
  const i = (o) => {
    e && (o.preventDefault(), e());
  };
  return /* @__PURE__ */ v(
    "h2",
    {
      className: A(
        "text-text-tertiary text-[18px] font-semibold leading-8 transition-colors md:truncate md:text-[20px]  lg:text-[22px]",
        n,
        (t || e) && "hover:text-text-primary cursor-pointer",
        r && "text-text-primary"
      ),
      onClick: i,
      children: a
    }
  );
}, Lg = ({
  data: a,
  isFetching: r,
  classnameBreadcrumbsItem: n,
  CustomBreadcrumbLinkItem: t
}) => {
  const e = Ae(null), i = Ae(null);
  return bu(() => {
    e.current && i.current && e.current.scrollTo(i.current.offsetLeft, 0);
  }, [r]), /* @__PURE__ */ v(
    "ul",
    {
      ref: e,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: a.map((o, s) => {
        const u = s === a.length - 1;
        return /* @__PURE__ */ _(
          "li",
          {
            className: "flex flex-nowrap items-center gap-3 md:truncate",
            ref: u ? i : void 0,
            children: [
              s !== 0 && /* @__PURE__ */ v(ji, { height: "14", width: "10", fill: "rgb(var(--text-tertiary))" }),
              !o.isStatic && r ? /* @__PURE__ */ v(Gt, { small: !0, type: "dark" }) : o.href ? /* @__PURE__ */ v(
                Ri,
                {
                  isLast: u,
                  className: A(n),
                  isLink: !0,
                  onClick: o.onClick,
                  children: t ? /* @__PURE__ */ v(t, { href: o.href, children: o.caption }) : /* @__PURE__ */ v("a", { href: o.href, rel: "noreferrer", className: "outline-hidden", children: o.caption })
                }
              ) : /* @__PURE__ */ v(
                Ri,
                {
                  onClick: o.onClick,
                  className: A(n),
                  isLast: u,
                  children: o.caption
                }
              )
            ]
          },
          s
        );
      })
    }
  );
};
export {
  am as $,
  mg as A,
  Oa as B,
  Zm as C,
  ns as D,
  _n as E,
  Pa as F,
  us as G,
  Jr as H,
  Qr as I,
  ss as J,
  Xr as K,
  Gt as L,
  Vm as M,
  pg as N,
  Jt as O,
  zm as P,
  ls as Q,
  bg as R,
  fg as S,
  vg as T,
  Mc as U,
  bc as V,
  kg as W,
  Tg as X,
  Zr as Y,
  wg as Z,
  rm as _,
  _u as a,
  Ii as a0,
  tm as a1,
  Eg as a2,
  Ur as a3,
  pt as a4,
  Na as a5,
  Bg as a6,
  Og as a7,
  Gg as a8,
  Pg as a9,
  rg as aA,
  ng as aB,
  Re as aC,
  $l as aD,
  ig as aE,
  ec as aF,
  Tr as aG,
  Dt as aH,
  or as aI,
  Ce as aJ,
  Ca as aK,
  Bn as aL,
  og as aM,
  uc as aN,
  sg as aO,
  ug as aP,
  lg as aQ,
  cg as aR,
  os as aS,
  Rm as aa,
  nu as ab,
  Ri as ac,
  Lg as ad,
  tr as ae,
  Ag as af,
  Ng as ag,
  Dg as ah,
  Ig as ai,
  Zi as aj,
  zi as ak,
  Ku as al,
  be as am,
  qm as an,
  jm as ao,
  wr as ap,
  Hu as aq,
  eg as ar,
  qi as as,
  ag as at,
  Da as au,
  Xm as av,
  Uu as aw,
  $m as ax,
  tg as ay,
  zr as az,
  Sa as b,
  Jm as c,
  Qm as d,
  dg as e,
  Ua as f,
  Zt as g,
  hg as h,
  Rn as i,
  rs as j,
  dc as k,
  hc as l,
  fc as m,
  lc as n,
  cc as o,
  gg as p,
  gc as q,
  Mg as r,
  yg as s,
  Cg as t,
  Sg as u,
  cs as v,
  ps as w,
  en as x,
  $r as y,
  ds as z
};
